(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
require("./json-schema-draft-01");
require("./json-schema-draft-02");
require("./json-schema-draft-03");
},{"./json-schema-draft-01":2,"./json-schema-draft-02":3,"./json-schema-draft-03":4}],2:[function(require,module,exports){
/**
 * json-schema-draft-01 Environment
 * 
 * @fileOverview Implementation of the first revision of the JSON Schema specification draft.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 1.7.1
 * @see http://github.com/garycourt/JSV
 */

/*
 * Copyright 2010 Gary Court. All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 * 
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 * 
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court or the JSON Schema specification.
 */

/*jslint white: true, sub: true, onevar: true, undef: true, eqeqeq: true, newcap: true, immed: true, indent: 4 */
/*global require */

(function () {
	var O = {},
		JSV = require('./jsv').JSV,
		ENVIRONMENT,
		TYPE_VALIDATORS,
		SCHEMA,
		HYPERSCHEMA,
		LINKS;
	
	TYPE_VALIDATORS = {
		"string" : function (instance, report) {
			return instance.getType() === "string";
		},
		
		"number" : function (instance, report) {
			return instance.getType() === "number";
		},
		
		"integer" : function (instance, report) {
			return instance.getType() === "number" && instance.getValue() % 1 === 0;
		},
		
		"boolean" : function (instance, report) {
			return instance.getType() === "boolean";
		},
		
		"object" : function (instance, report) {
			return instance.getType() === "object";
		},
		
		"array" : function (instance, report) {
			return instance.getType() === "array";
		},
		
		"null" : function (instance, report) {
			return instance.getType() === "null";
		},
		
		"any" : function (instance, report) {
			return true;
		}
	};
	
	ENVIRONMENT = new JSV.Environment();
	ENVIRONMENT.setOption("defaultFragmentDelimiter", ".");
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/schema#");  //updated later
	
	SCHEMA = ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/schema#",
		"type" : "object",
		
		"properties" : {
			"type" : {
				"type" : ["string", "array"],
				"items" : {
					"type" : ["string", {"$ref" : "#"}]
				},
				"optional" : true,
				"uniqueItems" : true,
				"default" : "any",
				
				"parser" : function (instance, self) {
					var parser;
					
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(
							instance, 
							self.getEnvironment().findSchema(self.resolveURI("#"))
						);
					} else if (instance.getType() === "array") {
						parser = self.getValueOfProperty("parser");
						return JSV.mapArray(instance.getProperties(), function (prop) {
							return parser(prop, self);
						});
					}
					//else
					return "any";
				},
			
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requiredTypes = JSV.toArray(schema.getAttribute("type")),
						x, xl, type, subreport, typeValidators;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && requiredTypes && requiredTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = requiredTypes.length; x < xl; ++x) {
							type = requiredTypes[x];
							if (JSV.isJSONSchema(type)) {
								subreport = JSV.createObject(report);
								subreport.errors = [];
								subreport.validated = JSV.clone(report.validated);
								if (type.validate(instance, subreport, parent, parentSchema, name).errors.length === 0) {
									return true;  //instance matches this schema
								}
							} else {
								if (typeValidators[type] !== O[type] && typeof typeValidators[type] === "function") {
									if (typeValidators[type](instance, report)) {
										return true;  //type is valid
									}
								} else {
									return true;  //unknown types are assumed valid
								}
							}
						}
						
						//if we get to this point, type is invalid
						report.addError(instance, schema, "type", "Instance is not a required type", requiredTypes);
						return false;
					}
					//else, anything is allowed if no type is specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment();
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI("#")));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI("#")));
							});
						}
					}
					//else
					return {};
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var propertySchemas, key;
					//this attribute is for object type instances only
					if (instance.getType() === "object") {
						//for each property defined in the schema
						propertySchemas = schema.getAttribute("properties");
						for (key in propertySchemas) {
							if (propertySchemas[key] !== O[key] && propertySchemas[key]) {
								//ensure that instance property is valid
								propertySchemas[key].validate(instance.getProperty(key), report, instance, schema, key);
							}
						}
					}
				}
			},
			
			"items" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var properties, items, x, xl, itemSchema, additionalProperties;
					
					if (instance.getType() === "array") {
						properties = instance.getProperties();
						items = schema.getAttribute("items");
						additionalProperties = schema.getAttribute("additionalProperties");
						
						if (JSV.typeOf(items) === "array") {
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema = items[x] || additionalProperties;
								if (itemSchema !== false) {
									itemSchema.validate(properties[x], report, instance, schema, x);
								} else {
									report.addError(instance, schema, "additionalProperties", "Additional items are not allowed", itemSchema);
								}
							}
						} else {
							itemSchema = items || additionalProperties;
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema.validate(properties[x], report, instance, schema, x);
							}
						}
					}
				}
			},
			
			"optional" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					if (instance.getType() === "undefined" && !schema.getAttribute("optional")) {
						report.addError(instance, schema, "optional", "Property is required", false);
					}
				},
				
				"validationRequired" : true
			},
			
			"additionalProperties" : {
				"type" : [{"$ref" : "#"}, "boolean"],
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "boolean" && instance.getValue() === false) {
						return false;
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var additionalProperties, propertySchemas, properties, key;
					//we only need to check against object types as arrays do their own checking on this property
					if (instance.getType() === "object") {
						additionalProperties = schema.getAttribute("additionalProperties");
						propertySchemas = schema.getAttribute("properties") || {};
						properties = instance.getProperties();
						for (key in properties) {
							if (properties[key] !== O[key] && properties[key] && !propertySchemas[key]) {
								if (JSV.isJSONSchema(additionalProperties)) {
									additionalProperties.validate(properties[key], report, instance, schema, key);
								} else if (additionalProperties === false) {
									report.addError(instance, schema, "additionalProperties", "Additional properties are not allowed", additionalProperties);
								}
							}
						}
					}
				}
			},
			
			"requires" : {
				"type" : ["string", {"$ref" : "#"}],
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requires;
					if (instance.getType() !== "undefined" && parent && parent.getType() !== "undefined") {
						requires = schema.getAttribute("requires");
						if (typeof requires === "string") {
							if (parent.getProperty(requires).getType() === "undefined") {
								report.addError(instance, schema, "requires", 'Property requires sibling property "' + requires + '"', requires);
							}
						} else if (JSV.isJSONSchema(requires)) {
							requires.validate(parent, report);  //WATCH: A "requires" schema does not support the "requires" attribute
						}
					}
				}
			},
			
			"minimum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minimum, minimumCanEqual;
					if (instance.getType() === "number") {
						minimum = schema.getAttribute("minimum");
						minimumCanEqual = schema.getAttribute("minimumCanEqual");
						if (typeof minimum === "number" && (instance.getValue() < minimum || (minimumCanEqual === false && instance.getValue() === minimum))) {
							report.addError(instance, schema, "minimum", "Number is less than the required minimum value", minimum);
						}
					}
				}
			},
			
			"maximum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maximum, maximumCanEqual;
					if (instance.getType() === "number") {
						maximum = schema.getAttribute("maximum");
						maximumCanEqual = schema.getAttribute("maximumCanEqual");
						if (typeof maximum === "number" && (instance.getValue() > maximum || (maximumCanEqual === false && instance.getValue() === maximum))) {
							report.addError(instance, schema, "maximum", "Number is greater than the required maximum value", maximum);
						}
					}
				}
			},
			
			"minimumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "minimum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"maximumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "maximum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"minItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minItems;
					if (instance.getType() === "array") {
						minItems = schema.getAttribute("minItems");
						if (typeof minItems === "number" && instance.getProperties().length < minItems) {
							report.addError(instance, schema, "minItems", "The number of items is less than the required minimum", minItems);
						}
					}
				}
			},
			
			"maxItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxItems;
					if (instance.getType() === "array") {
						maxItems = schema.getAttribute("maxItems");
						if (typeof maxItems === "number" && instance.getProperties().length > maxItems) {
							report.addError(instance, schema, "maxItems", "The number of items is greater than the required maximum", maxItems);
						}
					}
				}
			},
			
			"pattern" : {
				"type" : "string",
				"optional" : true,
				"format" : "regex",
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pattern;
					try {
						pattern = new RegExp(schema.getAttribute("pattern"));
						if (instance.getType() === "string" && pattern && !pattern.test(instance.getValue())) {
							report.addError(instance, schema, "pattern", "String does not match pattern", pattern.toString());
						}
					} catch (e) {
						report.addError(instance, schema, "pattern", "Invalid pattern", e);
					}
				}
			},
			
			"minLength" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minLength;
					if (instance.getType() === "string") {
						minLength = schema.getAttribute("minLength");
						if (typeof minLength === "number" && instance.getValue().length < minLength) {
							report.addError(instance, schema, "minLength", "String is less than the required minimum length", minLength);
						}
					}
				}
			},
			
			"maxLength" : {
				"type" : "integer",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxLength;
					if (instance.getType() === "string") {
						maxLength = schema.getAttribute("maxLength");
						if (typeof maxLength === "number" && instance.getValue().length > maxLength) {
							report.addError(instance, schema, "maxLength", "String is greater than the required maximum length", maxLength);
						}
					}
				}
			},
			
			"enum" : {
				"type" : "array",
				"optional" : true,
				"minItems" : 1,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var enums, x, xl;
					if (instance.getType() !== "undefined") {
						enums = schema.getAttribute("enum");
						if (enums) {
							for (x = 0, xl = enums.length; x < xl; ++x) {
								if (instance.equals(enums[x])) {
									return true;
								}
							}
							report.addError(instance, schema, "enum", "Instance is not one of the possible values", enums);
						}
					}
				}
			},
			
			"title" : {
				"type" : "string",
				"optional" : true
			},
			
			"description" : {
				"type" : "string",
				"optional" : true
			},
			
			"format" : {
				"type" : "string",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var format, formatValidators;
					if (instance.getType() === "string") {
						format = schema.getAttribute("format");
						formatValidators = self.getValueOfProperty("formatValidators");
						if (typeof format === "string" && formatValidators[format] !== O[format] && typeof formatValidators[format] === "function" && !formatValidators[format].call(this, instance, report)) {
							report.addError(instance, schema, "format", "String is not in the required format", format);
						}
					}
				},
				
				"formatValidators" : {}
			},
			
			"contentEncoding" : {
				"type" : "string",
				"optional" : true
			},
			
			"default" : {
				"type" : "any",
				"optional" : true
			},
			
			"maxDecimal" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
								
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxDecimal, decimals;
					if (instance.getType() === "number") {
						maxDecimal = schema.getAttribute("maxDecimal");
						if (typeof maxDecimal === "number") {
							decimals = instance.getValue().toString(10).split('.')[1];
							if (decimals && decimals.length > maxDecimal) {
								report.addError(instance, schema, "maxDecimal", "The number of decimal places is greater than the allowed maximum", maxDecimal);
							}
						}
					}
				}
			},
			
			"disallow" : {
				"type" : ["string", "array"],
				"items" : {"type" : "string"},
				"optional" : true,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string" || instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var disallowedTypes = JSV.toArray(schema.getAttribute("disallow")),
						x, xl, key, typeValidators;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && disallowedTypes && disallowedTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = disallowedTypes.length; x < xl; ++x) {
							key = disallowedTypes[x];
							if (typeValidators[key] !== O[key] && typeof typeValidators[key] === "function") {
								if (typeValidators[key](instance, report)) {
									report.addError(instance, schema, "disallow", "Instance is a disallowed type", disallowedTypes);
									return false;
								}
							} 
							/*
							else {
								report.addError(instance, schema, "disallow", "Instance may be a disallowed type", disallowedTypes);
								return false;
							}
							*/
						}
						
						//if we get to this point, type is valid
						return true;
					}
					//else, everything is allowed if no disallowed types are specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
		
			"extends" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var extensions = schema.getAttribute("extends"), x, xl;
					if (extensions) {
						if (JSV.isJSONSchema(extensions)) {
							extensions.validate(instance, report, parent, parentSchema, name);
						} else if (JSV.typeOf(extensions) === "array") {
							for (x = 0, xl = extensions.length; x < xl; ++x) {
								extensions[x].validate(instance, report, parent, parentSchema, name);
							}
						}
					}
				}
			}
		},
		
		"optional" : true,
		"default" : {},
		"fragmentResolution" : "dot-delimited",
		
		"parser" : function (instance, self) {
			if (instance.getType() === "object") {
				return instance.getEnvironment().createSchema(instance, self);
			}
		},
		
		"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
			var propNames = schema.getPropertyNames(), 
				x, xl,
				attributeSchemas = self.getAttribute("properties"),
				validator;
			
			for (x in attributeSchemas) {
				if (attributeSchemas[x] !== O[x] && attributeSchemas[x].getValueOfProperty("validationRequired")) {
					JSV.pushUnique(propNames, x);
				}
			}
			
			for (x = 0, xl = propNames.length; x < xl; ++x) {
				if (attributeSchemas[propNames[x]] !== O[propNames[x]]) {
					validator = attributeSchemas[propNames[x]].getValueOfProperty("validator");
					if (typeof validator === "function") {
						validator(instance, schema, attributeSchemas[propNames[x]], report, parent, parentSchema, name);
					}
				}
			}
		},
				
		"initializer" : function (instance) {
			var link, extension, extended;
			
			//if there is a link to a different schema, set reference
			link = instance._schema.getLink("describedby", instance);
			if (link && instance._schema._uri !== link) {
				instance.setReference("describedby", link);
			}
			
			//if instance has a URI link to itself, update it's own URI
			link = instance._schema.getLink("self", instance);
			if (JSV.typeOf(link) === "string") {
				instance._uri = JSV.formatURI(link);
			}
			
			//if there is a link to the full representation, set reference
			link = instance._schema.getLink("full", instance);
			if (link && instance._uri !== link) {
				instance.setReference("full", link);
			}
			
			//extend schema
			extension = instance.getAttribute("extends");
			if (JSV.isJSONSchema(extension)) {
				extended = JSV.inherits(extension, instance, true);
				instance = instance._env.createSchema(extended, instance._schema, instance._uri);
			}
			
			return instance;
		}
	}, true, "http://json-schema.org/schema#");
	
	HYPERSCHEMA = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA, ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/hyper-schema#",
	
		"properties" : {
			"links" : {
				"type" : "array",
				"items" : {"$ref" : "links#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var links,
						linkSchemaURI = self.getValueOfProperty("items")["$ref"],
						linkSchema = self.getEnvironment().findSchema(linkSchemaURI),
						linkParser = linkSchema && linkSchema.getValueOfProperty("parser");
					arg = JSV.toArray(arg);
					
					if (typeof linkParser === "function") {
						links = JSV.mapArray(instance.getProperties(), function (link) {
							return linkParser(link, linkSchema);
						});
					} else {
						links = JSV.toArray(instance.getValue());
					}
					
					if (arg[0]) {
						links = JSV.filterArray(links, function (link) {
							return link["rel"] === arg[0];
						});
					}
					
					if (arg[1]) {
						links = JSV.mapArray(links, function (link) {
							var instance = arg[1],
								href = link["href"];
							href = href.replace(/\{(.+)\}/g, function (str, p1, offset, s) {
								var value; 
								if (p1 === "-this") {
									value = instance.getValue();
								} else {
									value = instance.getValueOfProperty(p1);
								}
								return value !== undefined ? String(value) : "";
							});
							return href ? JSV.formatURI(instance.resolveURI(href)) : href;
						});
					}
					
					return links;
				}
			},
			
			"fragmentResolution" : {
				"type" : "string",
				"optional" : true,
				"default" : "dot-delimited"
			},
			
			"root" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"readonly" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"pathStart" : {
				"type" : "string",
				"optional" : true,
				"format" : "uri",
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pathStart;
					if (instance.getType() !== "undefined") {
						pathStart = schema.getAttribute("pathStart");
						if (typeof pathStart === "string") {
							//TODO: Find out what pathStart is relative to
							if (instance.getURI().indexOf(pathStart) !== 0) {
								report.addError(instance, schema, "pathStart", "Instance's URI does not start with " + pathStart, pathStart);
							}
						}
					}
				}
			},
			
			"mediaType" : {
				"type" : "string",
				"optional" : true,
				"format" : "media-type"
			},
			
			"alternate" : {
				"type" : "array",
				"items" : {"$ref" : "#"},
				"optional" : true
			}
		},
		
		"links" : [
			{
				"href" : "{$ref}",
				"rel" : "full"
			},
			
			{
				"href" : "{$schema}",
				"rel" : "describedby"
			},
			
			{
				"href" : "{id}",
				"rel" : "self"
			}
		]//,
		
		//not needed as JSV.inherits does the job for us
		//"extends" : {"$ref" : "http://json-schema.org/schema#"}
	}, SCHEMA), true), true, "http://json-schema.org/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/hyper-schema#");
	
	LINKS = ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/links#",
		"type" : "object",
		
		"properties" : {
			"href" : {
				"type" : "string"
			},
			
			"rel" : {
				"type" : "string"
			},
			
			"method" : {
				"type" : "string",
				"default" : "GET",
				"optional" : true
			},
			
			"enctype" : {
				"type" : "string",
				"requires" : "method",
				"optional" : true
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "hyper-schema#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment(),
						additionalPropertiesSchemaURI = self.getValueOfProperty("additionalProperties")["$ref"];
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
							});
						}
					}
				}
			}
		},
		
		"parser" : function (instance, self) {
			var selfProperties = self.getProperty("properties");
			if (instance.getType() === "object") {
				return JSV.mapObject(instance.getProperties(), function (property, key) {
					var propertySchema = selfProperties.getProperty(key),
						parser = propertySchema && propertySchema.getValueOfProperty("parser");
					if (typeof parser === "function") {
						return parser(property, propertySchema);
					}
					//else
					return property.getValue();
				});
			}
			return instance.getValue();
		}
	}, HYPERSCHEMA, "http://json-schema.org/links#");
	
	JSV.registerEnvironment("json-schema-draft-00", ENVIRONMENT);
	JSV.registerEnvironment("json-schema-draft-01", JSV.createEnvironment("json-schema-draft-00"));
	
	if (!JSV.getDefaultEnvironmentID()) {
		JSV.setDefaultEnvironmentID("json-schema-draft-01");
	}
	
}());
},{"./jsv":5}],3:[function(require,module,exports){
/**
 * json-schema-draft-02 Environment
 * 
 * @fileOverview Implementation of the second revision of the JSON Schema specification draft.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 1.7.1
 * @see http://github.com/garycourt/JSV
 */

/*
 * Copyright 2010 Gary Court. All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 * 
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 * 
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court or the JSON Schema specification.
 */

/*jslint white: true, sub: true, onevar: true, undef: true, eqeqeq: true, newcap: true, immed: true, indent: 4 */
/*global require */

(function () {
	var O = {},
		JSV = require('./jsv').JSV,
		ENVIRONMENT,
		TYPE_VALIDATORS,
		SCHEMA,
		HYPERSCHEMA,
		LINKS;
	
	TYPE_VALIDATORS = {
		"string" : function (instance, report) {
			return instance.getType() === "string";
		},
		
		"number" : function (instance, report) {
			return instance.getType() === "number";
		},
		
		"integer" : function (instance, report) {
			return instance.getType() === "number" && instance.getValue() % 1 === 0;
		},
		
		"boolean" : function (instance, report) {
			return instance.getType() === "boolean";
		},
		
		"object" : function (instance, report) {
			return instance.getType() === "object";
		},
		
		"array" : function (instance, report) {
			return instance.getType() === "array";
		},
		
		"null" : function (instance, report) {
			return instance.getType() === "null";
		},
		
		"any" : function (instance, report) {
			return true;
		}
	};
	
	ENVIRONMENT = new JSV.Environment();
	ENVIRONMENT.setOption("defaultFragmentDelimiter", "/");
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/schema#");  //updated later
	
	SCHEMA = ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/schema#",
		"type" : "object",
		
		"properties" : {
			"type" : {
				"type" : ["string", "array"],
				"items" : {
					"type" : ["string", {"$ref" : "#"}]
				},
				"optional" : true,
				"uniqueItems" : true,
				"default" : "any",
				
				"parser" : function (instance, self) {
					var parser;
					
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(
							instance, 
							self.getEnvironment().findSchema(self.resolveURI("#"))
						);
					} else if (instance.getType() === "array") {
						parser = self.getValueOfProperty("parser");
						return JSV.mapArray(instance.getProperties(), function (prop) {
							return parser(prop, self);
						});
					}
					//else
					return "any";
				},
			
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requiredTypes = JSV.toArray(schema.getAttribute("type")),
						x, xl, type, subreport, typeValidators;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && requiredTypes && requiredTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = requiredTypes.length; x < xl; ++x) {
							type = requiredTypes[x];
							if (JSV.isJSONSchema(type)) {
								subreport = JSV.createObject(report);
								subreport.errors = [];
								subreport.validated = JSV.clone(report.validated);
								if (type.validate(instance, subreport, parent, parentSchema, name).errors.length === 0) {
									return true;  //instance matches this schema
								}
							} else {
								if (typeValidators[type] !== O[type] && typeof typeValidators[type] === "function") {
									if (typeValidators[type](instance, report)) {
										return true;  //type is valid
									}
								} else {
									return true;  //unknown types are assumed valid
								}
							}
						}
						
						//if we get to this point, type is invalid
						report.addError(instance, schema, "type", "Instance is not a required type", requiredTypes);
						return false;
					}
					//else, anything is allowed if no type is specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment();
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI("#")));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI("#")));
							});
						}
					}
					//else
					return {};
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var propertySchemas, key;
					//this attribute is for object type instances only
					if (instance.getType() === "object") {
						//for each property defined in the schema
						propertySchemas = schema.getAttribute("properties");
						for (key in propertySchemas) {
							if (propertySchemas[key] !== O[key] && propertySchemas[key]) {
								//ensure that instance property is valid
								propertySchemas[key].validate(instance.getProperty(key), report, instance, schema, key);
							}
						}
					}
				}
			},
			
			"items" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var properties, items, x, xl, itemSchema, additionalProperties;
					
					if (instance.getType() === "array") {
						properties = instance.getProperties();
						items = schema.getAttribute("items");
						additionalProperties = schema.getAttribute("additionalProperties");
						
						if (JSV.typeOf(items) === "array") {
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema = items[x] || additionalProperties;
								if (itemSchema !== false) {
									itemSchema.validate(properties[x], report, instance, schema, x);
								} else {
									report.addError(instance, schema, "additionalProperties", "Additional items are not allowed", itemSchema);
								}
							}
						} else {
							itemSchema = items || additionalProperties;
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema.validate(properties[x], report, instance, schema, x);
							}
						}
					}
				}
			},
			
			"optional" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					if (instance.getType() === "undefined" && !schema.getAttribute("optional")) {
						report.addError(instance, schema, "optional", "Property is required", false);
					}
				},
				
				"validationRequired" : true
			},
			
			"additionalProperties" : {
				"type" : [{"$ref" : "#"}, "boolean"],
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "boolean" && instance.getValue() === false) {
						return false;
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var additionalProperties, propertySchemas, properties, key;
					//we only need to check against object types as arrays do their own checking on this property
					if (instance.getType() === "object") {
						additionalProperties = schema.getAttribute("additionalProperties");
						propertySchemas = schema.getAttribute("properties") || {};
						properties = instance.getProperties();
						for (key in properties) {
							if (properties[key] !== O[key] && properties[key] && !propertySchemas[key]) {
								if (JSV.isJSONSchema(additionalProperties)) {
									additionalProperties.validate(properties[key], report, instance, schema, key);
								} else if (additionalProperties === false) {
									report.addError(instance, schema, "additionalProperties", "Additional properties are not allowed", additionalProperties);
								}
							}
						}
					}
				}
			},
			
			"requires" : {
				"type" : ["string", {"$ref" : "#"}],
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requires;
					if (instance.getType() !== "undefined" && parent && parent.getType() !== "undefined") {
						requires = schema.getAttribute("requires");
						if (typeof requires === "string") {
							if (parent.getProperty(requires).getType() === "undefined") {
								report.addError(instance, schema, "requires", 'Property requires sibling property "' + requires + '"', requires);
							}
						} else if (JSV.isJSONSchema(requires)) {
							requires.validate(parent, report);  //WATCH: A "requires" schema does not support the "requires" attribute
						}
					}
				}
			},
			
			"minimum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minimum, minimumCanEqual;
					if (instance.getType() === "number") {
						minimum = schema.getAttribute("minimum");
						minimumCanEqual = schema.getAttribute("minimumCanEqual");
						if (typeof minimum === "number" && (instance.getValue() < minimum || (minimumCanEqual === false && instance.getValue() === minimum))) {
							report.addError(instance, schema, "minimum", "Number is less than the required minimum value", minimum);
						}
					}
				}
			},
			
			"maximum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maximum, maximumCanEqual;
					if (instance.getType() === "number") {
						maximum = schema.getAttribute("maximum");
						maximumCanEqual = schema.getAttribute("maximumCanEqual");
						if (typeof maximum === "number" && (instance.getValue() > maximum || (maximumCanEqual === false && instance.getValue() === maximum))) {
							report.addError(instance, schema, "maximum", "Number is greater than the required maximum value", maximum);
						}
					}
				}
			},
			
			"minimumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "minimum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"maximumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "maximum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"minItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minItems;
					if (instance.getType() === "array") {
						minItems = schema.getAttribute("minItems");
						if (typeof minItems === "number" && instance.getProperties().length < minItems) {
							report.addError(instance, schema, "minItems", "The number of items is less than the required minimum", minItems);
						}
					}
				}
			},
			
			"maxItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxItems;
					if (instance.getType() === "array") {
						maxItems = schema.getAttribute("maxItems");
						if (typeof maxItems === "number" && instance.getProperties().length > maxItems) {
							report.addError(instance, schema, "maxItems", "The number of items is greater than the required maximum", maxItems);
						}
					}
				}
			},
			
			"uniqueItems" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var value, x, xl, y, yl;
					if (instance.getType() === "array" && schema.getAttribute("uniqueItems")) {
						value = instance.getProperties();
						for (x = 0, xl = value.length - 1; x < xl; ++x) {
							for (y = x + 1, yl = value.length; y < yl; ++y) {
								if (value[x].equals(value[y])) {
									report.addError(instance, schema, "uniqueItems", "Array can only contain unique items", { x : x, y : y });
								}
							}
						}
					}
				}
			},
			
			"pattern" : {
				"type" : "string",
				"optional" : true,
				"format" : "regex",
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pattern;
					try {
						pattern = new RegExp(schema.getAttribute("pattern"));
						if (instance.getType() === "string" && pattern && !pattern.test(instance.getValue())) {
							report.addError(instance, schema, "pattern", "String does not match pattern", pattern.toString());
						}
					} catch (e) {
						report.addError(instance, schema, "pattern", "Invalid pattern", e);
					}
				}
			},
			
			"minLength" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minLength;
					if (instance.getType() === "string") {
						minLength = schema.getAttribute("minLength");
						if (typeof minLength === "number" && instance.getValue().length < minLength) {
							report.addError(instance, schema, "minLength", "String is less than the required minimum length", minLength);
						}
					}
				}
			},
			
			"maxLength" : {
				"type" : "integer",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxLength;
					if (instance.getType() === "string") {
						maxLength = schema.getAttribute("maxLength");
						if (typeof maxLength === "number" && instance.getValue().length > maxLength) {
							report.addError(instance, schema, "maxLength", "String is greater than the required maximum length", maxLength);
						}
					}
				}
			},
			
			"enum" : {
				"type" : "array",
				"optional" : true,
				"minItems" : 1,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var enums, x, xl;
					if (instance.getType() !== "undefined") {
						enums = schema.getAttribute("enum");
						if (enums) {
							for (x = 0, xl = enums.length; x < xl; ++x) {
								if (instance.equals(enums[x])) {
									return true;
								}
							}
							report.addError(instance, schema, "enum", "Instance is not one of the possible values", enums);
						}
					}
				}
			},
			
			"title" : {
				"type" : "string",
				"optional" : true
			},
			
			"description" : {
				"type" : "string",
				"optional" : true
			},
			
			"format" : {
				"type" : "string",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var format, formatValidators;
					if (instance.getType() === "string") {
						format = schema.getAttribute("format");
						formatValidators = self.getValueOfProperty("formatValidators");
						if (typeof format === "string" && formatValidators[format] !== O[format] && typeof formatValidators[format] === "function" && !formatValidators[format].call(this, instance, report)) {
							report.addError(instance, schema, "format", "String is not in the required format", format);
						}
					}
				},
				
				"formatValidators" : {}
			},
			
			"contentEncoding" : {
				"type" : "string",
				"optional" : true
			},
			
			"default" : {
				"type" : "any",
				"optional" : true
			},
			
			"divisibleBy" : {
				"type" : "number",
				"minimum" : 0,
				"minimumCanEqual" : false,
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var divisor;
					if (instance.getType() === "number") {
						divisor = schema.getAttribute("divisibleBy");
						if (divisor === 0) {
							report.addError(instance, schema, "divisibleBy", "Nothing is divisible by 0", divisor);
						} else if (divisor !== 1 && ((instance.getValue() / divisor) % 1) !== 0) {
							report.addError(instance, schema, "divisibleBy", "Number is not divisible by " + divisor, divisor);
						}
					}
				}
			},
			
			"disallow" : {
				"type" : ["string", "array"],
				"items" : {"type" : "string"},
				"optional" : true,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string" || instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var disallowedTypes = JSV.toArray(schema.getAttribute("disallow")),
						x, xl, key, typeValidators;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && disallowedTypes && disallowedTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = disallowedTypes.length; x < xl; ++x) {
							key = disallowedTypes[x];
							if (typeValidators[key] !== O[key] && typeof typeValidators[key] === "function") {
								if (typeValidators[key](instance, report)) {
									report.addError(instance, schema, "disallow", "Instance is a disallowed type", disallowedTypes);
									return false;
								}
							} 
							/*
							else {
								report.addError(instance, schema, "disallow", "Instance may be a disallowed type", disallowedTypes);
								return false;
							}
							*/
						}
						
						//if we get to this point, type is valid
						return true;
					}
					//else, everything is allowed if no disallowed types are specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
		
			"extends" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var extensions = schema.getAttribute("extends"), x, xl;
					if (extensions) {
						if (JSV.isJSONSchema(extensions)) {
							extensions.validate(instance, report, parent, parentSchema, name);
						} else if (JSV.typeOf(extensions) === "array") {
							for (x = 0, xl = extensions.length; x < xl; ++x) {
								extensions[x].validate(instance, report, parent, parentSchema, name);
							}
						}
					}
				}
			}
		},
		
		"optional" : true,
		"default" : {},
		"fragmentResolution" : "slash-delimited",
		
		"parser" : function (instance, self) {
			if (instance.getType() === "object") {
				return instance.getEnvironment().createSchema(instance, self);
			}
		},
		
		"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
			var propNames = schema.getPropertyNames(), 
				x, xl,
				attributeSchemas = self.getAttribute("properties"),
				validator;
			
			for (x in attributeSchemas) {
				if (attributeSchemas[x] !== O[x] && attributeSchemas[x].getValueOfProperty("validationRequired")) {
					JSV.pushUnique(propNames, x);
				}
			}
			
			for (x = 0, xl = propNames.length; x < xl; ++x) {
				if (attributeSchemas[propNames[x]] !== O[propNames[x]]) {
					validator = attributeSchemas[propNames[x]].getValueOfProperty("validator");
					if (typeof validator === "function") {
						validator(instance, schema, attributeSchemas[propNames[x]], report, parent, parentSchema, name);
					}
				}
			}
		},
				
		"initializer" : function (instance) {
			var link, extension, extended;
			
			//if there is a link to a different schema, set reference
			link = instance._schema.getLink("describedby", instance);
			if (link && instance._schema._uri !== link) {
				instance.setReference("describedby", link);
			}
			
			//if instance has a URI link to itself, update it's own URI
			link = instance._schema.getLink("self", instance);
			if (JSV.typeOf(link) === "string") {
				instance._uri = JSV.formatURI(link);
			}
			
			//if there is a link to the full representation, set reference
			link = instance._schema.getLink("full", instance);
			if (link && instance._uri !== link) {
				instance.setReference("full", link);
			}
			
			//extend schema
			extension = instance.getAttribute("extends");
			if (JSV.isJSONSchema(extension)) {
				extended = JSV.inherits(extension, instance, true);
				instance = instance._env.createSchema(extended, instance._schema, instance._uri);
			}
			
			return instance;
		}
	}, true, "http://json-schema.org/schema#");
	
	HYPERSCHEMA = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA, ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/hyper-schema#",
	
		"properties" : {
			"links" : {
				"type" : "array",
				"items" : {"$ref" : "links#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var links,
						linkSchemaURI = self.getValueOfProperty("items")["$ref"],
						linkSchema = self.getEnvironment().findSchema(linkSchemaURI),
						linkParser = linkSchema && linkSchema.getValueOfProperty("parser");
					arg = JSV.toArray(arg);
					
					if (typeof linkParser === "function") {
						links = JSV.mapArray(instance.getProperties(), function (link) {
							return linkParser(link, linkSchema);
						});
					} else {
						links = JSV.toArray(instance.getValue());
					}
					
					if (arg[0]) {
						links = JSV.filterArray(links, function (link) {
							return link["rel"] === arg[0];
						});
					}
					
					if (arg[1]) {
						links = JSV.mapArray(links, function (link) {
							var instance = arg[1],
								href = link["href"];
							href = href.replace(/\{(.+)\}/g, function (str, p1, offset, s) {
								var value; 
								if (p1 === "-this") {
									value = instance.getValue();
								} else {
									value = instance.getValueOfProperty(p1);
								}
								return value !== undefined ? String(value) : "";
							});
							return href ? JSV.formatURI(instance.resolveURI(href)) : href;
						});
					}
					
					return links;
				}
			},
			
			"fragmentResolution" : {
				"type" : "string",
				"optional" : true,
				"default" : "slash-delimited"
			},
			
			"root" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"readonly" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"pathStart" : {
				"type" : "string",
				"optional" : true,
				"format" : "uri",
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pathStart;
					if (instance.getType() !== "undefined") {
						pathStart = schema.getAttribute("pathStart");
						if (typeof pathStart === "string") {
							//TODO: Find out what pathStart is relative to
							if (instance.getURI().indexOf(pathStart) !== 0) {
								report.addError(instance, schema, "pathStart", "Instance's URI does not start with " + pathStart, pathStart);
							}
						}
					}
				}
			},
			
			"mediaType" : {
				"type" : "string",
				"optional" : true,
				"format" : "media-type"
			},
			
			"alternate" : {
				"type" : "array",
				"items" : {"$ref" : "#"},
				"optional" : true
			}
		},
		
		"links" : [
			{
				"href" : "{$ref}",
				"rel" : "full"
			},
			
			{
				"href" : "{$schema}",
				"rel" : "describedby"
			},
			
			{
				"href" : "{id}",
				"rel" : "self"
			}
		]//,
		
		//not needed as JSV.inherits does the job for us
		//"extends" : {"$ref" : "http://json-schema.org/schema#"}
	}, SCHEMA), true), true, "http://json-schema.org/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/hyper-schema#");
	
	LINKS = ENVIRONMENT.createSchema({
		"$schema" : "http://json-schema.org/hyper-schema#",
		"id" : "http://json-schema.org/links#",
		"type" : "object",
		
		"properties" : {
			"href" : {
				"type" : "string"
			},
			
			"rel" : {
				"type" : "string"
			},
			
			"targetSchema" : {
				"$ref" : "hyper-schema#",
				
				//need this here because parsers are run before links are resolved
				"parser" : HYPERSCHEMA.getAttribute("parser")
			},
			
			"method" : {
				"type" : "string",
				"default" : "GET",
				"optional" : true
			},
			
			"enctype" : {
				"type" : "string",
				"requires" : "method",
				"optional" : true
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "hyper-schema#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment(),
						additionalPropertiesSchemaURI = self.getValueOfProperty("additionalProperties")["$ref"];
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
							});
						}
					}
				}
			}
		},
		
		"parser" : function (instance, self) {
			var selfProperties = self.getProperty("properties");
			if (instance.getType() === "object") {
				return JSV.mapObject(instance.getProperties(), function (property, key) {
					var propertySchema = selfProperties.getProperty(key),
						parser = propertySchema && propertySchema.getValueOfProperty("parser");
					if (typeof parser === "function") {
						return parser(property, propertySchema);
					}
					//else
					return property.getValue();
				});
			}
			return instance.getValue();
		}
	}, HYPERSCHEMA, "http://json-schema.org/links#");
	
	JSV.registerEnvironment("json-schema-draft-02", ENVIRONMENT);
	if (!JSV.getDefaultEnvironmentID() || JSV.getDefaultEnvironmentID() === "json-schema-draft-01") {
		JSV.setDefaultEnvironmentID("json-schema-draft-02");
	}
	
}());
},{"./jsv":5}],4:[function(require,module,exports){
/**
 * json-schema-draft-03 Environment
 * 
 * @fileOverview Implementation of the third revision of the JSON Schema specification draft.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 1.5.1
 * @see http://github.com/garycourt/JSV
 */

/*
 * Copyright 2010 Gary Court. All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 * 
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 * 
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court or the JSON Schema specification.
 */

/*jslint white: true, sub: true, onevar: true, undef: true, eqeqeq: true, newcap: true, immed: true, indent: 4 */
/*global require */

(function () {
	var O = {},
		JSV = require('./jsv').JSV,
		TYPE_VALIDATORS,
		ENVIRONMENT,
		SCHEMA_00_JSON,
		HYPERSCHEMA_00_JSON,
		LINKS_00_JSON, 
		SCHEMA_00,
		HYPERSCHEMA_00,
		LINKS_00, 
		SCHEMA_01_JSON,
		HYPERSCHEMA_01_JSON,
		LINKS_01_JSON, 
		SCHEMA_01,
		HYPERSCHEMA_01,
		LINKS_01, 
		SCHEMA_02_JSON,
		HYPERSCHEMA_02_JSON,
		LINKS_02_JSON,
		SCHEMA_02,
		HYPERSCHEMA_02,
		LINKS_02, 
		SCHEMA_03_JSON,
		HYPERSCHEMA_03_JSON,
		LINKS_03_JSON,
		SCHEMA_03,
		HYPERSCHEMA_03,
		LINKS_03;
	
	TYPE_VALIDATORS = {
		"string" : function (instance, report) {
			return instance.getType() === "string";
		},
		
		"number" : function (instance, report) {
			return instance.getType() === "number";
		},
		
		"integer" : function (instance, report) {
			return instance.getType() === "number" && instance.getValue() % 1 === 0;
		},
		
		"boolean" : function (instance, report) {
			return instance.getType() === "boolean";
		},
		
		"object" : function (instance, report) {
			return instance.getType() === "object";
		},
		
		"array" : function (instance, report) {
			return instance.getType() === "array";
		},
		
		"null" : function (instance, report) {
			return instance.getType() === "null";
		},
		
		"any" : function (instance, report) {
			return true;
		}
	};
	
	ENVIRONMENT = new JSV.Environment();
	ENVIRONMENT.setOption("validateReferences", true);
	ENVIRONMENT.setOption("enforceReferences", false);
	ENVIRONMENT.setOption("strict", false);
	
	//
	// draft-00
	//
	
	SCHEMA_00_JSON = {
		"$schema" : "http://json-schema.org/draft-00/hyper-schema#",
		"id" : "http://json-schema.org/draft-00/schema#",
		"type" : "object",
		
		"properties" : {
			"type" : {
				"type" : ["string", "array"],
				"items" : {
					"type" : ["string", {"$ref" : "#"}]
				},
				"optional" : true,
				"uniqueItems" : true,
				"default" : "any",
				
				"parser" : function (instance, self) {
					var parser;
					
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(
							instance, 
							self.getEnvironment().findSchema(self.resolveURI("#"))
						);
					} else if (instance.getType() === "array") {
						parser = self.getValueOfProperty("parser");
						return JSV.mapArray(instance.getProperties(), function (prop) {
							return parser(prop, self);
						});
					}
					//else
					return "any";
				},
			
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requiredTypes = JSV.toArray(schema.getAttribute("type")),
						x, xl, type, subreport, typeValidators;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && requiredTypes && requiredTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = requiredTypes.length; x < xl; ++x) {
							type = requiredTypes[x];
							if (JSV.isJSONSchema(type)) {
								subreport = JSV.createObject(report);
								subreport.errors = [];
								subreport.validated = JSV.clone(report.validated);
								if (type.validate(instance, subreport, parent, parentSchema, name).errors.length === 0) {
									return true;  //instance matches this schema
								}
							} else {
								if (typeValidators[type] !== O[type] && typeof typeValidators[type] === "function") {
									if (typeValidators[type](instance, report)) {
										return true;  //type is valid
									}
								} else {
									return true;  //unknown types are assumed valid
								}
							}
						}
						
						//if we get to this point, type is invalid
						report.addError(instance, schema, "type", "Instance is not a required type", requiredTypes);
						return false;
					}
					//else, anything is allowed if no type is specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment();
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI("#")));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI("#")));
							});
						}
					}
					//else
					return {};
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var propertySchemas, key;
					//this attribute is for object type instances only
					if (instance.getType() === "object") {
						//for each property defined in the schema
						propertySchemas = schema.getAttribute("properties");
						for (key in propertySchemas) {
							if (propertySchemas[key] !== O[key] && propertySchemas[key]) {
								//ensure that instance property is valid
								propertySchemas[key].validate(instance.getProperty(key), report, instance, schema, key);
							}
						}
					}
				}
			},
			
			"items" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var properties, items, x, xl, itemSchema, additionalProperties;
					
					if (instance.getType() === "array") {
						properties = instance.getProperties();
						items = schema.getAttribute("items");
						additionalProperties = schema.getAttribute("additionalProperties");
						
						if (JSV.typeOf(items) === "array") {
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema = items[x] || additionalProperties;
								if (itemSchema !== false) {
									itemSchema.validate(properties[x], report, instance, schema, x);
								} else {
									report.addError(instance, schema, "additionalProperties", "Additional items are not allowed", itemSchema);
								}
							}
						} else {
							itemSchema = items || additionalProperties;
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema.validate(properties[x], report, instance, schema, x);
							}
						}
					}
				}
			},
			
			"optional" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					if (instance.getType() === "undefined" && !schema.getAttribute("optional")) {
						report.addError(instance, schema, "optional", "Property is required", false);
					}
				},
				
				"validationRequired" : true
			},
			
			"additionalProperties" : {
				"type" : [{"$ref" : "#"}, "boolean"],
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "boolean" && instance.getValue() === false) {
						return false;
					}
					//else
					return instance.getEnvironment().createEmptySchema();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var additionalProperties, propertySchemas, properties, key;
					//we only need to check against object types as arrays do their own checking on this property
					if (instance.getType() === "object") {
						additionalProperties = schema.getAttribute("additionalProperties");
						propertySchemas = schema.getAttribute("properties") || {};
						properties = instance.getProperties();
						for (key in properties) {
							if (properties[key] !== O[key] && properties[key] && propertySchemas[key] === O[key]) {
								if (JSV.isJSONSchema(additionalProperties)) {
									additionalProperties.validate(properties[key], report, instance, schema, key);
								} else if (additionalProperties === false) {
									report.addError(instance, schema, "additionalProperties", "Additional properties are not allowed", additionalProperties);
								}
							}
						}
					}
				}
			},
			
			"requires" : {
				"type" : ["string", {"$ref" : "#"}],
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					} else if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var requires;
					if (instance.getType() !== "undefined" && parent && parent.getType() !== "undefined") {
						requires = schema.getAttribute("requires");
						if (typeof requires === "string") {
							if (parent.getProperty(requires).getType() === "undefined") {
								report.addError(instance, schema, "requires", 'Property requires sibling property "' + requires + '"', requires);
							}
						} else if (JSV.isJSONSchema(requires)) {
							requires.validate(parent, report);  //WATCH: A "requires" schema does not support the "requires" attribute
						}
					}
				}
			},
			
			"minimum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minimum, minimumCanEqual;
					if (instance.getType() === "number") {
						minimum = schema.getAttribute("minimum");
						minimumCanEqual = schema.getAttribute("minimumCanEqual");
						if (typeof minimum === "number" && (instance.getValue() < minimum || (minimumCanEqual === false && instance.getValue() === minimum))) {
							report.addError(instance, schema, "minimum", "Number is less than the required minimum value", minimum);
						}
					}
				}
			},
			
			"maximum" : {
				"type" : "number",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maximum, maximumCanEqual;
					if (instance.getType() === "number") {
						maximum = schema.getAttribute("maximum");
						maximumCanEqual = schema.getAttribute("maximumCanEqual");
						if (typeof maximum === "number" && (instance.getValue() > maximum || (maximumCanEqual === false && instance.getValue() === maximum))) {
							report.addError(instance, schema, "maximum", "Number is greater than the required maximum value", maximum);
						}
					}
				}
			},
			
			"minimumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "minimum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"maximumCanEqual" : {
				"type" : "boolean",
				"optional" : true,
				"requires" : "maximum",
				"default" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "boolean") {
						return instance.getValue();
					}
					//else
					return true;
				}
			},
			
			"minItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minItems;
					if (instance.getType() === "array") {
						minItems = schema.getAttribute("minItems");
						if (typeof minItems === "number" && instance.getProperties().length < minItems) {
							report.addError(instance, schema, "minItems", "The number of items is less than the required minimum", minItems);
						}
					}
				}
			},
			
			"maxItems" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxItems;
					if (instance.getType() === "array") {
						maxItems = schema.getAttribute("maxItems");
						if (typeof maxItems === "number" && instance.getProperties().length > maxItems) {
							report.addError(instance, schema, "maxItems", "The number of items is greater than the required maximum", maxItems);
						}
					}
				}
			},
			
			"pattern" : {
				"type" : "string",
				"optional" : true,
				"format" : "regex",
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pattern;
					try {
						pattern = new RegExp(schema.getAttribute("pattern"));
						if (instance.getType() === "string" && pattern && !pattern.test(instance.getValue())) {
							report.addError(instance, schema, "pattern", "String does not match pattern", pattern.toString());
						}
					} catch (e) {
						report.addError(schema, self, "pattern", "Invalid pattern", schema.getValueOfProperty("pattern"));
					}
				}
			},
			
			"minLength" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
				"default" : 0,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
					//else
					return 0;
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minLength;
					if (instance.getType() === "string") {
						minLength = schema.getAttribute("minLength");
						if (typeof minLength === "number" && instance.getValue().length < minLength) {
							report.addError(instance, schema, "minLength", "String is less than the required minimum length", minLength);
						}
					}
				}
			},
			
			"maxLength" : {
				"type" : "integer",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxLength;
					if (instance.getType() === "string") {
						maxLength = schema.getAttribute("maxLength");
						if (typeof maxLength === "number" && instance.getValue().length > maxLength) {
							report.addError(instance, schema, "maxLength", "String is greater than the required maximum length", maxLength);
						}
					}
				}
			},
			
			"enum" : {
				"type" : "array",
				"optional" : true,
				"minItems" : 1,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var enums, x, xl;
					if (instance.getType() !== "undefined") {
						enums = schema.getAttribute("enum");
						if (enums) {
							for (x = 0, xl = enums.length; x < xl; ++x) {
								if (instance.equals(enums[x])) {
									return true;
								}
							}
							report.addError(instance, schema, "enum", "Instance is not one of the possible values", enums);
						}
					}
				}
			},
			
			"title" : {
				"type" : "string",
				"optional" : true
			},
			
			"description" : {
				"type" : "string",
				"optional" : true
			},
			
			"format" : {
				"type" : "string",
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var format, formatValidators;
					if (instance.getType() === "string") {
						format = schema.getAttribute("format");
						formatValidators = self.getValueOfProperty("formatValidators");
						if (typeof format === "string" && formatValidators[format] !== O[format] && typeof formatValidators[format] === "function" && !formatValidators[format].call(this, instance, report)) {
							report.addError(instance, schema, "format", "String is not in the required format", format);
						}
					}
				},
				
				"formatValidators" : {}
			},
			
			"contentEncoding" : {
				"type" : "string",
				"optional" : true
			},
			
			"default" : {
				"type" : "any",
				"optional" : true
			},
			
			"maxDecimal" : {
				"type" : "integer",
				"optional" : true,
				"minimum" : 0,
								
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maxDecimal, decimals;
					if (instance.getType() === "number") {
						maxDecimal = schema.getAttribute("maxDecimal");
						if (typeof maxDecimal === "number") {
							decimals = instance.getValue().toString(10).split('.')[1];
							if (decimals && decimals.length > maxDecimal) {
								report.addError(instance, schema, "maxDecimal", "The number of decimal places is greater than the allowed maximum", maxDecimal);
							}
						}
					}
				}
			},
			
			"disallow" : {
				"type" : ["string", "array"],
				"items" : {"type" : "string"},
				"optional" : true,
				"uniqueItems" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "string" || instance.getType() === "array") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var disallowedTypes = JSV.toArray(schema.getAttribute("disallow")),
						x, xl, key, typeValidators, subreport;
					
					//for instances that are required to be a certain type
					if (instance.getType() !== "undefined" && disallowedTypes && disallowedTypes.length) {
						typeValidators = self.getValueOfProperty("typeValidators") || {};
						
						//ensure that type matches for at least one of the required types
						for (x = 0, xl = disallowedTypes.length; x < xl; ++x) {
							key = disallowedTypes[x];
							if (JSV.isJSONSchema(key)) {  //this is supported draft-03 and on
								subreport = JSV.createObject(report);
								subreport.errors = [];
								subreport.validated = JSV.clone(report.validated);
								if (key.validate(instance, subreport, parent, parentSchema, name).errors.length === 0) {
									//instance matches this schema
									report.addError(instance, schema, "disallow", "Instance is a disallowed type", disallowedTypes);
									return false;  
								}
							} else if (typeValidators[key] !== O[key] && typeof typeValidators[key] === "function") {
								if (typeValidators[key](instance, report)) {
									report.addError(instance, schema, "disallow", "Instance is a disallowed type", disallowedTypes);
									return false;
								}
							} 
							/*
							else {
								report.addError(instance, schema, "disallow", "Instance may be a disallowed type", disallowedTypes);
								return false;
							}
							*/
						}
						
						//if we get to this point, type is valid
						return true;
					}
					//else, everything is allowed if no disallowed types are specified
					return true;
				},
				
				"typeValidators" : TYPE_VALIDATORS
			},
		
			"extends" : {
				"type" : [{"$ref" : "#"}, "array"],
				"items" : {"$ref" : "#"},
				"optional" : true,
				"default" : {},
				
				"parser" : function (instance, self) {
					if (instance.getType() === "object") {
						return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
					} else if (instance.getType() === "array") {
						return JSV.mapArray(instance.getProperties(), function (instance) {
							return instance.getEnvironment().createSchema(instance, self.getEnvironment().findSchema(self.resolveURI("#")));
						});
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var extensions = schema.getAttribute("extends"), x, xl;
					if (extensions) {
						if (JSV.isJSONSchema(extensions)) {
							extensions.validate(instance, report, parent, parentSchema, name);
						} else if (JSV.typeOf(extensions) === "array") {
							for (x = 0, xl = extensions.length; x < xl; ++x) {
								extensions[x].validate(instance, report, parent, parentSchema, name);
							}
						}
					}
				}
			}
		},
		
		"optional" : true,
		"default" : {},
		"fragmentResolution" : "dot-delimited",
		
		"parser" : function (instance, self) {
			if (instance.getType() === "object") {
				return instance.getEnvironment().createSchema(instance, self);
			}
		},
		
		"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
			var propNames = schema.getPropertyNames(), 
				x, xl,
				attributeSchemas = self.getAttribute("properties"),
				strict = instance.getEnvironment().getOption("strict"),
				validator;
			
			for (x in attributeSchemas) {
				if (attributeSchemas[x] !== O[x]) {
					if (attributeSchemas[x].getValueOfProperty("validationRequired")) {
						JSV.pushUnique(propNames, x);
					}
					if (strict && attributeSchemas[x].getValueOfProperty("deprecated")) {
						JSV.popFirst(propNames, x);
					}
				}
			}
			
			for (x = 0, xl = propNames.length; x < xl; ++x) {
				if (attributeSchemas[propNames[x]] !== O[propNames[x]]) {
					validator = attributeSchemas[propNames[x]].getValueOfProperty("validator");
					if (typeof validator === "function") {
						validator(instance, schema, attributeSchemas[propNames[x]], report, parent, parentSchema, name);
					}
				}
			}
		}
	};
	
	HYPERSCHEMA_00_JSON = {
		"$schema" : "http://json-schema.org/draft-00/hyper-schema#",
		"id" : "http://json-schema.org/draft-00/hyper-schema#",
	
		"properties" : {
			"links" : {
				"type" : "array",
				"items" : {"$ref" : "links#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var links,
						linkSchemaURI = self.getValueOfProperty("items")["$ref"],
						linkSchema = self.getEnvironment().findSchema(linkSchemaURI),
						linkParser = linkSchema && linkSchema.getValueOfProperty("parser"),
						selfReferenceVariable;
					arg = JSV.toArray(arg);
					
					if (typeof linkParser === "function") {
						links = JSV.mapArray(instance.getProperties(), function (link) {
							return linkParser(link, linkSchema);
						});
					} else {
						links = JSV.toArray(instance.getValue());
					}
					
					if (arg[0]) {
						links = JSV.filterArray(links, function (link) {
							return link["rel"] === arg[0];
						});
					}
					
					if (arg[1]) {
						selfReferenceVariable = self.getValueOfProperty("selfReferenceVariable");
						links = JSV.mapArray(links, function (link) {
							var instance = arg[1],
								href = link["href"];
							href = href.replace(/\{(.+)\}/g, function (str, p1, offset, s) {
								var value; 
								if (p1 === selfReferenceVariable) {
									value = instance.getValue();
								} else {
									value = instance.getValueOfProperty(p1);
								}
								return value !== undefined ? String(value) : "";
							});
							return href ? JSV.formatURI(instance.resolveURI(href)) : href;
						});
					}
					
					return links;
				},
				
				"selfReferenceVariable" : "-this"
			},
			
			"fragmentResolution" : {
				"type" : "string",
				"optional" : true,
				"default" : "dot-delimited"
			},
			
			"root" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"readonly" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false
			},
			
			"pathStart" : {
				"type" : "string",
				"optional" : true,
				"format" : "uri",
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var pathStart;
					if (instance.getType() !== "undefined") {
						pathStart = schema.getAttribute("pathStart");
						if (typeof pathStart === "string") {
							//TODO: Find out what pathStart is relative to
							if (instance.getURI().indexOf(pathStart) !== 0) {
								report.addError(instance, schema, "pathStart", "Instance's URI does not start with " + pathStart, pathStart);
							}
						}
					}
				}
			},
			
			"mediaType" : {
				"type" : "string",
				"optional" : true,
				"format" : "media-type"
			},
			
			"alternate" : {
				"type" : "array",
				"items" : {"$ref" : "#"},
				"optional" : true
			}
		},
		
		"links" : [
			{
				"href" : "{$ref}",
				"rel" : "full"
			},
			
			{
				"href" : "{$schema}",
				"rel" : "describedby"
			},
			
			{
				"href" : "{id}",
				"rel" : "self"
			}
		],
				
		"initializer" : function (instance) {
			var link, extension, extended;
			
			//if there is a link to a different schema, set reference
			link = instance._schema.getLink("describedby", instance);
			if (link && instance._schema._uri !== link) {
				instance.setReference("describedby", link);
			}
			
			//if instance has a URI link to itself, update it's own URI
			link = instance._schema.getLink("self", instance);
			if (JSV.typeOf(link) === "string") {
				instance._uri = JSV.formatURI(link);
			}
			
			//if there is a link to the full representation, set reference
			link = instance._schema.getLink("full", instance);
			if (link && instance._uri !== link) {
				instance.setReference("full", link);
			}
			
			//extend schema
			extension = instance.getAttribute("extends");
			if (JSV.isJSONSchema(extension)) {
				extended = JSV.inherits(extension, instance, true);
				instance = instance._env.createSchema(extended, instance._schema, instance._uri);
			}
			
			return instance;
		}
		
		//not needed as JSV.inherits does the job for us
		//"extends" : {"$ref" : "http://json-schema.org/schema#"}
	};
	
	LINKS_00_JSON = {
		"$schema" : "http://json-schema.org/draft-00/hyper-schema#",
		"id" : "http://json-schema.org/draft-00/links#",
		"type" : "object",
		
		"properties" : {
			"href" : {
				"type" : "string"
			},
			
			"rel" : {
				"type" : "string"
			},
			
			"method" : {
				"type" : "string",
				"default" : "GET",
				"optional" : true
			},
			
			"enctype" : {
				"type" : "string",
				"requires" : "method",
				"optional" : true
			},
			
			"properties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "hyper-schema#"},
				"optional" : true,
				
				"parser" : function (instance, self, arg) {
					var env = instance.getEnvironment(),
						selfEnv = self.getEnvironment(),
						additionalPropertiesSchemaURI = self.getValueOfProperty("additionalProperties")["$ref"];
					if (instance.getType() === "object") {
						if (arg) {
							return env.createSchema(instance.getProperty(arg), selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
						} else {
							return JSV.mapObject(instance.getProperties(), function (instance) {
								return env.createSchema(instance, selfEnv.findSchema(self.resolveURI(additionalPropertiesSchemaURI)));
							});
						}
					}
				}
			}
		},
		
		"parser" : function (instance, self) {
			var selfProperties = self.getProperty("properties");
			if (instance.getType() === "object") {
				return JSV.mapObject(instance.getProperties(), function (property, key) {
					var propertySchema = selfProperties.getProperty(key),
						parser = propertySchema && propertySchema.getValueOfProperty("parser");
					if (typeof parser === "function") {
						return parser(property, propertySchema);
					}
					//else
					return property.getValue();
				});
			}
			return instance.getValue();
		}
	};
	
	ENVIRONMENT.setOption("defaultFragmentDelimiter", ".");
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-00/schema#");  //updated later
	
	SCHEMA_00 = ENVIRONMENT.createSchema(SCHEMA_00_JSON, true, "http://json-schema.org/draft-00/schema#");
	HYPERSCHEMA_00 = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA_00, ENVIRONMENT.createSchema(HYPERSCHEMA_00_JSON, true, "http://json-schema.org/draft-00/hyper-schema#"), true), true, "http://json-schema.org/draft-00/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-00/hyper-schema#");
	
	LINKS_00 = ENVIRONMENT.createSchema(LINKS_00_JSON, HYPERSCHEMA_00, "http://json-schema.org/draft-00/links#");
	
	//
	// draft-01
	//
		
	SCHEMA_01_JSON = JSV.inherits(SCHEMA_00_JSON, {
		"$schema" : "http://json-schema.org/draft-01/hyper-schema#",
		"id" : "http://json-schema.org/draft-01/schema#"
	});
	
	HYPERSCHEMA_01_JSON = JSV.inherits(HYPERSCHEMA_00_JSON, {
		"$schema" : "http://json-schema.org/draft-01/hyper-schema#",
		"id" : "http://json-schema.org/draft-01/hyper-schema#"
	});
	
	LINKS_01_JSON = JSV.inherits(LINKS_00_JSON, {
		"$schema" : "http://json-schema.org/draft-01/hyper-schema#",
		"id" : "http://json-schema.org/draft-01/links#"
	});
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-01/schema#");  //update later
	
	SCHEMA_01 = ENVIRONMENT.createSchema(SCHEMA_01_JSON, true, "http://json-schema.org/draft-01/schema#");
	HYPERSCHEMA_01 = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA_01, ENVIRONMENT.createSchema(HYPERSCHEMA_01_JSON, true, "http://json-schema.org/draft-01/hyper-schema#"), true), true, "http://json-schema.org/draft-01/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-01/hyper-schema#");
	
	LINKS_01 = ENVIRONMENT.createSchema(LINKS_01_JSON, HYPERSCHEMA_01, "http://json-schema.org/draft-01/links#");
	
	//
	// draft-02
	//
	
	SCHEMA_02_JSON = JSV.inherits(SCHEMA_01_JSON, {
		"$schema" : "http://json-schema.org/draft-02/hyper-schema#",
		"id" : "http://json-schema.org/draft-02/schema#",
		
		"properties" : {
			"uniqueItems" : {
				"type" : "boolean",
				"optional" : true,
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var value, x, xl, y, yl;
					if (instance.getType() === "array" && schema.getAttribute("uniqueItems")) {
						value = instance.getProperties();
						for (x = 0, xl = value.length - 1; x < xl; ++x) {
							for (y = x + 1, yl = value.length; y < yl; ++y) {
								if (value[x].equals(value[y])) {
									report.addError(instance, schema, "uniqueItems", "Array can only contain unique items", { x : x, y : y });
								}
							}
						}
					}
				}
			},
			
			"maxDecimal" : {
				"deprecated" : true
			},
			
			"divisibleBy" : {
				"type" : "number",
				"minimum" : 0,
				"minimumCanEqual" : false,
				"optional" : true,
				
				"parser" : function (instance, self) {
					if (instance.getType() === "number") {
						return instance.getValue();
					}
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var divisor, value, digits;
					if (instance.getType() === "number") {
						divisor = schema.getAttribute("divisibleBy");
						if (divisor === 0) {
							report.addError(instance, schema, "divisibleBy", "Nothing is divisible by 0", divisor);
						} else if (divisor !== 1) {
							value = instance.getValue();
							digits = Math.max((value.toString().split(".")[1] || " ").length, (divisor.toString().split(".")[1] || " ").length);
							digits = parseFloat(((value / divisor) % 1).toFixed(digits));  //cut out floating point errors
							if (0 < digits && digits < 1) {
								report.addError(instance, schema, "divisibleBy", "Number is not divisible by " + divisor, divisor);
							}
						}
					}
				}
			}
		},
		
		"fragmentResolution" : "slash-delimited"
	});
	
	HYPERSCHEMA_02_JSON = JSV.inherits(HYPERSCHEMA_01_JSON, {
		"id" : "http://json-schema.org/draft-02/hyper-schema#",
		
		"properties" : {
			"fragmentResolution" : {
				"default" : "slash-delimited"
			}
		}
	});
	
	LINKS_02_JSON = JSV.inherits(LINKS_01_JSON, {
		"$schema" : "http://json-schema.org/draft-02/hyper-schema#",
		"id" : "http://json-schema.org/draft-02/links#",
		
		"properties" : {
			"targetSchema" : {
				"$ref" : "hyper-schema#",
				
				//need this here because parsers are run before links are resolved
				"parser" : HYPERSCHEMA_01.getAttribute("parser")
			}
		}
	});
	
	ENVIRONMENT.setOption("defaultFragmentDelimiter", "/");
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-02/schema#");  //update later
	
	SCHEMA_02 = ENVIRONMENT.createSchema(SCHEMA_02_JSON, true, "http://json-schema.org/draft-02/schema#");
	HYPERSCHEMA_02 = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA_02, ENVIRONMENT.createSchema(HYPERSCHEMA_02_JSON, true, "http://json-schema.org/draft-02/hyper-schema#"), true), true, "http://json-schema.org/draft-02/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-02/hyper-schema#");
	
	LINKS_02 = ENVIRONMENT.createSchema(LINKS_02_JSON, HYPERSCHEMA_02, "http://json-schema.org/draft-02/links#");
	
	//
	// draft-03
	//
	
	function getMatchedPatternProperties(instance, schema, report, self) {
		var matchedProperties = {}, patternProperties, pattern, regexp, properties, key;
		
		if (instance.getType() === "object") {
			patternProperties = schema.getAttribute("patternProperties");
			properties = instance.getProperties();
			for (pattern in patternProperties) {
				if (patternProperties[pattern] !== O[pattern]) {
					regexp = null;
					try {
						regexp = new RegExp(pattern);
					} catch (e) {
						if (report) {
							report.addError(schema, self, "patternProperties", "Invalid pattern", pattern);
						}
					}
					
					if (regexp) {
						for (key in properties) {
							if (properties[key] !== O[key]  && regexp.test(key)) {
								matchedProperties[key] = matchedProperties[key] ? JSV.pushUnique(matchedProperties[key], patternProperties[pattern]) : [ patternProperties[pattern] ];
							}
						}
					}
				}
			}
		}
		
		return matchedProperties;
	}
	
	SCHEMA_03_JSON = JSV.inherits(SCHEMA_02_JSON, {
		"$schema" : "http://json-schema.org/draft-03/schema#",
		"id" : "http://json-schema.org/draft-03/schema#",
		
		"properties" : {
			"patternProperties" : {
				"type" : "object",
				"additionalProperties" : {"$ref" : "#"},
				"default" : {},
				
				"parser" : SCHEMA_02.getValueOfProperty("properties")["properties"]["parser"],
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var matchedProperties, key, x;
					if (instance.getType() === "object") {
						matchedProperties = getMatchedPatternProperties(instance, schema, report, self);
						for (key in matchedProperties) {
							if (matchedProperties[key] !== O[key]) {
								x = matchedProperties[key].length;
								while (x--) {
									matchedProperties[key][x].validate(instance.getProperty(key), report, instance, schema, key);
								}
							}
						}
					}
				}
			},
			
			"additionalProperties" : {
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var additionalProperties, propertySchemas, properties, matchedProperties, key;
					if (instance.getType() === "object") {
						additionalProperties = schema.getAttribute("additionalProperties");
						propertySchemas = schema.getAttribute("properties") || {};
						properties = instance.getProperties();
						matchedProperties = getMatchedPatternProperties(instance, schema);
						for (key in properties) {
							if (properties[key] !== O[key] && properties[key] && propertySchemas[key] === O[key] && matchedProperties[key] === O[key]) {
								if (JSV.isJSONSchema(additionalProperties)) {
									additionalProperties.validate(properties[key], report, instance, schema, key);
								} else if (additionalProperties === false) {
									report.addError(instance, schema, "additionalProperties", "Additional properties are not allowed", additionalProperties);
								}
							}
						}
					}
				}
			},
			
			"items" : {
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var properties, items, x, xl, itemSchema, additionalItems;
					
					if (instance.getType() === "array") {
						properties = instance.getProperties();
						items = schema.getAttribute("items");
						additionalItems = schema.getAttribute("additionalItems");
						
						if (JSV.typeOf(items) === "array") {
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema = items[x] || additionalItems;
								if (itemSchema !== false) {
									itemSchema.validate(properties[x], report, instance, schema, x);
								} else {
									report.addError(instance, schema, "additionalItems", "Additional items are not allowed", itemSchema);
								}
							}
						} else {
							itemSchema = items || additionalItems;
							for (x = 0, xl = properties.length; x < xl; ++x) {
								itemSchema.validate(properties[x], report, instance, schema, x);
							}
						}
					}
				}
			},
			
			"additionalItems" : {
				"type" : [{"$ref" : "#"}, "boolean"],
				"default" : {},
				
				"parser" : SCHEMA_02.getValueOfProperty("properties")["additionalProperties"]["parser"],
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var additionalItems, properties, x, xl;
					//only validate if the "items" attribute is undefined
					if (instance.getType() === "array" && schema.getProperty("items").getType() === "undefined") {
						additionalItems = schema.getAttribute("additionalItems");
						properties = instance.getProperties();
						
						if (additionalItems !== false) {
							for (x = 0, xl = properties.length; x < xl; ++x) {
								additionalItems.validate(properties[x], report, instance, schema, x);
							}
						} else if (properties.length) {
							report.addError(instance, schema, "additionalItems", "Additional items are not allowed", additionalItems);
						}
					}
				}
			},
			
			"optional" : {
				"validationRequired" : false,
				"deprecated" : true
			},
			
			"required" : {
				"type" : "boolean",
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					if (instance.getType() === "undefined" && schema.getAttribute("required")) {
						report.addError(instance, schema, "required", "Property is required", true);
					}
				}
			},
			
			"requires" : {
				"deprecated" : true
			},
			
			"dependencies" : {
				"type" : "object",
				"additionalProperties" : {
					"type" : ["string", "array", {"$ref" : "#"}],
					"items" : {
						"type" : "string"
					}
				},
				"default" : {},
				
				"parser" : function (instance, self, arg) {
					function parseProperty(property) {
						var type = property.getType();
						if (type === "string" || type === "array") {
							return property.getValue();
						} else if (type === "object") {
							return property.getEnvironment().createSchema(property, self.getEnvironment().findSchema(self.resolveURI("#")));
						}
					}
					
					if (instance.getType() === "object") {
						if (arg) {
							return parseProperty(instance.getProperty(arg));
						} else {
							return JSV.mapObject(instance.getProperties(), parseProperty);
						}
					}
					//else
					return {};
				},
				
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var dependencies, key, dependency, type, x, xl;
					if (instance.getType() === "object") {
						dependencies = schema.getAttribute("dependencies");
						for (key in dependencies) {
							if (dependencies[key] !== O[key] && instance.getProperty(key).getType() !== "undefined") {
								dependency = dependencies[key];
								type = JSV.typeOf(dependency);
								if (type === "string") {
									if (instance.getProperty(dependency).getType() === "undefined") {
										report.addError(instance, schema, "dependencies", 'Property "' + key + '" requires sibling property "' + dependency + '"', dependencies);
									}
								} else if (type === "array") {
									for (x = 0, xl = dependency.length; x < xl; ++x) {
										if (instance.getProperty(dependency[x]).getType() === "undefined") {
											report.addError(instance, schema, "dependencies", 'Property "' + key + '" requires sibling property "' + dependency[x] + '"', dependencies);
										}
									}
								} else if (JSV.isJSONSchema(dependency)) {
									dependency.validate(instance, report);
								}
							}
						}
					}
				}
			},
			
			"minimumCanEqual" : {
				"deprecated" : true
			},
			
			"maximumCanEqual" : {
				"deprecated" : true
			},
			
			"exclusiveMinimum" : {
				"type" : "boolean",
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				}
			},
			
			"exclusiveMaximum" : {
				"type" : "boolean",
				"default" : false,
				
				"parser" : function (instance, self) {
					return !!instance.getValue();
				}
			},
			
			"minimum" : {
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var minimum, exclusiveMinimum;
					if (instance.getType() === "number") {
						minimum = schema.getAttribute("minimum");
						exclusiveMinimum = schema.getAttribute("exclusiveMinimum") || (!instance.getEnvironment().getOption("strict") && !schema.getAttribute("minimumCanEqual"));
						if (typeof minimum === "number" && (instance.getValue() < minimum || (exclusiveMinimum === true && instance.getValue() === minimum))) {
							report.addError(instance, schema, "minimum", "Number is less than the required minimum value", minimum);
						}
					}
				}
			},
			
			"maximum" : {
				"validator" : function (instance, schema, self, report, parent, parentSchema, name) {
					var maximum, exclusiveMaximum;
					if (instance.getType() === "number") {
						maximum = schema.getAttribute("maximum");
						exclusiveMaximum = schema.getAttribute("exclusiveMaximum") || (!instance.getEnvironment().getOption("strict") && !schema.getAttribute("maximumCanEqual"));
						if (typeof maximum === "number" && (instance.getValue() > maximum || (exclusiveMaximum === true && instance.getValue() === maximum))) {
							report.addError(instance, schema, "maximum", "Number is greater than the required maximum value", maximum);
						}
					}
				}
			},
			
			"contentEncoding" : {
				"deprecated" : true
			},
			
			"divisibleBy" : {
				"exclusiveMinimum" : true
			},
			
			"disallow" : {
				"items" : {
					"type" : ["string", {"$ref" : "#"}]
				},
				
				"parser" : SCHEMA_02_JSON["properties"]["type"]["parser"]
			},
			
			"id" : {
				"type" : "string",
				"format" : "uri"
			},
			
			"$ref" : {
				"type" : "string",
				"format" : "uri"
			},
			
			"$schema" : {
				"type" : "string",
				"format" : "uri"
			}
		},
		
		"dependencies" : {
			"exclusiveMinimum" : "minimum",
			"exclusiveMaximum" : "maximum"
		},
		
		"initializer" : function (instance) {
			var link, extension, extended,
				schemaLink = instance.getValueOfProperty("$schema"),
				refLink = instance.getValueOfProperty("$ref"),
				idLink = instance.getValueOfProperty("id");
			
			//if there is a link to a different schema, set reference
			if (schemaLink) {
				link = instance.resolveURI(schemaLink);
				instance.setReference("describedby", link);
			}
			
			//if instance has a URI link to itself, update it's own URI
			if (idLink) {
				link = instance.resolveURI(idLink);
				if (JSV.typeOf(link) === "string") {
					instance._uri = JSV.formatURI(link);
				}
			}
			
			//if there is a link to the full representation, set reference
			if (refLink) {
				link = instance.resolveURI(refLink);
				instance.setReference("full", link);
			}
			
			//extend schema
			extension = instance.getAttribute("extends");
			if (JSV.isJSONSchema(extension)) {
				extended = JSV.inherits(extension, instance, true);
				instance = instance._env.createSchema(extended, instance._schema, instance._uri);
			}
			
			return instance;
		}
	});
	
	HYPERSCHEMA_03_JSON = JSV.inherits(HYPERSCHEMA_02_JSON, {
		"$schema" : "http://json-schema.org/draft-03/hyper-schema#",
		"id" : "http://json-schema.org/draft-03/hyper-schema#",
		
		"properties" : {
			"links" : {
				"selfReferenceVariable" : "@"
			},
			
			"root" : {
				"deprecated" : true
			},
			
			"contentEncoding" : {
				"deprecated" : false  //moved from core to hyper
			},
			
			"alternate" : {
				"deprecated" : true
			}
		}
	});
	
	LINKS_03_JSON = JSV.inherits(LINKS_02_JSON, {
		"$schema" : "http://json-schema.org/draft-03/hyper-schema#",
		"id" : "http://json-schema.org/draft-03/links#",
		
		"properties" : {
			"href" : {
				"required" : true,
				"format" : "link-description-object-template"
			},
			
			"rel" : {
				"required" : true
			},
			
			"properties" : {
				"deprecated" : true
			},
			
			"schema" : {"$ref" : "http://json-schema.org/draft-03/hyper-schema#"}
		}
	});
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-03/schema#");  //update later
	
	SCHEMA_03 = ENVIRONMENT.createSchema(SCHEMA_03_JSON, true, "http://json-schema.org/draft-03/schema#");
	HYPERSCHEMA_03 = ENVIRONMENT.createSchema(JSV.inherits(SCHEMA_03, ENVIRONMENT.createSchema(HYPERSCHEMA_03_JSON, true, "http://json-schema.org/draft-03/hyper-schema#"), true), true, "http://json-schema.org/draft-03/hyper-schema#");
	
	ENVIRONMENT.setOption("defaultSchemaURI", "http://json-schema.org/draft-03/hyper-schema#");
	
	LINKS_03 = ENVIRONMENT.createSchema(LINKS_03_JSON, true, "http://json-schema.org/draft-03/links#");
	
	ENVIRONMENT.setOption("latestJSONSchemaSchemaURI", "http://json-schema.org/draft-03/schema#");
	ENVIRONMENT.setOption("latestJSONSchemaHyperSchemaURI", "http://json-schema.org/draft-03/hyper-schema#");
	ENVIRONMENT.setOption("latestJSONSchemaLinksURI", "http://json-schema.org/draft-03/links#");
	
	//
	//Latest JSON Schema
	//
	
	//Hack, but WAY faster than instantiating a new schema
	ENVIRONMENT._schemas["http://json-schema.org/schema#"] = SCHEMA_03;
	ENVIRONMENT._schemas["http://json-schema.org/hyper-schema#"] = HYPERSCHEMA_03;
	ENVIRONMENT._schemas["http://json-schema.org/links#"] = LINKS_03;
	
	//
	//register environment
	//
	
	JSV.registerEnvironment("json-schema-draft-03", ENVIRONMENT);
	if (!JSV.getDefaultEnvironmentID() || JSV.getDefaultEnvironmentID() === "json-schema-draft-01" || JSV.getDefaultEnvironmentID() === "json-schema-draft-02") {
		JSV.setDefaultEnvironmentID("json-schema-draft-03");
	}
	
}());
},{"./jsv":5}],5:[function(require,module,exports){
/**
 * JSV: JSON Schema Validator
 * 
 * @fileOverview A JavaScript implementation of a extendable, fully compliant JSON Schema validator.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 4.0.2
 * @see http://github.com/garycourt/JSV
 */

/*
 * Copyright 2010 Gary Court. All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 * 
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 * 
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court or the JSON Schema specification.
 */

/*jslint white: true, sub: true, onevar: true, undef: true, eqeqeq: true, newcap: true, immed: true, indent: 4 */

var exports = exports || this,
	require = require || function () {
		return exports;
	};

(function () {
	
	var URI = require("./uri/uri").URI,
		O = {},
		I2H = "0123456789abcdef".split(""),
		mapArray, filterArray, searchArray,
		
		JSV;
	
	//
	// Utility functions
	//
	
	function typeOf(o) {
		return o === undefined ? "undefined" : (o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase());
	}
	
	/** @inner */
	function F() {}
	
	function createObject(proto) {
		F.prototype = proto || {};
		return new F();
	}
	
	function mapObject(obj, func, scope) {
		var newObj = {}, key;
		for (key in obj) {
			if (obj[key] !== O[key]) {
				newObj[key] = func.call(scope, obj[key], key, obj);
			}
		}
		return newObj;
	}
	
	/** @ignore */
	mapArray = function (arr, func, scope) {
		var x = 0, xl = arr.length, newArr = new Array(xl);
		for (; x < xl; ++x) {
			newArr[x] = func.call(scope, arr[x], x, arr);
		}
		return newArr;
	};
		
	if (Array.prototype.map) {
		/** @ignore */
		mapArray = function (arr, func, scope) {
			return Array.prototype.map.call(arr, func, scope);
		};
	}
	
	/** @ignore */
	filterArray = function (arr, func, scope) {
		var x = 0, xl = arr.length, newArr = [];
		for (; x < xl; ++x) {
			if (func.call(scope, arr[x], x, arr)) {
				newArr[newArr.length] = arr[x];
			}
		}
		return newArr;
	};
	
	if (Array.prototype.filter) {
		/** @ignore */
		filterArray = function (arr, func, scope) {
			return Array.prototype.filter.call(arr, func, scope);
		};
	}
	
	/** @ignore */
	searchArray = function (arr, o) {
		var x = 0, xl = arr.length;
		for (; x < xl; ++x) {
			if (arr[x] === o) {
				return x;
			}
		}
		return -1;
	};
	
	if (Array.prototype.indexOf) {
		/** @ignore */
		searchArray = function (arr, o) {
			return Array.prototype.indexOf.call(arr, o);
		};
	}
	
	function toArray(o) {
		return o !== undefined && o !== null ? (o instanceof Array && !o.callee ? o : (typeof o.length !== "number" || o.split || o.setInterval || o.call ? [ o ] : Array.prototype.slice.call(o))) : [];
	}
	
	function keys(o) {
		var result = [], key;
		
		switch (typeOf(o)) {
		case "object":
			for (key in o) {
				if (o[key] !== O[key]) {
					result[result.length] = key;
				}
			}
			break;
		case "array":
			for (key = o.length - 1; key >= 0; --key) {
				result[key] = key;
			}
			break;
		}
		
		return result;
	}
	
	function pushUnique(arr, o) {
		if (searchArray(arr, o) === -1) {
			arr.push(o);
		}
		return arr;
	}
	
	function popFirst(arr, o) {
		var index = searchArray(arr, o);
		if (index > -1) {
			arr.splice(index, 1);
		}
		return arr;
	}
	
	function randomUUID() {
		return [
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			"-",
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			"-4",  //set 4 high bits of time_high field to version
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			"-",
			I2H[(Math.floor(Math.random() * 0x10) & 0x3) | 0x8],  //specify 2 high bits of clock sequence
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			"-",
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)],
			I2H[Math.floor(Math.random() * 0x10)]
		].join("");
	}
	
	function escapeURIComponent(str) {
		return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A');
	}
	
	function formatURI(uri) {
		if (typeof uri === "string" && uri.indexOf("#") === -1) {
			uri += "#";
		}
		return uri;
	}
	
	function stripInstances(o) {
		if (o instanceof JSONInstance) {
			return o.getURI();
		}
		
		switch (typeOf(o)) {
		case "undefined":
		case "null":
		case "boolean":
		case "number":
		case "string":
			return o;  //do nothing
		
		case "object":
			return mapObject(o, stripInstances);
		
		case "array":
			return mapArray(o, stripInstances);
		
		default:
			return o.toString();
		}
	}
	
	/**
	 * The exception that is thrown when a schema fails to be created.
	 * 
	 * @name InitializationError
	 * @class
	 * @param {JSONInstance|String} instance The instance (or instance URI) that is invalid
	 * @param {JSONSchema|String} schema The schema (or schema URI) that was validating the instance
	 * @param {String} attr The attribute that failed to validated
	 * @param {String} message A user-friendly message on why the schema attribute failed to validate the instance
	 * @param {Any} details The value of the schema attribute
	 */
	
	function InitializationError(instance, schema, attr, message, details) {
		Error.call(this, message);
		
		this.uri = instance instanceof JSONInstance ? instance.getURI() : instance;
		this.schemaUri = schema instanceof JSONInstance ? schema.getURI() : schema;
		this.attribute = attr;
		this.message = message;
		this.description = message;  //IE
		this.details = details;
	}
	
	InitializationError.prototype = new Error();
	InitializationError.prototype.constructor = InitializationError;
	InitializationError.prototype.name = "InitializationError";
	
	/**
	 * Defines an error, found by a schema, with an instance.
	 * This class can only be instantiated by {@link Report#addError}. 
	 * 
	 * @name ValidationError
	 * @class
	 * @see Report#addError
	 */
	
	/**
	 * The URI of the instance that has the error.
	 * 
	 * @name ValidationError.prototype.uri
	 * @type String
	 */
	
	/**
	 * The URI of the schema that generated the error.
	 * 
	 * @name ValidationError.prototype.schemaUri
	 * @type String
	 */
	
	/**
	 * The name of the schema attribute that generated the error.
	 * 
	 * @name ValidationError.prototype.attribute
	 * @type String
	 */
	
	/**
	 * An user-friendly (English) message about what failed to validate.
	 * 
	 * @name ValidationError.prototype.message
	 * @type String
	 */
	
	/**
	 * The value of the schema attribute that generated the error.
	 * 
	 * @name ValidationError.prototype.details
	 * @type Any
	 */
	
	/**
	 * Reports are returned from validation methods to describe the result of a validation.
	 * 
	 * @name Report
	 * @class
	 * @see JSONSchema#validate
	 * @see Environment#validate
	 */
	
	function Report() {
		/**
		 * An array of {@link ValidationError} objects that define all the errors generated by the schema against the instance.
		 * 
		 * @name Report.prototype.errors
		 * @type Array
		 * @see Report#addError
		 */
		this.errors = [];
		
		/**
		 * A hash table of every instance and what schemas were validated against it.
		 * <p>
		 * The key of each item in the table is the URI of the instance that was validated.
		 * The value of this key is an array of strings of URIs of the schema that validated it.
		 * </p>
		 * 
		 * @name Report.prototype.validated
		 * @type Object
		 * @see Report#registerValidation
		 * @see Report#isValidatedBy
		 */
		this.validated = {};
		
		/**
		 * If the report is generated by {@link Environment#validate}, this field is the generated instance.
		 * 
		 * @name Report.prototype.instance
		 * @type JSONInstance
		 * @see Environment#validate
		 */
		
		/**
		 * If the report is generated by {@link Environment#validate}, this field is the generated schema.
		 * 
		 * @name Report.prototype.schema
		 * @type JSONSchema
		 * @see Environment#validate
		 */
		 
		/**
		 * If the report is generated by {@link Environment#validate}, this field is the schema's schema.
		 * This value is the same as calling <code>schema.getSchema()</code>.
		 * 
		 * @name Report.prototype.schemaSchema
		 * @type JSONSchema
		 * @see Environment#validate
		 * @see JSONSchema#getSchema
		 */
	}
	
	/**
	 * Adds a {@link ValidationError} object to the <a href="#errors"><code>errors</code></a> field.
	 * 
	 * @param {JSONInstance|String} instance The instance (or instance URI) that is invalid
	 * @param {JSONSchema|String} schema The schema (or schema URI) that was validating the instance
	 * @param {String} attr The attribute that failed to validated
	 * @param {String} message A user-friendly message on why the schema attribute failed to validate the instance
	 * @param {Any} details The value of the schema attribute
	 */
	
	Report.prototype.addError = function (instance, schema, attr, message, details) {
		this.errors.push({
			uri : instance instanceof JSONInstance ? instance.getURI() : instance,
			schemaUri : schema instanceof JSONInstance ? schema.getURI() : schema,
			attribute : attr,
			message : message,
			details : stripInstances(details)
		});
	};
	
	/**
	 * Registers that the provided instance URI has been validated by the provided schema URI. 
	 * This is recorded in the <a href="#validated"><code>validated</code></a> field.
	 * 
	 * @param {String} uri The URI of the instance that was validated
	 * @param {String} schemaUri The URI of the schema that validated the instance
	 */
	
	Report.prototype.registerValidation = function (uri, schemaUri) {
		if (!this.validated[uri]) {
			this.validated[uri] = [ schemaUri ];
		} else {
			this.validated[uri].push(schemaUri);
		}
	};
	
	/**
	 * Returns if an instance with the provided URI has been validated by the schema with the provided URI. 
	 * 
	 * @param {String} uri The URI of the instance
	 * @param {String} schemaUri The URI of a schema
	 * @returns {Boolean} If the instance has been validated by the schema.
	 */
	
	Report.prototype.isValidatedBy = function (uri, schemaUri) {
		return !!this.validated[uri] && searchArray(this.validated[uri], schemaUri) !== -1;
	};
	
	/**
	 * A wrapper class for binding an Environment, URI and helper methods to an instance. 
	 * This class is most commonly instantiated with {@link Environment#createInstance}.
	 * 
	 * @name JSONInstance
	 * @class
	 * @param {Environment} env The environment this instance belongs to
	 * @param {JSONInstance|Any} json The value of the instance
	 * @param {String} [uri] The URI of the instance. If undefined, the URI will be a randomly generated UUID. 
	 * @param {String} [fd] The fragment delimiter for properties. If undefined, uses the environment default.
	 */
	
	function JSONInstance(env, json, uri, fd) {
		if (json instanceof JSONInstance) {
			if (typeof fd !== "string") {
				fd = json._fd;
			}
			if (typeof uri !== "string") {
				uri = json._uri;
			}
			json = json._value;
		}
		
		if (typeof uri !== "string") {
			uri = "urn:uuid:" + randomUUID() + "#";
		} else if (uri.indexOf(":") === -1) {
			uri = formatURI(URI.resolve("urn:uuid:" + randomUUID() + "#", uri));
		}
		
		this._env = env;
		this._value = json;
		this._uri = uri;
		this._fd = fd || this._env._options["defaultFragmentDelimiter"];
	}
	
	/**
	 * Returns the environment the instance is bound to.
	 * 
	 * @returns {Environment} The environment of the instance
	 */
	
	JSONInstance.prototype.getEnvironment = function () {
		return this._env;
	};
	
	/**
	 * Returns the name of the type of the instance.
	 * 
	 * @returns {String} The name of the type of the instance
	 */
	
	JSONInstance.prototype.getType = function () {
		return typeOf(this._value);
	};
	
	/**
	 * Returns the JSON value of the instance.
	 * 
	 * @returns {Any} The actual JavaScript value of the instance
	 */
	
	JSONInstance.prototype.getValue = function () {
		return this._value;
	};
	
	/**
	 * Returns the URI of the instance.
	 * 
	 * @returns {String} The URI of the instance
	 */
	
	JSONInstance.prototype.getURI = function () {
		return this._uri;
	};
	
	/**
	 * Returns a resolved URI of a provided relative URI against the URI of the instance.
	 * 
	 * @param {String} uri The relative URI to resolve
	 * @returns {String} The resolved URI
	 */
	
	JSONInstance.prototype.resolveURI = function (uri) {
		return formatURI(URI.resolve(this._uri, uri));
	};
	
	/**
	 * Returns an array of the names of all the properties.
	 * 
	 * @returns {Array} An array of strings which are the names of all the properties
	 */
	
	JSONInstance.prototype.getPropertyNames = function () {
		return keys(this._value);
	};
	
	/**
	 * Returns a {@link JSONInstance} of the value of the provided property name. 
	 * 
	 * @param {String} key The name of the property to fetch
	 * @returns {JSONInstance} The instance of the property value
	 */
	
	JSONInstance.prototype.getProperty = function (key) {
		var value = this._value ? this._value[key] : undefined;
		if (value instanceof JSONInstance) {
			return value;
		}
		//else
		return new JSONInstance(this._env, value, this._uri + this._fd + escapeURIComponent(key), this._fd);
	};
	
	/**
	 * Returns all the property instances of the target instance.
	 * <p>
	 * If the target instance is an Object, then the method will return a hash table of {@link JSONInstance}s of all the properties. 
	 * If the target instance is an Array, then the method will return an array of {@link JSONInstance}s of all the items.
	 * </p> 
	 * 
	 * @returns {Object|Array|undefined} The list of instances for all the properties
	 */
	
	JSONInstance.prototype.getProperties = function () {
		var type = typeOf(this._value),
			self = this;
		
		if (type === "object") {
			return mapObject(this._value, function (value, key) {
				if (value instanceof JSONInstance) {
					return value;
				}
				return new JSONInstance(self._env, value, self._uri + self._fd + escapeURIComponent(key), self._fd);
			});
		} else if (type === "array") {
			return mapArray(this._value, function (value, key) {
				if (value instanceof JSONInstance) {
					return value;
				}
				return new JSONInstance(self._env, value, self._uri + self._fd + escapeURIComponent(key), self._fd);
			});
		}
	};
	
	/**
	 * Returns the JSON value of the provided property name. 
	 * This method is a faster version of calling <code>instance.getProperty(key).getValue()</code>.
	 * 
	 * @param {String} key The name of the property
	 * @returns {Any} The JavaScript value of the instance
	 * @see JSONInstance#getProperty
	 * @see JSONInstance#getValue
	 */
	
	JSONInstance.prototype.getValueOfProperty = function (key) {
		if (this._value) {
			if (this._value[key] instanceof JSONInstance) {
				return this._value[key]._value;
			}
			return this._value[key];
		}
	};
	
	/**
	 * Return if the provided value is the same as the value of the instance.
	 * 
	 * @param {JSONInstance|Any} instance The value to compare
	 * @returns {Boolean} If both the instance and the value match
	 */
	
	JSONInstance.prototype.equals = function (instance) {
		if (instance instanceof JSONInstance) {
			return this._value === instance._value;
		}
		//else
		return this._value === instance;
	};
	
	/**
	 * Warning: Not a generic clone function
	 * Produces a JSV acceptable clone
	 */
	
	function clone(obj, deep) {
		var newObj, x;
		
		if (obj instanceof JSONInstance) {
			obj = obj.getValue();
		}
		
		switch (typeOf(obj)) {
		case "object":
			if (deep) {
				newObj = {};
				for (x in obj) {
					if (obj[x] !== O[x]) {
						newObj[x] = clone(obj[x], deep);
					}
				}
				return newObj;
			} else {
				return createObject(obj);
			}
			break;
		case "array":
			if (deep) {
				newObj = new Array(obj.length);
				x = obj.length;
				while (--x >= 0) {
					newObj[x] = clone(obj[x], deep);
				}
				return newObj;
			} else {
				return Array.prototype.slice.call(obj);
			}
			break;
		default:
			return obj;
		}
	}
	
	/**
	 * This class binds a {@link JSONInstance} with a {@link JSONSchema} to provided context aware methods. 
	 * 
	 * @name JSONSchema
	 * @class
	 * @param {Environment} env The environment this schema belongs to
	 * @param {JSONInstance|Any} json The value of the schema
	 * @param {String} [uri] The URI of the schema. If undefined, the URI will be a randomly generated UUID. 
	 * @param {JSONSchema|Boolean} [schema] The schema to bind to the instance. If <code>undefined</code>, the environment's default schema will be used. If <code>true</code>, the instance's schema will be itself.
	 * @extends JSONInstance
	 */
	
	function JSONSchema(env, json, uri, schema) {
		var fr;
		JSONInstance.call(this, env, json, uri);
		
		if (schema === true) {
			this._schema = this;
		} else if (json instanceof JSONSchema && !(schema instanceof JSONSchema)) {
			this._schema = json._schema;  //TODO: Make sure cross environments don't mess everything up
		} else {
			this._schema = schema instanceof JSONSchema ? schema : this._env.getDefaultSchema() || this._env.createEmptySchema();
		}
		
		//determine fragment delimiter from schema
		fr = this._schema.getValueOfProperty("fragmentResolution");
		if (fr === "dot-delimited") {
			this._fd = ".";
		} else if (fr === "slash-delimited") {
			this._fd = "/";
		}
		
		return this.rebuild();  //this works even when called with "new"
	}
	
	JSONSchema.prototype = createObject(JSONInstance.prototype);
	
	/**
	 * Returns the schema of the schema.
	 * 
	 * @returns {JSONSchema} The schema of the schema
	 */
	
	JSONSchema.prototype.getSchema = function () {
		var uri = this._refs && this._refs["describedby"],
			newSchema;
		
		if (uri) {
			newSchema = uri && this._env.findSchema(uri);
			
			if (newSchema) {
				if (!newSchema.equals(this._schema)) {
					this._schema = newSchema;
					this.rebuild();  //if the schema has changed, the context has changed - so everything must be rebuilt
				}
			} else if (this._env._options["enforceReferences"]) {
				throw new InitializationError(this, this._schema, "{describedby}", "Unknown schema reference", uri);
			}
		}
		
		return this._schema;
	};
	
	/**
	 * Returns the value of the provided attribute name.
	 * <p>
	 * This method is different from {@link JSONInstance#getProperty} as the named property 
	 * is converted using a parser defined by the schema's schema before being returned. This
	 * makes the return value of this method attribute dependent.
	 * </p>
	 * 
	 * @param {String} key The name of the attribute
	 * @param {Any} [arg] Some attribute parsers accept special arguments for returning resolved values. This is attribute dependent.
	 * @returns {JSONSchema|Any} The value of the attribute
	 */
	
	JSONSchema.prototype.getAttribute = function (key, arg) {
		var schemaProperty, parser, property, result,
			schema = this.getSchema();  //we do this here to make sure the "describedby" reference has not changed, and that the attribute cache is up-to-date
		
		if (!arg && this._attributes && this._attributes.hasOwnProperty(key)) {
			return this._attributes[key];
		}
		
		schemaProperty = schema.getProperty("properties").getProperty(key);
		parser = schemaProperty.getValueOfProperty("parser");
		property = this.getProperty(key);
		if (typeof parser === "function") {
			result = parser(property, schemaProperty, arg);
			if (!arg && this._attributes) {
				this._attributes[key] = result;
			}
			return result;
		}
		//else
		return property.getValue();
	};
	
	/**
	 * Returns all the attributes of the schema.
	 * 
	 * @returns {Object} A map of all parsed attribute values
	 */
	
	JSONSchema.prototype.getAttributes = function () {
		var properties, schemaProperties, key, schemaProperty, parser,
			schema = this.getSchema();  //we do this here to make sure the "describedby" reference has not changed, and that the attribute cache is up-to-date
		
		if (!this._attributes && this.getType() === "object") {
			properties = this.getProperties();
			schemaProperties = schema.getProperty("properties");
			this._attributes = {};
			for (key in properties) {
				if (properties[key] !== O[key]) {
					schemaProperty = schemaProperties && schemaProperties.getProperty(key);
					parser = schemaProperty && schemaProperty.getValueOfProperty("parser");
					if (typeof parser === "function") {
						this._attributes[key] = parser(properties[key], schemaProperty);
					} else {
						this._attributes[key] = properties[key].getValue();
					}
				}
			}
		}
		
		return clone(this._attributes, false);
	};
	
	/**
	 * Convenience method for retrieving a link or link object from a schema. 
	 * This method is the same as calling <code>schema.getAttribute("links", [rel, instance])[0];</code>.
	 * 
	 * @param {String} rel The link relationship
	 * @param {JSONInstance} [instance] The instance to resolve any URIs from
	 * @returns {String|Object|undefined} If <code>instance</code> is provided, a string containing the resolve URI of the link is returned.
	 *   If <code>instance</code> is not provided, a link object is returned with details of the link.
	 *   If no link with the provided relationship exists, <code>undefined</code> is returned.
	 * @see JSONSchema#getAttribute
	 */
	
	JSONSchema.prototype.getLink = function (rel, instance) {
		var schemaLinks = this.getAttribute("links", [rel, instance]);
		if (schemaLinks && schemaLinks.length && schemaLinks[schemaLinks.length - 1]) {
			return schemaLinks[schemaLinks.length - 1];
		}
	};
	
	/**
	 * Validates the provided instance against the target schema and returns a {@link Report}.
	 * 
	 * @param {JSONInstance|Any} instance The instance to validate; may be a {@link JSONInstance} or any JavaScript value
	 * @param {Report} [report] A {@link Report} to concatenate the result of the validation to. If <code>undefined</code>, a new {@link Report} is created. 
	 * @param {JSONInstance} [parent] The parent/containing instance of the provided instance
	 * @param {JSONSchema} [parentSchema] The schema of the parent/containing instance
	 * @param {String} [name] The name of the parent object's property that references the instance
	 * @returns {Report} The result of the validation
	 */
	
	JSONSchema.prototype.validate = function (instance, report, parent, parentSchema, name) {
		var schemaSchema = this.getSchema(),
			validator = schemaSchema.getValueOfProperty("validator");
		
		if (!(instance instanceof JSONInstance)) {
			instance = this.getEnvironment().createInstance(instance);
		}
		
		if (!(report instanceof Report)) {
			report = new Report();
		}
		
		if (this._env._options["validateReferences"] && this._refs) {
			if (this._refs["describedby"] && !this._env.findSchema(this._refs["describedby"])) {
				report.addError(this, this._schema, "{describedby}", "Unknown schema reference", this._refs["describedby"]);
			}
			if (this._refs["full"] && !this._env.findSchema(this._refs["full"])) {
				report.addError(this, this._schema, "{full}", "Unknown schema reference", this._refs["full"]);
			}
		}
		
		if (typeof validator === "function" && !report.isValidatedBy(instance.getURI(), this.getURI())) {
			report.registerValidation(instance.getURI(), this.getURI());
			validator(instance, this, schemaSchema, report, parent, parentSchema, name);
		}
		
		return report;
	};
	
	/** @inner */
	function createFullLookupWrapper(func) {
		return /** @inner */ function fullLookupWrapper() {
			var scope = this,
				stack = [],
				uri = scope._refs && scope._refs["full"],
				schema;
			
			while (uri) {
				schema = scope._env.findSchema(uri);
				if (schema) {
					if (schema._value === scope._value) {
						break;
					}
					scope = schema;
					stack.push(uri);
					uri = scope._refs && scope._refs["full"];
					if (stack.indexOf(uri) > -1) {
						break;  //stop infinite loop
					}
				} else if (scope._env._options["enforceReferences"]) {
					throw new InitializationError(scope, scope._schema, "{full}", "Unknown schema reference", uri);
				} else {
					uri = null;
				}
			}
			return func.apply(scope, arguments);
		};
	}
	
	/**
	 * Wraps all JSONInstance methods with a function that resolves the "full" reference.
	 * 
	 * @inner
	 */
	
	(function () {
		var key;
		for (key in JSONSchema.prototype) {
			if (JSONSchema.prototype[key] !== O[key] && typeOf(JSONSchema.prototype[key]) === "function") {
				JSONSchema.prototype[key] = createFullLookupWrapper(JSONSchema.prototype[key]);
			}
		}
	}());
	
	/**
	 * Reinitializes/re-registers/rebuilds the schema.
	 * <br/>
	 * This is used internally, and should only be called when a schema's private variables are modified directly.
	 * 
	 * @private
	 * @return {JSONSchema} The newly rebuilt schema
	 */
	
	JSONSchema.prototype.rebuild = function () {
		var instance = this,
			initializer = instance.getSchema().getValueOfProperty("initializer");
		
		//clear previous built values
		instance._refs = null;
		instance._attributes = null;
		
		if (typeof initializer === "function") {
			instance = initializer(instance);
		}
		
		//register schema
		instance._env._schemas[instance._uri] = instance;
		
		//build & cache the rest of the schema
		instance.getAttributes();
		
		return instance;
	};
	
	/**
	 * Set the provided reference to the given value.
	 * <br/>
	 * References are used for establishing soft-links to other {@link JSONSchema}s.
	 * Currently, the following references are natively supported:
	 * <dl>
	 *   <dt><code>full</code></dt>
	 *   <dd>The value is the URI to the full instance of this instance.</dd>
	 *   <dt><code>describedby</code></dt>
	 *   <dd>The value is the URI to the schema of this instance.</dd>
	 * </dl>
	 * 
	 * @param {String} name The name of the reference
	 * @param {String} uri The URI of the schema to refer to
	 */
	
	JSONSchema.prototype.setReference = function (name, uri) {
		if (!this._refs) {
			this._refs = {};
		}
		this._refs[name] = this.resolveURI(uri);
	};
	
	/**
	 * Returns the value of the provided reference name.
	 * 
	 * @param {String} name The name of the reference
	 * @return {String} The value of the provided reference name
	 */
	
	JSONSchema.prototype.getReference = function (name) {
		return this._refs && this._refs[name];
	};
	
	/**
	 * Merges two schemas/instances together.
	 */
	
	function inherits(base, extra, extension) {
		var baseType = typeOf(base),
			extraType = typeOf(extra),
			child, x;
		
		if (extraType === "undefined") {
			return clone(base, true);
		} else if (baseType === "undefined" || extraType !== baseType) {
			return clone(extra, true);
		} else if (extraType === "object") {
			if (base instanceof JSONSchema) {
				base = base.getAttributes();
			}
			if (extra instanceof JSONSchema) {
				extra = extra.getAttributes();
				if (extra["extends"] && extension && extra["extends"] instanceof JSONSchema) {
					extra["extends"] = [ extra["extends"] ];
				}
			}
			child = clone(base, true);  //this could be optimized as some properties get overwritten
			for (x in extra) {
				if (extra[x] !== O[x]) {
					child[x] = inherits(base[x], extra[x], extension);
				}
			}
			return child;
		} else {
			return clone(extra, true);
		}
	}
	
	/**
	 * An Environment is a sandbox of schemas thats behavior is different from other environments.
	 * 
	 * @name Environment
	 * @class
	 */
	
	function Environment() {
		this._id = randomUUID();
		this._schemas = {};
		this._options = {};
		
		this.createSchema({}, true, "urn:jsv:empty-schema#");
	}
	
	/**
	 * Returns a clone of the target environment.
	 * 
	 * @returns {Environment} A new {@link Environment} that is a exact copy of the target environment 
	 */
	
	Environment.prototype.clone = function () {
		var env = new Environment();
		env._schemas = createObject(this._schemas);
		env._options = createObject(this._options);
		
		return env;
	};
	
	/**
	 * Returns a new {@link JSONInstance} of the provided data.
	 * 
	 * @param {JSONInstance|Any} data The value of the instance
	 * @param {String} [uri] The URI of the instance. If undefined, the URI will be a randomly generated UUID. 
	 * @returns {JSONInstance} A new {@link JSONInstance} from the provided data
	 */
	
	Environment.prototype.createInstance = function (data, uri) {
		uri = formatURI(uri);
		
		if (data instanceof JSONInstance && (!uri || data.getURI() === uri)) {
			return data;
		}

		return new JSONInstance(this, data, uri);
	};
	
	/**
	 * Creates a new {@link JSONSchema} from the provided data, and registers it with the environment. 
	 * 
	 * @param {JSONInstance|Any} data The value of the schema
	 * @param {JSONSchema|Boolean} [schema] The schema to bind to the instance. If <code>undefined</code>, the environment's default schema will be used. If <code>true</code>, the instance's schema will be itself.
	 * @param {String} [uri] The URI of the schema. If undefined, the URI will be a randomly generated UUID. 
	 * @returns {JSONSchema} A new {@link JSONSchema} from the provided data
	 * @throws {InitializationError} If a schema that is not registered with the environment is referenced 
	 */
	
	Environment.prototype.createSchema = function (data, schema, uri) {
		uri = formatURI(uri);
		
		if (data instanceof JSONSchema && (!uri || data._uri === uri) && (!schema || data.getSchema().equals(schema))) {
			return data;
		}
		
		return new JSONSchema(this, data, uri, schema);
	};
	
	/**
	 * Creates an empty schema.
	 * 
	 * @returns {JSONSchema} The empty schema, who's schema is itself.
	 */
	
	Environment.prototype.createEmptySchema = function () {
		return this._schemas["urn:jsv:empty-schema#"];
	};
	
	/**
	 * Returns the schema registered with the provided URI.
	 * 
	 * @param {String} uri The absolute URI of the required schema
	 * @returns {JSONSchema|undefined} The request schema, or <code>undefined</code> if not found
	 */
	
	Environment.prototype.findSchema = function (uri) {
		return this._schemas[formatURI(uri)];
	};
	
	/**
	 * Sets the specified environment option to the specified value.
	 * 
	 * @param {String} name The name of the environment option to set
	 * @param {Any} value The new value of the environment option
	 */
	
	Environment.prototype.setOption = function (name, value) {
		this._options[name] = value;
	};
	
	/**
	 * Returns the specified environment option.
	 * 
	 * @param {String} name The name of the environment option to set
	 * @returns {Any} The value of the environment option
	 */
	
	Environment.prototype.getOption = function (name) {
		return this._options[name];
	};
	
	/**
	 * Sets the default fragment delimiter of the environment.
	 * 
	 * @deprecated Use {@link Environment#setOption} with option "defaultFragmentDelimiter"
	 * @param {String} fd The fragment delimiter character
	 */
	
	Environment.prototype.setDefaultFragmentDelimiter = function (fd) {
		if (typeof fd === "string" && fd.length > 0) {
			this._options["defaultFragmentDelimiter"] = fd;
		}
	};
	
	/**
	 * Returns the default fragment delimiter of the environment.
	 * 
	 * @deprecated Use {@link Environment#getOption} with option "defaultFragmentDelimiter"
	 * @returns {String} The fragment delimiter character
	 */
	
	Environment.prototype.getDefaultFragmentDelimiter = function () {
		return this._options["defaultFragmentDelimiter"];
	};
	
	/**
	 * Sets the URI of the default schema for the environment.
	 * 
	 * @deprecated Use {@link Environment#setOption} with option "defaultSchemaURI"
	 * @param {String} uri The default schema URI
	 */
	
	Environment.prototype.setDefaultSchemaURI = function (uri) {
		if (typeof uri === "string") {
			this._options["defaultSchemaURI"] = formatURI(uri);
		}
	};
	
	/**
	 * Returns the default schema of the environment.
	 * 
	 * @returns {JSONSchema} The default schema
	 */
	
	Environment.prototype.getDefaultSchema = function () {
		return this.findSchema(this._options["defaultSchemaURI"]);
	};
	
	/**
	 * Validates both the provided schema and the provided instance, and returns a {@link Report}. 
	 * If the schema fails to validate, the instance will not be validated.
	 * 
	 * @param {JSONInstance|Any} instanceJSON The {@link JSONInstance} or JavaScript value to validate.
	 * @param {JSONSchema|Any} schemaJSON The {@link JSONSchema} or JavaScript value to use in the validation. This will also be validated againt the schema's schema.
	 * @returns {Report} The result of the validation
	 */
	
	Environment.prototype.validate = function (instanceJSON, schemaJSON) {
		var instance,
			schema,
			schemaSchema,
			report = new Report();
		
		try {
			instance = this.createInstance(instanceJSON);
			report.instance = instance;
		} catch (e) {
			report.addError(e.uri, e.schemaUri, e.attribute, e.message, e.details);
		}
		
		try {
			schema = this.createSchema(schemaJSON);
			report.schema = schema;
			
			schemaSchema = schema.getSchema();
			report.schemaSchema = schemaSchema;
		} catch (f) {
			report.addError(f.uri, f.schemaUri, f.attribute, f.message, f.details);
		}
		
		if (schemaSchema) {
			schemaSchema.validate(schema, report);
		}
			
		if (report.errors.length) {
			return report;
		}
		
		return schema.validate(instance, report);
	};
	
	/**
	 * @private
	 */
	
	Environment.prototype._checkForInvalidInstances = function (stackSize, schemaURI) {
		var result = [],
			stack = [
				[schemaURI, this._schemas[schemaURI]]
			], 
			counter = 0,
			item, uri, instance, properties, key;
		
		while (counter++ < stackSize && stack.length) {
			item = stack.shift();
			uri = item[0];
			instance = item[1];
			
			if (instance instanceof JSONSchema) {
				if (this._schemas[instance._uri] !== instance) {
					result.push("Instance " + uri + " does not match " + instance._uri);
				} else {
					//schema = instance.getSchema();
					//stack.push([uri + "/{schema}", schema]);
					
					properties = instance.getAttributes();
					for (key in properties) {
						if (properties[key] !== O[key]) {
							stack.push([uri + "/" + escapeURIComponent(key), properties[key]]);
						}
					}
				}
			} else if (typeOf(instance) === "object") {
				properties = instance;
				for (key in properties) {
					if (properties.hasOwnProperty(key)) {
						stack.push([uri + "/" + escapeURIComponent(key), properties[key]]);
					}
				}
			} else if (typeOf(instance) === "array") {
				properties = instance;
				for (key = 0; key < properties.length; ++key) {
					stack.push([uri + "/" + escapeURIComponent(key), properties[key]]);
				}
			}
		}
		
		return result.length ? result : counter;
	};
	
	/**
	 * A globaly accessible object that provides the ability to create and manage {@link Environments},
	 * as well as providing utility methods.
	 * 
	 * @namespace
	 */
	
	JSV = {
		_environments : {},
		_defaultEnvironmentID : "",
		
		/**
		 * Returns if the provide value is an instance of {@link JSONInstance}.
		 * 
		 * @param o The value to test
		 * @returns {Boolean} If the provide value is an instance of {@link JSONInstance}
		 */
		
		isJSONInstance : function (o) {
			return o instanceof JSONInstance;
		},
		
		/**
		 * Returns if the provide value is an instance of {@link JSONSchema}.
		 * 
		 * @param o The value to test
		 * @returns {Boolean} If the provide value is an instance of {@link JSONSchema}
		 */
		
		isJSONSchema : function (o) {
			return o instanceof JSONSchema;
		},
		
		/**
		 * Creates and returns a new {@link Environment} that is a clone of the environment registered with the provided ID.
		 * If no environment ID is provided, the default environment is cloned.
		 * 
		 * @param {String} [id] The ID of the environment to clone. If <code>undefined</code>, the default environment ID is used.
		 * @returns {Environment} A newly cloned {@link Environment}
		 * @throws {Error} If there is no environment registered with the provided ID
		 */
		
		createEnvironment : function (id) {
			id = id || this._defaultEnvironmentID;
			
			if (!this._environments[id]) {
				throw new Error("Unknown Environment ID");
			}
			//else
			return this._environments[id].clone();
		},
		
		Environment : Environment,
		
		/**
		 * Registers the provided {@link Environment} with the provided ID.
		 * 
		 * @param {String} id The ID of the environment
		 * @param {Environment} env The environment to register
		 */
		
		registerEnvironment : function (id, env) {
			id = id || (env || 0)._id;
			if (id && !this._environments[id] && env instanceof Environment) {
				env._id = id;
				this._environments[id] = env;
			}
		},
		
		/**
		 * Sets which registered ID is the default environment.
		 * 
		 * @param {String} id The ID of the registered environment that is default
		 * @throws {Error} If there is no registered environment with the provided ID
		 */
		
		setDefaultEnvironmentID : function (id) {
			if (typeof id === "string") {
				if (!this._environments[id]) {
					throw new Error("Unknown Environment ID");
				}
				
				this._defaultEnvironmentID = id;
			}
		},
		
		/**
		 * Returns the ID of the default environment.
		 * 
		 * @returns {String} The ID of the default environment
		 */
		
		getDefaultEnvironmentID : function () {
			return this._defaultEnvironmentID;
		},
		
		//
		// Utility Functions
		//
		
		/**
		 * Returns the name of the type of the provided value.
		 *
		 * @event //utility
		 * @param {Any} o The value to determine the type of
		 * @returns {String} The name of the type of the value
		 */
		typeOf : typeOf,
		
		/**
		 * Return a new object that inherits all of the properties of the provided object.
		 *
		 * @event //utility
		 * @param {Object} proto The prototype of the new object
		 * @returns {Object} A new object that inherits all of the properties of the provided object
		 */
		createObject : createObject,
		
		/**
		 * Returns a new object with each property transformed by the iterator.
		 *
		 * @event //utility
		 * @param {Object} obj The object to transform
		 * @param {Function} iterator A function that returns the new value of the provided property
		 * @param {Object} [scope] The value of <code>this</code> in the iterator
		 * @returns {Object} A new object with each property transformed
		 */
		mapObject : mapObject,
		
		/**
		 * Returns a new array with each item transformed by the iterator.
		 * 
		 * @event //utility
		 * @param {Array} arr The array to transform
		 * @param {Function} iterator A function that returns the new value of the provided item
		 * @param {Object} scope The value of <code>this</code> in the iterator
		 * @returns {Array} A new array with each item transformed
		 */
		mapArray : mapArray,
		
		/**
		 * Returns a new array that only contains the items allowed by the iterator.
		 *
		 * @event //utility
		 * @param {Array} arr The array to filter
		 * @param {Function} iterator The function that returns true if the provided property should be added to the array
		 * @param {Object} scope The value of <code>this</code> within the iterator
		 * @returns {Array} A new array that contains the items allowed by the iterator
		 */
		filterArray : filterArray,
		
		/**
		 * Returns the first index in the array that the provided item is located at.
		 *
		 * @event //utility
		 * @param {Array} arr The array to search
		 * @param {Any} o The item being searched for
		 * @returns {Number} The index of the item in the array, or <code>-1</code> if not found
		 */
		searchArray : searchArray,
			
		/**
		 * Returns an array representation of a value.
		 * <ul>
		 * <li>For array-like objects, the value will be casted as an Array type.</li>
		 * <li>If an array is provided, the function will simply return the same array.</li>
		 * <li>For a null or undefined value, the result will be an empty Array.</li>
		 * <li>For all other values, the value will be the first element in a new Array. </li>
		 * </ul>
		 *
		 * @event //utility
		 * @param {Any} o The value to convert into an array
		 * @returns {Array} The value as an array
		 */
		toArray : toArray,
		
		/**
		 * Returns an array of the names of all properties of an object.
		 * 
		 * @event //utility
		 * @param {Object|Array} o The object in question
		 * @returns {Array} The names of all properties
		 */
		keys : keys,
		
		/**
		 * Mutates the array by pushing the provided value onto the array only if it is not already there.
		 *
		 * @event //utility
		 * @param {Array} arr The array to modify
		 * @param {Any} o The object to add to the array if it is not already there
		 * @returns {Array} The provided array for chaining
		 */
		pushUnique : pushUnique,
		
		/**
		 * Mutates the array by removing the first item that matches the provided value in the array.
		 *
		 * @event //utility
		 * @param {Array} arr The array to modify
		 * @param {Any} o The object to remove from the array
		 * @returns {Array} The provided array for chaining
		 */
		popFirst : popFirst,
		
		/**
		 * Creates a copy of the target object.
		 * <p>
		 * This method will create a new instance of the target, and then mixin the properties of the target.
		 * If <code>deep</code> is <code>true</code>, then each property will be cloned before mixin.
		 * </p>
		 * <p><b>Warning</b>: This is not a generic clone function, as it will only properly clone objects and arrays.</p>
		 * 
		 * @event //utility
		 * @param {Any} o The value to clone 
		 * @param {Boolean} [deep=false] If each property should be recursively cloned
		 * @returns A cloned copy of the provided value
		 */
		clone : clone,
		
		/**
		 * Generates a pseudo-random UUID.
		 * 
		 * @event //utility
		 * @returns {String} A new universally unique ID
		 */
		randomUUID : randomUUID,
		
		/**
		 * Properly escapes a URI component for embedding into a URI string.
		 * 
		 * @event //utility
		 * @param {String} str The URI component to escape
		 * @returns {String} The escaped URI component
		 */
		escapeURIComponent : escapeURIComponent,
		
		/**
		 * Returns a URI that is formated for JSV. Currently, this only ensures that the URI ends with a hash tag (<code>#</code>).
		 * 
		 * @event //utility
		 * @param {String} uri The URI to format
		 * @returns {String} The URI formatted for JSV
		 */
		formatURI : formatURI,
		
		/**
		 * Merges two schemas/instance together.
		 * 
		 * @event //utility
		 * @param {JSONSchema|Any} base The old value to merge
		 * @param {JSONSchema|Any} extra The new value to merge
		 * @param {Boolean} extension If the merge is a JSON Schema extension
		 * @return {Any} The modified base value
		 */
		 
		inherits : inherits,
		
		/**
		 * @private
		 * @event //utility
		 */
		
		InitializationError : InitializationError
	};
	
	this.JSV = JSV;  //set global object
	exports.JSV = JSV;  //export to CommonJS
	
	require("./environments");  //load default environments
	
}());
},{"./environments":1,"./uri/uri":6}],6:[function(require,module,exports){
/**
 * URI.js
 * 
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 1.3
 * @see http://github.com/garycourt/uri-js
 * @license URI.js v1.3 (c) 2010 Gary Court. License: http://github.com/garycourt/uri-js
 */

/**
 * Copyright 2010 Gary Court. All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 * 
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 * 
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */

/*jslint white: true, sub: true, onevar: true, undef: true, eqeqeq: true, newcap: true, immed: true, indent: 4 */
/*global exports:true, require:true */

if (typeof exports === "undefined") {
	exports = {}; 
}
if (typeof require !== "function") {
	require = function (id) {
		return exports;
	};
}
(function () {
	var	
		/**
		 * @param {...string} sets
		 * @return {string}
		 */
		mergeSet = function (sets) {
			var set = arguments[0],
				x = 1,
				nextSet = arguments[x];
			
			while (nextSet) {
				set = set.slice(0, -1) + nextSet.slice(1);
				nextSet = arguments[++x];
			}
			
			return set;
		},
		
		/**
		 * @param {string} str
		 * @return {string}
		 */
		subexp = function (str) {
			return "(?:" + str + ")";
		},
	
		ALPHA$$ = "[A-Za-z]",
		CR$ = "[\\x0D]",
		DIGIT$$ = "[0-9]",
		DQUOTE$$ = "[\\x22]",
		HEXDIG$$ = mergeSet(DIGIT$$, "[A-Fa-f]"),  //case-insensitive
		LF$$ = "[\\x0A]",
		SP$$ = "[\\x20]",
		PCT_ENCODED$ = subexp("%" + HEXDIG$$ + HEXDIG$$),
		GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]",
		SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
		RESERVED$$ = mergeSet(GEN_DELIMS$$, SUB_DELIMS$$),
		UNRESERVED$$ = mergeSet(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]"),
		SCHEME$ = subexp(ALPHA$$ + mergeSet(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"),
		USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + mergeSet(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"),
		DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$),
		IPV4ADDRESS$ = subexp(DEC_OCTET$ + "\\." + DEC_OCTET$ + "\\." + DEC_OCTET$ + "\\." + DEC_OCTET$),
		H16$ = subexp(HEXDIG$$ + "{1,4}"),
		LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$),
		IPV6ADDRESS$ = subexp(mergeSet(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"),  //FIXME
		IPVFUTURE$ = subexp("v" + HEXDIG$$ + "+\\." + mergeSet(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"),
		IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"),
		REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + mergeSet(UNRESERVED$$, SUB_DELIMS$$)) + "*"),
		HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "|" + REG_NAME$),
		PORT$ = subexp(DIGIT$$ + "*"),
		AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"),
		PCHAR$ = subexp(PCT_ENCODED$ + "|" + mergeSet(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")),
		SEGMENT$ = subexp(PCHAR$ + "*"),
		SEGMENT_NZ$ = subexp(PCHAR$ + "+"),
		SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + mergeSet(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"),
		PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"),
		PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"),  //simplified
		PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$),  //simplified
		PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$),  //simplified
		PATH_EMPTY$ = subexp(""),  //simplified
		PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
		QUERY$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"),
		FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"),
		HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
		URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
		RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$),
		RELATIVE_REF$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
		URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE_REF$),
		ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"),
		
		URI_REF = new RegExp("^" + subexp("(" + URI$ + ")|(" + RELATIVE_REF$ + ")") + "$"),
		GENERIC_REF  = new RegExp("^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$"),
		RELATIVE_REF = new RegExp("^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$"),
		ABSOLUTE_REF = new RegExp("^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$"),
		SAMEDOC_REF = new RegExp("^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$"),
		AUTHORITY = new RegExp("^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$"),
		
		NOT_SCHEME = new RegExp(mergeSet("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
		NOT_USERINFO = new RegExp(mergeSet("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
		NOT_HOST = new RegExp(mergeSet("[^\\%]", UNRESERVED$$, SUB_DELIMS$$), "g"),
		NOT_PATH = new RegExp(mergeSet("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
		NOT_PATH_NOSCHEME = new RegExp(mergeSet("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
		NOT_QUERY = new RegExp(mergeSet("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
		NOT_FRAGMENT = NOT_QUERY,
		ESCAPE = new RegExp(mergeSet("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
		UNRESERVED = new RegExp(UNRESERVED$$, "g"),
		OTHER_CHARS = new RegExp(mergeSet("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
		PCT_ENCODEDS = new RegExp(PCT_ENCODED$ + "+", "g"),
		URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?([^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/i,
		RDS1 = /^\.\.?\//,
		RDS2 = /^\/\.(\/|$)/,
		RDS3 = /^\/\.\.(\/|$)/,
		RDS4 = /^\.\.?$/,
		RDS5 = /^\/?.*?(?=\/|$)/,
		NO_MATCH_IS_UNDEFINED = ("").match(/(){0}/)[1] === undefined,
		
		/**
		 * @param {string} chr
		 * @return {string}
		 */
		pctEncChar = function (chr) {
			var c = chr.charCodeAt(0);
 
			if (c < 128) {
				return "%" + c.toString(16).toUpperCase();
			}
			else if ((c > 127) && (c < 2048)) {
				return "%" + ((c >> 6) | 192).toString(16).toUpperCase() + "%" + ((c & 63) | 128).toString(16).toUpperCase();
			}
			else {
				return "%" + ((c >> 12) | 224).toString(16).toUpperCase() + "%" + (((c >> 6) & 63) | 128).toString(16).toUpperCase() + "%" + ((c & 63) | 128).toString(16).toUpperCase();
			}
		},
		
		/**
		 * @param {string} str
		 * @return {string}
		 */
		pctDecUnreserved = function (str) {
			var newStr = "", 
				i = 0,
				c, s;
	 
			while (i < str.length) {
				c = parseInt(str.substr(i + 1, 2), 16);
	 
				if (c < 128) {
					s = String.fromCharCode(c);
					if (s.match(UNRESERVED)) {
						newStr += s;
					} else {
						newStr += str.substr(i, 3);
					}
					i += 3;
				}
				else if ((c > 191) && (c < 224)) {
					newStr += str.substr(i, 6);
					i += 6;
				}
				else {
					newStr += str.substr(i, 9);
					i += 9;
				}
			}
	 
			return newStr;
		},
		
		/**
		 * @param {string} str
		 * @return {string}
		 */
		pctDecChars = function (str) {
			var newStr = "", 
				i = 0,
				c, c2, c3;
	 
			while (i < str.length) {
				c = parseInt(str.substr(i + 1, 2), 16);
	 
				if (c < 128) {
					newStr += String.fromCharCode(c);
					i += 3;
				}
				else if ((c > 191) && (c < 224)) {
					c2 = parseInt(str.substr(i + 4, 2), 16);
					newStr += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
					i += 6;
				}
				else {
					c2 = parseInt(str.substr(i + 4, 2), 16);
					c3 = parseInt(str.substr(i + 7, 2), 16);
					newStr += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
					i += 9;
				}
			}
	 
			return newStr;
		},
		
		/**
		 * @return {string}
		 */
		typeOf = function (o) {
			return o === undefined ? "undefined" : (o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase());
		},
		
		/**
		 * @constructor
		 * @implements URIComponents
		 */
		Components = function () {
			this.errors = [];
		}, 
		
		/** @namespace */ 
		URI = exports;
	
	/**
	 * Components
	 */
	
	Components.prototype = {
		/**
		 * @type String
		 */
		
		scheme : undefined,
		
		/**
		 * @type String
		 */
		
		authority : undefined,
		
		/**
		 * @type String
		 */
		
		userinfo : undefined,
		
		/**
		 * @type String
		 */
		
		host : undefined,
		
		/**
		 * @type number
		 */
		
		port : undefined,
		
		/**
		 * @type string
		 */
		
		path : undefined,
		
		/**
		 * @type string
		 */
		
		query : undefined,
		
		/**
		 * @type string
		 */
		
		fragment : undefined,
		
		/**
		 * @type string
		 * @values "uri", "absolute", "relative", "same-document"
		 */
		
		reference : undefined,
		
		/**
		 * @type Array
		 */
		
		errors : undefined
	};
	
	/**
	 * URI
	 */
	
	/**
	 * @namespace
	 */
	
	URI.SCHEMES = {};
	
	/**
	 * @param {string} uriString
	 * @param {Options} [options]
	 * @returns {URIComponents}
	 */
	
	URI.parse = function (uriString, options) {
		var matches, 
			components = new Components(),
			schemeHandler;
		
		uriString = uriString ? uriString.toString() : "";
		options = options || {};
		
		if (options.reference === "suffix") {
			uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
		}
		
		matches = uriString.match(URI_REF);
		
		if (matches) {
			if (matches[1]) {
				//generic URI
				matches = uriString.match(GENERIC_REF);
			} else {
				//relative URI
				matches = uriString.match(RELATIVE_REF);
			}
		} 
		
		if (!matches) {
			if (!options.tolerant) {
				components.errors.push("URI is not strictly valid.");
			}
			matches = uriString.match(URI_PARSE);
		}
		
		if (matches) {
			if (NO_MATCH_IS_UNDEFINED) {
				//store each component
				components.scheme = matches[1];
				components.authority = matches[2];
				components.userinfo = matches[3];
				components.host = matches[4];
				components.port = parseInt(matches[5], 10);
				components.path = matches[6] || "";
				components.query = matches[7];
				components.fragment = matches[8];
				
				//fix port number
				if (isNaN(components.port)) {
					components.port = matches[5];
				}
			} else {  //IE FIX for improper RegExp matching
				//store each component
				components.scheme = matches[1] || undefined;
				components.authority = (uriString.indexOf("//") !== -1 ? matches[2] : undefined);
				components.userinfo = (uriString.indexOf("@") !== -1 ? matches[3] : undefined);
				components.host = (uriString.indexOf("//") !== -1 ? matches[4] : undefined);
				components.port = parseInt(matches[5], 10);
				components.path = matches[6] || "";
				components.query = (uriString.indexOf("?") !== -1 ? matches[7] : undefined);
				components.fragment = (uriString.indexOf("#") !== -1 ? matches[8] : undefined);
				
				//fix port number
				if (isNaN(components.port)) {
					components.port = (uriString.match(/\/\/.*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined);
				}
			}
			
			//determine reference type
			if (!components.scheme && !components.authority && !components.path && !components.query) {
				components.reference = "same-document";
			} else if (!components.scheme) {
				components.reference = "relative";
			} else if (!components.fragment) {
				components.reference = "absolute";
			} else {
				components.reference = "uri";
			}
			
			//check for reference errors
			if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
				components.errors.push("URI is not a " + options.reference + " reference.");
			}
			
			//check if a handler for the scheme exists
			schemeHandler = URI.SCHEMES[(components.scheme || options.scheme || "").toLowerCase()];
			if (schemeHandler && schemeHandler.parse) {
				//perform extra parsing
				schemeHandler.parse(components, options);
			}
		} else {
			components.errors.push("URI can not be parsed.");
		}
		
		return components;
	};
	
	/**
	 * @private
	 * @param {URIComponents} components
	 * @returns {string|undefined}
	 */
	
	URI._recomposeAuthority = function (components) {
		var uriTokens = [];
		
		if (components.userinfo !== undefined || components.host !== undefined || typeof components.port === "number") {
			if (components.userinfo !== undefined) {
				uriTokens.push(components.userinfo.toString().replace(NOT_USERINFO, pctEncChar));
				uriTokens.push("@");
			}
			if (components.host !== undefined) {
				uriTokens.push(components.host.toString().toLowerCase().replace(NOT_HOST, pctEncChar));
			}
			if (typeof components.port === "number") {
				uriTokens.push(":");
				uriTokens.push(components.port.toString(10));
			}
		}
		
		return uriTokens.length ? uriTokens.join("") : undefined;
	};
	
	/**
	 * @param {string} input
	 * @returns {string}
	 */
	
	URI.removeDotSegments = function (input) {
		var output = [], s;
		
		while (input.length) {
			if (input.match(RDS1)) {
				input = input.replace(RDS1, "");
			} else if (input.match(RDS2)) {
				input = input.replace(RDS2, "/");
			} else if (input.match(RDS3)) {
				input = input.replace(RDS3, "/");
				output.pop();
			} else if (input === "." || input === "..") {
				input = "";
			} else {
				s = input.match(RDS5)[0];
				input = input.slice(s.length);
				output.push(s);
			}
		}
		
		return output.join("");
	};
	
	/**
	 * @param {URIComponents} components
	 * @param {Options} [options]
	 * @returns {string}
	 */
	
	URI.serialize = function (components, options) {
		var uriTokens = [], 
			schemeHandler, 
			s;
		options = options || {};
		
		//check if a handler for the scheme exists
		schemeHandler = URI.SCHEMES[components.scheme || options.scheme];
		if (schemeHandler && schemeHandler.serialize) {
			//perform extra serialization
			schemeHandler.serialize(components, options);
		}
		
		if (options.reference !== "suffix" && components.scheme) {
			uriTokens.push(components.scheme.toString().toLowerCase().replace(NOT_SCHEME, ""));
			uriTokens.push(":");
		}
		
		components.authority = URI._recomposeAuthority(components);
		if (components.authority !== undefined) {
			if (options.reference !== "suffix") {
				uriTokens.push("//");
			}
			
			uriTokens.push(components.authority);
			
			if (components.path && components.path.charAt(0) !== "/") {
				uriTokens.push("/");
			}
		}
		
		if (components.path) {
			s = URI.removeDotSegments(components.path.toString().replace(/%2E/ig, "."));
			
			if (components.scheme) {
				s = s.replace(NOT_PATH, pctEncChar);
			} else {
				s = s.replace(NOT_PATH_NOSCHEME, pctEncChar);
			}
			
			if (components.authority === undefined) {
				s = s.replace(/^\/\//, "/%2F");  //don't allow the path to start with "//"
			}
			uriTokens.push(s);
		}
		
		if (components.query) {
			uriTokens.push("?");
			uriTokens.push(components.query.toString().replace(NOT_QUERY, pctEncChar));
		}
		
		if (components.fragment) {
			uriTokens.push("#");
			uriTokens.push(components.fragment.toString().replace(NOT_FRAGMENT, pctEncChar));
		}
		
		return uriTokens
			.join('')  //merge tokens into a string
			.replace(PCT_ENCODEDS, pctDecUnreserved)  //undecode unreserved characters
			//.replace(OTHER_CHARS, pctEncChar)  //replace non-URI characters
			.replace(/%[0-9A-Fa-f]{2}/g, function (str) {  //uppercase percent encoded characters
				return str.toUpperCase();
			})
		;
	};
	
	/**
	 * @param {URIComponents} base
	 * @param {URIComponents} relative
	 * @param {Options} [options]
	 * @param {boolean} [skipNormalization]
	 * @returns {URIComponents}
	 */
	
	URI.resolveComponents = function (base, relative, options, skipNormalization) {
		var target = new Components();
		
		if (!skipNormalization) {
			base = URI.parse(URI.serialize(base, options), options);  //normalize base components
			relative = URI.parse(URI.serialize(relative, options), options);  //normalize relative components
		}
		options = options || {};
		
		if (!options.tolerant && relative.scheme) {
			target.scheme = relative.scheme;
			target.authority = relative.authority;
			target.userinfo = relative.userinfo;
			target.host = relative.host;
			target.port = relative.port;
			target.path = URI.removeDotSegments(relative.path);
			target.query = relative.query;
		} else {
			if (relative.authority !== undefined) {
				target.authority = relative.authority;
				target.userinfo = relative.userinfo;
				target.host = relative.host;
				target.port = relative.port;
				target.path = URI.removeDotSegments(relative.path);
				target.query = relative.query;
			} else {
				if (!relative.path) {
					target.path = base.path;
					if (relative.query !== undefined) {
						target.query = relative.query;
					} else {
						target.query = base.query;
					}
				} else {
					if (relative.path.charAt(0) === "/") {
						target.path = URI.removeDotSegments(relative.path);
					} else {
						if (base.authority !== undefined && !base.path) {
							target.path = "/" + relative.path;
						} else if (!base.path) {
							target.path = relative.path;
						} else {
							target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
						}
						target.path = URI.removeDotSegments(target.path);
					}
					target.query = relative.query;
				}
				target.authority = base.authority;
				target.userinfo = base.userinfo;
				target.host = base.host;
				target.port = base.port;
			}
			target.scheme = base.scheme;
		}
		
		target.fragment = relative.fragment;
		
		return target;
	};
	
	/**
	 * @param {string} baseURI
	 * @param {string} relativeURI
	 * @param {Options} [options]
	 * @returns {string}
	 */
	
	URI.resolve = function (baseURI, relativeURI, options) {
		return URI.serialize(URI.resolveComponents(URI.parse(baseURI, options), URI.parse(relativeURI, options), options, true), options);
	};
	
	/**
	 * @param {string|URIComponents} uri
	 * @param {Options} options
	 * @returns {string|URIComponents}
	 */
	
	URI.normalize = function (uri, options) {
		if (typeof uri === "string") {
			return URI.serialize(URI.parse(uri, options), options);
		} else if (typeOf(uri) === "object") {
			return URI.parse(URI.serialize(uri, options), options);
		}
		
		return uri;
	};
	
	/**
	 * @param {string|URIComponents} uriA
	 * @param {string|URIComponents} uriB
	 * @param {Options} options
	 */
	
	URI.equal = function (uriA, uriB, options) {
		if (typeof uriA === "string") {
			uriA = URI.serialize(URI.parse(uriA, options), options);
		} else if (typeOf(uriA) === "object") {
			uriA = URI.serialize(uriA, options);
		}
		
		if (typeof uriB === "string") {
			uriB = URI.serialize(URI.parse(uriB, options), options);
		} else if (typeOf(uriB) === "object") {
			uriB = URI.serialize(uriB, options);
		}
		
		return uriA === uriB;
	};
	
	/**
	 * @param {string} str
	 * @returns {string}
	 */
	
	URI.escapeComponent = function (str) {
		return str && str.toString().replace(ESCAPE, pctEncChar);
	};
	
	/**
	 * @param {string} str
	 * @returns {string}
	 */
	
	URI.unescapeComponent = function (str) {
		return str && str.toString().replace(PCT_ENCODEDS, pctDecChars);
	};
	
	//export API
	exports.pctEncChar = pctEncChar;
	exports.pctDecChars = pctDecChars;
	exports.Components = Components;
	exports.URI = URI;
	
	//name-safe export API
	exports["pctEncChar"] = pctEncChar;
	exports["pctDecChars"] = pctDecChars;
	exports["Components"] = Components;
	exports["URI"] = {
		"SCHEMES" : URI.SCHEMES,
		"parse" : URI.parse,
		"removeDotSegments" : URI.removeDotSegments,
		"serialize" : URI.serialize,
		"resolveComponents" : URI.resolveComponents,
		"resolve" : URI.resolve,
		"normalize" : URI.normalize,
		"equal" : URI.equal,
		"escapeComponent" : URI.escapeComponent,
		"unescapeComponent" : URI.unescapeComponent
	};
	
}());
},{}],7:[function(require,module,exports){
//! moment.js
//! version : 2.11.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')$', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')$', 'i');
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             if (this.isValid() && other.isValid()) {
                 return other < this ? this : other;
             } else {
                 return valid__createInvalid();
             }
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this > +localInput;
        } else {
            return +localInput < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return +this < +localInput;
        } else {
            return +this.clone().endOf(units) < +localInput;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return +this === +localInput;
        } else {
            inputMs = +localInput;
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // JSON.stringify(new Date(NaN)) === 'null'
        return this.isValid() ? this.toISOString() : 'null';
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        // console.log("got", weekYear, week, weekday, "set", date.toISOString());
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = local__createLocal([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = getSet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = getSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto._months           = defaultLocaleMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto._monthsRegex      = defaultMonthsRegex;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.11.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],8:[function(require,module,exports){
/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (typeof exports === 'object') {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = require('moment'); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        if (opts.isEmpty) {
            return '<td class="is-empty"></td>';
        }
        var arr = [];
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL)
    {
        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</thead>';
    },

    renderTitle = function(instance, c, year, month, refYear)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div class="pika-title">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }
        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (hasMoment) {
                date = moment(opts.field.value, opts.format);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            setToStartOfDay(value);
            this._o.minDate = value;
            this._o.minYear  = value.getFullYear();
            this._o.minMonth = value.getMonth();
            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            setToStartOfDay(value);
            this._o.maxDate = value;
            this._o.maxYear = value.getFullYear();
            this._o.maxMonth = value.getMonth();
            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '';

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year) + this.render(this.calendars[c].year, this.calendars[c].month) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                var self = this;
                sto(function() {
                    self._o.onDraw.call(self);
                }, 0);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    isEmpty = i < before || i >= (days + before),
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day)),
                    dayConfig = {
                        day: 1 + (i - before),
                        month: month,
                        year: year,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange
                    };

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL));
                    row = [];
                    r = 0;
                }
            }
            return renderTable(opts, data);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this._v) {
                removeClass(this.el, 'is-hidden');
                this._v = true;
                this.draw();
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));

},{"moment":7}],9:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name oxyCheckInApp
* @purpose Web check-in application
*/

window.Ractive.DEBUG = o2context.debug;
window.Promise = Ractive.Promise;

var utils = require('./libs/utils.js'),
    SiteParams = require('./siteParams.js'),
    EnvironmentUrls = require('./environmentUrls.js'),
    SiteAliases = require('./siteAliases.js'),
    CountriesDict = require('./countriesDict.js'),
    DocumentTypesDict = require('./documentTypesDict.js'),
    CheckinService = require('./checkinService.js'),
    Mapper = require('./mapper.js'),
    Autocomplete = require('./autocomplete.js');

Ractive.components.autocomplete = Autocomplete;

require('./libs/selectPicker.js');
require('./libs/ajaxer.js');

(function (window) {

    'use strict';

    function App() {

        var app = this;

        // Application initialization promise

        app.ready = new Promise(function (resolve, reject) {
            $(function () {

                Promise.all([
                    $('#oxyCheckinApp').ajaxer({url: './json/get-params'}),
                    $('#oxyCheckinApp').ajaxer({url: './' + o2context.staticFolderRelativePath + '/aliases-' + o2context.systemLanguage + '.json'}),
                    $('#oxyCheckinApp').ajaxer({url: './json/astra-countries-dictionary'}),
                    $('#oxyCheckinApp').ajaxer({url: './json/application-constants'})
                ]).then(function (responses) {

                    $('body').removeClass('loading');
                    Ractive.defaults.data.param = app.siteParams = new SiteParams(
                        utils.deepDecodeQuot(responses[0])
                    );
                    Ractive.defaults.data.environmentUrl = app.environmentUrls = new EnvironmentUrls(app.siteParams('check-in.environmentUrls'));
                    Ractive.defaults.data.alias = app.siteAliases = new SiteAliases(responses[1]);
                    Ractive.defaults.data.utils = utils;
                    app.countriesDict = new CountriesDict(responses[2]);
                    app.documentTypesDict = new DocumentTypesDict();
                    app.constants = responses[3];

                    app.checkinService = new CheckinService();
                    app.mapper = new Mapper();

                    resolve();

                }, reject);

            });
        });

        utils.sendStartAppPostMessage();

    }

    window.app = new App();

}(window));

require('./cookieWarning.js');

},{"./autocomplete.js":10,"./checkinService.js":11,"./cookieWarning.js":12,"./countriesDict.js":13,"./documentTypesDict.js":14,"./environmentUrls.js":15,"./libs/ajaxer.js":17,"./libs/selectPicker.js":19,"./libs/utils.js":20,"./mapper.js":22,"./siteAliases.js":46,"./siteParams.js":47}],10:[function(require,module,exports){

(function () {

    'use strict';

    var KEY_ENTER = 13;
    var KEY_ESC = 27;
    var KEY_UP = 38;
    var KEY_DOWN = 40;

    var template = (

            '<input type="{{ type }}" value="{{ value }}" disabled="{{ disabled }}" autocomplete="off" ' +
                'class="{{ cssClass }}" ' +
                'name="{{ code }}" ' +
                'id="{{ code }}" ' +
                'on-blur="blur" ' +
                'on-keyup="keyup"/>' +
            '{{#if (list && list.length)}}' +
                '<ul class="autocomplete-list">' +
                    '{{#list:i}}' +
                        '<li class="{{#if i == activeNum}}active{{/if}}" on-mouseover="hoverItem(i)" on-click="setItem(i)">{{ list[i] }}</li>' +
                    '{{/list:i}}' +
                '</ul>' +
            '{{/if}}'

    );


    module.exports = Ractive.extend({
        template: template,
        lazy: false,
        isolated: true,
        hoverItem: function (i) {
            this.set('activeNum', i);
        },
        setItem: function (i) {
            var list = this.get('list');
            this.set('value', list[i]);
            $('#' + this.get('code')).triggerHandler('blur');
            this.set('list', []);
        },
        onrender: function() {

            this.set('activeNum', 0);

            this.on('keyup', function(event) {

                var key = event.original.keyCode,
                    oldActiveNum = this.get('activeNum'),
                    oldList = this.get('list');

                if (oldList && oldActiveNum > oldList.length - 1) {
                    this.set('activeNum', 0);
                    oldActiveNum = 0;
                }

                if (key == KEY_ENTER) {
                    event.original.preventDefault();
                    this.setItem(oldActiveNum);
                } else if (key == KEY_ESC) {
                    event.original.preventDefault();
                    this.set('list', []);
                } else if (key == KEY_UP) {
                    if (oldActiveNum === 0) {
                        this.set('activeNum', oldList.length - 1);
                    } else {
                        this.set('activeNum', oldActiveNum - 1);
                    }
                } else if (key == KEY_DOWN) {
                    if (oldActiveNum === oldList.length - 1) {
                        this.set('activeNum', 0);
                    } else {
                        this.set('activeNum', oldActiveNum + 1);
                    }
                } else {

                    this.set(
                        'list',
                        this.get('suggest')(this.get('value'))
                    );

                }
            });

            this.on('blur', function() {
                // Prevent blur before setItem by click
                var self = this;
                setTimeout(function () {
                    self.set('list', []);
                }, 200);
            });

        }
    });


}());

},{}],11:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Checkin Service
* @purpose API to checkin server
*/

window.jsonTesting = false;


var utils = require('./libs/utils.js');

(function () {

    'use strict';

    function CheckinService() {

        return this;

    }

    function getRequestPromise(reqName, reqParams, reformator) {

        var jsonPath = jsonTesting ? ('json-testing/' + reqName + '.json') : ('json/' + reqName);
        reqParams = reqParams || {};

        return new Promise(function (resolve, reject) {
            $('body').ajaxer({
                url: jsonPath,
                data: reqParams,
                headers: {
                    'Unique-Tab-Id': getTabId()
                }
            }).then(function (resp) {

                if (reformator) {
                    resp = reformator(resp);
                }
                resolve(resp);

            }, reject);
        });
    }

    function getPaidSeatsInfo(passengers) {

        var info = {
                paid: {
                    count: 0
                },
                notPaid: {
                    count: 0
                }
            },
            paidCosts = {},
            notPaidCosts = {};


        _.each(passengers, function (passenger) {
            if (passenger.selected) {
                _.each(passenger.segments, function (segment) {
                    if (segment.seat && segment.seat.cost && segment.seat.currency) {
                        if (segment.seat.paid) {
                            info.paid.count = info.paid.count + 1;
                            if(paidCosts[segment.seat.currency]) {
                                paidCosts[segment.seat.currency] += segment.seat.cost;
                            } else {
                                paidCosts[segment.seat.currency] = segment.seat.cost;
                            }
                        } else {
                            info.notPaid.count = info.notPaid.count + 1;
                            if(notPaidCosts[segment.seat.currency]) {
                                notPaidCosts[segment.seat.currency] += segment.seat.cost;
                            } else {
                                notPaidCosts[segment.seat.currency] = segment.seat.cost;
                            }
                        }
                    }
                });
            }
        });

        info.paid.costs = _.keys(paidCosts).map(function (currency) {
            return {
                currency: currency,
                totalCost: paidCosts[currency]
            };
        });

        info.notPaid.costs = _.keys(notPaidCosts).map(function (currency) {
            return {
                currency: currency,
                totalCost: notPaidCosts[currency]
            };
        });

        return info;
    }


    function reformatExtraServiceByGroupPrices(totalExtraServiceByGroup) {

        if (totalExtraServiceByGroup) {
            totalExtraServiceByGroup = _.mapObject(
                _.indexBy(totalExtraServiceByGroup.map(utils.markInsuranceOnline), 'code'),
                function (item) {
                    return item.price;
                }
            );
        } else {
            totalExtraServiceByGroup = {};
        }

        return totalExtraServiceByGroup;

    }


    function getExtraServicesByPassengers(passengers, plainFlights, servicesList) {
        return passengers.map(function (passenger) {

            var hasPassengerServices = false,
                passengerSegmentServices = plainFlights.map(function (segment) {

                    var passengerSegmentServicesList = [],
                        mealService = _.findWhere(servicesList, { code: 'meal' }),
                        mealServicePassenger,
                        mealServicePassengerSegment,
                        mealServicePassengerSegmentSelectedItem,
                        baggageService = _.findWhere(servicesList, { code: 'baggage' }),
                        baggageServicePassenger,
                        baggageServicePassengerSegment,
                        seatService = _.findWhere(servicesList, { code: 'seat' }),
                        seatServicePassenger,
                        seatServicePassengerSegment,
                        seatServicePassengerSegmentSelectedItem,
                        aeroexpressService = _.findWhere(servicesList, { code: 'aeroexpress' }),
                        insuranceService = _.findWhere(servicesList, { code: 'insurance' });

                    if (mealService) {
                        mealServicePassenger = _.findWhere(mealService.passengers, {
                            id: passenger.id,
                            pnr: passenger.pnr
                        });
                        if (mealServicePassenger) {
                            mealServicePassengerSegment = _.findWhere(mealServicePassenger.segments, {
                                id: segment.id
                            });

                            if (mealServicePassengerSegment && mealServicePassengerSegment.selectedExtraServices) {
                                mealServicePassengerSegmentSelectedItem = utils.getFirstNotEmptyListItem(
                                    mealServicePassengerSegment.selectedExtraServices
                                );
                                if (mealServicePassengerSegmentSelectedItem) {
                                    passengerSegmentServicesList.push({
                                        code: 'meal',
                                        serviceItem: mealServicePassengerSegmentSelectedItem
                                    });
                                }
                            }

                        }
                    }

                    if (baggageService) {
                        baggageServicePassenger = _.findWhere(baggageService.passengers, {
                            id: passenger.id,
                            pnr: passenger.pnr
                        });
                        if (baggageServicePassenger) {
                            baggageServicePassengerSegment = _.findWhere(baggageServicePassenger.segments, {
                                id: segment.id
                            });
                            /* jshint maxlen: 250 */
                            if (baggageServicePassengerSegment && baggageServicePassengerSegment.selectedExtraServices && baggageServicePassengerSegment.selectedExtraServices.length) {
                                passengerSegmentServicesList.push({
                                    code: 'baggage',
                                    items: baggageServicePassengerSegment.selectedExtraServices
                                });
                            }

                        }
                    }

                    if (seatService) {
                        seatServicePassenger = _.findWhere(seatService.passengers, {
                            id: passenger.id,
                            pnr: passenger.pnr
                        });
                        if (seatServicePassenger) {
                            seatServicePassengerSegment = _.findWhere(seatServicePassenger.segments, {
                                id: segment.id
                            });
                            /* jshint maxlen: 250 */
                            if (seatServicePassengerSegment && seatServicePassengerSegment.selectedExtraServices && seatServicePassengerSegment.selectedExtraServices.length) {
                                seatServicePassengerSegmentSelectedItem = utils.getFirstNotEmptyListItem(
                                    seatServicePassengerSegment.selectedExtraServices
                                );
                                if (seatServicePassengerSegmentSelectedItem) {
                                    passengerSegmentServicesList.push({
                                        code: 'seat',
                                        serviceItem: seatServicePassengerSegmentSelectedItem
                                    });
                                }
                            }

                        }
                    }

                    if (aeroexpressService && aeroexpressService.items) {
                        aeroexpressService.items.forEach(function (item) {
                            if (
                                item.firstName === passenger.firstName &&
                                item.lastName === passenger.lastName &&
                                item.dateOfBirth === passenger.dateOfBirth
                            ) {
                                // Добавляем АЭ к сегменту, если поезд приходит в порт вылета или выходит из порта прилета
                                if (item.arrival_code === (segment.originPortCode || segment.originCityCode) || item.departure_code === (segment.destinationPortCode || segment.destinationCityCode)) {
                                    passengerSegmentServicesList.push({
                                        code: 'aeroexpress',
                                        serviceItem: item
                                    });
                                }
                            }
                        });
                    }

                    if (insuranceService && insuranceService.items) {
                        insuranceService.items.forEach(function (item) {
                            if (
                                item.passengerId === passenger.id &&
                                item.pnr === passenger.pnr &&
                                item.segmentId === segment.id
                            ) {
                                passengerSegmentServicesList.push({
                                    code: 'insurance',
                                    serviceItem: item
                                });
                            }
                        });
                    }

                    servicesList.forEach(function (service) {
                        var commonServicePassenger,
                            commonServicePassengerSegment,
                            commonServicePassengerSegmentSelectedItem;
                        if (utils.isCommonServiceCode(service.code)) {
                            commonServicePassenger = _.findWhere(service.passengers, {
                                id: passenger.id,
                                pnr: passenger.pnr
                            });
                            if (commonServicePassenger) {
                                commonServicePassengerSegment = _.findWhere(commonServicePassenger.segments, {
                                    id: segment.id
                                });
                                /* jshint maxlen: 250 */
                                if (commonServicePassengerSegment && commonServicePassengerSegment.selectedExtraServices && commonServicePassengerSegment.selectedExtraServices.length) {
                                    commonServicePassengerSegmentSelectedItem = utils.getFirstNotEmptyListItem(
                                        commonServicePassengerSegment.selectedExtraServices
                                    );
                                    if (commonServicePassengerSegmentSelectedItem) {
                                        passengerSegmentServicesList.push({
                                            code: service.code,
                                            serviceItem: commonServicePassengerSegmentSelectedItem
                                        });
                                    }
                                }
                            }
                        }
                    });

                    if (!passengerSegmentServicesList.length) {
                        passengerSegmentServicesList = false;
                    }

                    return passengerSegmentServicesList;
                });

            passengerSegmentServices.forEach(function (passengerSegmentServicesList) {
                if (passengerSegmentServicesList) {
                    hasPassengerServices = true;
                }
            });

            if (!hasPassengerServices) {
                return false;
            } else {
                return {
                    passengerSegmentServices: passengerSegmentServices
                };
            }

        });
    }

    function getCommonServicesList(totalExtraServiceByGroup) {
        return _.keys(totalExtraServiceByGroup || {}).filter(utils.isCommonServiceCode).map(function (code) {
            return {
                code: code,
                value: totalExtraServiceByGroup[code]
            };
        });
    }

    function getExtraPassengersList(sirenaOrder) {
        var orderAeroexpressService = _.findWhere(sirenaOrder.allExtraServices, { code: 'aeroexpress' }),
            list = [];
        if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
            orderAeroexpressService.items.forEach(function (item) {
                if (
                    !_.findWhere(sirenaOrder.passengers, {
                        firstName: item.firstName,
                        lastName: item.lastName,
                        dateOfBirth: item.dateOfBirth
                    }) && !_.findWhere(list, {
                        firstName: item.firstName,
                        lastName: item.lastName,
                        dateOfBirth: item.dateOfBirth
                    })
                ) {
                    list.push({
                        firstName: item.firstName,
                        lastName: item.lastName,
                        dateOfBirth: item.dateOfBirth,
                        aeroexpressDocumentType: item.documentType,
                        aeroexpressDocumentNumber: item.documentNumber
                    });
                }
            });
        }
        return list;
    }

    function getTabId() {
        try {
            return window.sessionStorage.UNIQUE_TAB_ID || generateNewTabId();
        } catch (err) {
            return 'NONE';
        }
    }

    function generateNewTabId() {
        var TAB_ID_LENGTH = 32;
        var timestamp = (new Date()).getTime().toString();
        var randomString = randomBase64(TAB_ID_LENGTH - timestamp.length);
        var tabId = timestamp + randomString;
        if (window.sessionStorage.UNIQUE_TAB_ID !== tabId) {
            window.sessionStorage.UNIQUE_TAB_ID = tabId;
        }
        return tabId;
    }

    function randomBase64(length) {
        var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
        var str = '';
        var rand;
        for (var i = 0; i < length; ++i) {
            rand = Math.floor(Math.random() * ALPHABET.length);
            str += ALPHABET.substring(rand, rand+1);
        }
        return str;
    }


    CheckinService.prototype.addToOrder = function (req) {
        return getRequestPromise('add-to-order', req);
    };

    CheckinService.prototype.orderInfo = function () {
        return getRequestPromise('order-info', {}, function (data) {

            if (data.passengers && data.passengers.length) {
                _.each(data.passengers, function (passenger, index) {
                    passenger.index = index;
                    if (passenger.child) {
                        passenger.child.isChild = true;
                    }
                    _.each(passenger.segments, function (segment) {
                        segment.seat = segment.chosenSeatThroughGui || segment.alreadyAssignedSeatInAstra || false;
                        if (
                            segment.possibleActions &&
                            utils.hasInList(segment.possibleActions, 'GET_BOARDING_PASS')
                        ) {
                            data.hasPassengerSegmentsWithBoardingPass = true;
                        }
                        if (segment.document && segment.document.fields) {
                            segment.document.isAllFieldsDisabled = segment.document.fields.every(function (field) {
                                return field.disabled;
                            });
                        }
                    });
                    if (passenger.child) {
                        _.each(passenger.child.segments, function (segment) {
                            if (segment.document && segment.document.fields) {
                                segment.document.isAllFieldsDisabled = segment.document.fields.every(function (field) {
                                    return field.disabled;
                                });
                            }
                        });
                    }
                });
                data.paidSeats = getPaidSeatsInfo(data.passengers);
            }

            if (data.sirenaOrder) {
                data.sirenaOrder.extraPassengers = getExtraPassengersList(data.sirenaOrder);
                data.sirenaOrder.hasSelectedExtraServices = false;
                if (data.sirenaOrder.pricesEditable) {
                    data.sirenaOrder.pricesEditable.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesEditable.totalExtraServiceByGroup);
                    if (data.sirenaOrder.pricesEditable.totalExtraServices) {
                        data.sirenaOrder.hasSelectedExtraServices = true;
                    }
                }
                if (data.sirenaOrder.pricesIssued) {
                    data.sirenaOrder.pricesIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesIssued.totalExtraServiceByGroup);
                    data.sirenaOrder.pricesIssued.totalCommonServicesList = getCommonServicesList(data.sirenaOrder.pricesIssued.totalExtraServiceByGroup);
                }
                if (data.sirenaOrder.pricesNotIssued) {
                    data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup = reformatExtraServiceByGroupPrices(data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup);
                    data.sirenaOrder.pricesNotIssued.totalCommonServicesList = getCommonServicesList(data.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup);
                }
                if (data.sirenaOrder.editableExtraServices) {
                    data.sirenaOrder.editableExtraServices = data.sirenaOrder.editableExtraServices.map(utils.markInsuranceOnline);
                    data.sirenaOrder.editableExtraServicesByPassengers = getExtraServicesByPassengers(
                        data.sirenaOrder.passengers,
                        data.sirenaOrder.segments,
                        data.sirenaOrder.editableExtraServices
                    );
                    data.sirenaOrder.editableExtraServicesByExtraPassengers = getExtraServicesByPassengers(
                        data.sirenaOrder.extraPassengers,
                        data.sirenaOrder.segments,
                        data.sirenaOrder.editableExtraServices
                    );
                }
                if (data.sirenaOrder.allExtraServices) {
                    data.sirenaOrder.allExtraServices = data.sirenaOrder.allExtraServices.map(utils.markInsuranceOnline);
                    data.sirenaOrder.allExtraServicesByPassengers = getExtraServicesByPassengers(
                        data.sirenaOrder.passengers,
                        data.sirenaOrder.segments,
                        data.sirenaOrder.allExtraServices
                    );
                    data.sirenaOrder.allExtraServicesByExtraPassengers = getExtraServicesByPassengers(
                        data.sirenaOrder.extraPassengers,
                        data.sirenaOrder.segments,
                        data.sirenaOrder.allExtraServices
                    );
                }
            }

            return data;
        });
    };

    CheckinService.prototype.confirmPassengersSelection = function (req) {
        return getRequestPromise('confirm-passengers-selection', req);
    };

    CheckinService.prototype.viewCraft = function (req) {
        return getRequestPromise('view-craft', req, function (data) {

            data.hasSeatsNearEmergencyExit = false;
            data.hasAutoAssignedSeats = false;

            if (data.cabins && data.cabins.length) {
                _.each(data.cabins, function (cabin) {
                    var rowNum,
                        placeNum,
                        currentRowEmptyPlaces, //количество пустых мест для текущего просматриваемого вертикального ряда
                        emptyVerticalRowsXCoordinates, //x-координаты вертикальных рядов, в которых больше всего пустых мест, там будут на карте мест рисоваться номера рядов
                        amountOfPlacesInEmptyVerticalRows = -1; //"длина" пустых рядов, все ряды с такой длиной будут выбираться, и в них будут рисоваться номера
                    cabin.tableRows = [];
                    cabin.tableCols = [];
                    for (rowNum = 0; rowNum < cabin.yCount; rowNum++) {
                        cabin.tableRows[rowNum] = [];
                        for (placeNum = 0; placeNum < cabin.xCount; placeNum++) {
                            cabin.tableRows[rowNum][placeNum] = {
                                isEmptyCell: true,
                                y: rowNum,
                                x: placeNum
                            };
                        }
                    }

                    _.each(cabin.places, function (place) {
                        if (place.seatNumber) {
                            place.colName = place.seatNumber.charAt(place.seatNumber.length - 1);
                            place.rowName = place.seatNumber.slice(0, place.seatNumber.length - 1);
                            cabin.tableCols[place.x] = place.colName;
                        } else {
                            if (!cabin.tableCols[place.x]) {
                                cabin.tableCols[place.x] = "";
                            }
                        }
                        cabin.tableRows[place.y][place.x] = place;
                    });

                    //Проходим по каждому вертикальному ряду, смотрим там количество пустых мест, на основании этого инициализируем emptyVerticalRowsXCoordinates
                    for (placeNum = 0; placeNum < cabin.xCount; placeNum++) {
                        currentRowEmptyPlaces = 0;
                        for (rowNum = 0; rowNum < cabin.yCount; rowNum++) {
                            if (cabin.tableRows[rowNum][placeNum].isEmptyCell) {
                                currentRowEmptyPlaces++;
                            }
                        }
                        if (currentRowEmptyPlaces > amountOfPlacesInEmptyVerticalRows) {
                            amountOfPlacesInEmptyVerticalRows = currentRowEmptyPlaces;
                            emptyVerticalRowsXCoordinates = [];
                        }
                        if (currentRowEmptyPlaces == amountOfPlacesInEmptyVerticalRows) {
                            emptyVerticalRowsXCoordinates.push(placeNum);
                        }
                    }

                    _.each(cabin.tableRows, function (row) {
                        var rowName; //В этой переменной будет номер ряда если он есть. Ряд просто может быть целиком пустым, тогда в нем вообще нет номера и его не нужно отображать.

                        _.each(row, function (cell) {
                            if (cell.rowName) {
                                rowName = cell.rowName;
                            }
                            if (cell.type === 'SEAT_NEAR_EMERGENCY_EXIT') {
                                data.hasSeatsNearEmergencyExit = true;
                            }
                            if (cell.autoAssigned) {
                                data.hasAutoAssignedSeats = true;
                            }
                        });

                        if (rowName) {
                            _.each(emptyVerticalRowsXCoordinates, function (x) {
                                row[x].label = rowName;
                            });
                        }
                    });
                });
            }

            return data;
        });
    };

    CheckinService.prototype.selectSeatNumber = function (req) {
        return getRequestPromise('select-seat-number', req);
    };

    CheckinService.prototype.cancelCheckin = function (req) {
        return getRequestPromise('cancel-check-in', req);
    };

    CheckinService.prototype.confirmCheckin = function (req) {
        return getRequestPromise('confirm-check-in', req);
    };

    CheckinService.prototype.boardingPassEmail = function (req) {
        return getRequestPromise('check-in-finished-email', req);
    };

    CheckinService.prototype.checkOrderStatus = function () {
        return getRequestPromise('check-order-status', {});
    };

    CheckinService.prototype.modifyDataSeat = function (req) {
        return getRequestPromise('modify-data-seat', req);
    };

    CheckinService.prototype.setRedirectResultFromIps = function (req) {
        return getRequestPromise('set-redirect-result-from-ips', req);
    };

    CheckinService.prototype.clearSession = function () {
        return getRequestPromise('clear-session', {});
    };

    CheckinService.prototype.getExtraServices = function () {
        return getRequestPromise('extra-services', {}, function (data) {
            var resp = {};
            resp.extra_services = data.extraServiceGroups || [];
            return resp;
        });
    };

    CheckinService.prototype.modifyExtraService = function (req) {
        return getRequestPromise('extra-services-modify', req);
    };

    CheckinService.prototype.removeExtraService = function (req) {
        return getRequestPromise('extra-services-remove', req);
    };

    CheckinService.prototype.aeroexpressSchedule = function (req) {
        return getRequestPromise('aeroexpress-schedule', req);
    };

    CheckinService.prototype.changePassengerSelection = function (passengerIndex, selected) {
        return getRequestPromise('change-passenger-selection', {
            passengerIndex: passengerIndex,
            selected: selected
        });
    };

    CheckinService.prototype.getTabId = getTabId;

    module.exports = CheckinService;

}());

},{"./libs/utils.js":20}],12:[function(require,module,exports){
/**
/**
 * @author Valentin Agafonov <agafonov@sirena2000.ru>
 * @name cookieWarning
 * @purpose Cookie warning
 */

var template = require('./templates/includes/cookieWarning.html');

(function() {

    'use strict';

    app.ready.then(function () {
        
        var cookieWarningRactive = new Ractive({
            data: {
                active: (
                    (!window.localStorage || !window.localStorage.oxygen_hide_cookie_warning) &&
                    window.location.hash  !== '#privacyPolicy'
                )
            },
            template: template,
        });
    
        cookieWarningRactive.on('close', close);
    
        function close() {            
            if (window.localStorage) {
                window.localStorage.oxygen_hide_cookie_warning = true;
            }
            cookieWarningRactive.set('active', false);
            return false;
        }

        cookieWarningRactive.render('oxyCheckinAppWarningList');
        
        $(window).on('hashchange', function () {
            if (window.location.hash  === '#privacyPolicy') {
                cookieWarningRactive.set('active', false);
            }
        });

    });

}());


},{"./templates/includes/cookieWarning.html":49}],13:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Countries dictionary module
* @purpose Interface to astra countries dictionary
*/

var utils = require('./libs/utils.js');

(function () {

    'use strict';

    var countriesIndex = {},
        countriesList = [];

    function reformatCountriesList(list) {
        list = list.sort(function (a, b) {

            if (a.code === 'RUS') {
                return -1;
            }
            if (b.code === 'RUS') {
                return 1;
            }

            if (a.value > b.value) {
                return 1;
            }
            if (a.value < b.value) {
                return -1;
            }
            return 0;

        });

        return list;
    }

    function CountriesDict(resp) {
        countriesList = reformatCountriesList(resp.items) || [];
        countriesIndex = utils.createIndex(countriesList);
        return this;
    }

    CountriesDict.prototype.getCountriesList = function () {
        return countriesList;
    };

    CountriesDict.prototype.getCountryNameByCode = function (code) {
        return countriesIndex[code] || code;
    };

    module.exports = CountriesDict;

}());

},{"./libs/utils.js":20}],14:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Document types dictionary module
* @purpose Document types list - hardcode =(
*/

(function () {

    'use strict';

    var documentTypesList = ['A', 'C', 'F', 'I', 'IP', 'M', 'N', 'P', 'T'];

    function getDocumentTypesList() {
        return documentTypesList;
    }

    function DocumentTypesDict() {
        return getDocumentTypesList;
    }

    module.exports = DocumentTypesDict;

}());

},{}],15:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Application environment urls module
* @purpose Interface to SWC environment urls
*/

(function () {

    'use strict';

    var environmentUrls = {};


    function getEnvironmentUrl(code) {
        return environmentUrls[code] || false;
    }

    function initEnvironmentUrls(jsonStr) {
        try {
            environmentUrls = JSON.parse(jsonStr);
        } catch (err) {
            console.log('Invalid check-in.environmentUrls: ', err);
        }
    }

    function EnvironmentUrls(jsonStr) {
        initEnvironmentUrls(jsonStr);
        return getEnvironmentUrl;
    }

    module.exports = EnvironmentUrls;

}());

},{}],16:[function(require,module,exports){
/**
/**
 * @author Valentin Agafonov <agafonov@sirena2000.ru>
 * @name CheckIn
 * @purpose Extra services ractive object
 */

var utils = require('./libs/utils.js'),
    template = require('./templates/includes/extraServices.html'),
    ServiceСonditionsModal = require('./modals/serviceСonditions.js'),
    SelectMealModal = require('./modals/selectMeal.js'),
    AeroexpressScheduleModal = require('./modals/aeroexpressSchedule.js'),
    orderPricesTemplate = require('./templates/includes/orderPrices.html'),
    groupedServicesListTemplate = require('./templates/includes/groupedServicesList.html'),
    aeroexpressListTemplate = require('./templates/includes/aeroexpressList.html'),
    Validation = require('./libs/validation.js');

(function() {

    'use strict';

    function ExtraServices(sirenaOrder, updateOrderInfoCallback) {

        var availableExtraServices,
            baggageCountByPassengerSegmentsBySubgoupItems,
            activeMealPassenger,
            activeMealSegment,
            mealMenu,
            selectedMealByPassengerSegments,
            selectMealModal,
            aeroexpressScheduleModal,
            extraPassengers = [],
            aeExtraPassengersFormValidation = [],
            aeOrderPassengersFormValidation = [],
            aeItemsByExtraPassengers = [],
            extraServicesRactive = new Ractive({
                template: template,
                data: {
                    sirenaOrder: sirenaOrder,
                    getAffectedFlights: getAffectedFlights,
                    isExtraPassengerFreeForAllDates: isExtraPassengerFreeForAllDates,
                    activeMealSubgroup: -1
                },
                partials: {
                    orderPrices: orderPricesTemplate,
                    groupedServicesList: groupedServicesListTemplate,
                    aeroexpressList: aeroexpressListTemplate
                }
            });

        init();

        extraServicesRactive.on('switch-service', switchService);

        extraServicesRactive.on('switch-service-insurance', switchServiceInsurance);
        extraServicesRactive.on('switch-insurance-item', switchServiceInsuranceItem);

        extraServicesRactive.on('switch-service-meal', switchServiceMeal);
        extraServicesRactive.on('select-meal-segment-passenger', selectMealSegmentPassenger);
        extraServicesRactive.on('set-passenger-segment-meal', setPassengerSegmentMeal);
        extraServicesRactive.on('select-meal-segment-passenger-mobile', selectMealSegmentPassengerMobile);
        extraServicesRactive.on('set-meal-subgroup', setMealSubgroup);

        extraServicesRactive.on('switch-service-aeroexpress', switchServiceAeroexpress);
        extraServicesRactive.on('add-extra-passenger', addExtraPassenger);
        extraServicesRactive.on('remove-extra-passenger', removeExtraPassenger);
        extraServicesRactive.on('switch-aeroexpress-item', switchAeroexpressItem);
        extraServicesRactive.on('aeroexpress-date-change', aeroexpressDateChange);
        extraServicesRactive.on('open-aeroexpress-schedule-modal', openAeroexpressScheduleModal);

        extraServicesRactive.on('switch-service-baggage', switchServiceBaggage);
        extraServicesRactive.on('decrease-baggage-count', decreaseBaggageCount);
        extraServicesRactive.on('increase-baggage-count', increaseBaggageCount);

        extraServicesRactive.on('switch-service-by-flight-passenger', switchServiceByFlightPassenger);
        extraServicesRactive.on('remove-service-by-flight-passenger', removeServiceByFlightPassenger);

        extraServicesRactive.on('open-conditions-modal', openConditionsModal);

        function init() {

            var externalStorageBaseUrl = app.environmentUrls('externalStorage');
            extraServicesRactive.set('externalStorageBaseUrl', (
                externalStorageBaseUrl ?
                externalStorageBaseUrl + '/img/content/meal' :
                './themes/websky/build/img/content/meal'
            ));

            /*
            app.checkinService.getExtraServices().then(function(resp) {
                availableExtraServices = utils.reformatAvailableExtraServices(resp.extra_services, sirenaOrder);
                if (sirenaOrder.extraPassengers) {
                    extraPassengers = _.clone(sirenaOrder.extraPassengers);
                    aeItemsByExtraPassengers = extraPassengers.map(getItemsForExtraPassenger);
                    extraServicesRactive.set('extraPassengers', extraPassengers);
                    extraServicesRactive.set('aeItemsByExtraPassengers', aeItemsByExtraPassengers);
                }
                extraServicesRactive.set('availableExtraServices', availableExtraServices);
                if (sirenaOrder.extraPassengers) {
                    extraServicesRactive.update().then(function () {
                        aeExtraPassengersFormValidation = extraPassengers.map(createExtraPassengerValidation);
                    });
                }
                aeOrderPassengersFormValidation = sirenaOrder.passengers.map(createOrderPassengerValidation);
                updateBaggageCountByPassengerSegmentsBySubgoupItems();
                updateSelectedMeal();
                updateSelectedAeroexpressDocs();
            });
            */
            updateOrderServices();



        }

        function switchService(event) {
            var btn = $(event.original.target),
                cont = btn.parents('div.availableExtraServiceItem'),
                serviceCode = cont.attr('data-code'),
                service = _.findWhere(availableExtraServices, {
                    code: serviceCode
                });
            editService({
                code: serviceCode
            }, service.active);
            service.active = !service.active;
            extraServicesRactive.set('availableExtraServices', availableExtraServices);
            return false;
        }

        function switchServiceInsurance() {
            var service = _.findWhere(availableExtraServices, {
                code: 'insurance'
            });
            if (service && service.items && service.items.length) {
                if (service.active || service.items.length === 1) {
                    editService(getInsuranceSubmitParams(service), service.active);
                }
                service.active = !service.active;
                extraServicesRactive.set('availableExtraServices', availableExtraServices);
            }
            return false;
        }

        function switchServiceInsuranceItem(event) {
            var chb = $(event.original.target),
                passengerNumStr = chb.attr('data-passenger'),
                passengerNum = passengerNumStr && passengerNumStr * 1,
                itemNum = chb.attr('data-item') * 1,
                active = chb.is(':checked'),
                service = _.findWhere(availableExtraServices, {
                    code: 'insurance'
                });
            editService(
                getInsuranceSubmitParams(service, itemNum, passengerNum),
                !active
            );
        }

        function getInsuranceSubmitParams(service, itemNum, passengerNum) {
            itemNum = itemNum || 0;
            var params = { code: 'insurance' },
                item;
            if (passengerNum !== undefined) {
                item = service.itemsByPassengers[passengerNum][itemNum];
                params.passenger_id = sirenaOrder.passengers[passengerNum].id;
                params.pnr = sirenaOrder.passengers[passengerNum].pnr;
            } else {
                item = service.items[itemNum];
            }
            params.ins = item.ins;
            params.tins = item.tins;
            if (item.productCode) {
                params.productCode = item.productCode;
            }
            if (service.onlineMode) {
                params.code = 'insuranceOnline';
            }
            return params;
        }

        function switchServiceByFlightPassenger(event) {
            var btn = $(event.original.target),
                cont = btn.parents('div.availableExtraServiceItem'),
                passengerSegmentItem = btn.parents('div.passengerSegmentItem'),
                serviceCode = cont.attr('data-code'),
                service = _.findWhere(availableExtraServices, {
                    code: serviceCode
                }),
                segmentNum = passengerSegmentItem.attr('data-flight') * 1,
                passengerNum = passengerSegmentItem.attr('data-passenger') * 1,
                item = utils.getFirstNotEmptySubListItem(
                    service.itemsByPassengerSegments[passengerNum][segmentNum]
                );

            editService({
                code: serviceCode,
                passenger_id: sirenaOrder.passengers[passengerNum].id,
                pnr: sirenaOrder.passengers[passengerNum].pnr,
                segment_id: sirenaOrder.segments[segmentNum].id,
                subgroup: service.commonSubgroup,
                service_type: item.serviceType,
                rfisc: item.rfisc
            }, service.pricesByPassengerSegments[passengerNum][segmentNum]);

            return false;
        }

        function removeServiceByFlightPassenger(event) {
            var link = $(event.original.target),
                cont = link.parents('div.passenger'),
                serviceCont = link.parents('div.availableExtraServiceItem'),
                passengerNum = cont.attr('data-passenger') * 1,
                segmentNum = cont.attr('data-segment') * 1;

            editService({
                code: serviceCont.attr('data-code'),
                passenger_id: sirenaOrder.passengers[passengerNum].id,
                pnr: sirenaOrder.passengers[passengerNum].pnr,
                segment_id: sirenaOrder.segments[segmentNum].id
            }, true);

            return false;
        }

        function editService(params, remove, ignoreOrderUpdate) {
            var method = remove ? 'removeExtraService' : 'modifyExtraService';
            if (ignoreOrderUpdate) {
                return app.checkinService[method](params);
            } else {
                return app.checkinService[method](params).then(updateOrderServices, updateOrderServices);
            }
        }

        function updateOrderExtraServiceSuccess(servicesData, orderData) {
            sirenaOrder = orderData.sirenaOrder;
            availableExtraServices = utils.reformatAvailableExtraServices(servicesData.extra_services, sirenaOrder, availableExtraServices);
            extraServicesRactive.set('availableExtraServices', availableExtraServices);
            extraServicesRactive.set('sirenaOrder', sirenaOrder);
            updateMealMenu();
            updateSelectedMeal();
            updateSelectedAeroexpressDocs();
            updateOrderInfoCallback(orderData);
            if (sirenaOrder.extraPassengers) {
                extraPassengers = _.clone(sirenaOrder.extraPassengers);
                aeItemsByExtraPassengers = extraPassengers.map(getItemsForExtraPassenger);
                extraServicesRactive.set('extraPassengers', extraPassengers);
                extraServicesRactive.set('aeItemsByExtraPassengers', aeItemsByExtraPassengers);
                extraServicesRactive.update().then(function () {
                    aeExtraPassengersFormValidation = extraPassengers.map(createExtraPassengerValidation);
                });
            }
            aeOrderPassengersFormValidation = sirenaOrder.passengers.map(createOrderPassengerValidation);
            updateBaggageCountByPassengerSegmentsBySubgoupItems();
        }

        function updateExtraServiceSuccess(servicesData) {
            return app.checkinService.orderInfo().then(function (orderData) {
                updateOrderExtraServiceSuccess(servicesData, orderData);
            });
        }

        function updateOrderServices() {
            return app.checkinService.getExtraServices().then(updateExtraServiceSuccess);
        }

        function openConditionsModal(event) {
            var btn = $(event.original.target),
                cont = btn.parents('div.availableExtraServiceItem'),
                serviceCode = cont.attr('data-code');
            new ServiceСonditionsModal(serviceCode);
            return false;
        }

        function switchServiceMeal() {

            availableExtraServices.forEach(function (service) {
                if (service.code === 'meal') {
                    if (service.active) {
                        editService({
                            code: 'meal'
                        }, true);
                    }
                    service.active = !service.active;
                    extraServicesRactive.set('availableExtraServices', availableExtraServices);
                }
            });

            return false;
        }

        function selectMealSegmentPassenger(event) {
            var link = $(event.original.target),
                cont = link.parents('div.passenger');
            activeMealPassenger = cont.attr('data-passenger') * 1;
            activeMealSegment = cont.attr('data-segment') * 1;
            extraServicesRactive.set('activeMealPassenger', activeMealPassenger);
            extraServicesRactive.set('activeMealSegment', activeMealSegment);
            updateMealMenu();
            return false;
        }

        function selectMealSegmentPassengerMobile(event) {
            selectMealSegmentPassenger(event);
            selectMealModal = new SelectMealModal(
                mealMenu,
                sirenaOrder.passengers[activeMealPassenger],
                sirenaOrder.segments[activeMealSegment],
                mobileMealSelectCallback
            );
            return false;
        }

        function setMealSubgroup(event) {
            var link = $(event.original.target);
            extraServicesRactive.set('activeMealSubgroup', link.attr('data-subgroup') * 1);
            return false;
        }

        function mobileMealSelectCallback(mealItem, subgroupNum) {
            var mealService = _.findWhere(availableExtraServices, { code: 'meal' });
            editService({
                code: 'meal',
                passenger_id: sirenaOrder.passengers[activeMealPassenger].id,
                pnr: sirenaOrder.passengers[activeMealPassenger].pnr,
                segment_id: sirenaOrder.segments[activeMealSegment].id,
                subgroup: mealService.subgroups[subgroupNum],
                service_type: mealItem.serviceType,
                rfisc: mealItem.rfisc
            });
        }

        function updateMealMenu() {
            var mealService = _.findWhere(availableExtraServices, { code: 'meal' });
            if (activeMealPassenger !== undefined && activeMealSegment !== undefined) {
                mealMenu = mealService.itemsByPassengerSegments[activeMealPassenger][activeMealSegment];
                extraServicesRactive.set('mealMenu', mealMenu);
            }
        }

        function setPassengerSegmentMeal(event) {

            var link = $(event.original.target),
                cont = link.parents('div.item'),
                subgroupNum = cont.attr('data-subgroup') * 1,
                itemNum = cont.attr('data-item') * 1,
                mealService = _.findWhere(availableExtraServices, { code: 'meal' }),
                mealItem = mealMenu[subgroupNum][itemNum],
                newMealParams = {
                    code: 'meal',
                    passenger_id: sirenaOrder.passengers[activeMealPassenger].id,
                    pnr: sirenaOrder.passengers[activeMealPassenger].pnr,
                    segment_id: sirenaOrder.segments[activeMealSegment].id,
                    subgroup: mealService.subgroups[subgroupNum],
                    service_type: mealItem.serviceType,
                    rfisc: mealItem.rfisc
                },
                selectedMeal = getSelectedPassengerFlightMeal(activeMealPassenger, activeMealSegment);

            if (selectedMeal) {
                editService({
                    code: 'meal',
                    passenger_id: sirenaOrder.passengers[activeMealPassenger].id,
                    pnr: sirenaOrder.passengers[activeMealPassenger].pnr,
                    segment_id: sirenaOrder.segments[activeMealSegment].id,
                    subgroup: selectedMeal.subgroupCode,
                    service_type: selectedMeal.serviceType,
                    rfisc: selectedMeal.rfisc
                }, true, true).then(function () {
                    editService(newMealParams);
                });
            } else {
                editService(newMealParams);
            }
            return false;

        }

        function getSelectedPassengerFlightMeal(passengerNum, flightNum) {
            var result = false,
                passengerSegmentServices,
                passengerSegmentMeal;
            if (sirenaOrder.editableExtraServicesByPassengers) {
                if (sirenaOrder.editableExtraServicesByPassengers[passengerNum]) {
                    /* jshint maxlen: 150 */
                    passengerSegmentServices = sirenaOrder.editableExtraServicesByPassengers[passengerNum].passengerSegmentServices[flightNum];
                    if (passengerSegmentServices) {
                        passengerSegmentMeal = _.findWhere(passengerSegmentServices, { code: 'meal' });
                        if (passengerSegmentMeal) {
                            result = passengerSegmentMeal.serviceItem;
                        }
                    }
                }
            }
            return result;
        }

        function updateSelectedMeal() {
            if (sirenaOrder) {
                selectedMealByPassengerSegments = sirenaOrder.passengers.map(function (passenger, passengerNum) {
                    return sirenaOrder.segments.map(function (segment, segmentNum) {
                        return getSelectedPassengerFlightMeal(passengerNum, segmentNum);
                    });
                });
                extraServicesRactive.set('selectedMealByPassengerSegments', selectedMealByPassengerSegments);
            }
        }

        function updateSelectedAeroexpressDocs() {
            var aeroexpressService,
                orderAeroexpressService,
                orderAeroexpressItem;

            if (sirenaOrder) {
                aeroexpressService = _.findWhere(availableExtraServices, { code: 'aeroexpress' });
                orderAeroexpressService = _.findWhere(sirenaOrder.editableExtraServices, { code: 'aeroexpress' });

                if (
                    aeroexpressService &&
                    aeroexpressService.documents &&
                    aeroexpressService.documents.length
                ) {
                    sirenaOrder.passengers.forEach(function (passenger) {
                        if (
                            orderAeroexpressService &&
                            orderAeroexpressService.items &&
                            orderAeroexpressService.items.length
                        ) {
                            orderAeroexpressItem = _.findWhere(orderAeroexpressService.items, {
                                firstName: passenger.firstName,
                                lastName: passenger.lastName,
                                dateOfBirth: passenger.dateOfBirth
                            });
                        }

                        if (orderAeroexpressItem) {
                            passenger.aeroexpressDocumentNumber = orderAeroexpressItem.documentNumber;
                            passenger.aeroexpressDocumentType = orderAeroexpressItem.documentType;
                        } else if (
                                _.findWhere(
                                    aeroexpressService.documents,
                                    { code: passenger.documentCode }
                                )
                        ) { 
                            passenger.aeroexpressDocumentType = passenger.documentCode;
                            passenger.aeroexpressDocumentNumber = passenger.documentNumber;
                        } else {
                            passenger.aeroexpressDocumentType = aeroexpressService.documents[0].code;
                        }
                        
                    });
                    extraServicesRactive.set('sirenaOrder', sirenaOrder);
                }
            }
        }

        function switchServiceAeroexpress() {
            var aeroexpressService = _.findWhere(availableExtraServices, {
                code: 'aeroexpress'
            });
            if (aeroexpressService.active) {
                editService({
                    code: 'aeroexpress'
                }, true);
            }
            aeroexpressService.active = !aeroexpressService.active;
            extraServicesRactive.set('availableExtraServices', availableExtraServices);
            return false;
        }

        function addExtraPassenger() {
            extraPassengers.push({});
            aeItemsByExtraPassengers.push(getItemsForExtraPassenger());
            extraServicesRactive.update().then(function () {
                aeExtraPassengersFormValidation.push(createExtraPassengerValidation(extraPassengers[extraPassengers.length-1], extraPassengers.length-1));
            });
            return false;
        }

        function createExtraPassengerValidation(pax, num) {

            var aeroexpressService = _.findWhere(availableExtraServices, {
                    code: 'aeroexpress'
                }),
                form = $('form[name="extraPassengerDocForms[' + num + ']"]')[0];

            $('input[name="dateOfBirth"]', form).mask('00.00.0000');

            return new Validation({
                form: form,
                rules: {
                    lastName: {
                        required: true,
                        testByRegExp: aeroexpressService.passengerLastNameRegexp,
                        formatMess: 'oxygen-check-in.messages.aeroexpress.invalidLastName'
                    },
                    firstName: {
                        required: true,
                        testByRegExp: aeroexpressService.passengerFirstNameRegexp,
                        formatMess: 'oxygen-check-in.messages.aeroexpress.invalidFirstName'
                    },
                    dateOfBirth: {
                        required: true
                    },
                    documentType: {
                        required: true
                    },
                    documentNumber: {
                        required: true
                    }
                }
            });

        }

        function createOrderPassengerValidation(pax, num) {

            return new Validation({
                form: $('form[name="passengerDocForms[' + num + ']"]')[0],
                rules: {
                    documentType: {
                        required: true
                    },
                    documentNumber: {
                        required: true
                    }
                }
            });

        }

        function removeExtraPassenger(event) {
            var btn = $(event.original.target),
                passengerNum = btn.attr('data-passenger') * 1;
            extraPassengers.splice(passengerNum, 1);
            aeItemsByExtraPassengers.splice(passengerNum, 1);
            aeExtraPassengersFormValidation.splice(passengerNum, 1);
            return false;
        }

        function getItemsForExtraPassenger(passengerData) {
            var aeroexpressService = _.findWhere(availableExtraServices, {
                code: 'aeroexpress'
            });
            return aeroexpressService.items.map(function (item) {
                var passengerItem = _.clone(item);
                if (passengerData) {
                    passengerItem.firstName = passengerData.firstName;
                    passengerItem.lastName = passengerData.lastName;
                    passengerItem.dateOfBirth = passengerData.dateOfBirth;
                    passengerItem.documentType = passengerData.documentType;
                    passengerItem.documentNumber = passengerData.documentNumber;
                }
                passengerItem.selected = isPassengerItemSelected(passengerItem, sirenaOrder);

                if (passengerItem.selected) {
                    passengerItem.selectedDate = getPassengerItemSelectedDate(passengerItem, sirenaOrder);
                } else {
                    passengerItem.selectedDate = passengerItem.dates[0];
                }

                return passengerItem;
            });
        }

        function isPassengerItemSelected(passengerItem, sirenaOrder) {
            var orderAeroexpressService = _.findWhere(sirenaOrder.editableExtraServices, { code: 'aeroexpress' });
            if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
                return !!_.findWhere(orderAeroexpressService.items, {
                    departure_code: passengerItem.departure_code,
                    arrival_code: passengerItem.arrival_code,
                    firstName: passengerItem.firstName,
                    lastName: passengerItem.lastName
                });
            }
            return false;
        }

        function getPassengerItemSelectedDate(passengerItem, sirenaOrder) {
            var orderAeroexpressService = _.findWhere(sirenaOrder.editableExtraServices, { code: 'aeroexpress' });
            if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
                return _.findWhere(orderAeroexpressService.items, {
                    departure_code: passengerItem.departure_code,
                    arrival_code: passengerItem.arrival_code,
                    firstName: passengerItem.firstName,
                    lastName: passengerItem.lastName
                }).departure_date;
            }
        }

        function openAeroexpressScheduleModal(event) {
            var link = $(event.original.target),
                date = link.attr('data-date'),
                arrivalCode = link.attr('data-arrival-code'),
                departureCode = link.attr('data-departure-code'),
                arrival = link.attr('data-arrival'),
                departure = link.attr('data-departure');
            aeroexpressScheduleModal = new AeroexpressScheduleModal({
                date: date,
                arrival: arrivalCode,
                departure: departureCode
            }, arrival, departure);
            return false;
        }

        function switchAeroexpressItem(event) {
            var link = $(event.original.target),
                passengerNum = link.attr('data-passenger') * 1,
                isExtraPassenger = (link.attr('data-is-extra-passenger') === 'true'),
                itemNum = link.attr('data-item'),
                aeroexpressService = _.findWhere(availableExtraServices, {
                    code: 'aeroexpress'
                }),
                passenger = (
                    isExtraPassenger ?
                    extraServicesRactive.get('extraPassengers')[passengerNum] :
                    extraServicesRactive.get('sirenaOrder').passengers[passengerNum]
                ),
                passengerItem = (
                    isExtraPassenger ?
                    aeItemsByExtraPassengers[passengerNum][itemNum] :
                    aeroexpressService.itemsByPassengers[passengerNum][itemNum]
                ),
                isFormValid = (
                    isExtraPassenger ?
                    aeExtraPassengersFormValidation[passengerNum].getValidStatus() :
                    aeOrderPassengersFormValidation[passengerNum].getValidStatus()
                );

            if (isFormValid) {
                editService({
                    code: 'aeroexpress',
                    departure_code: passengerItem.departure_code,
                    arrival_code: passengerItem.arrival_code,
                    firstName: passenger.firstName,
                    lastName: passenger.lastName,
                    dateOfBirth: passenger.dateOfBirth,
                    documentType: passenger.aeroexpressDocumentType,
                    documentNumber: passenger.aeroexpressDocumentNumber,
                    date: passengerItem.selectedDate,
                    type: calcFareType(passengerItem, aeroexpressService.passengersChild[passengerNum])
                }, !passengerItem.selected);
            }

        }

        function aeroexpressDateChange(event) {
            var link = $(event.original.target),
                passengerNum = link.attr('data-passenger'),
                isExtraPassenger = (link.attr('data-is-extra-passenger') === 'true'),
                itemNum = link.attr('data-item'),
                aeroexpressService = _.findWhere(availableExtraServices, {
                    code: 'aeroexpress'
                }),
                passenger = (
                    isExtraPassenger ?
                    extraServicesRactive.get('extraPassengers')[passengerNum] :
                    extraServicesRactive.get('sirenaOrder').passengers[passengerNum]
                ),
                passengerItem = (
                    isExtraPassenger ?
                    aeItemsByExtraPassengers[passengerNum][itemNum] :
                    aeroexpressService.itemsByPassengers[passengerNum][itemNum]
                );
            if (passengerItem.selected) {
                editService({
                    code: 'aeroexpress',
                    departure_code: passengerItem.departure_code,
                    arrival_code: passengerItem.arrival_code,
                    firstName: passenger.firstName,
                    lastName: passenger.lastName,
                    dateOfBirth: passenger.dateOfBirth,
                    documentType: passenger.aeroexpressDocumentType,
                    documentNumber: passenger.aeroexpressDocumentNumber,
                    date: passengerItem.selectedDate,
                    type: calcFareType(passengerItem, aeroexpressService.passengersChild[passengerNum])
                });
            }
        }

        function calcFareType(passengerItem, isChildByDate) {
            if (passengerItem.fares) {
                if (passengerItem.fares.length === 1) {
                    return passengerItem.fares.fare_type;
                } else {
                    if (isChildByDate && isChildByDate[passengerItem.selectedDate]) {
                        if (_.findWhere(passengerItem.fares, { fare_type: 'child' })) {
                            return 'child';
                        }
                    }
                }
            }
            return 'full';
        }

        function switchServiceBaggage() {
            var baggageService = _.findWhere(availableExtraServices, {
                code: 'baggage'
            });
            if (baggageService.active) {
                editService({
                    code: 'baggage'
                }, true);
            }
            baggageService.active = !baggageService.active;
            extraServicesRactive.set('availableExtraServices', availableExtraServices);
            return false;
        }

        function decreaseBaggageCount(event) {
            var btn = $(event.original.target),
                disabled = btn.hasClass('disabled'),
                baggageControl = btn.parents('div.baggageControl'),
                segmentNum = baggageControl.attr('data-segment') * 1,
                passengerNum = baggageControl.attr('data-passenger') * 1,
                subgroupNum = baggageControl.attr('data-subgroup') * 1,
                count = baggageControl.attr('data-count') * 1,
                subgroupCode = baggageControl.attr('data-subgroup-code'),
                itemNum = baggageControl.attr('data-item') * 1,
                baggageService = _.findWhere(availableExtraServices, {
                    code: 'baggage'
                }),
                baggageItem = baggageService.itemsByPassengerSegments[passengerNum][segmentNum][subgroupNum][itemNum];
            if (!disabled) {
                changeBaggageCount(segmentNum, passengerNum, baggageItem, subgroupCode, count - 1);
            }
            return false;
        }

        function increaseBaggageCount(event) {
            var btn = $(event.original.target),
                disabled = btn.hasClass('disabled'),
                baggageControl = btn.parents('div.baggageControl'),
                segmentNum = baggageControl.attr('data-segment') * 1,
                passengerNum = baggageControl.attr('data-passenger') * 1,
                subgroupNum = baggageControl.attr('data-subgroup') * 1,
                count = baggageControl.attr('data-count') * 1,
                subgroupCode = baggageControl.attr('data-subgroup-code'),
                itemNum = baggageControl.attr('data-item') * 1,
                baggageService = _.findWhere(availableExtraServices, {
                    code: 'baggage'
                }),
                baggageItem = baggageService.itemsByPassengerSegments[passengerNum][segmentNum][subgroupNum][itemNum];
            if (!disabled) {
                changeBaggageCount(segmentNum, passengerNum, baggageItem, subgroupCode, count + 1);
            }
            return false;
        }

        function changeBaggageCount(segmentNum, passengerNum, baggageItem, subgroupCode, count) {
            editService({
                code: 'baggage',
                passenger_id: sirenaOrder.passengers[passengerNum].id,
                pnr: sirenaOrder.passengers[passengerNum].pnr,
                segment_id: sirenaOrder.segments[segmentNum].id,
                subgroup: subgroupCode,
                amount: count,
                service_type: baggageItem.serviceType,
                rfisc: baggageItem.rfisc
            }).then(updateBaggageCountByPassengerSegmentsBySubgoupItems, updateBaggageCountByPassengerSegmentsBySubgoupItems);
        }


        function getBaggageCountByPassengerSegmentsBySubgoupItems(sirenaOrder, availableExtraServices) {
            var orderBaggageService = _.findWhere(sirenaOrder.editableExtraServices, {
                    code: 'baggage'
                }),
                availableBaggageService = _.findWhere(availableExtraServices, {
                    code: 'baggage'
                });
            if (sirenaOrder.passengers) {
                return sirenaOrder.passengers.map(function(passenger, passengerNum) {
                    return sirenaOrder.segments.map(function(flight, flightNum) {
                        var passengerSegmentCounts = [];
                        if (availableBaggageService && availableBaggageService.passengers) {
                            availableBaggageService.passengers.forEach(function(servicePassenger) {
                                if (
                                    servicePassenger.id === passenger.id &&
                                    servicePassenger.pnr === passenger.pnr
                                ) {
                                    servicePassenger.segments.forEach(function(servicePassengerSegment) {
                                        if (servicePassengerSegment.id === flight.id) {

                                            passengerSegmentCounts = availableBaggageService.subgroups.map(function(subgoup, subgoupNum) {
                                                if (availableBaggageService.itemsByPassengerSegments[passengerNum][flightNum][subgoupNum]) {
                                                    return availableBaggageService.itemsByPassengerSegments[passengerNum][flightNum][subgoupNum].map(function(tmpItem) {
                                                        var orderServicePassengerSegment = getOrderServicePassengerSegment(orderBaggageService, passenger.id, passenger.pnr, flight.id),
                                                            selectedTmpItem;
                                                        if (orderServicePassengerSegment && orderServicePassengerSegment.selectedExtraServices) {
                                                            selectedTmpItem = _.findWhere(
                                                                orderServicePassengerSegment.selectedExtraServices, {
                                                                    rfisc: tmpItem.rfisc,
                                                                    subgroupCode: subgoup.code
                                                                }
                                                            );
                                                        }
                                                        if (selectedTmpItem && selectedTmpItem.amount) {
                                                            return selectedTmpItem.amount;
                                                        } else {
                                                            return 0;
                                                        }
                                                    });
                                                }
                                            });

                                        }
                                    });
                                }
                            });
                        }
                        return passengerSegmentCounts;
                    });
                });
            }
        }

        function getOrderServicePassengerSegment(orderService, passengerId, pnr, segmentId) {
            var i, j;
            if (orderService && orderService.passengers) {
                for (i = 0; i < orderService.passengers.length; i++) {
                    if (
                        orderService.passengers[i].id === passengerId &&
                        orderService.passengers[i].pnr === pnr &&
                        orderService.passengers[i].segments
                    ) {
                        for (j = 0; j < orderService.passengers[i].segments.length; j++) {
                            if (orderService.passengers[i].segments[j].id === segmentId) {
                                return orderService.passengers[i].segments[j];
                            }
                        }
                    }
                }
            }
        }

        function updateBaggageCountByPassengerSegmentsBySubgoupItems() {
            baggageCountByPassengerSegmentsBySubgoupItems = getBaggageCountByPassengerSegmentsBySubgoupItems(sirenaOrder, availableExtraServices);
            extraServicesRactive.set('baggageCountByPassengerSegmentsBySubgoupItems', baggageCountByPassengerSegmentsBySubgoupItems);
        }

        function getAffectedFlights(list) {
            return list.map(function (segId) {
                return _.findWhere(sirenaOrder.segments, {
                    id: segId
                });
            });
        }

        function isExtraPassengerFreeForAllDates(passengerNum) {
            var dateOfBirth = moment(extraPassengers[passengerNum].dateOfBirth, 'DD.MM.YYYY'),
                i, j;
            for (i = 0; i < aeItemsByExtraPassengers[passengerNum].length; i++) {
                for (j = 0; j < aeItemsByExtraPassengers[passengerNum][i].dates.length; j++) {
                    // Если дата АЭ минус 5 лет позже даты рождения - билет платный
                    if (
                        moment(
                            aeItemsByExtraPassengers[passengerNum][i].dates[j],
                            'DD.MM.YYYY'
                        ).subtract(
                            app.siteParams('check-in.aeroexpressMinChildAge'), 'years'
                        ).isAfter(dateOfBirth)
                    ) {
                        return false;
                    }
                }
            }
            return true;
        }

        return extraServicesRactive;

    }

    module.exports = ExtraServices;

}());

},{"./libs/utils.js":20,"./libs/validation.js":21,"./modals/aeroexpressSchedule.js":23,"./modals/selectMeal.js":33,"./modals/serviceСonditions.js":39,"./templates/includes/aeroexpressList.html":48,"./templates/includes/extraServices.html":50,"./templates/includes/groupedServicesList.html":51,"./templates/includes/orderPrices.html":52}],17:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Ajaxer plugin
* @purpose Useful cover of standard jQuery ajax method.
*/

/*
    http://localhost:8081/checkin/docson/#addToOrder.json
    http://localhost:8081/checkin/docson/#orderInfo.json
    http://localhost:8081/checkin/docson/#rejectCheckIn.json
*/

var Modal = require('./modal.js'),
    errorModal;

if (o2context.debug) {
    var JSV = require("JSV").JSV,
        JSVEnvironment = JSV.createEnvironment();
}

$.fn.ajaxer = function (options) {

    'use strict';
    var domNode = this;

    return new Promise(function (resolve, reject) {

        var switchIndicator = function (flag) {
                if (this.indicator.length) {
                    if (flag) {
                        this.indicator.addClass("loading");
                    } else {
                        this.indicator.removeClass("loading");
                    }
                }
            },
            globalErrorCallback = function (resp) {

                /* Global error callback */

                if (app.siteAliases) {

                    var errorMessage = "oxygen-check-in.error.common.json";

                    if (resp && resp.error && typeof (resp.error) === "string") {
                        errorMessage = resp.error;
                    }

                    if (errorModal) {
                        errorModal.teardown();
                    }

                    errorModal = new Modal({
                        data: {
                            cssClass: "ajaxer-error-modal"
                        },
                        partials: {
                            modalHeader: app.siteAliases('oxygen-check-in.messages.error'),
                            modalContent: '<div class="modal-content">' + app.siteAliases(errorMessage) + '</div>'
                        }
                    });

                    resp.errorModal = errorModal;
                    console.log('Ajaxer error:', errorMessage, errorModal);


                }

                reject(resp);

            },
            settings = $.extend({
                type: "POST",
                dataType: "json",
                switchMethod: switchIndicator,
                indicator: $(domNode),
                async: true,
                timeout: (2 * 60 * 1000),
                success: function (resp) {

                    if (o2context.debug) {
                        if (resp.$schema) {

                            $.ajax({
                                url: resp.$schema,
                                success: function (schema) {

                                    var report = JSVEnvironment.validate(resp, schema);
                                    if (report.errors.length !== 0) {
                                        console.error('Invalid JSON: ', report.errors);
                                    }
                                    settings.switchMethod(false);
                                    if (!resp || resp.error) {
                                        globalErrorCallback(resp);
                                        return;
                                    }

                                    /* Global success callback */
                                    resolve(resp);


                                },
                                error: function () {
                                    console.error('Invalid JSON - schema undefined!');
                                    reject(resp);
                                }
                            });

                        } else {
                            console.error('Invalid JSON - schema undefined!');
                            reject(resp);
                        }
                    } else {

                        settings.switchMethod(false);
                        if (!resp || resp.error) {
                            globalErrorCallback(resp);
                            return;
                        }

                        /* Global success callback */
                        resolve(resp);

                    }

                },
                error: function (resp) {

                    settings.switchMethod(false);
                    globalErrorCallback(resp);

                }
            }, options);

        settings.switchMethod(true);
        $.ajax(settings);

    });


};

$.fn.ajaxer.prototype = $.fn;

},{"./modal.js":18,"JSV":5}],18:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Modal
* @purpose Modal window module
*/

var modalTemplate = require('../templates/modal.html');

(function (window) {

    'use strict';

    var Modal = Ractive.extend({

        el: 'oxyCheckinApp',
        append: true,
        template: modalTemplate,

        onrender: function () {
            var self = this, resizeHandler = function () {
                self.center();
            };

            this.outer = this.find('div.modal-cont');
            this.modal = this.find('div.modal');

            this.on('outside-click', function (event) {
                if (!self.disableContClick && $(event.original.target).hasClass('modal-cont')) {
                    self.fire('close', event);
                }
            });
            this.on('close', function (event) {
                if ((document.body.contains(event.original.target) && !this.modal.contains(event.original.target)) || $(event.original.target).hasClass('btn-close')) {
                    this.teardown();
                }
            });

            window.addEventListener('resize', resizeHandler, false);
            this.on('teardown', function () {
                window.removeEventListener('resize', resizeHandler);
            }, false);
            this.center();
        },

        center: function () {
            var outerHeight, modalHeight, verticalSpace;
            outerHeight = this.outer.clientHeight;
            modalHeight = this.modal.clientHeight;
            verticalSpace = (outerHeight - modalHeight) / 2;
            this.modal.style.top = verticalSpace + 'px';
        }
    });

    module.exports = Modal;

}(window));

},{"../templates/modal.html":58}],19:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name selectPicker plugin
* @purpose Select decorator.
*/

$(function () {

    'use strict';

    $("body").on("click", function (e) {
        var target = $(e.target);
        if (target.hasClass("selectpicker-item") && !target.hasClass("selectpicker-item-disabled")) {
            target.parents("div.selectpicker").prev().val(target.attr("data-code")).trigger("change");
            $("div.selectpicker-button", target.parents("div.selectpicker")).text(target.text());
            $("div.selectpicker-list", target.parents("div.selectpicker")).hide();

        } else if (target.hasClass("selectpicker-button") || target.hasClass("selectpicker-dropdown")) {
            $("div.selectpicker-list").hide();
            if (!target.parents("div.selectpicker").hasClass("disabled-selectpicker")) {
                $("div.selectpicker-list", target.parents("div.selectpicker")).show();
            }
        } else {
            $("div.selectpicker-list").hide();
        }
    });

});

$.fn.selectPicker = function (options) {

    'use strict';

    var settings = $.extend({
            containerTemplate: '<div class="selectpicker"><div class="selectpicker-dropdown"></div><div class="selectpicker-button"></div><div class="selectpicker-list"></div></div>'
        }, options),
        elements = this;

    function getItemsHtml(select) {
        var html = '',
            items = $("option", select);

        items.each(function (i, item) {
            var code = $(item).attr("value"),
                disabled = !!$(item).attr("disabled"),
                value = $(item).text();
            html += '<div class="selectpicker-item ';
            if (disabled) {
                html += 'selectpicker-item-disabled';
            }
            html += '" data-code="' + (code || value) + '">' + value + '</div>';
        });

        return html;
    }

    function initContainer() {
        elements.each(function (i, element) {
            var select = $(element),
                container = select.next();
            if (!container.hasClass("selectpicker")) {
                select.after(settings.containerTemplate).hide();
                container = select.next();
                container.addClass(select.attr("class"));
            }
        });
    }

    function updateDisabledState() {
        elements.each(function (i, element) {
            var select = $(element),
                container = select.next();
            if (select.is(':disabled')) {
                container.addClass("disabled-selectpicker");
            } else {
                container.removeClass("disabled-selectpicker");
            }
        });
    }

    function updateItems() {
        elements.each(function (i, element) {
            var select = $(element),
                container = select.next(),
                currentCode = select.val(),
                currentValue = $("option[value='" + currentCode + "']", select).text();
            if (container.hasClass("selectpicker")) {
                if (currentValue) {
                    $("div.selectpicker-button", container).text(currentValue);
                }
                $("div.selectpicker-list", container).html(getItemsHtml(select));
            }
        });
    }

    initContainer();
    updateDisabledState();
    updateItems();

    return {
        updateItems: updateItems,
        updateDisabledState: updateDisabledState
    };



};

$.fn.selectPicker.prototype = $.fn;

},{}],20:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Useful utils collection
* @purpose Simple lib
*/

(function (window) {

    'use strict';

    var sessionStoragePropDocumentsAndFFP = 'webCheckInDocumentsAndFFP';

    function formatPriceNum(num) {

        var str = String(num),
            resultStr = '',
            paths = str.split("."),
            i,
            from,
            to;
        str = paths[0];

        for (i = str.length; i > 0; i -= 3) {
            from = i - 3;
            to = 3;
            if (from < 0) {
                to = from + 3;
                from = 0;
            }
            resultStr = str.substr(from, to) + " " + resultStr;
        }

        if (paths[1] && paths[1] !== "0" && paths[1] !== "00") {
            if (paths[1].length === 1) {
                paths[1] = paths[1] + "0";
            }
            resultStr = resultStr.trim() + "." + paths[1] + " ";
        }

        resultStr = resultStr.replace(/\s/g, "&nbsp;");

        return resultStr;

    }

    function getValueProps(source) {
        var target = {};
        source = source || {};
        _.each(source, function (item, name) {
            if (item && item.value) {
                target[name] = item.value;
            }
        });
        return target;
    }

    function setValueProps(target, source) {
        target = target || {};
        _.each(source, function (val, name) {
            if (target[name]) {
                target[name].value = val;
            } else {
                target[name] = {
                    value: val
                };
            }
        });
        return target;
    }

    function getNameValueObj(fields) {
        var nameValueObj = {};
        _.each(fields, function (field) {
            nameValueObj[field.name] = field.value;
        });
        return nameValueObj;
    }

    function setNameValueObj(fields, nameValueObj) {
        if (nameValueObj) {
            _.each(fields, function (field) {
                if (nameValueObj[field.name]) {
                    field.value = nameValueObj[field.name];
                }
            });
        }
        return fields;
    }

    function getDocumentsAndFFPbyPassenger(passenger) {
        var targetSegments = [];
        _.each(passenger.segments, function (sourceSegment) {
            var targetSegment = {
                document: getNameValueObj(sourceSegment.document.fields)
            };
            if (sourceSegment.visa && sourceSegment.visa.required) {
                if (!sourceSegment.visa.checkboxNotRequired) {
                    targetSegment.visa = getNameValueObj(sourceSegment.visa.fields);
                } else {
                    targetSegment.visaCheckboxNotRequired = true;
                }
            }
            if (sourceSegment.ffpCardNumber) {
                targetSegment.ffpCardNumber = sourceSegment.ffpCardNumber;
            }
            targetSegments.push(targetSegment);
        });
        return {
            astraVirtualId: passenger.astraVirtualId,
            segments: targetSegments
        };
    }

    function getDocumentsAndFFPOnePassengerOneSegment(passenger, segmentIndex) {
        var result = {
            document: getNameValueObj(passenger.segments[segmentIndex].document.fields)
        };

        if (passenger.segments[segmentIndex].visa.required) {
            if (!passenger.segments[segmentIndex].visa.checkboxNotRequired) {
                result.visa = getNameValueObj(passenger.segments[segmentIndex].visa.fields);
            } else {
                result.visaCheckboxNotRequired = true;
            }
        }

        if (passenger.segments[segmentIndex].ffpCardNumber) {
            result.ffpCardNumber = passenger.segments[segmentIndex].ffpCardNumber;
        }

        return  JSON.stringify(result);
    }

    function getDocumentsAndFFP(passengers) {
        var documentsAndFFP = [];
        _.each(passengers, function (passenger) {
            if (passenger.selected) {
                documentsAndFFP.push(getDocumentsAndFFPbyPassenger(passenger));
                if (passenger.child) {
                    documentsAndFFP.push(getDocumentsAndFFPbyPassenger(passenger.child));
                }
            }
        });
        return JSON.stringify(documentsAndFFP);
    }

    function setDocumentsAndFFPbyPassenger(passenger, documentsAndFFP) {
        var documentsAndFFPitem = _.findWhere(documentsAndFFP, {astraVirtualId: passenger.astraVirtualId});
        if (documentsAndFFPitem && documentsAndFFPitem.segments && documentsAndFFPitem.segments.length) {
            _.each(passenger.segments, function (segment, segNum) {
                segment.document.fields = setNameValueObj(segment.document.fields, documentsAndFFPitem.segments[segNum].document);
                segment.visa.fields = setNameValueObj(segment.visa.fields, documentsAndFFPitem.segments[segNum].visa);
                if (documentsAndFFPitem.segments[segNum].visaCheckboxNotRequired) {
                    segment.visa.checkboxNotRequired = true;
                }
                segment.ffpCardNumber = documentsAndFFPitem.segments[segNum].ffpCardNumber;
            });
        }
    }

    function setDocumentsAndFFP(passengers, documentsAndFFPjson) {
        var documentsAndFFP = JSON.parse(documentsAndFFPjson);
        _.each(passengers, function (passenger) {
            if (passenger.selected) {
                setDocumentsAndFFPbyPassenger(passenger, documentsAndFFP);
                if (passenger.child) {
                    setDocumentsAndFFPbyPassenger(passenger.child, documentsAndFFP);
                }
            }
        });
    }

    function setSavePaxData(segmentData, savePaxData) {

        _.each(segmentData.visa.fields, function (field) {
            if (field.name === 'number' && savePaxData.visaNumber) { field.value = savePaxData.visaNumber; }
            if (field.name === 'issueCity' && savePaxData.visaIssueCity) { field.value = savePaxData.visaIssueCity; }
            if (field.name === 'issueCountry' && savePaxData.visaIssueCountry) { field.value = savePaxData.visaIssueCountry; }
            if (field.name === 'issueDate' && savePaxData.visaIssueDate) { field.value = savePaxData.visaIssueDate; }
            if (field.name === 'expirationDate' && savePaxData.visaExpirationDate) { field.value = savePaxData.visaExpirationDate; }
            if (field.name === 'hostCountry' && savePaxData.visaHostCountry) { field.value = savePaxData.visaHostCountry; }
            if (field.name === 'birthPlace' && savePaxData.visaBirthPlace) { field.value = savePaxData.visaBirthPlace; }
        });

        segmentData.visa.checkboxNotRequired = !!savePaxData.visaNotRequired;

        _.each(segmentData.document.fields, function (field) {
            if (field.name === 'type' && savePaxData.documentType) { field.value = savePaxData.documentType; }
            if (field.name === 'nationality' && savePaxData.documentNationality) { field.value = savePaxData.documentNationality; }
            if (field.name === 'number' && savePaxData.documentNumber) { field.value = savePaxData.documentNumber; }
            if (field.name === 'gender' && savePaxData.documentGender) { field.value = savePaxData.documentGender; }
            if (field.name === 'birthDate' && savePaxData.documentBirthDate) { field.value = savePaxData.documentBirthDate; }
            if (field.name === 'issueCountry' && savePaxData.documentIssueCountry) { field.value = savePaxData.documentIssueCountry; }
            if (field.name === 'expirationDate' && savePaxData.documentExpirationDate) { field.value = savePaxData.documentExpirationDate; }
        });

        segmentData.ffpCardNumber = savePaxData.ffpCardNumber;

    }

    function checkByRegExp(value, regExp) {
        return (new RegExp(regExp)).test(value);
    }

    function checkInternational(value) {
        return checkByRegExp(value, '^[-.: a-zA-Z0-9]+$');
    }

    function checkPassengerSegmentData(passengerSegment) {

        var todayMoment = moment().startOf('day').fromNow(),
            visa = passengerSegment.visa,
            validVisa = true,
            validDocument = true,
            validFFP = true,
            document = passengerSegment.document,
            ffpCardNumber = passengerSegment.ffpCardNumber;

        if (visa.required && !visa.checkboxNotRequired) {
            _.each(visa.fields, function (field) {
                if (field.required && !field.value) {
                    validVisa = false;
                }
                if (field.value) {
                    if (field.name === 'number' && !checkByRegExp(field.value, app.constants.visaNumberRegexp)) {
                        validVisa = false;
                    }
                    if (field.name === 'issueCity' && !checkByRegExp(field.value, app.constants.visaIssueCityRegexp)) {
                        validVisa = false;
                    }
                    if (field.name === 'birthPlace' && !checkByRegExp(field.value, app.constants.visaBirthPlaceRegexp)) {
                        validVisa = false;
                    }
                    if (field.name === 'issueDate' && (!moment(field.value, "DD.MM.YYYY").isValid() || moment(field.value, "DD.MM.YYYY").isAfter(todayMoment))) {
                        validVisa = false;
                    }
                    if (field.name === 'expirationDate' && (!moment(field.value, "DD.MM.YYYY").isValid() || moment(field.value, "DD.MM.YYYY").isBefore(todayMoment))) {
                        validVisa = false;
                    }
                    if (visa.isInternational && !checkInternational(field.value)) {
                        validVisa = false;
                    }
                }
            });
        }

        _.each(document.fields, function (field) {
            if (field.required && !field.value) {
                validDocument = false;
            }
            if (field.value) {
                if (field.name === 'number' && !checkByRegExp(field.value, app.constants.documentNumberRegexp)) {
                    validDocument = false;
                }
                if (field.name === 'expirationDate' && (!moment(field.value, "DD.MM.YYYY").isValid() || moment(field.value, "DD.MM.YYYY").isBefore(todayMoment))) {
                    validDocument = false;
                }
            }
        });

        if (ffpCardNumber && !checkByRegExp(ffpCardNumber, app.constants.ffpNumber)) {
            validFFP = false;
        }

        return (validDocument && validFFP && validVisa);

    }

    function checkPassengerSeatSelected(segments, segNum, passenger) {
        return segments[segNum].selectSeatsMode !== 'HAVE_TO_SELECT' || !hasInList(passenger.segments[segNum].possibleActions, 'CHANGE_SEAT') || passenger.segments[segNum].seat;
    }

    function fillinSearchForm(lastName, ticketNumber) {
        $('#searchForm_0_lastName').val(lastName);
        $('#searchForm_0_ticketNumber').val(ticketNumber);
        $('#searchForm a.change-btn').trigger('click');
        $('#searchForm').trigger('submit');
    }

    function getDatePickerI18nData(lang) {
        var ld;

        if (lang === 'hy') {
            lang = 'hy-am';
        }

        ld = moment.localeData(lang);
        if (!ld) {
            ld = moment.localeData('en');
        }

        return {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : (ld._months.standalone || ld._months).map(capitalize),
            weekdays      : (ld._weekdays.standalone || ld._weekdays).map(capitalize),
            weekdaysShort : (ld._weekdaysShort.standalone || ld._weekdaysShort).map(capitalize)
        };
    }

    function hasInList(list, item) {
        var i;
        if (list && item) {
            for (i = 0; i < list.length; i++) {
                if (list[i] == item) {
                    return true;
                }
            }
        }
        return false;
    }

    function isVisaEmpty(visa) {
        var result = true;

        _.each(visa.fields, function (field) {
            if (field.value) {
                result = false;
            }
        });

        return result;
    }

    function getInternetExplorerVersion() {
        var rv = -1,
            ua = window.navigator.userAgent,
            re;

        if (window.navigator.appName === 'Microsoft Internet Explorer') {
            re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        } else if (window.navigator.appName === 'Netscape') {
            re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }
        if (window.navigator.userAgent.indexOf('Edge') > -1) {
            rv = 'Edge';
        }
        return rv;
    }

    function capitalize(string) {
        string = String(string).toLowerCase();
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function reformatAvailableExtraServices(availableExtraServices, sirenaOrder, oldAvailableExtraServices) {
        if (!availableExtraServices || !availableExtraServices.length) {
            return false;
        } else {
            if (!oldAvailableExtraServices) {
                oldAvailableExtraServices = [];
            }
            return availableExtraServices.map(markInsuranceOnline).map(function (availableExtraService) {

                    if (availableExtraService.code === 'insurance') {
                        return getInsuranceServiceInfo(
                            sirenaOrder,
                            _.findWhere(oldAvailableExtraServices, {code: availableExtraService.code}),
                            availableExtraService
                        );
                    } else if (availableExtraService.code === 'aeroexpress') {
                        return getAeroexpressServiceInfo(
                            sirenaOrder,
                            _.findWhere(oldAvailableExtraServices, {code: availableExtraService.code}),
                            availableExtraService
                        );
                    } else if (availableExtraService.code === 'meal') {
                        return getMealServiceInfo(
                            sirenaOrder,
                            _.findWhere(oldAvailableExtraServices, {code: availableExtraService.code}),
                            availableExtraService
                        );
                    } else if (availableExtraService.code === 'baggage') {
                        return getBaggageServiceInfo(
                            sirenaOrder,
                            _.findWhere(oldAvailableExtraServices, {code: availableExtraService.code}),
                            availableExtraService
                        );
                    } else {
                        return getCommonServiceInfo(
                            sirenaOrder,
                            _.findWhere(oldAvailableExtraServices, {code: availableExtraService.code}),
                            availableExtraService
                        );
                    }

            });

        }
    }

    function markInsuranceOnline(service) {
        if (service.code === 'insuranceOnline') {
            service.code = 'insurance';
            service.onlineMode = true;
        }
        return service;
    }

    function deepDecodeQuot(data) {
        var key;
        if (typeof (data) === 'object') {
            for (key in data) {
                if (data.hasOwnProperty(key)) {
                    data[key] = deepDecodeQuot(data[key]);
                }
            }
            return data;
        } else if (typeof (data) === 'string') {
            return data.replace(/&quot;/g, '"');
        } else {
            return data;
        }
    }

    function getBaggageServiceInfo(sirenaOrder, oldAvailableExtraService, availableExtraService) {
        var info = {
                active: (
                    (
                        sirenaOrder.pricesEditable &&
                        sirenaOrder.pricesEditable.totalExtraServiceByGroup.baggage
                    ) || (
                        oldAvailableExtraService && oldAvailableExtraService.active
                    )
                ),
                code: 'baggage',
                availableByPassengerSegments: getAvailableByPassengerSegments(sirenaOrder, availableExtraService),
                itemsByPassengerSegments: getItemsByPassengerSegments(sirenaOrder, availableExtraService),
                pricesByPassengers: getBaggagePricesByPassengers(sirenaOrder),
                minPrice: getServiceMinPrice(availableExtraService),
                subgroups: availableExtraService.structure.subgroups,
                passengers: availableExtraService.passengers
            };
        if (info.availableByPassengerSegments) {
            return info;
        } else {
            return false;
        }
    }

    function getMealServiceInfo(sirenaOrder, oldAvailableExtraService, availableExtraService) {
        var info = {
                active: (
                    (
                        sirenaOrder.pricesEditable &&
                        sirenaOrder.pricesEditable.totalExtraServiceByGroup.meal
                    ) || (
                        oldAvailableExtraService && oldAvailableExtraService.active
                    )
                ),
                code: 'meal',
                availableByPassengerSegments: getAvailableByPassengerSegments(sirenaOrder, availableExtraService),
                itemsByPassengerSegments: getItemsByPassengerSegments(sirenaOrder, availableExtraService),
                minPrice: getServiceMinPrice(availableExtraService),
                subgroups: availableExtraService.structure.subgroups.map(function (subgroup) {
                    return subgroup.code;
                }),
                passengers: availableExtraService.passengers
            };
        if (info.availableByPassengerSegments) {
            setActiveMealItemsState(info.itemsByPassengerSegments, sirenaOrder);
            info.availableBySegments = getAvailableBySegments(info.availableByPassengerSegments);
            return info;
        } else {
            return false;
        }
    }

    function setActiveMealItemsState(itemsByPassengerSegments, sirenaOrder) {


        if (sirenaOrder.editableExtraServicesByPassengers) {
            itemsByPassengerSegments.forEach(function (passenger, passengerNum) {
                if (sirenaOrder.editableExtraServicesByPassengers[passengerNum] && passenger) {
                    passenger.forEach(function (availableExtraServices, segmentNum) {
                        /* jshint maxlen: 200 */
                        var passengerSegmentServices = sirenaOrder.editableExtraServicesByPassengers[passengerNum].passengerSegmentServices[segmentNum],
                            passengerSegmentMeal,
                            serviceType,
                            rfisc,
                            price;
                        if (passengerSegmentServices) {
                            passengerSegmentMeal = _.findWhere(passengerSegmentServices, { code: 'meal' });
                            if (passengerSegmentMeal) {
                                serviceType = passengerSegmentMeal.serviceItem.serviceType;
                                rfisc = passengerSegmentMeal.serviceItem.rfisc;
                                price = passengerSegmentMeal.serviceItem.totalPrice;
                            }
                        }

                        if (availableExtraServices) {
                            availableExtraServices.forEach(function (subgroup) {
                                subgroup.forEach(function (mealItem) {
                                    /* jshint maxlen: 150 */
                                    mealItem.active = (serviceType && rfisc && mealItem.serviceType === serviceType && mealItem.rfisc === rfisc);
                                    if (mealItem.active && price && !mealItem.price) {
                                        mealItem.price = price;
                                    }
                                });
                            });
                        }

                    });
                }
            });
        } else {
            itemsByPassengerSegments.forEach(function (passenger) {
                if (passenger) {
                    passenger.forEach(function (availableExtraServices) {
                        if (availableExtraServices) {
                            availableExtraServices.forEach(function (subgroup) {
                                subgroup.forEach(function (mealItem) {
                                    mealItem.active = false;
                                });
                            });
                        }
                    });
                }
            });
        }
    }

    function getCommonServiceInfo(sirenaOrder, oldAvailableExtraService, availableExtraService) {
        var hasAvailable = false,
            info = {
                active: (
                    (
                        sirenaOrder.pricesEditable &&
                        sirenaOrder.pricesEditable.totalExtraServiceByGroup[availableExtraService.code]
                    ) || (
                        oldAvailableExtraService && oldAvailableExtraService.active
                    )
                ),
                code: availableExtraService.code,
                iconCode: availableExtraService.iconCode || 'none',
                defaultSelected: availableExtraService.defaultSelected || false,
                availableByPassengerSegments: getAvailableByPassengerSegments(sirenaOrder, availableExtraService),
                itemsByPassengerSegments: getItemsByPassengerSegments(sirenaOrder, availableExtraService),
                pricesByPassengerSegments: getCommonServicePricesByPassengerSegments(sirenaOrder, availableExtraService.code),
                fullPrice: getCommonServiceFullPrice(availableExtraService),
                commonSubgroup: getServiceCommonSubgroup(availableExtraService)
            };

        info.availableBySegments = getAvailableBySegments(info.availableByPassengerSegments);
        info.availableBySegments.forEach(function (hasSeg) {
            if (!hasAvailable && hasSeg) {
                hasAvailable = true;
            }
        });

        if (!hasAvailable) {
            return;
        } else {
            return info;
        }
    }

    function getInsuranceServiceInfo(sirenaOrder, oldAvailableExtraService, availableExtraService) {
        var serviceInfo = {
            active: (
                (
                    sirenaOrder.pricesEditable &&
                    sirenaOrder.pricesEditable.totalExtraServiceByGroup[availableExtraService.code]
                ) || (
                    oldAvailableExtraService && oldAvailableExtraService.active
                )
            ),
            code: availableExtraService.code,
            onlineMode: availableExtraService.onlineMode,
            defaultSelected: availableExtraService.defaultSelected || false,
            items: reformatInsuranceItems(availableExtraService.items),
            itemsByPassengers: getInsuranceItemsByPassengers(_.clone(availableExtraService.items), sirenaOrder.passengers),
            fullPrice: getInsuranceServiceFullPrice(availableExtraService, sirenaOrder.passengers.length)
        };
        if (serviceInfo.itemsByPassengers) {
            setActiveInsuranceItemsStateByPassengers(serviceInfo.itemsByPassengers, sirenaOrder);
        } else {
            setActiveInsuranceItems(serviceInfo.items, sirenaOrder);
        }
        return serviceInfo;
    }

    function reformatInsuranceItems(items) {
        return items.map(function (item) {
            if (!item.price) {
                item.price = Big(item.insurance_premium || 0).plus(item.luggage_premium || 0).toFixed(2);
            }
            return item;
        });
    }

    function getInsuranceItemsByPassengers(items, passengers) {
        if (
            items.some(function (item) {
                return (
                    item.passengerId !== undefined &&
                    item.pnr !== undefined
                );
            })
        ) {
            return passengers.map(function (passenger) {
                return items.filter(function (item) {
                     return (
                         item.passengerId === passenger.id &&
                         item.pnr === passenger.pnr
                     );
                });
            });
        } else {
            return false;
        }
    }

    function setActiveInsuranceItemsStateByPassengers(itemsByPassengers, orderInfo) {
        var editableInsuranceService;

        if (orderInfo.editableExtraServices) {
            editableInsuranceService = _.findWhere(orderInfo.editableExtraServices, {code: 'insurance'});
            if (
                editableInsuranceService &&
                editableInsuranceService.items &&
                editableInsuranceService.items.length
            ) {
                editableInsuranceService.items.forEach(function (editableInsuranceServiceItem) {
                    orderInfo.passengers.forEach(function (passenger, passengerNum) {
                        itemsByPassengers[passengerNum].forEach(function (item) {
                            if (
                                item.ins === editableInsuranceServiceItem.ins &&
                                item.tins === editableInsuranceServiceItem.tins &&
                                item.passengerId === editableInsuranceServiceItem.passengerId &&
                                item.pnr === editableInsuranceServiceItem.pnr &&
                                item.productCode === editableInsuranceServiceItem.productCode
                            ) {
                                item.selected = true;
                            }
                        });
                    });
                });
            }
        }
    }

    function setActiveInsuranceItems(items, orderInfo) {
        var editableInsuranceService;

        if (orderInfo.editableExtraServices) {
            editableInsuranceService = _.findWhere(orderInfo.editableExtraServices, {code: 'insurance'});
            if (
                editableInsuranceService &&
                editableInsuranceService.items &&
                editableInsuranceService.items.length
            ) {
                editableInsuranceService.items.forEach(function (editableInsuranceServiceItem) {
                    items.forEach(function(item) {
                        if (
                            item.ins === editableInsuranceServiceItem.ins &&
                            item.tins === editableInsuranceServiceItem.tins
                        ) {
                            item.selected = true;
                        }
                    });
                });
            }
        }
    }

    function getAeroexpressServiceInfo(sirenaOrder, oldAvailableExtraService, availableExtraService) {
        var info = {
            active: (
                (
                    sirenaOrder.pricesEditable &&
                    sirenaOrder.pricesEditable.totalExtraServiceByGroup[availableExtraService.code]
                ) || (
                    oldAvailableExtraService && oldAvailableExtraService.active
                )
            ),
            code: availableExtraService.code,
            items: reformatAeroexpressItems(availableExtraService.items, sirenaOrder),
            documents: availableExtraService.documents,
            passengerLastNameRegexp: availableExtraService.passengerLastNameRegexp,
            passengerFirstNameRegexp: availableExtraService.passengerFirstNameRegexp,
            passengersFree: availableExtraService.passengers_free,
            passengersFreeForAllDates: availableExtraService.passengers_free.map(function (datesObj) {
                var isFree = true,
                    datesList = _.keys(datesObj);
                datesList.forEach(function (date) {
                    if (!datesObj[date]) {
                        isFree = false;
                    }
                });
                return isFree;
            }),
            passengersChild: availableExtraService.passengers_child
        };
        info.minPrice = getServiceMinPrice({ items: info.items });
        info.itemsByPassengers = sirenaOrder.passengers.map(function (passenger, passengerNum) {
            return info.items.map(function (item) {
                var passengerItem = _.clone(item);
                passengerItem.passenger_id = passenger.id;
                passengerItem.firstName = passenger.firstName;
                passengerItem.lastName = passenger.lastName;
                passengerItem.dateOfBirth = passenger.dateOfBirth;
                // Поменчаем полностью бесплатные элементы
                passengerItem.free = isAllPassengerItemDatesFree(
                    info.passengersFree[passengerNum],
                    passengerItem.dates
                );
                // Оставляем только даты, на которых есть платные билеты
                passengerItem.dates = passengerItem.dates.filter(function (date) {
                    return !info.passengersFree[passengerNum][date];
                });
                passengerItem.selected = isPassengerItemSelected(passengerItem, sirenaOrder);
                if (passengerItem.selected) {
                    passengerItem.selectedDate = getPassengerItemSelectedDate(passengerItem, sirenaOrder);
                } else {
                    passengerItem.selectedDate = passengerItem.dates[0];
                }
                return passengerItem;
            });
        });
        return info;
    }

    function isAllPassengerItemDatesFree(freeDatesObj, availableDatesList) {
        var isFree = true;
        availableDatesList.forEach(function (date) {
            if (!freeDatesObj[date]) {
                isFree = false;
            }
        });
        return isFree;
    }

    function isPassengerItemSelected(passengerItem, orderInfo) {
        var orderAeroexpressService = _.findWhere(orderInfo.editableExtraServices, { code: 'aeroexpress' });
        if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
            return !!_.findWhere(orderAeroexpressService.items, {
                departure_code: passengerItem.departure_code,
                arrival_code: passengerItem.arrival_code,
                firstName: passengerItem.firstName,
                lastName: passengerItem.lastName,
                dateOfBirth: passengerItem.dateOfBirth
            });
        }
        return false;
    }

    function getPassengerItemSelectedDate(passengerItem, orderInfo) {
        var orderAeroexpressService = _.findWhere(orderInfo.editableExtraServices, { code: 'aeroexpress' });
        if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
            return _.findWhere(orderAeroexpressService.items, {
                departure_code: passengerItem.departure_code,
                arrival_code: passengerItem.arrival_code,
                firstName: passengerItem.firstName,
                lastName: passengerItem.lastName,
                dateOfBirth: passengerItem.dateOfBirth
            }).departure_date;
        }
    }

    function reformatAeroexpressItems(list, orderInfo) {
        return list.map(function (serviceItem) {
            var fullFare = _.findWhere(serviceItem.fares, { fare_type: 'full' });
            return {
                departure: serviceItem.departure_name,
                departure_code: serviceItem.departure_code,
                arrival: serviceItem.arrival_name,
                arrival_code: serviceItem.arrival_code,
                dates: serviceItem.dates,
                selectedDate: getSelectedAeroexpressItemDate(orderInfo, serviceItem.segment) || serviceItem.dates[0],
                fares: serviceItem.fares,
                price: fullFare && fullFare.cost,
                currency: fullFare && fullFare.currency
            };
        });
    }

    function getSelectedAeroexpressItemDate(orderInfo, segmentId) {
        var orderAeroexpressService,
            result = false;
        if (orderInfo.editableExtraServices) {
            orderAeroexpressService = _.findWhere(orderInfo.editableExtraServices, { code: 'aeroexpress' });
            if (orderAeroexpressService && orderAeroexpressService.items) {
                orderAeroexpressService.items.forEach(function (item) {
                    if (item.segment === segmentId) {
                        result = item.departure_date;
                    }
                });
            }
        }
        return result;
    }

    function getAvailableByPassengerSegments(sirenaOrder, service) {
        var availableByPassengers = sirenaOrder.passengers.map(function (orderPassenger) {
                var servicePassenger = _.findWhere(service.passengers, { 
                        id: orderPassenger.id,
                        pnr: orderPassenger.pnr
                    }),
                    availableBySegments,
                    hasAvailableBySegments = false;
                if (!servicePassenger) {
                    return false;
                }
                availableBySegments = sirenaOrder.segments.map(function (orderSegment) {
                    var servicePassengerSegment = _.findWhere(
                            servicePassenger.segments,
                            { id: orderSegment.id }
                        ),
                        available;
                    if (servicePassengerSegment) {
                        available = !!getFirstNotEmptySubListItem(servicePassengerSegment.availableExtraServices);
                        if (!hasAvailableBySegments && available) {
                            hasAvailableBySegments = true;
                        }
                    }
                    return available;
                });
                if (!hasAvailableBySegments) {
                    return false;
                }
                return availableBySegments;
            }),
            hasAvailableByPassengers = false;

        availableByPassengers.forEach(function (item) {
            if (item) {
                hasAvailableByPassengers = true;
            }
        });

        if (!hasAvailableByPassengers) {
            return false;
        }        

        return availableByPassengers;
    }

    function getAvailableBySegments(availableByPassengerSegments) {
        var availableBySegments = [];

        if (!availableByPassengerSegments) {
            return availableBySegments;
        }

        availableByPassengerSegments.forEach(function (segmentsList, passengerNum) {
            if (segmentsList) {
                segmentsList.forEach(function (segmentAvailable, segmentNum) {
                    if (!passengerNum) {
                        availableBySegments.push(segmentAvailable);
                    } else {
                        if (!availableBySegments[segmentNum] && segmentAvailable) {
                            availableBySegments[segmentNum] = true;
                        }
                    }
                });
            }
        });
        return availableBySegments;
    }

    function getFirstNotEmptySubListItem(list) {
        var resultItem;
        list.forEach(function (subList) {
            if (subList.length && !resultItem) {
                subList.forEach(function (item) {
                    if (item && !resultItem) {
                        resultItem = item;
                    }
                });
            }
        });
        return resultItem;
    }

    function getFirstNotEmptyListItem(list) {
        var resultItem;
        list.forEach(function (item) {
            if (item && !resultItem) {
                resultItem = item;
            }
        });
        return resultItem;
    }

    function getItemsByPassengerSegments(sirenaOrder, service) {
        return sirenaOrder.passengers.map(function (orderPassenger) {
            var servicePassenger = _.findWhere(service.passengers, {
                id: orderPassenger.id,
                pnr: orderPassenger.pnr
            });
            if (!servicePassenger) {
                return false;
            }
            return sirenaOrder.segments.map(function (orderSegment) {
                var servicePassengerSegment = _.findWhere(
                    servicePassenger.segments,
                    { id: orderSegment.id }
                );
                if (servicePassengerSegment && servicePassengerSegment.availableExtraServices) {
                    return servicePassengerSegment.availableExtraServices;
                } else {
                    return false;
                }
            });
        });
    }

    function getCommonServicePricesByPassengerSegments(sirenaOrder, serviceCode) {
        if (sirenaOrder.editableExtraServicesByPassengers) {
            return sirenaOrder.editableExtraServicesByPassengers.map(function (item) {

                if (item && item.passengerSegmentServices) {
                    return item.passengerSegmentServices.map(function (segment) {
                        var segmentPrice = false;
                        if (segment) {
                            segment.forEach(function (service) {
                                if (service.code === serviceCode) {
                                    segmentPrice = service.serviceItem.totalPrice;
                                }
                            });
                        }
                        return segmentPrice;
                    });
                } else {
                    return sirenaOrder.segments.map(function () {
                        return false;
                    });
                }

            });
        } else {
            return sirenaOrder.passengers.map(function () {
                return sirenaOrder.segments.map(function () {
                    return false;
                });
            });
        }
    }

    function getInsuranceServiceFullPrice(service, count) {
        var i = 0,
            min,
            minCurrency,
            currentItemPrice;

        if (!service.items || !service.items[0]) {
            return;
        }

        while (i < service.items.length) {
            currentItemPrice = (service.items[i].price ||
                Big(service.items[i].insurance_premium || 0)
                    .plus(service.items[i].luggage_premium || 0)
                    .times(count).toFixed(2));

            if (!min || min.gt(currentItemPrice)) {
                min = Big(currentItemPrice);
                minCurrency = service.items[i].currency;
            }

            i++;
        }

        return {
            price: min.toFixed(2),
            currency: minCurrency
        };
    }

    function getCommonServiceFullPrice(service) {
        var fullPrice = 0,
            currency;
        if (service.passengers) {
            service.passengers.forEach(function (pass) {
                pass.segments.forEach(function (passSeg) {
                    var item = getFirstNotEmptySubListItem(passSeg.availableExtraServices);
                    if (item) {
                        if (item.price) {
                            fullPrice += item.price*1;
                        }
                        if (item.currency && !currency) {
                            currency = item.currency;
                        }
                    }
                });
            });
        }

        return {
            price: fullPrice,
            currency: currency
        };
    }

    function getServiceCommonSubgroup(service) {
        var commonSubgroup = 'common';
        if (service.structure && service.structure.subgroups) {
            if (service.structure.subgroups[0] && service.structure.subgroups[0].code) {
                commonSubgroup = service.structure.subgroups[0].code;
            }
        }
        return commonSubgroup;
    }

    function isCommonServiceCode(code) {
        return (
            code &&
            code !== 'seat' &&
            code !== 'baggage' &&
            code !== 'meal' &&
            code !== 'insurance' &&
            code !== 'aeroexpress'
        );
    }

    function getBaggagePricesByPassengers(sirenaOrder) {
        if (sirenaOrder.editableExtraServicesByPassengers) {
            return sirenaOrder.editableExtraServicesByPassengers.map(function (item) {
                var passengerPrice = false;
                if (item && item.passengerSegmentServices) {
                    item.passengerSegmentServices.forEach(function (segment) {
                        if (segment) {
                            segment.forEach(function (service) {
                                if (service.code === 'baggage' && service.items) {
                                    service.items.forEach(function (item) {
                                        passengerPrice = (passengerPrice || 0) + item.totalPrice;
                                    });
                                }
                            });
                        }
                    });
                }
                return passengerPrice;
            });
        } else {
            return sirenaOrder.passengers.map(function () {
                return false;
            });
        }
    }

    function getServiceMinPrice(service) {
        var prices = [],
            currency;
        if (service.passengers) {
            service.passengers.forEach(function (pass) {
                pass.segments.forEach(function (passSeg) {
                    passSeg.availableExtraServices.forEach(function (subgroup) {
                        subgroup.forEach(function (serviceItem) {
                            if (!currency && serviceItem.currency) {
                                currency = serviceItem.currency;
                            }
                            if (serviceItem.price) {
                                prices.push(serviceItem.price);
                            }
                        });
                    });
                });
            });
        } else if (service.items) {
            service.items.forEach(function (serviceItem) {
                if (!currency && serviceItem.currency) {
                    currency = serviceItem.currency;
                }
                if (serviceItem.price) {
                    prices.push(serviceItem.price);
                }
            });
        }
        if (!prices.length || !currency) {
            return false;
        }
        return {
            price: getMinPrice(prices),
            currency: currency
        };
    }

    function getMinPrice(prices) {
        var i = 0,
            min;
        while (i < prices.length) {
            if (!min || min > prices[i]) {
                min = prices[i];
            }
            i++;
        }
        if (!min) {
            return false;
        }
        return min;
    }

    module.exports = {

        getLeadPassenger: function (passengers) {
            return _.findWhere(passengers, {lead: true});
        },

        createIndex: function (list) {
            var index = {};
            _.each(list, function (item) {
                index[item.code] = item.value;
            });
            return index;
        },

        keyboardConvert: function (str) {
            var ruKb = "ЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ",
                enKb = "QWERTYUIOP[]ASDFGHJKL;'ZXCVBNM,.",
                newStr = "",
                i,
                indexRu,
                indexEn;

            if (typeof str !== "string") {
                return str;
            }

            str = str.toUpperCase();

            for (i = 0; i < str.length; i = i + 1) {
                indexRu = ruKb.indexOf(str[i]);
                indexEn = enKb.indexOf(str[i]);
                if (indexRu !== -1) {
                    newStr += enKb[indexRu];
                } else if (indexEn !== -1) {
                    newStr += ruKb[indexEn];
                } else {
                    newStr += str[i];
                }
            }
            return (newStr || str);
        },

        getFormParams: function (form) {

            var paramsList = form.serializeArray(),
                paramsIndex = {};
            _.each(paramsList, function (item) {
                paramsIndex[item.name] = item.value;
            });

            return paramsIndex;

        },

        formatPrice: function (num, currency) {
            if (!num && num !== 0) {
                return "";
            }
            currency = currency || app.siteAliases('oxygen-check-in.defaultCurrency');
            if (currency === "РУБ" || currency === "RUB") {
                currency = '<span class="rub">a</span>';
            }
            return formatPriceNum(num) + currency;
        },

        defaultDatePicker: function (options) {
            return $.extend({
                format: 'DD.MM.YYYY',
                i18n: getDatePickerI18nData(o2context.systemLanguage),
                firstDay: 1
            }, options);
        },

        getLocalNameProp: function () {
            return "name" + capitalize(app.sessionParams.lang);
        },

        getParamFromLocation: function (name) {
            var location = window.location,
                isName = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search);
            if (isName) {
                return decodeURIComponent(isName[1]);
            }
        },

        sendStartAppPostMessage: function () {
            if (window.parent) {
                window.parent.postMessage('{"type": "AppStart"}', "*");
            }
        },

        cleanDocNum: function (str) {

            // общее ограничение на номера документов в Сирене
            // только цифры или буквы русского (без Ё и Ъ) и латинского алфавита, не более 17 символов

            var allowedChars = "0123456789АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЭЮЯABCDEFGHIJKLMNOPQRSTUVWXYZ",
                newStr = "",
                i;
            if (str) {
                str = str.toUpperCase();
                for (i = 0; i < str.length; i = i + 1) {
                    if (allowedChars.indexOf(str[i]) !== -1 && i < 17) {
                        newStr += str[i];
                    }
                }
            }
            return newStr;

        },

        backupDocumentsAndFFP: function (passengers) {
            sessionStorage.setItem(sessionStoragePropDocumentsAndFFP, getDocumentsAndFFP(passengers));
        },

        restoreDocumentsAndFFP: function (passengers) {
            var documentsAndFFPjson = sessionStorage.getItem(sessionStoragePropDocumentsAndFFP);
            if (documentsAndFFPjson) {
                setDocumentsAndFFP(passengers, documentsAndFFPjson);
            }
        },

        clearDocumentsAndFFP: function () {
            delete sessionStorage[sessionStoragePropDocumentsAndFFP];
        },

        unlockScreen: function () {
            $('body').removeClass('loading');
        },

        lockScreen: function () {
            $('body').addClass('loading');
        },

        setActiveStep: function (stepCode) {
            _.each(app.data.steps, function (step) {
                step.active = (step.code === stepCode);
            });
            app.ractive.update();
        },

        checkPassengersSegmentReady: function (orderInfo, segNum) {
            var hasPassengersWithoutSeat = false,
                hasInvalidPassengersData = false;

            _.each(orderInfo.passengers, function (passenger) {
                if (passenger.selected) {
                    if (!checkPassengerSeatSelected(orderInfo.segments, segNum, passenger)) {
                        hasPassengersWithoutSeat = true;
                    }

                    if (!checkPassengerSegmentData(passenger.segments[segNum])) {
                        hasInvalidPassengersData = true;
                    }
                }
            });

            return !hasPassengersWithoutSeat && !hasInvalidPassengersData;
        },

        checkPassengerSegmentReady: function (orderInfo, segNum, passengerNum) {
            var passenger = orderInfo.passengers[passengerNum];

            if (passenger.selected) {
                if (!checkPassengerSeatSelected(orderInfo.segments, segNum, passenger)) {
                    return false;
                }

                return checkPassengerSegmentData(passenger.segments[segNum]);
            }

            return false;
        },

        hasSelectedPassengers: function (passengers) {
            return _.findWhere(passengers, { selected: true });
        },

        isAtLeastOneOpenedSegmentInOrder: function (segments) {
            var areAllSegmentsClosed = true;

            _.each(segments, function (segment) {
                if (segment.status === 'OPENED') {
                    areAllSegmentsClosed = false;
                }
            });

            return !areAllSegmentsClosed;
        },

        hasOpenedSegments: function (segments) {
            return !!_.where(segments, {status: 'OPENED'}).length;
        },

        getTimestamp: function () {
            return new Date().getTime();
        },

        checkSegmentWillBeOpened: function (checkinOpenDate) {
            var checkinOpenMoment = moment(checkinOpenDate, 'DD.MM.YYYY HH:mm'),
                serverMoment = moment(o2context.serverDateTime);
            return (checkinOpenMoment.diff(serverMoment) >= 0);
        },

        hasInList: hasInList,

        getValueProps: getValueProps,

        setValueProps: setValueProps,

        getDocumentsAndFFP: getDocumentsAndFFP,

        setSavePaxData: setSavePaxData,

        checkPassengerSegmentData: checkPassengerSegmentData,

        checkPassengerSeatSelected: checkPassengerSeatSelected,

        checkByRegExp: checkByRegExp,

        checkInternational: checkInternational,

        fillinSearchForm: fillinSearchForm,

        getFirstSelectedPassengerIndex: function (passengers) {
            var index = -1;
            _.each(passengers, function (passenger, passengerIndex) {
                if (passenger.selected) {
                    index = passengerIndex;
                }
            });
            return index;
        },

        isVisaEmpty: isVisaEmpty,

        getDocumentsAndFFPOnePassengerOneSegment: getDocumentsAndFFPOnePassengerOneSegment,

        getInternetExplorerVersion: getInternetExplorerVersion,

        getCustomCabinLabel: function (properties) {
            return properties.map(function (property) {
                var customAliasCode = 'oxygen-check-in.customAircraftCabinPropertyLabel.' + property,
                    customAliasValue = app.siteAliases(customAliasCode);
                return (customAliasValue === customAliasCode) ? '' : customAliasValue;
            }).join('');
        },

        hasAlias: function (code) {
            return app.siteAliases(code) !== code;
        },

        capitalize: capitalize,

        reformatAvailableExtraServices: reformatAvailableExtraServices,

        isCommonServiceCode: isCommonServiceCode,

        getFirstNotEmptySubListItem: getFirstNotEmptySubListItem,

        getFirstNotEmptyListItem: getFirstNotEmptyListItem,

        completeEmail: function (text) {
            var popularMailDomains = (app.siteParams('check-in.popularMailDomains') || '').split(' ').join('').split(','),
                textParts = text.split('@'),
                list = [];
            if (!textParts[0] || !popularMailDomains[0]) {
                return list;
            } else if (!textParts[1]) {
                list = popularMailDomains.map(function (domain) {
                    return textParts[0] + '@' + domain;
                });
                list.unshift(text);
            } else {
                list = popularMailDomains.filter(function (domain) {
                    return (
                        domain.indexOf(textParts[1]) === 0
                    );
                }).map(function (domain) {
                    return textParts[0] + '@' + domain;
                });
            }
            return list.slice(0, 5);
        },

        markInsuranceOnline: markInsuranceOnline,

        deepDecodeQuot: deepDecodeQuot

    };

    window.fillinSearchForm = fillinSearchForm;

    window.createAlias = function (name, ru, en) {

        $.ajax({
            url: "json/add-alias",
            type: "POST",
            data: {
                name: name,
                ru: ru,
                en: en
            },
            success: function () {

                console.info('Alias created');

            }
        });

    };


}(window));

},{}],21:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Application validation module
* @purpose checking form fields by conditions
*/

var utils = require('./utils.js');

(function ($, _) {

    'use strict';

    function validateItem(validation, item, global) {

        var rules = validation.getRulesByName(item.attr("name")),
            value = item.val(),
            disabled = item.is(':disabled'),
            valid = true,
            message = "";

        if (_.isObject(rules) && !disabled) {
            if (global || value !== "") {
                if (rules.testByRegExp && !utils.checkByRegExp(value, rules.testByRegExp)) {
                    valid = false;
                    message = app.siteAliases(rules.formatMess || 'oxygen-check-in.messages.format');
                }
                if (rules.checkInternational && !utils.checkInternational(value)) {
                    valid = false;
                    message = app.siteAliases('oxygen-check-in.messages.formatInternational');
                }
                if (rules.dateRange) {
                    if (moment(value, "DD.MM.YYYY").isValid()) {
                        if ((rules.dateRange.min && moment(value, "DD.MM.YYYY").isBefore(rules.dateRange.min)) || (rules.dateRange.max && moment(value, "DD.MM.YYYY").isAfter(rules.dateRange.max))) {
                            valid = false;
                            message = app.siteAliases('oxygen-check-in.messages.dateOutOfRange');
                        }
                    } else {
                        valid = false;
                        message = app.siteAliases(rules.formatMess || 'oxygen-check-in.messages.format');
                    }
                }
            }
            if (global && (value).trim() === "") {
                if (rules.required || item.hasClass('required')) {
                    valid = false;
                    message = app.siteAliases('oxygen-check-in.messages.required');
                } else {
                    valid = true;
                }
            }
        }

        item.attr("data-valid", valid);

        if (valid) {
            validation.setValid(item);
        } else {
            validation.setInvalid(item, message);
        }

    }

    function noValidateItem(validation, item) {
        validation.setValid(item);
    }

    function Validation(options) {

        if (options.form) {
            this.form = options.form;
            this.rules = options.rules;
            this.items = this.form.elements;

            var validation = this;

            _.each(this.items, function (item) {
                item = $(item);
                item.on("blur", function () {
                    validateItem(validation, item, false);
                });
                item.on("focus", function () {
                    noValidateItem(validation, item);
                });
            });
        } else {
            console.log('Error: no form for Validation()');
        }

    }

    Validation.prototype.updateRules = function (rules) {
        _.extend(this.rules, rules);
    };

    Validation.prototype.getRulesByName = function (name) {
        return this.rules[name] || {};
    };

    Validation.prototype.validateItems = function () {
        var validation = this;
        _.each(validation.items, function (item) {
            item = $(item);
            validateItem(validation, item, false);
        });
    };

    Validation.prototype.getValidStatus = function (silent) {
        var validation = this,
            validStatus = true;
        _.each(validation.items, function (item) {
            item = $(item);
            validateItem(validation, item, !silent);
            if (item.attr("data-valid") !== "true") {
                validStatus = false;
            }
        });
        return validStatus;
    };

    Validation.prototype.setInvalid = function (item, message) {

        var cont = item.parents('div.form-group');

        console.log('invalid item: ', item, item.val(), message);
        item.addClass('invalid-control');
        cont.addClass('tooltip-cont')
            .addClass('tooltip-err-cont')
            .attr('data-title', message)
            .trigger('mouseover')
            .addClass('tooltip-cont-hover');


    };

    Validation.prototype.setValid = function (item) {

        var cont = item.parents('div.form-group');

        item.removeClass("invalid-control");
        cont.removeClass('tooltip-cont')
            .removeClass('tooltip-err-cont')
            .removeAttr('data-title');
        $('div.tooltip', cont).remove();


    };

    module.exports = Validation;

}(window.$, window._));

},{"./utils.js":20}],22:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Mapper
* @purpose Application router
*/

var routes = new Rlite(),
    utils = require('./libs/utils.js'),
    Screens = require('./screens.js');

(function (window) {

    'use strict';

    var mapper;

    function Mapper() {

        this.screens = new Screens();
        mapper = this;

        _.each(this.screens, function (screen) {
            routes.add(screen.code, function () {

                $('title').text(app.siteAliases('oxygen-check-in.title.' + screen.code));

                if (mapper.currentScreen) {
                    mapper.currentScreen.detach();
                }
                mapper.currentScreen = screen;
                if (mapper.currentScreen.el) {
                    mapper.currentScreen.insert('oxyCheckinApp');
                } else {
                    mapper.currentScreen.render('oxyCheckinApp');
                }

            });
        });

        $(window).on('hashchange', this.onhashchange);
        this.fixInternetExplorerHash();
        this.onhashchange();

        // Block disabled links
        $('#oxyCheckinApp').on('click', 'a.disabled', function (event) {
            event.preventDefault();
        });

    }

    Mapper.prototype.onhashchange = function () {
        var selectedScreenCode = mapper.screens[0].code;
        if (location.hash) {
            mapper.screens.forEach(function (screen) {
                if ('#' + screen.code.toUpperCase() === location.hash.toUpperCase()) {
                    selectedScreenCode = screen.code;
                }
            });
        }
        routes.run(selectedScreenCode);
        window.scrollTo(0, 0);
    };

    Mapper.prototype.fixInternetExplorerHash = function () {
        var ieVersion = utils.getInternetExplorerVersion(),
            stepParam = utils.getParamFromLocation('step');
        if (ieVersion === 9 || ieVersion === 10 || ieVersion === 11 || ieVersion === 'Edge') {
            if (!location.hash && stepParam) {
                location.hash = '#' + stepParam;
            }
        }
    };

    module.exports = Mapper;

}(window));

},{"./libs/utils.js":20,"./screens.js":40}],23:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/aeroexpressSchedule.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function AeroexpressSchedule(params, arrival, departure) {

        var aeroexpressScheduleModal = new Modal({
            data: {
                arrival: arrival,
                departure: departure,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.aeroexpressScheduleModal.header'),
                modalContent: template
            }
        });

        app.checkinService.aeroexpressSchedule(params).then(function (resp) {
            if (resp.schedule) {
                aeroexpressScheduleModal.set('schedule', resp.schedule);
            }
        });

        return aeroexpressScheduleModal;

    }

    module.exports = AeroexpressSchedule;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/aeroexpressSchedule.html":59}],24:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name CancelCheckin modal
* @purpose Confirm cancel checkin
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/cancelCheckin.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function CancelCheckin(orderInfo, passengerIndex, callback) {

        var cancelCheckinModal = new Modal({
                data: {
                    passenger: orderInfo.passengers[passengerIndex],
                    alias: app.siteAliases,
                    utils: utils
                },
                partials: {
                    modalHeader: app.siteAliases('oxygen-check-in.cancelCheckinModal.header'),
                    modalContent: template
                }
            });

        cancelCheckinModal.on('confirm-cancel', function () {

            app.checkinService.cancelCheckin({
                passengerIndex: passengerIndex
            }).then(function (resp) {
                cancelCheckinModal.teardown();
                callback(resp);
            });

        });

        return cancelCheckinModal;

    }

    module.exports = CancelCheckin;


}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/cancelCheckin.html":60}],25:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Conditions modal
* @purpose Checkin terms and conditions
*/

var template = require('../templates/modals/conditions.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function Conditions() {

        return new Modal({
            data: {
                alias: app.siteAliases
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.conditionsModal.header'),
                conditionsText: app.siteAliases('oxygen-check-in.termsAndConditions'),
                modalContent: template
            }
        });

    }

    module.exports = Conditions;


}());

},{"../libs/modal.js":18,"../templates/modals/conditions.html":61}],26:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name ConfirmPaidServices modal
* @purpose Confirm redirect to payment
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/confirmPaidServices.html'),
    Modal = require('../libs/modal.js'),
    Validation = require('../libs/validation.js');

(function () {

    'use strict';

    function ConfirmPaidServices(orderInfo, submitHandler, canChoosePassenger, phoneRequired, emailRequired) {

        var paidServicesConfirmForm,
            paidServicesConfirmFormValidation,
            contactsOwnerVariants = canChoosePassenger ? generateContactsOwnerVariants() : false,
            hasPaidServices = (
                orderInfo.sirenaOrder &&
                orderInfo.sirenaOrder.pricesNotIssued &&
                orderInfo.sirenaOrder.pricesNotIssued.totalExtraServices
            ),
            confirmPaidServicesModal = new Modal({
                data: {
                    orderInfo: orderInfo,
                    alias: app.siteAliases,
                    utils: utils,
                    contactsOwnerVariants: contactsOwnerVariants,
                    hasPaidServices: hasPaidServices
                },
                disableContClick: true,
                partials: {
                    modalHeader: (
                        hasPaidServices ?
                        app.siteAliases('oxygen-check-in.confirmPaidServicesModal.header') :
                        app.siteAliases('oxygen-check-in.confirmCheckinModal.header')
                    ),
                    modalContent: template
                }
            });

        confirmPaidServicesModal.on('complete', function () {
            paidServicesConfirmForm = $('#paidServicesConfirmForm');
            paidServicesConfirmFormValidation = new Validation({
                form: paidServicesConfirmForm[0],
                rules: {
                    payerPhone: {
                        testByRegExp: app.siteParams('oxygen-check-in.phoneRegexp'),
                        required: phoneRequired
                    },
                    payerEmail: {
                        testByRegExp: app.siteParams('oxygen-check-in.emailRegexp'),
                        required: emailRequired
                    }
                }
            });

        });

        confirmPaidServicesModal.on('contacts-owner-select', function () {
            var contactsOwnerNum = confirmPaidServicesModal.get('contactsOwnerNum');
            var contactsOwner = contactsOwnerVariants[contactsOwnerNum];
            $('#payerEmail').val(contactsOwner.email);
            $('#payerPhone').val(contactsOwner.phone);
            confirmPaidServicesModal.set('contactsOwnerSelected', true);
        });

        confirmPaidServicesModal.on('contacts-owner-focus', function () {
            confirmPaidServicesModal.set('contactsOwnerSelected', true);
        });

        confirmPaidServicesModal.on('submit', function () {
            if (paidServicesConfirmFormValidation.getValidStatus()) {
                var contactsOwnerNum = confirmPaidServicesModal.get('contactsOwnerNum');
                var contactsOwner = contactsOwnerVariants[contactsOwnerNum];
                var formParams = utils.getFormParams(paidServicesConfirmForm);
                submitHandler({
                    phone: formParams.payerPhone,
                    email: formParams.payerEmail,
                    contactsPassengerId: contactsOwner && contactsOwner.id,
                    contactsPnr: contactsOwner && contactsOwner.pnr
                });
                this.teardown();
            }
        });

        function generateContactsOwnerVariants() {
            var options = [];
            var CONTACTS_OWNER_MIN_AGE = 18;
            orderInfo.sirenaOrder.passengers.filter(function (pax) {
                var dateOfBirth = moment(pax.dateOfBirth, 'DD.MM.YYYY');
                var todayMoment = moment(o2context.serverDateTime);
                var yearsDiff = todayMoment.diff(dateOfBirth, 'years', false);
                return (yearsDiff > CONTACTS_OWNER_MIN_AGE);
            }).forEach(function (pax) {
                options.push({
                    id: pax.id,
                    pnr: pax.pnr,
                    label: pax.lastName + ' ' + pax.firstName,
                    phone: pax.phone || '',
                    email: pax.email || ''
                });
            });
            if (!options.length) {
                return false;
            }
            options.push({
                id: -1,
                pnr: false,
                label: app.siteAliases('oxygen-check-in.confirmPaidServicesModal.notOrderPax'),
                phone: '',
                email: ''
            });
            return options;
        }

        return confirmPaidServicesModal;
    }

    module.exports = ConfirmPaidServices;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../libs/validation.js":21,"../templates/modals/confirmPaidServices.html":62}],27:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name PassengerCanLoseFreeSeatWarning modal
* @purpose Show removed services list after confirm
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/passengerCanLoseFreeSeatWarning.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function PassengerCanLoseFreeSeatWarning(selectSeatParams, submitHandler) {

        var passengerCanLoseFreeSeatWarningModal = new Modal({
            data: {
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.passengerCanLoseFreeSeatWarning.header'),
                modalContent: template
            }
        });

        passengerCanLoseFreeSeatWarningModal.on('submit', function () {
            submitHandler(selectSeatParams);
            this.teardown();
        });

        return passengerCanLoseFreeSeatWarningModal;

    }

    module.exports = PassengerCanLoseFreeSeatWarning;


}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/passengerCanLoseFreeSeatWarning.html":63}],28:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name PassengerDataSeat modal
* @purpose View and edit passenger data and seat
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/passengerDataSeat.html'),
    passengerFormInnerTemplate = require('../templates/includes/passengersDataFormItemInner.html'),
    viewCraftTemplate = require('../templates/includes/viewCraft.html'),
    Modal = require('../libs/modal.js'),
    Pikaday = require('pikaday'),
    Validation = require('../libs/validation.js');

(function () {

    'use strict';

    function PassengerDataSeat(orderInfo, cb, activeSegNum, activePassengerNum, mode) {

        var datePickers = [],
            passFormValidation,
            passFormSelectpickers,
            childFormValidation,
            todayMoment = moment(o2context.serverDateTime),
            todayDate = todayMoment.toDate(),
            viewCraftRactive,
            hasChild = !!orderInfo.passengers[activePassengerNum].child,
            selectedSeatNumber = orderInfo.passengers[activePassengerNum].segments[activeSegNum].seat ? orderInfo.passengers[activePassengerNum].segments[activeSegNum].seat.number : false,
            passengerDataSeatModal = new Modal({
                data: {
                    orderInfo: orderInfo,
                    activeSegNum: activeSegNum,
                    activePassengerNum: activePassengerNum,
                    mode: mode,
                    hasChild: hasChild,
                    alias: app.siteAliases,
                    param: app.siteParams,
                    utils: utils,
                    documentTypes: app.documentTypesDict(),
                    countriesDict: app.countriesDict,
                    selectedSeatNumber: selectedSeatNumber
                },
                disableContClick: true,
                partials: {
                    modalHeader: app.siteAliases('oxygen-check-in.passengerDataSeatModal.header'),
                    modalContent: template,
                    passengerFormInner: passengerFormInnerTemplate
                }
            }),
            setPassFormsPickers = function () {
                $('#editPaxCont input[name="visaIssueDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        maxDate: todayDate
                    })));
                });
                $('#editPaxCont input[name="visaExpirationDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        minDate: todayDate
                    })));
                });
                $('#editPaxCont input[name="documentBirthDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        maxDate: todayDate
                    })));
                });
                $('#editPaxCont input[name="documentExpirationDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        minDate: todayDate
                    })));
                });
                passFormSelectpickers = $('#editPaxCont select').selectPicker();
            },
            setPassFormValidation = function () {

                var passengerSegment = orderInfo.passengers[activePassengerNum].segments[activeSegNum],
                    rules = {
                        visaNumber: {
                            testByRegExp: app.constants.visaNumberRegexp
                        },
                        visaIssueCity: {
                            testByRegExp: app.constants.visaIssueCityRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        visaIssueDate: {
                            dateRange: {
                                max: todayMoment
                            }
                        },
                        visaExpirationDate: {
                            dateRange: {
                                min: todayMoment
                            }
                        },
                        visaBirthPlace: {
                            testByRegExp: app.constants.visaBirthPlaceRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        documentNumber: {
                            testByRegExp: app.constants.documentNumberRegexp
                        },
                        documentBirthDate: {
                            dateRange: {
                                max: todayMoment
                            }
                        },
                        documentExpirationDate: {
                            dateRange: {
                                min: todayMoment
                            }
                        },
                        ffpCardNumber: {
                            testByRegExp: app.constants.ffpNumber
                        }
                    };

                passFormValidation = new Validation({
                    form: $('#editPaxCont form.pass-edit-form')[0],
                    rules: rules
                });

                if (hasChild) {
                    childFormValidation = new Validation({
                        form: $('#editPaxCont form.child-edit-form')[0],
                        rules: rules
                    });
                }

            },
            highlightSelectedSeats = function () {
                var alreadyAssignedSeatInAstra = orderInfo.passengers[activePassengerNum].segments[activeSegNum].alreadyAssignedSeatInAstra,
                    otherSelectedSeats = [],
                    viewCraftBox = $('#editPaxCont div.view-craft-box-inner');

                _.each(orderInfo.passengers, function (passenger, passengerNum) {
                    if (passengerNum != activePassengerNum) {
                        otherSelectedSeats.push(passenger.segments[activeSegNum].seat);
                    }
                });

                $('div.seat-order', viewCraftBox).removeClass('seat-order');
                _.each(otherSelectedSeats, function (otherSeat) {
                    $('div.seat[data-seat="' + otherSeat.number + '"]', viewCraftBox).addClass('seat-order');
                });

                //Место, которое уже ранее было закреплено за человеком, потом можно будет выбрать назад, поэтому оно искуственно делается доступным
                if (alreadyAssignedSeatInAstra) {
                    $('div.seat[data-seat="' + alreadyAssignedSeatInAstra.number + '"]', viewCraftBox).removeClass('seat-engaged').addClass('seat-vacant');
                }

                $('div.seat-selected', viewCraftBox).removeClass('seat-selected');
                if (selectedSeatNumber) {
                    $('div.seat[data-seat="' + selectedSeatNumber + '"]', viewCraftBox).addClass('seat-selected');
                }
            },
            seatClick = function (event) {
                var seatButton = $(event.original.target);
                passengerDataSeatModal.set('showUnableSelectPaidSeatMessage', seatButton.hasClass('paid-seat'));
                if (seatButton.hasClass('seat-vacant') && !seatButton.hasClass('paid-seat') && !seatButton.hasClass('seat-order') && !seatButton.hasClass('seat-selected')) {
                    selectedSeatNumber = seatButton.attr('data-seat');
                    passengerDataSeatModal.set('selectedSeatNumber', selectedSeatNumber);
                    highlightSelectedSeats();
                }
            },
            getPassengerDataForRequest = function(formValues) {
                var result = {};

                result.document = {};
                if (formValues.documentType) { result.document.type = formValues.documentType; }
                if (formValues.documentIssueCountry) { result.document.issueCountry = formValues.documentIssueCountry; }
                if (formValues.documentNumber) { result.document.number = formValues.documentNumber; }
                if (formValues.documentNationality) { result.document.nationality = formValues.documentNationality; }
                if (formValues.documentGender) { result.document.gender = formValues.documentGender; }
                if (formValues.documentBirthDate) { result.document.birthDate = formValues.documentBirthDate; }
                if (formValues.documentExpirationDate) { result.document.expirationDate = formValues.documentExpirationDate; }

                if (!!formValues.visaNotRequired) {
                    result.visaCheckboxNotRequired = true;
                } else {
                    result.visaCheckboxNotRequired = false;

                    result.visa = {};
                    if (formValues.visaBirthPlace) { result.visa.birthPlace = formValues.visaBirthPlace; }
                    if (formValues.visaNumber) { result.visa.number = formValues.visaNumber; }
                    if (formValues.visaIssueCity) { result.visa.issueCity = formValues.visaIssueCity; }
                    if (formValues.visaIssueCountry) { result.visa.issueCountry = formValues.visaIssueCountry; }
                    if (formValues.visaIssueDate) { result.visa.issueDate = formValues.visaIssueDate; }
                    if (formValues.visaExpirationDate) { result.visa.expirationDate = formValues.visaExpirationDate; }
                    if (formValues.visaHostCountry) { result.visa.hostCountry = formValues.visaHostCountry; }
                }

                result.ffpCardNumber = formValues.ffpCardNumber;

                return JSON.stringify(result);
            };

        passengerDataSeatModal.on('complete', function () {

            setPassFormsPickers();
            setPassFormValidation();

            if (utils.hasInList(orderInfo.passengers[activePassengerNum].segments[activeSegNum].possibleActions, 'CHANGE_SEAT')  && orderInfo.segments[activeSegNum].selectSeatsMode !== 'CANT_SELECT') {
                app.checkinService.viewCraft({
                    segmentIndex: activeSegNum,
                    passengerIndex: activePassengerNum
                }).then(function (resp) {

                    viewCraftRactive = new Ractive({
                        el: $('#editPaxCont div.view-craft-box'),
                        template: viewCraftTemplate,
                        oncomplete: function () {
                            highlightSelectedSeats();
                        },
                        data: {
                            cabins: resp.cabins
                        }
                    });
                    viewCraftRactive.on('seat-click', seatClick);

                });
            }
        });

        passengerDataSeatModal.on('teardown', function () {
            _.each(datePickers, function (datePicker) {
                datePicker.destroy();
            });
        });

        passengerDataSeatModal.on('switch-to-seat', function () {
            passengerDataSeatModal.set('mode', 'seat');
        });
        passengerDataSeatModal.on('switch-to-data', function () {
            passengerDataSeatModal.set('mode', 'data');
        });
        passengerDataSeatModal.on('switch-to-child', function () {
            passengerDataSeatModal.set('mode', 'child');
        });

        passengerDataSeatModal.on('toggle-visa-required', function () {
            passFormValidation.getValidStatus();
            passFormSelectpickers.updateDisabledState();
        });

        passengerDataSeatModal.on('passenger-data-submit', function () {
            var allDataToSave = {};

            if (passFormValidation.getValidStatus() && (!hasChild || childFormValidation.getValidStatus())) {
                allDataToSave.segmentIndex = activeSegNum;
                allDataToSave.passengerIndex = activePassengerNum;
                if (utils.hasInList(orderInfo.passengers[activePassengerNum].segments[activeSegNum].possibleActions, 'CHANGE_SEAT')) {
                    allDataToSave.seatNumber = selectedSeatNumber;
                }
                allDataToSave.passengerData = getPassengerDataForRequest(utils.getFormParams($('#editPaxCont form.pass-edit-form')));
                if (hasChild) {
                    allDataToSave.passengerChildData = getPassengerDataForRequest(utils.getFormParams($('#editPaxCont form.child-edit-form')));
                }

                this.teardown();

                app.checkinService.modifyDataSeat(allDataToSave).then(function (resp) {
                    if (resp.result === 'ok') {
                        cb();
                    }
                });

            } else {
                passengerDataSeatModal.set('mode', 'data');
            }
        });


        return passengerDataSeatModal;

    }

    module.exports = PassengerDataSeat;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../libs/validation.js":21,"../templates/includes/passengersDataFormItemInner.html":55,"../templates/includes/viewCraft.html":57,"../templates/modals/passengerDataSeat.html":64,"pikaday":8}],29:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name PassengersData modal
* @purpose View and edit passengers data
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/passengersData.html'),
    passengerMenuItemTemplate = require('../templates/includes/passengersDataMenuItem.html'),
    passengerFormItemTemplate = require('../templates/includes/passengersDataFormItem.html'),
    passengerFormItemInnerTemplate = require('../templates/includes/passengersDataFormItemInner.html'),
    Modal = require('../libs/modal.js'),
    Pikaday = require('pikaday'),
    Validation = require('../libs/validation.js');

(function () {

    'use strict';

    function PassengersData(orderInfo, activeSegNum, activePassengerNum) {

        var datePickers = [],
            passFormsValidation = [],
            passFormSelectpickers = [],
            visasCheckboxNotRequiredOriginal = [],
            todayMoment = moment(o2context.serverDateTime),
            todayDate = todayMoment.toDate(),
            passengersDataModal = new Modal({
                data: {
                    orderInfo: orderInfo,
                    activeSegNum: activeSegNum,
                    activePassengerNum: activePassengerNum,
                    activeIsChild: false,
                    alias: app.siteAliases,
                    param: app.siteParams,
                    utils: utils,
                    documentTypes: app.documentTypesDict(),
                    countriesDict: app.countriesDict
                },
                disableContClick: true,
                partials: {
                    modalHeader: app.siteAliases('oxygen-check-in.passengersDataModal.header'),
                    modalContent: template,
                    passengerMenuItem: passengerMenuItemTemplate,
                    passengerFormItem: passengerFormItemTemplate,
                    passengerFormItemInner: passengerFormItemInnerTemplate
                }
            }),
            setPassFormsPickers = function () {
                $('#savePaxCont input[name="visaIssueDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        maxDate: todayDate
                    })));

                });
                $('#savePaxCont input[name="visaExpirationDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        minDate: todayDate
                    })));
                });
                $('#savePaxCont input[name="documentBirthDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        maxDate: todayDate
                    })));
                });
                $('#savePaxCont input[name="documentExpirationDate"]').each(function (i, inp) {
                    datePickers.push(new Pikaday(utils.defaultDatePicker({
                        field: inp,
                        minDate: todayDate
                    })));
                });
                passFormSelectpickers = $('#savePaxCont select').selectPicker();
            },
            highlightFFPandVisaStatus = function (passForm) {

                var passengerNum = $(passForm).attr('data-passenger'),
                    isChild = !!$(passForm).attr('data-child'),
                    menuItemCont = $('#savePaxCont li.passenger-item[data-passenger="' + passengerNum + '"]' + (isChild ? '[data-child="true"]' : ''))[0],
                    isEmptyFFP = ($('input[name="ffpCardNumber"]', passForm).val() === ''),
                    isInvalidFFP = $('input[name="ffpCardNumber"]', passForm).hasClass('invalid-control'),
                    visaControls = $('input.form-control-visa', passForm),
                    documentControls = $('input.form-control-document', passForm),
                    isEmptyVisa = true,
                    isInvalidVisa = false,
                    isInvalidDocument = false;

                visaControls.each(function (i, inp) {
                    if ($(inp).val() !== '') {
                        isEmptyVisa = false;
                    }
                    if ($(inp).hasClass('invalid-control')) {
                        isInvalidVisa = true;
                    }
                });

                documentControls.each(function (i, inp) {
                    if ($(inp).val() === '') {
                        isInvalidDocument = true;
                    }
                    if ($(inp).hasClass('invalid-control')) {
                        isInvalidDocument = true;
                    }
                });

                $('div.pass-document', menuItemCont).toggleClass('pass-data-error', isInvalidDocument);
                $('div.pass-visa', menuItemCont).toggleClass('pass-data-error', isInvalidVisa).toggleClass('pass-data-empty', isEmptyVisa);
                $('div.pass-ffp', menuItemCont).toggleClass('pass-data-error', isInvalidFFP).toggleClass('pass-data-empty', isEmptyFFP);

            },
            setPassFormValidation = function (passForm) {

                var passengerSegment = orderInfo.passengers[activePassengerNum].segments[activeSegNum];

                passFormsValidation.push(new Validation({
                    form: passForm,
                    rules: {
                        visaNumber: {
                            testByRegExp: app.constants.visaNumberRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        visaIssueCity: {
                            testByRegExp: app.constants.visaIssueCityRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        visaIssueDate: {
                            dateRange: {
                                max: todayMoment
                            }
                        },
                        visaExpirationDate: {
                            dateRange: {
                                min: todayMoment
                            }
                        },
                        visaBirthPlace: {
                            testByRegExp: app.constants.visaBirthPlaceRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        documentNumber: {
                            testByRegExp: app.constants.documentNumberRegexp,
                            checkInternational: passengerSegment.visa.isInternational
                        },
                        documentBirthDate: {
                            dateRange: {
                                max: todayMoment
                            }
                        },
                        documentExpirationDate: {
                            dateRange: {
                                min: todayMoment
                            }
                        },
                        ffpCardNumber: {
                            testByRegExp: app.constants.ffpNumber
                        }
                    }
                }));

                $('input', passForm).on('blur', function () {
                    highlightFFPandVisaStatus(passForm);
                });

                highlightFFPandVisaStatus(passForm);

            },
            openPassFormTab = function (passForm) {
                var passengerNum = passForm.attr('data-passenger'),
                    isChild = !!passForm.attr('data-child');

                passengersDataModal.set({
                    activePassengerNum: passengerNum,
                    activeIsChild: isChild
                });
            };

        function saveVisasCheckboxNotRequiredOriginal() {
            visasCheckboxNotRequiredOriginal = orderInfo.passengers.map(function (passenger) {
                if (passenger.selected) {
                    return passenger.segments.map(function (segment) {
                        return !!segment.visa.checkboxNotRequired;
                    });
                } else {
                    return false;
                }
            });
        }

        function restoreVisasCheckboxNotRequiredOriginal() {
            _.each(orderInfo.passengers, function (passenger, passengerNum) {
                if (passenger.selected) {
                    _.each(passenger.segments, function (segment, segmentNum) {
                        segment.visa.checkboxNotRequired = visasCheckboxNotRequiredOriginal[passengerNum][segmentNum];
                    });
                }
            });
        }

        passengersDataModal.on('complete', function () {
            saveVisasCheckboxNotRequiredOriginal();
            setPassFormsPickers();
            _.each(orderInfo.passengers, function (passenger, passengerNum) {
                if (passenger.selected) {
                    setPassFormValidation($('#savePaxCont form.pass-edit-form[data-passenger="' + passengerNum + '"]')[0]);
                    if (passenger.child) {
                        setPassFormValidation($('#savePaxCont form.pass-edit-form[data-passenger="' + passengerNum + '"][data-child="true"]')[0]);
                    }
                }
            });
        });

        passengersDataModal.on('teardown', function () {
            _.each(datePickers, function (datePicker) {
                datePicker.destroy();
            });
        });

        passengersDataModal.on('passenger-data-click', function (event) {

            var button = $(event.node),
                passengerNum = button.attr('data-passenger'),
                isChild = !!button.attr('data-child');

            passengersDataModal.set({
                activePassengerNum: passengerNum,
                activeIsChild: isChild
            });

        });

        passengersDataModal.on('toggle-visa-required', function () {
            _.each(passFormsValidation, function (passFormValidation) {
                if ($(passFormValidation.form).hasClass('pax-cont-active')) {
                    passFormValidation.getValidStatus();
                    highlightFFPandVisaStatus($(passFormValidation.form));
                }
            });
            passFormSelectpickers.updateDisabledState();
        });

        passengersDataModal.on('passenger-data-submit', function () {

            var valid = true,
                firstInvalid = true;

            _.each(passFormsValidation, function (passFormValidation) {
                if (!passFormValidation.getValidStatus()) {
                    valid = false;
                    if (firstInvalid) {
                        openPassFormTab($(passFormValidation.form));
                        firstInvalid = false;
                    }
                }
                highlightFFPandVisaStatus($(passFormValidation.form));
            });

            if (valid) {
                $('#savePaxCont form.pass-edit-form').each(function (i, form) {
                    var passengerNum = $(form).attr('data-passenger'),
                        isChild = !!$(form).attr('data-child'),
                        savePaxData = utils.getFormParams($(form)),
                        segmentData = orderInfo.passengers[passengerNum].segments[activeSegNum];

                    if (isChild) {
                        segmentData = orderInfo.passengers[passengerNum].child.segments[activeSegNum];
                    }

                    utils.setSavePaxData(segmentData, savePaxData);
                });

                utils.backupDocumentsAndFFP(orderInfo.passengers);
                app.mapper.currentScreen.update();
                this.teardown();
            }
        });

        passengersDataModal.on('close', function () {
            restoreVisasCheckboxNotRequiredOriginal();
        });


        return passengersDataModal;

    }

    module.exports = PassengersData;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../libs/validation.js":21,"../templates/includes/passengersDataFormItem.html":54,"../templates/includes/passengersDataFormItemInner.html":55,"../templates/includes/passengersDataMenuItem.html":56,"../templates/modals/passengersData.html":65,"pikaday":8}],30:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name QR modal
* @purpose Show QR code for checkin
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/qr-all.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function QR(segments, passengers) {        

        var qrModal = new Modal({
            data: {
                segments: segments,
                passengers: passengers,
                alias: app.siteAliases,
                utils: utils,
                tabId: app.checkinService.getTabId()
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.qrModal.header'),
                modalContent: template
            }
        });

        return qrModal;

    }

    module.exports = QR;


}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/qr-all.html":66}],31:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name QR modal
* @purpose Show QR code for checkin
*/

var template = require('../templates/modals/qr.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function QR(segmentIndex, passengerIndex) {

        var qrModal = new Modal({
            data: {
                segmentIndex: segmentIndex,
                passengerIndex: passengerIndex,
                alias: app.siteAliases,
                tabId: app.checkinService.getTabId()
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.qrModal.header'),
                modalContent: template
            }
        });

        return qrModal;

    }

    module.exports = QR;


}());

},{"../libs/modal.js":18,"../templates/modals/qr.html":67}],32:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name RemovedServicesWarning modal
* @purpose Show removed services list after confirm
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/removedServicesWarning.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function RemovedServicesWarning(orderInfo, removedSvcs, svcsToIssue, contactsData, submitHandler) {

        var removedServicesWarningModal = new Modal({
            data: {
                orderInfo: orderInfo,
                removedSvcs: reformatRemovedSvcs(removedSvcs),
                svcsToIssueBySegments: reformatSvcsToIssue(svcsToIssue),
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.popupRemovedServicesWarning.header'),
                modalContent: template
            }
        });

        removedServicesWarningModal.on('submit', function () {
            submitHandler(contactsData);
            this.teardown();
        });

        return removedServicesWarningModal;

        function linkOrderPassenger(svc) {
            svc.passenger = _.findWhere(orderInfo.sirenaOrder.passengers, {
                id: svc.passengerId,
                pnr: svc.pnr,
            });
            return svc;
        }
    
        function reformatRemovedSvcs(list) {
            return list.map(linkOrderPassenger);
        }

        function reformatSvcsToIssue(list) {
            var listByGroups = _.groupBy(list, 'groupCode'),
                groupCodes = _.keys(listByGroups);
            return orderInfo.sirenaOrder.segments.map(function (flight) {
                if (_.findWhere(list, { segmentId: flight.id })) {
                    return groupCodes.filter(function (code) {
                        return _.findWhere(list, { segmentId: flight.id, groupCode: code });
                    }).map(function (groupCode) {
                        return {
                            groupCode: groupCode,
                            servicesList: _.where(listByGroups[groupCode], { segmentId: flight.id }).map(linkOrderPassenger)
                        };
                    });
                } else {
                    return false;
                }
            });
        }

    }

    module.exports = RemovedServicesWarning;


}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/removedServicesWarning.html":68}],33:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/selectMeal.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SelectMeal(mealMenu, passenger, segment, callback) {

        var selectMealModal = new Modal({
            data: {
                mealMenu: mealMenu,
                passenger: passenger,
                segment: segment,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.selectMealModal.header'),
                modalContent: template
            }
        });

        selectMealModal.on('meal-click', function (event) {
            var link = $(event.original.target),
                cont = link.parents('div.item'),
                subgroupNum = cont.attr('data-subgroup') * 1,
                itemNum = cont.attr('data-item') * 1,
                mealItem = mealMenu[subgroupNum][itemNum];
            this.teardown();
            callback(mealItem, subgroupNum);
            return false;
        });

        return selectMealModal;

    }

    module.exports = SelectMeal;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/selectMeal.html":69}],34:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/selectSegmentGroups.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SelectSegmentGroups(selectSegmentsGroupCase, callback) {

        var selectSegmentGroupsModal = new Modal({
            data: {
                selectSegmentsGroupCase: selectSegmentsGroupCase,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.search.selectSegmentsGroupModal.header'),
                modalContent: template
            }
        });
        

        selectSegmentGroupsModal.on('confirm-segments', function () {
            this.teardown();
            callback(selectSegmentGroupsModal.get('selectedSegments'));
        });

        return selectSegmentGroupsModal;

    }

    module.exports = SelectSegmentGroups;

}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/selectSegmentGroups.html":70}],35:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/selectSegments.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SelectSegments(selectSegmentsCase, callback) {

        var selectSegmentsModal = new Modal({
            data: {
                selectSegmentsCase: selectSegmentsCase,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.search.selectSegmentsModal.header'),
                modalContent: template
            }
        });

        selectSegmentsModal.on('confirm-segments', function () {
            var selectedSegmentsRadio = selectSegmentsModal.get('selectedSegments') + '',
                selectedSegments,
                segmentIdsList;
            if (selectedSegmentsRadio === 'through') {
                selectedSegments = selectSegmentsCase.segmentsForThroughCheckIn;
            } else {
                selectedSegments = [selectSegmentsCase.openedSegments[parseInt(selectedSegmentsRadio)]];
            }
            segmentIdsList = selectedSegments.map(function (segment) {
                return segment.id;
            });
            this.teardown();
            callback(JSON.stringify(segmentIdsList));
        });

        return selectSegmentsModal;

    }

    module.exports = SelectSegments;

}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/selectSegments.html":71}],36:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/selectSegmentsTruncated.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SelectSegmentsTruncated(selectSegmentsTruncatedCase, callback) {

        var selectSegmentsTruncatedModal = new Modal({
            data: {
                selectSegmentsTruncatedCase: selectSegmentsTruncatedCase,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.search.selectSegmentsTruncatedModal.header'),
                modalContent: template
            }
        });

        selectSegmentsTruncatedModal.on('confirm', function () {
            this.teardown();
            callback();
        });

        return selectSegmentsTruncatedModal;

    }

    module.exports = SelectSegmentsTruncated;

}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/selectSegmentsTruncated.html":72}],37:[function(require,module,exports){
var utils = require('../libs/utils.js'),
    template = require('../templates/modals/selectSegmentsType.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SelectSegmentsType(selectSegmentsTypeCase, callback) {

        var selectSegmentsTypeModal = new Modal({
            data: {
                selectSegmentsTypeCase: selectSegmentsTypeCase,
                alias: app.siteAliases,
                utils: utils
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.search.selectSegmentsTypeModal.header'),
                modalContent: template
            }
        });

        selectSegmentsTypeModal.on('confirm-segments-type', function () {
            var selectedSegmentsType = selectSegmentsTypeModal.get('selectedSegmentsType');
            this.teardown();
            callback(selectedSegmentsType);
        });

        return selectSegmentsTypeModal;

    }

    module.exports = SelectSegmentsType;

}());
},{"../libs/modal.js":18,"../libs/utils.js":20,"../templates/modals/selectSegmentsType.html":73}],38:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name SendBoardingPass modal
* @purpose Ask e-mail
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/modals/sendBoardingPass.html'),
    Modal = require('../libs/modal.js'),
    Validation = require('../libs/validation.js');

(function () {

    'use strict';

    function getOtherPassengers(passengers, mainPassengerIndex) {
        var otherPassengers = [];
        _.each(passengers, function (passenger, passengerIndex) {
            if (passenger.selected && mainPassengerIndex != passengerIndex) {
                passenger.passengerIndex = passengerIndex;
                otherPassengers.push(passenger);
            }
        });
        return otherPassengers;
    }

    function getSelectedPassengersJSON(passengers) {
        return JSON.stringify({
            passengers: passengers.map(function (passenger, passengerIndex) {
                return $('#selected-passenger-' + passengerIndex).is(':checked');
            })
        });
    }

    function SendBoardingPass(passengers, mainPassengerIndex, withoutPaxSelect) {

        var otherPassengers = getOtherPassengers(passengers, mainPassengerIndex),
            sendBoardingPassForm,
            sendBoardingPassFormValidation,
            sendBoardingPassModal = new Modal({
                data: {
                    mainPassenger: passengers[mainPassengerIndex],
                    mainPassengerIndex: mainPassengerIndex,
                    otherPassengers: otherPassengers,
                    withoutPaxSelect: withoutPaxSelect,
                    mailList: [''],
                    alias: app.siteAliases,
                    utils: utils
                },
                disableContClick: true,
                partials: {
                    modalHeader: app.siteAliases('oxygen-check-in.sendBoardingPassModal.header'),
                    modalContent: template
                }
            });

        sendBoardingPassModal.on('complete', function () {
            sendBoardingPassForm = $('#sendBoardingPassForm');
            sendBoardingPassFormValidation = new Validation({
                form: sendBoardingPassForm[0],
                rules: {
                    'email_0': {
                        testByRegExp: app.siteParams('oxygen-check-in.emailRegexp'),
                        required: true
                    }
                }
            });
        });

        sendBoardingPassModal.on('add-mail', function () {
            var mailList = sendBoardingPassModal.get('mailList'),
                rules = {};
            rules['email_' + mailList.length] = {
                testByRegExp: app.siteParams('oxygen-check-in.emailRegexp'),
                required: true
            };
            mailList.push('');
            sendBoardingPassFormValidation.updateRules(rules);
            sendBoardingPassModal.set('mailList', mailList);
        });

        sendBoardingPassModal.on('delete-mail', function (event) {

            var mailList = sendBoardingPassModal.get('mailList'),
                num = parseInt($(event.node).attr('data-num'), 10),
                newMailList = [];
            _.each(mailList, function (mail, i) {
                if (i !== num) {
                    newMailList.push(mail);
                }
            });
            sendBoardingPassModal.set('mailList', newMailList);

        });

        sendBoardingPassModal.on('submit', function () {
            sendBoardingPassForm.trigger('submit');
        });

        sendBoardingPassModal.on('send-boarding-pass', function () {
            var params;
            if (
                sendBoardingPassFormValidation.getValidStatus() &&
                (hasSelectedPassengers() || withoutPaxSelect)
            ) {
                params = {
                    email: sendBoardingPassModal.get('mailList').join(', ')
                };
                if (!withoutPaxSelect) {
                    params.selected = getSelectedPassengersJSON(passengers);
                }
                app.checkinService.boardingPassEmail(params).then(function () {
                    sendBoardingPassModal.set('showSuccessMessage', true);
                });
            }

            return false;
        });

        sendBoardingPassModal.on('toggle-all-passengers', function (event) {
            var chb = $(event.original.target);

            _.each($('#otherPassengersList input[name="selected-passenger"]'), function (passChb) {
                if (chb.is(':checked') !== $(passChb).is(':checked')) {
                    $(passChb).trigger('click');
                }
            });

        });

        sendBoardingPassModal.on('passengers-change', function () {
            checkSubmit();
        });

        function checkSubmit() {
            if (hasSelectedPassengers()) {
                $('#submitBoardingPassButton').removeClass('disabled');
            } else {
                $('#submitBoardingPassButton').addClass('disabled');
            }
        }

        function hasSelectedPassengers() {
            var hasSelected = false;
            _.each($('input[name="selected-passenger"]', $('#sendBoardingPassForm')), function (passChb) {
                if ($(passChb).is(':checked')) {
                    hasSelected = true;
                }
            });
            return hasSelected;
        }

        return sendBoardingPassModal;

    }

    module.exports = SendBoardingPass;


}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../libs/validation.js":21,"../templates/modals/sendBoardingPass.html":74}],39:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Conditions modal
* @purpose Extra service terms and conditions
*/

var template = require('../templates/modals/serviceСonditions.html'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function ServiceСonditions(code) {

        return new Modal({
            data: {
                alias: app.siteAliases
            },
            partials: {
                modalHeader: app.siteAliases('oxygen-check-in.extraServicesRules.header'),
                conditionsText: app.siteAliases('oxygen-check-in.extraServicesRules.' + code),
                modalContent: template
            }
        });

    }

    module.exports = ServiceСonditions;


}());

},{"../libs/modal.js":18,"../templates/modals/serviceСonditions.html":75}],40:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name appSteps
* @purpose Application steps config
*/

var ConditionsScreen = require('./screens/conditions.js'),
    PrivacyPolicyScreen = require('./screens/privacyPolicy.js'),
    SearchScreen = require('./screens/search.js'),
    CheckInScreen = require('./screens/checkIn.js'),
    BoardingPassScreen = require('./screens/boardingPass.js');

(function () {

    'use strict';

    function Screens() {
        var screensList = [
            new SearchScreen(),
            new CheckInScreen(),
            new BoardingPassScreen(),
            new PrivacyPolicyScreen()
        ];
        if (app.siteParams('oxygen-check-in.displayConditionsFirst')) {
            screensList.unshift(new ConditionsScreen());
        }
        return screensList;
    }

    module.exports = Screens;

}());

},{"./screens/boardingPass.js":41,"./screens/checkIn.js":42,"./screens/conditions.js":43,"./screens/privacyPolicy.js":44,"./screens/search.js":45}],41:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name BoardingPass
* @purpose BoardingPass step ractive object
*/

/*jslint browser: true, nomen: true */
/*global require, module, console, $, Ractive, app*/

var utils = require('../libs/utils.js'),
    template = require('../templates/screens/boardingPass/boardingPass.html'),
    templateRossiya = require('../templates/screens/boardingPass/boardingPassRossiya.html'),
    passengerItemTemplate = require('../templates/includes/passengerItem.html'),
    PassengerDataSeatModal = require('../modals/passengerDataSeat.js'),
    SendBoardingPassModal = require('../modals/sendBoardingPass.js'),
    QRModal = require('../modals/qr.js'),
    QRAllModal = require('../modals/qr-all.js'),
    CancelCheckinModal = require('../modals/cancelCheckin.js'),
    orderPricesTemplate = require('../templates/includes/orderPrices.html'),
    groupedServicesListTemplate = require('../templates/includes/groupedServicesList.html');

(function () {

    'use strict';

    function BoardingPassScreen() {

        var orderInfo,
            passengerDataSeatModal,
            qrModal,
            qrAllModal,
            sendBoardingPassModal,
            cancelCheckinModal,
            isLastCanceledPassenger = false,
            boardingPassRactive = new Ractive({
                code: 'boardingPass',
                template: window.useBoardingPassTemplateRossiya ? templateRossiya : template,
                data: {
                    countriesDict: app.countriesDict,
                    systemLanguage: o2context.systemLanguage,
                    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
                    isAndroid: /(android)/i.test(navigator.userAgent),
                    tabId: app.checkinService.getTabId()
                },
                partials: {
                    passengerItem: passengerItemTemplate,
                    orderPrices: orderPricesTemplate,
                    groupedServicesList: groupedServicesListTemplate
                }
            }),
            checkOrderInfo = function () {
                var valid = true;

                // Игнорирование невалидной orderInfo после отмены последнего пассажира.
                if (isLastCanceledPassenger) {
                    return;
                }

                if (valid && !orderInfo) {
                    valid = false;
                    console.log('Invalid orderInfo');
                }

                if (valid && orderInfo.paymentInProgress) {
                    valid = false;
                    console.log('payment in progress');
                }

                if (valid && !utils.hasSelectedPassengers(orderInfo.passengers)) {
                    valid = false;
                    console.log('Invalid orderInfo - none selected passengers');
                }

                if (valid && orderInfo.passengersType !== 'CHECKED') {
                    console.log('Passengers are not checked');
                    valid = false;
                }

                if (!valid) {
                    console.log('Goto first screen');
                    location.hash = '#search';
                }

            },
            //Данная функция сделана, чтобы проставить галочку "виза не требуется" для незаполненных виз.
            //Потому что раз пассажир оказался на этом шаге, т.е. успешно зарегистрировался, а его виза пустая
            //значит по умолчанию ее требовать от пассажира не нужно.
            setVisasNotRequiredIfEmpty = function() {
                orderInfo.passengers.forEach(function (passenger) {
                    passenger.segments.forEach(function (segment) {
                        if (utils.isVisaEmpty(segment.visa)) {
                            segment.visa.checkboxNotRequired = true;
                        }
                    });

                    if (passenger.child) {
                        passenger.child.segments.forEach(function (segment) {
                            if (utils.isVisaEmpty(segment.visa)) {
                                segment.visa.checkboxNotRequired = true;
                            }
                        });
                    }
                });
            },
            getAssignedAnotherSeatNotificationMessages = function (orderInfo) {
                var notificationMessages = [];
                orderInfo.passengers.forEach(function (passenger) {
                    passenger.segments.forEach(function (segment, segmentNumber) {
                        if (segment.assignedAnotherSeat) {
                            notificationMessages.push({
                                type: 'assignedAnotherSeat',
                                passengerLastName: passenger.lastName,
                                passengerName: passenger.name,
                                seatNumber: segment.seat.number,
                                flightNumber: orderInfo.segments[segmentNumber].flightNumber,
                                airlineCode: orderInfo.segments[segmentNumber].airlineCode,
                                departureCity: orderInfo.segments[segmentNumber].departureCity,
                                arrivalCity: orderInfo.segments[segmentNumber].arrivalCity
                            });
                        }
                    });
                });
                return notificationMessages;
            },
            updateOrderInfo = function (cb) {
                app.checkinService.orderInfo().then(function (resp) {
                    orderInfo = resp;
                    checkOrderInfo();
                    setVisasNotRequiredIfEmpty();
                    boardingPassRactive.set('orderInfo', orderInfo);
                    if (cb) {
                        cb();
                    }
                }, function (resp) {
                    console.log('orderInfo error: ', resp);
                });
            };

        boardingPassRactive.on('complete insert', function () {
            updateOrderInfo(function () {
                var list = getAssignedAnotherSeatNotificationMessages(orderInfo);
                list.push({type: 'checkinComplete'});
                boardingPassRactive.set('notificationMessages', list);
            });
        });

        boardingPassRactive.on('edit-pass-seat-click', function (event) {

            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                segNum = cont.attr('data-segment'),
                passengerNum = cont.attr('data-passenger');

            passengerDataSeatModal = new PassengerDataSeatModal(orderInfo, function () {
                updateOrderInfo(function () {
                    var list = getAssignedAnotherSeatNotificationMessages(orderInfo);
                    list.push({type : 'dataModified'});
                    boardingPassRactive.set('notificationMessages', list);
                });
            }, segNum, passengerNum, 'seat');
            return false;

        });

        boardingPassRactive.on('edit-pass-data-click', function (event) {

            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                segNum = cont.attr('data-segment'),
                passengerNum = cont.attr('data-passenger');

            passengerDataSeatModal = new PassengerDataSeatModal(orderInfo, function () {
                updateOrderInfo(function () {
                    var list = getAssignedAnotherSeatNotificationMessages(orderInfo);
                    list.push({type : 'dataModified'});
                    boardingPassRactive.set('notificationMessages', list);
                });
            }, segNum, passengerNum, 'data');
            return false;

        });

        boardingPassRactive.on('show-qr-modal', function (event) {
            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                segmentNum = cont.attr('data-segment'),
                passengerNum = cont.attr('data-passenger');
            qrModal = new QRModal(segmentNum, passengerNum);
            return false;
        });

        boardingPassRactive.on('show-all-qrs-modal', function () {
            qrAllModal = new QRAllModal(orderInfo.segments, orderInfo.passengers);
            return false;
        });

        boardingPassRactive.on('show-send-modal', function (event) {
            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                passengerNum = cont.attr('data-passenger');
            sendBoardingPassModal = new SendBoardingPassModal(orderInfo.passengers, passengerNum);
            return false;
        });

        boardingPassRactive.on('show-send-modal-all', function () {
            sendBoardingPassModal = new SendBoardingPassModal(
                orderInfo.passengers,
                utils.getFirstSelectedPassengerIndex(orderInfo.passengers)
            );
            return false;
        });

        boardingPassRactive.on('show-send-modal-all-without-pax-select', function () {
            sendBoardingPassModal = new SendBoardingPassModal(
                orderInfo.passengers,
                0,
                true
            );
            return false;
        });

        boardingPassRactive.on('clear-session', function () {
            app.checkinService.clearSession().then(function () {
                var paramLang = utils.getParamFromLocation('lang');
                document.location.assign(paramLang ? './?lang=' + paramLang + '#search' : './#search');
            });
        });

        boardingPassRactive.on('cancel-checkin-click', function (event) {

            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                passengerIndex = cont.attr('data-passenger');

            cancelCheckinModal = new CancelCheckinModal(orderInfo, passengerIndex, function (resp) {
                if (resp.needFullOrderUpdate) {
                    boardingPassRactive.set('orderInfo', false);
                    boardingPassRactive.set('notificationMessages', [{type: 'needFullOrderUpdate'}]);
                } else {
                    updateOrderInfo(function () {
                        var list = getAssignedAnotherSeatNotificationMessages(orderInfo);
                        if (resp.lastPassengerCancelled) {
                            list = [{type: 'checkinCancelForLastPassenger'}];
                        } else {
                            list.push({type : 'checkinCancel'});
                        }
                        boardingPassRactive.set('notificationMessages', list);
                    });
                }
            });
            return false;

        });

        return boardingPassRactive;

    }

    module.exports = BoardingPassScreen;

}());

},{"../libs/utils.js":20,"../modals/cancelCheckin.js":24,"../modals/passengerDataSeat.js":28,"../modals/qr-all.js":30,"../modals/qr.js":31,"../modals/sendBoardingPass.js":38,"../templates/includes/groupedServicesList.html":51,"../templates/includes/orderPrices.html":52,"../templates/includes/passengerItem.html":53,"../templates/screens/boardingPass/boardingPass.html":76,"../templates/screens/boardingPass/boardingPassRossiya.html":77}],42:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name CheckIn
* @purpose CheckIn step ractive object
*/

var utils = require('../libs/utils.js'),
    ConfirmPaidServicesModal = require('../modals/confirmPaidServices.js'),
    PassengersDataModal = require('../modals/passengersData.js'),
    PassengerCanLoseFreeSeatWarningModal = require('../modals/passengerCanLoseFreeSeatWarning.js'),
    ConditionsModal = require('../modals/conditions.js'),
    RemovedServicesWarningModal = require('../modals/removedServicesWarning.js'),
    ExtraServices = require('../extraServices.js'),
    template = require('../templates/screens/checkIn/checkIn.html'),
    templateRossiya = require('../templates/screens/checkIn/checkInRossiya.html'),
    viewCraftTemplate = require('../templates/includes/viewCraft.html'),
    passengerItemTemplate = require('../templates/includes/passengerItem.html'),
    paidCheckinInfoTemplate = require('../templates/screens/checkIn/paidCheckinInfo.html');

(function () {

    'use strict';

    function CheckInScreen() {

        var orderInfo,
            extraServicesRactive,
            confirmPaidServicesModal,
            passengersDataModal,
            removedServicesWarningModal,
            passengerCanLoseFreeSeatWarningModal,
            visibleSegments = [],
            checkInRactive = new Ractive({
                code: 'checkIn',
                template: window.useCheckInTemplateRossiya ? templateRossiya : template,
                data: {
                    visibleSegments: visibleSegments,
                    countriesDict: app.countriesDict,
                    hasAgreeLabelHtml: app.siteAliases('oxygen-check-in.termsAndConditions.agreeLabelHtml') !== 'oxygen-check-in.termsAndConditions.agreeLabelHtml',
                    showViewCraft:true
                },
                partials: {
                    paidCheckinInfo: paidCheckinInfoTemplate,
                    passengerItem: passengerItemTemplate,
                    agreeLabelHtml: app.siteAliases('oxygen-check-in.termsAndConditions.agreeLabelHtml')
                }
            }),
            checkOrderInfo = function () {
                var valid = true;

                if (valid && !orderInfo) {
                    valid = false;
                    console.log('Invalid orderInfo');
                }

                if (valid && !utils.hasSelectedPassengers(orderInfo.passengers)) {
                    valid = false;
                    console.log('Invalid orderInfo - none selected passengers');
                }

                if (valid && orderInfo.passengersType === 'CHECKED') {
                    console.log('Goto #boardingPass screen');
                    location.hash = '#boardingPass';
                    return;
                }

                //Проверка должна быть именно тут, после того как проверили, что работаем с незарегистрированным пассажирами.
                //Потому что зарегистрированные пассажиры могут работать с заказом где нет открытых сегментов.
                if (valid && !utils.isAtLeastOneOpenedSegmentInOrder(orderInfo.segments)) {
                    valid = false;
                    console.log('Invalid orderInfo - at least one segment has to be opened');
                }

                if (!valid) {
                    console.log('Goto first screen');
                    location.hash = 'search';
                }

            },
            checkReadyToConfirm = function () {
                var hasPassengersWithoutSeat = false,
                    hasInvalidPassengersData = false,
                    hasAgree = (
                        app.siteParams('oxygen-check-in.displayConditionsFirst') || 
                        app.siteParams('oxygen-check-in.showSearchAgreeCheckbox') || 
                        checkInRactive.get('agree')
                    ),
                    checkinConfirmButton = $('#checkinConfirmButton');
                _.each(orderInfo.passengers, function (passenger) {
                    if (passenger.selected) {
                        _.each(passenger.segments, function (segment, segmentIndex) {
                            if (orderInfo.segments[segmentIndex].status === 'OPENED') {
                                if (!utils.checkPassengerSeatSelected(orderInfo.segments, segmentIndex, passenger)) {
                                    hasPassengersWithoutSeat = true;
                                }

                                if (!utils.checkPassengerSegmentData(segment)) {
                                    hasInvalidPassengersData = true;
                                }
                            }
                        });
                    }
                });
                if (hasPassengersWithoutSeat || hasInvalidPassengersData || !hasAgree) {
                    checkinConfirmButton.addClass('disabled');
                } else {
                    checkinConfirmButton.removeClass('disabled');
                }
            },
            setOrderInfo = function (data) {
                orderInfo = data;
                checkOrderInfo();
                utils.restoreDocumentsAndFFP(orderInfo.passengers);
                checkReadyToConfirm();
                checkInRactive.set('orderInfo', orderInfo);
            },
            updateOrderInfo = function (cb) {
                app.checkinService.orderInfo().then(function (resp) {
                    setOrderInfo(resp);
                    if (cb) {
                        cb();
                    }
                }, function (resp) {
                    console.log('orderInfo error: ', resp);
                });
            },
            viewCraftsRactive = [],
            highlightSelectedSeats = function (segNum) {
                var mainSelectedSeat = false,
                    otherSelectedSeats = [],
                    selectedPassengerItem = $('#checkinForm div.selected-passenger-item[data-segment="' + segNum + '"]'),
                    passengerNum = selectedPassengerItem.attr('data-passenger'),
                    viewCraftBox = $('#checkinForm div.view-craft-box[data-segment="' + segNum + '"] div.view-craft-box-inner');

                mainSelectedSeat = orderInfo.passengers[passengerNum].segments[segNum].seat;

                _.each(orderInfo.passengers, function (passenger) {
                    if (passenger.selected && passenger.segments[segNum].seat) {
                        otherSelectedSeats.push(passenger.segments[segNum].seat);
                    }
                });

                $('div.seat-selected', viewCraftBox).removeClass('seat-selected');
                $('div.seat-order', viewCraftBox).removeClass('seat-order');

                if (mainSelectedSeat) {
                    $('div.seat[data-seat="' + mainSelectedSeat.number + '"]', viewCraftBox).addClass('seat-selected');
                }

                checkInRactive.set('selectedSeatNumber', mainSelectedSeat && mainSelectedSeat.number);

                _.each(otherSelectedSeats, function (otherSeat) {
                    if (!mainSelectedSeat || otherSeat.number !== mainSelectedSeat.number) {
                        $('div.seat[data-seat="' + otherSeat.number + '"]', viewCraftBox).addClass('seat-order');
                    }
                });

            },
            selectSeatHandler = function (selectSeatParams) {
                app.checkinService.selectSeatNumber(selectSeatParams).then(function (resp) {
                    if (resp.result === 'ok') {
                        updateViewCraft(
                            selectSeatParams.passengerIndex, 
                            selectSeatParams.segmentIndex,
                            function () {
                                updateOrderInfo(function () {
                                    highlightSelectedSeats(selectSeatParams.segmentIndex);
                                    if (orderInfo.sirenaOrder) {
                                        extraServicesRactive.set('sirenaOrder', orderInfo.sirenaOrder);
                                    }
                                });
                            }
                        );
                    }
                });
            },
            seatClick = function (event) {
                var seatButton = $(event.original.target),
                    seatNumber = seatButton.attr('data-seat'),
                    viewCraftBox = seatButton.parents('div.view-craft-box'),
                    segmentIndex = viewCraftBox.attr('data-segment'),
                    showWarningPassengerCanLoseFreeSeat = seatButton.attr('data-show-warning') === 'true',
                    cont = seatButton.parents('div.passenger-section'),
                    selectedPassengerItem = $('div.selected-passenger-item', cont),
                    passengerIndex = selectedPassengerItem.attr('data-passenger'),
                    possibleActions = orderInfo.passengers[passengerIndex].segments[segmentIndex].possibleActions,
                    selectSeatParams = {
                        segmentIndex: segmentIndex,
                        passengerIndex: passengerIndex,
                        seatNumber: seatNumber
                    };

                if (
                    utils.hasInList(possibleActions, 'CHANGE_SEAT') &&
                    seatButton.hasClass('seat-vacant') &&
                    !seatButton.hasClass('seat-order') &&
                    !seatButton.hasClass('seat-selected')
                ) {

                    if (showWarningPassengerCanLoseFreeSeat) {
                        passengerCanLoseFreeSeatWarningModal = new PassengerCanLoseFreeSeatWarningModal(
                            selectSeatParams,
                            selectSeatHandler
                        );
                    } else {
                        selectSeatHandler(selectSeatParams);
                    }

                }

            },

            waitPayment = function () {
                checkInRactive.set('waitingPayment', true);
                app.checkinService.checkOrderStatus().then(function (resp) {
                    utils.lockScreen();
                    if (resp.status === 'PAID') {
                        window.location.hash = '#boardingPass';
                    } else if (resp.status === 'CANNOT_BE_PAID' || resp.status === 'NOT_PAID') {
                        checkInRactive.set('waitingPayment', false);
                        checkInRactive.set('failedPayment', resp.status);
                        utils.unlockScreen();
                    } else {
                        setTimeout(waitPayment, app.siteParams('oxygen-check-in.paymentStatusAttemptsInterval') * 1000);
                    }
                });
            },

            updateViewCraft = function (passNum, segNum, cb) {

                var cont = $('div.order-cont-segment-' + segNum),
                    possibleActions = orderInfo.passengers[passNum].segments[segNum].possibleActions;

                visibleSegments[segNum] = true;
                checkInRactive.set('visibleSegments', visibleSegments);

                if (orderInfo.segments[segNum].selectSeatsMode !== 'CANT_SELECT') {

                    app.checkinService.viewCraft({
                        segmentIndex: segNum,
                        passengerIndex: passNum
                    }).then(function (resp) {

                        viewCraftsRactive[segNum] = new Ractive({
                            el: $('div.view-craft-box', cont),
                            template: viewCraftTemplate,
                            oncomplete: checkReadyToConfirm,
                            data: {
                                cabins: resp.cabins,
                                disabledMode: !utils.hasInList(possibleActions, 'CHANGE_SEAT')
                            }
                        });

                        checkInRactive.set('hasSeatsNearEmergencyExit', resp.hasSeatsNearEmergencyExit);
                        checkInRactive.set('hasAutoAssignedSeats', resp.hasAutoAssignedSeats);

                        viewCraftsRactive[segNum].on('seat-click', seatClick);

                        if (cb) {
                            cb();
                        }

                    });
                } else {
                    checkReadyToConfirm();
                }

            };

        checkInRactive.on('complete insert', function () {
            var resultParam = utils.getParamFromLocation('result');
            visibleSegments = [];
            checkInRactive.set('visibleSegments', visibleSegments);
            updateOrderInfo(function () {
                checkInRactive.set('waitingPayment', false);
                checkInRactive.set('failedPayment', false);

                //Если сейчас идет процесс оплаты, то надо либо делать редирект на страницу МПС, либо блокировать экран и ждать, пока оплата подтвердится.
                //Был сделан специальный признак redirectResultFromIPS, котоырй говорит о том, был ли сделан переход с платежной страницы. Если он был сделан, то надо ждать оплату,
                //если не был - редиректить на страницу МПС.
                if (orderInfo.paymentInProgress) {
                    if (orderInfo.paymentInProgress.redirectResultFromIPS) {
                        utils.lockScreen();
                        waitPayment();
                    } else {
                        if (resultParam) {
                            utils.lockScreen();
                            //Сообщим серверу, что был редирект с платежной страницы
                            app.checkinService.setRedirectResultFromIps({result: resultParam}).then(function () {
                                waitPayment();
                            });
                        } else {
                            openPaymentUrl(orderInfo.paymentInProgress.redirectTo);
                        }
                    }
                }

                if (orderInfo.paymentStatus && (orderInfo.paymentStatus === 'CANNOT_BE_PAID' || orderInfo.paymentStatus === 'NOT_PAID')) {
                    checkInRactive.set('failedPayment', orderInfo.paymentStatus);
                }

                if (orderInfo.sirenaOrder && !orderInfo.paymentInProgress) {
                    extraServicesRactive = new ExtraServices(orderInfo.sirenaOrder, setOrderInfo);
                    extraServicesRactive.render('extraServicesCont');
                }

            });
        });

        checkInRactive.on('detach', function () {
            checkInRactive.set('orderInfo', false);
        });

        checkInRactive.on('switch-view-craft', function () {
            checkInRactive.set(
                'showViewCraft',
                !checkInRactive.get('showViewCraft')
            );
            return false;
        });

        checkInRactive.on('goto-segment', function (event) {
            var button = $(event.original.target),
                segNum = button.attr('data-segment'),
                cont = $('div.order-cont-segment-' + segNum);
            if (button.hasClass('btn-open-segment-active')) return;
            $('a.btn-open-segment', cont).addClass('btn-open-segment-active');
            $($('div.passenger-item div.accordion-head', cont)[0]).trigger('click');
        });

        checkInRactive.on('passenger-click', function (event) {
            var button = $(event.original.target),
                selectedPassengerItem = button.parents('div.passenger-item'),
                segNum = selectedPassengerItem.attr('data-segment'),
                passNum = selectedPassengerItem.attr('data-passenger'),
                cont = button.parents('div.passenger-section'),
                errorDataTooltipCont = $('div.data.tooltip-err-cont', selectedPassengerItem);

            $('.tooltip-cont-hover').removeClass('tooltip-cont-hover');
            errorDataTooltipCont.trigger('mouseover').addClass('tooltip-cont-hover');

            if (!selectedPassengerItem.hasClass('selected-passenger-item')) {
                $('div.passenger-item', cont).removeClass('selected-passenger-item');
                selectedPassengerItem.addClass('selected-passenger-item');
                updateViewCraft(passNum, segNum, function () {
                    highlightSelectedSeats(segNum);
                });
            }

        });

        checkInRactive.on('edit-pass-click', function (event) {

            var button = $(event.original.target),
                cont = button.parents('div.passenger-item'),
                segNum = cont.attr('data-segment'),
                passengerNum = cont.attr('data-passenger');

            passengersDataModal = new PassengersDataModal(orderInfo, segNum, passengerNum);

        });

        checkInRactive.on('payment-frame-load', PaymentFrameLoadHandler);

        checkInRactive.on('update conditions-agree-change', checkReadyToConfirm);

        checkInRactive.on('open-conditions-modal', function () {
            return new ConditionsModal();
        });

        checkInRactive.on('checkin-confirm', function (event) {
            var button = $(event.original.target);

            if (!button.hasClass('disabled')) {
                app.checkinService.confirmCheckin({
                    documentsAndFFP: utils.getDocumentsAndFFP(orderInfo.passengers)
                }).then(function (resp) {
                    if (resp.result === 'ok') {
                        location.hash = '#boardingPass';
                    }
                }, function (resp) {
                    if (resp.error === 'check-in.contactsRequired') {
                        resp.errorModal.teardown();
                        confirmPaidServicesModal = new ConfirmPaidServicesModal(
                            orderInfo,
                            confirmPaidServicesSubmitHandler,
                            resp.canChoosePassenger,
                            resp.phoneRequired,
                            resp.emailRequired
                        );                        
                    }
                });
            }

        });

        return checkInRactive;

        function confirmPaidServicesSubmitHandler(contactsData) {
            var confirmParams = {
                documentsAndFFP: utils.getDocumentsAndFFP(orderInfo.passengers),
                phone: contactsData.phone,
                email: contactsData.email
            };
            if (contactsData.contactsPassengerId !== -1 && contactsData.contactsPnr) {
                confirmParams.contactsPassengerId = contactsData.contactsPassengerId;
                confirmParams.contactsPnr = contactsData.contactsPnr;
            }
            app.checkinService.confirmCheckin(confirmParams).then(function (resp) {
                if (resp.removedSvcs && resp.removedSvcs.length) {
                    removedServicesWarningModal = new RemovedServicesWarningModal(
                        orderInfo, 
                        resp.removedSvcs, 
                        resp.svcsToIssue,
                        contactsData,
                        confirmPaidServicesSubmitHandler
                    );
                } else {
                    app.checkinService.orderInfo().then(function (orderInfoResp) {
                        if (orderInfoResp.paymentInProgress && orderInfoResp.paymentInProgress.redirectTo) {
                            openPaymentUrl(orderInfoResp.paymentInProgress.redirectTo);
                        } else {
                            location.hash = '#boardingPass';
                        }
                    });
                }
            });
        }

        function openPaymentUrl(redirectTo) {
            if (app.siteParams('check-in.openPaymentInIframe')) {
                if (extraServicesRactive) {
                    extraServicesRactive.teardown();
                }
                checkInRactive.set('showPaymentFrame', true);
                checkInRactive.set('paymentFrameUrl', redirectTo);
                window.scrollTo(0, document.getElementById('paymentFrame').offsetTop);
            } else {
                utils.lockScreen();
                window.location = redirectTo;
            }
        }

        function PaymentFrameLoadHandler() {
            var paymentFrame = document.getElementById('paymentFrame');
            try {
                if (paymentFrame.contentWindow.location.hostname === window.location.hostname) {
                    window.location = paymentFrame.contentWindow.location.href;
                    paymentFrame.style.display = 'none';
                }
            } catch (e) {
                console.info("paymentFrame load err: ", e, event);
            }
        }

    }



    module.exports = CheckInScreen;

}());

},{"../extraServices.js":16,"../libs/utils.js":20,"../modals/conditions.js":25,"../modals/confirmPaidServices.js":26,"../modals/passengerCanLoseFreeSeatWarning.js":27,"../modals/passengersData.js":29,"../modals/removedServicesWarning.js":32,"../templates/includes/passengerItem.html":53,"../templates/includes/viewCraft.html":57,"../templates/screens/checkIn/checkIn.html":78,"../templates/screens/checkIn/checkInRossiya.html":79,"../templates/screens/checkIn/paidCheckinInfo.html":80}],43:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Conditions
* @purpose Conditions screen
*/

var template = require('../templates/screens/conditions/conditions.html');

(function () {

    'use strict';

    function ConditionsScreen() {

        var orderInfo,
            conditionsRactive = new Ractive({
                code: 'conditions',
                template: template,
                partials: {
                    conditionsText: app.siteAliases('oxygen-check-in.termsAndConditions')
                }
            });

        conditionsRactive.on('complete insert', function () {
            //order-info вызывается только затем, чтобы посмотреть есть ли в текущей сессии paymentInProgress, который означает,
            //есть ли на данный момент заказ в НЕКОНЕЧНОМ статусе (т.е. being_paid). Если есть, то идет редирект на экран #checkIn,
            //где будет завершена оплата.
            //Данный механизм сделан на случай если человек закроет вкладку не дождавшись завершения оплаты. Ведь если он просто переищет заказ,
            //то не сможет узнать статус оплаты, т.к. его уже не будет в сессии. И данный механизм не дает работать с другими заказами
            //пока не будет завершена оплата с основным.
            app.checkinService.orderInfo().then(function (resp) {
                orderInfo = resp;
                if (orderInfo.paymentInProgress) {
                    console.log('have payment in progress, go to #checkIn screen');
                    if (orderInfo.paymentInProgress.redirectResultFromIPS) {
                        window.location = './?result=' + orderInfo.paymentInProgress.redirectResultFromIPS +  '#checkIn';
                    } else {
                        window.location.hash = '#checkIn';
                    }
                } else {
                    app.checkinService.clearSession();
                }
            });
        });

        return conditionsRactive;

    }

    module.exports = ConditionsScreen;

}());

},{"../templates/screens/conditions/conditions.html":81}],44:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Conditions
* @purpose Conditions screen
*/

var template = require('../templates/screens/privacyPolicy/privacyPolicy.html');

(function () {

    'use strict';

    function PrivacyPolicyScreen() {

        var privacyPolicyRactive = new Ractive({
            code: 'privacyPolicy',
            template: template,
            partials: {
                privacyPolicyText: app.siteAliases('oxygen-check-in.privacyPolicy.text')
            }
        });

        return privacyPolicyRactive;

    }

    module.exports = PrivacyPolicyScreen;

}());

},{"../templates/screens/privacyPolicy/privacyPolicy.html":82}],45:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Search
* @purpose Search screen
*/

var utils = require('../libs/utils.js'),
    template = require('../templates/screens/search/search.html'),
    searchResultTemplate = require('../templates/screens/search/searchResult.html'),
    passengerItemTemplate = require('../templates/screens/search/passengerItem.html'),
    SelectSegmentsTypeModal = require('../modals/selectSegmentsType.js'),
    SelectSegmentsModal = require('../modals/selectSegments.js'),
    SelectSegmentsTruncatedModal = require('../modals/selectSegmentsTruncated.js'),
    SelectSegmentGroupsModal = require('../modals/selectSegmentGroups.js'),
    Validation = require('../libs/validation.js'),
    Modal = require('../libs/modal.js');

(function () {

    'use strict';

    function SearchScreen() {

        var orderInfo,
            searchFormsValidation = [],
            updateSearchFormsValidation = function () {
                _.each($('form.search-form'), function (searchForm) {
                    searchFormsValidation.push(new Validation({
                        form: searchForm,
                        rules: {
                            lastName: {
                                required: true,
                                testByRegExp: app.siteParams("oxygen-check-in.search.lastNameRegexp"),
                                formatMess: 'oxygen-check-in.messages.invalidLastName'
                            },
                            ticketNumber: {
                                required: true,
                                testByRegExp: app.siteParams("check-in.search.ticketNumberRegexp"),
                                formatMess: 'oxygen-check-in.messages.invalidNumber'
                            }
                        }
                    }));
                });

            },
            searchRactive = new Ractive({
                code: 'search',
                template: template,
                partials: {
                    searchResult: searchResultTemplate,
                    passengerItem: passengerItemTemplate,
                    agreeLabelHtml: app.siteAliases('oxygen-check-in.termsAndConditions.searchAgreeLabelHtml'),
                    searchFooterHtml: app.siteAliases('oxygen-check-in.searchFormFooter'),
                    searchHeaderHtml: app.siteAliases('oxygen-check-in.searchFormHeader')
                }
            }),
            hasSelectedPassengers = function () {
                var hasSelected = false;
                _.each($('#searchResult div.order-item'), function (orderItem) {
                    _.each($('input[name="selected-passenger"]', orderItem), function (passChb) {
                        if ($(passChb).is(':checked')) {
                            hasSelected = true;
                        }
                    });
                });
                return hasSelected;
            },
            checkGotoCheckin = function () {
                if (hasSelectedPassengers() && (orderInfo.passengersType === 'CHECKED' || utils.hasOpenedSegments(orderInfo.segments))) {
                    $('#gotoCheckinButton').removeClass('disabled');
                } else {
                    $('#gotoCheckinButton').addClass('disabled');
                }
            },
            checkToggleAllPassengersCheckbox = function () {
                $('#searchResult div.other-passengers').each(function (i, cont) {
                    var hasEnabled = false;
                    $('input[name="selected-passenger"]', cont).each(function (j, chb) {
                        if (!$(chb).is(':disabled')) {
                            hasEnabled = true;
                        }
                    });
                    if (!hasEnabled) {
                        $('div.select-all-cont', cont).hide();
                    }
                });
            },
            checkExternalSearchParams = function () {
                var lastName = utils.getParamFromLocation('lastName'),
                    ticketNumber = utils.getParamFromLocation('ticketNumber');
                if (
                    (
                        !orderInfo.passengers ||
                        !orderInfo.passengers.lenght
                    ) &&
                    lastName &&
                    ticketNumber
                ) {
                    utils.fillinSearchForm(lastName, ticketNumber);
                    checkFormReady();
                }
            },
            updateOrderInfo = function (cb) {
                app.checkinService.orderInfo().then(function (resp) {
                    //См. аналогичный комментарий в conditions.js. Данный механизм сделан на случай если человек закроет вкладку не дождавшись завершения оплаты. Ведь если он просто переищет заказ,
                    //то не сможет узнать статус оплаты, т.к. его уже не будет в сессии. И данный механизм не дает работать с другими заказами
                    //пока не будет завершена оплата с основным.
                    orderInfo = resp;
                    if (orderInfo.paymentInProgress) {
                        console.log('have payment in progress, go to #checkIn screen');
                        if (orderInfo.paymentInProgress.redirectResultFromIPS) {
                            window.location = './?result=' + orderInfo.paymentInProgress.redirectResultFromIPS +  '#checkIn';
                        } else {
                            window.location.hash = '#checkIn';
                        }

                        return;
                    }
                    //Конец блока

                    searchRactive.set('orderInfo', orderInfo);
                    if (orderInfo.passengers && orderInfo.passengers.length) {
                        searchRactive.set('agree', true);
                    }
                    updateSearchFormsValidation();

                    $('#addNewOrderPassengerCont').show();
                    $('#newSearchForm').hide();
                    $('#searchForm_new_lastName').val('');
                    $('#searchForm_new_ticketNumber').val('');

                    checkGotoCheckin();
                    checkToggleAllPassengersCheckbox();

                    if (cb) {
                        cb();
                    }

                }, function (resp) {
                    console.log('orderInfo error: ', resp);
                });
            },
            selectSegmentsTypeModal,
            selectSegmentsModal,
            selectSegmentGroupsModal,
            selectSegmentsTruncatedModal,
            addToOrder = function (searchParams) {

                if ($("body").hasClass("loading")) return;

                app.checkinService.addToOrder(searchParams).then(function (resp) {

                    utils.clearDocumentsAndFFP();

                    searchRactive.set('captchaRequired', false);

                    if (resp.result === 'OK') {

                        updateOrderInfo();

                    } else if (resp.result === 'CAPTCHA_REQUIRED') {

                        searchRactive.set('captchaRequired', true);

                    } else if (resp.result === 'SELECT_SEGMENTS_TYPE') {

                        selectSegmentsTypeModal = new SelectSegmentsTypeModal(resp.selectSegmentsTypeCase, function (selectedSegmentsType) {
                            searchParams.segmentsType = selectedSegmentsType;
                            addToOrder(searchParams);
                        });

                    } else if (resp.result === 'SELECT_SEGMENTS') {

                        selectSegmentsModal = new SelectSegmentsModal(resp.selectSegmentsCase, function (selectedSegments) {
                            searchParams.selectedSegments = selectedSegments;
                            addToOrder(searchParams);
                        });

                    } else if (resp.result === 'SEGMENTS_TRUNCATED') {

                        selectSegmentsTruncatedModal = new SelectSegmentsTruncatedModal(resp.segmentsTruncatedCase, function () {
                            searchParams.agreedWithSegmentsTruncation = true;
                            addToOrder(searchParams);
                        });

                    } else if (resp.result === 'SELECT_SEGMENTS_GROUP') {
                        
                        selectSegmentGroupsModal = new SelectSegmentGroupsModal(resp.selectSegmentsGroupCase, function (segmentsGroupIndex) {
                            searchParams.segmentsGroupIndex = segmentsGroupIndex;
                            addToOrder(searchParams);
                        });

                    }

                }, function (resp) {
                    console.log('addToOrder error: ', resp);
                    // Если до ответа с ошибкой требовался ввод капчи, то капчу нужно обновить.
                    if (searchRactive.get('captchaRequired')) {
                        searchRactive.set('captchaRequired', false);
                        searchRactive.set('captchaRequired', true);
                    }
                });
            },
            getSelectedPassengersJSON = function () {
                return JSON.stringify({
                    passengers: orderInfo.passengers.map(function (passenger, passengerIndex) {
                        return $('#selected-passenger-' + passengerIndex).is(':checked');
                    })
                });
            },
            checkAgree = function () {
                return (
                    !app.siteParams('oxygen-check-in.showSearchAgreeCheckbox') ||
                    searchRactive.get('agree')
                );
            },
            checkFormReady = function () {
                var params = utils.getFormParams($('#searchForm'));
                searchRactive.set('formReady', (
                    searchFormsValidation[0].getValidStatus(true) &&
                    params &&
                    params.lastName &&
                    params.ticketNumber
                ));
            };



        searchRactive.on('complete insert', function () {
            updateSearchFormsValidation();
            updateOrderInfo(checkExternalSearchParams);
            searchRactive.set('agree', false);
        });

        searchRactive.on('search-order', function (event) {

            var searchForm = $(event.original.target),
                searchFormNum = $('form.search-form').index(searchForm),
                searchParams = utils.getFormParams(searchForm);

            if (searchFormNum !== 0 && orderInfo) {
                searchParams.mode = 'add_to_existing_order';
            }

            if (searchFormsValidation[searchFormNum].getValidStatus() && checkAgree()) {
                addToOrder(searchParams);
            }

            return false;

        });

        searchRactive.on('toggle-all-passengers', function (event) {
            var chb = $(event.original.target),
                cont = chb.parents('div.order-passengers-list');

            _.each($('input[name="selected-passenger"]', cont), function (passChb) {
                if (!$(passChb).parents('div.select-all-cont').length) {
                    if (chb.is(':checked') !== $(passChb).is(':checked') && !$(passChb).is(':disabled')) {
                        $(passChb).trigger('click');
                    }
                }
            });

        });

        searchRactive.on('unlock-search-order', function () {
            orderInfo.passengers = [];
            orderInfo.segments = [];
            searchRactive.set('orderInfo', orderInfo);
            checkFormReady();
        });

        searchRactive.on('add-new-search-order', function () {
            $('#addNewOrderPassengerCont').hide();
            $('#newSearchForm').show();
        });

        searchRactive.on('passengers-change', function (event) {
            var chb = $(event.original.target),
                num = chb.attr('data-passenger-index');
            app.checkinService.changePassengerSelection(num, chb.is(':checked')).then(checkGotoCheckin);
        });

        searchRactive.on('passengers-click', function () {
            if (orderInfo.completelyInitialized) {
                Modal({
                    data: {
                        cssClass: "ajaxer-error-modal"
                    },
                    partials: {
                        modalHeader: app.siteAliases('oxygen-check-in.messages.error'),
                        modalContent: '<div class="modal-content">' + app.siteAliases('oxygen-check-in.messages.cantDeselectPaxFromCompletelyInitializedOrder') + '</div>'
                    }
                });
            }
        });

        searchRactive.on('search-form-field-change', function (event) {
            var inp = $(event.original.target),
                text = inp.val().toUpperCase();
            inp.val(text.split(' ').join(''));
            checkFormReady();
        });

        searchRactive.on('new-search-form-field-change', function (event) {
            var inp = $(event.original.target),
                text = inp.val().toUpperCase();
            inp.val(text.split(' ').join(''));
        });

        searchRactive.on('goto-checkin', function (event) {
            if (!$(event.original.target).hasClass('disabled')) {
                if (orderInfo.completelyInitialized) {
                    location.hash = '#checkin';
                } else {
                    app.checkinService.confirmPassengersSelection({
                        selected: getSelectedPassengersJSON()
                    }).then(function () {
                        location.hash = '#checkin';
                    });
                }
            }
        });

        return searchRactive;

    }

    module.exports = SearchScreen;

}());

},{"../libs/modal.js":18,"../libs/utils.js":20,"../libs/validation.js":21,"../modals/selectSegmentGroups.js":34,"../modals/selectSegments.js":35,"../modals/selectSegmentsTruncated.js":36,"../modals/selectSegmentsType.js":37,"../templates/screens/search/passengerItem.html":83,"../templates/screens/search/search.html":84,"../templates/screens/search/searchResult.html":85}],46:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Application site aliases module
* @purpose Interface to SWC site aliases
*/

var utils = require('./libs/utils.js');

(function () {

    'use strict';

    var aliasesIndex = {},
        aliasesList = [];

    function getSiteAlias(code) {
        var value = aliasesIndex[code];
        if (value === undefined || o2context.advancedAliasesMode) {
            value = code;
        }
        return value;
    }

    function SiteAliases(resp) {
        aliasesList = resp.aliases || [];
        aliasesIndex = utils.createIndex(aliasesList);
        return getSiteAlias;
    }

    module.exports = SiteAliases;

}());

},{"./libs/utils.js":20}],47:[function(require,module,exports){
/**
* @author Valentin Agafonov <agafonov@sirena2000.ru>
* @name Application site parameters module
* @purpose Interface to SWC site parameters
*/

var utils = require('./libs/utils.js');

(function () {

    'use strict';

    var parametersIndex = {},
        parametersList = [];

    function getSiteParam(code) {
        var value = parametersIndex[code],
            numValue = parseInt(value, 10);
        if (value === "true") {
            value = true;
        } else if (value === "false") {
            value = false;
        } else if (numValue === 0 || (numValue && typeof numValue === 'number')) {
            value = numValue;
        }
        return value;
    }

    function SiteParams(resp) {
        parametersList = resp.parameters || [];
        parametersIndex = utils.createIndex(parametersList);
        return getSiteParam;
    }

    module.exports = SiteParams;

}());

},{"./libs/utils.js":20}],48:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"aeroexpress-table-wrap"},"f":[{"t":4,"f":[{"t":7,"e":"table","a":{"class":"aeroexpress-table"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"infoRow"},"f":[{"t":7,"e":"td","a":{"colspan":"3"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.comment\")"}}]}]}]}]}],"n":50,"r":"isFreeForAllDates"},{"t":4,"n":51,"f":[{"t":7,"e":"table","a":{"class":"aeroexpress-table"},"f":[{"t":4,"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"infoRow"},"f":[{"t":7,"e":"td","a":{"colspan":"3"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.comment\")"}}]}]}],"n":50,"r":"item.free"},{"t":4,"n":51,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"customCheckbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","checked":[{"t":2,"rx":{"r":"aeroexpressItems","m":[{"t":30,"n":"itemNum"},"selected"]}}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-is-extra-passenger":[{"t":2,"x":{"r":["isOrderPassenger"],"s":"!_0"}}],"data-item":[{"t":2,"r":"itemNum"}]},"v":{"change":"switch-aeroexpress-item"}}," ",{"t":7,"e":"span"}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":"link","data-date":[{"t":2,"rx":{"r":"aeroexpressItems","m":[{"t":30,"n":"itemNum"},"selectedDate"]}}],"data-departure":[{"t":2,"r":"departure"}],"data-departure-code":[{"t":2,"r":"departure_code"}],"data-arrival":[{"t":2,"r":"arrival"}],"data-arrival-code":[{"t":2,"r":"arrival_code"}]},"v":{"click":"open-aeroexpress-schedule-modal"},"f":[{"t":2,"r":"departure"}," – ",{"t":2,"r":"arrival"}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"r":"dates.0"}]}],"n":50,"x":{"r":["dates.length"],"s":"_0==1"}}," ",{"t":4,"f":[{"t":7,"e":"select","a":{"name":"aeroexpressDate","value":[{"t":2,"rx":{"r":"aeroexpressItems","m":[{"t":30,"n":"itemNum"},"selectedDate"]}}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-is-extra-passenger":[{"t":2,"x":{"r":["isOrderPassenger"],"s":"!_0"}}],"data-item":[{"t":2,"r":"itemNum"}]},"v":{"change":"aeroexpress-date-change"},"f":[{"t":4,"f":[{"t":7,"e":"option","f":[{"t":2,"rx":{"r":"dates","m":[{"t":30,"n":"dateNum"}]}}]}],"n":52,"i":"dateNum","r":"dates"}]}],"n":50,"x":{"r":["dates.length"],"s":"_0>1"}}]}]}],"r":"item.free"}]}],"n":52,"i":"itemNum","r":"aeroexpressItems"}]}],"r":"isFreeForAllDates"}]}]}
},{}],49:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"common-warning"},"f":[{"t":7,"e":"div","a":{"class":"common-warning__inner"},"f":[{"t":7,"e":"a","a":{"href":0,"class":"common-warning__close"},"v":{"click":"close"}}," ",{"t":7,"e":"h2","a":{"class":"common-warning__header"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.cookieWarning.header\")"}}]}," ",{"t":7,"e":"div","a":{"class":"common-warning__body"},"f":[{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.cookieWarning.text\")"}}]}," ",{"t":7,"e":"div","a":{"class":"common-warning__footer"},"f":[{"t":7,"e":"a","a":{"href":"./#privacyPolicy","target":"_blank","class":"link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.cookieWarning.privacyPolicyLink\")"}}]}]}]}]}],"n":50,"r":"active"}]}
},{}],50:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":4,"f":[{"t":7,"e":"h2","a":{"class":"title"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.header\")"}}]}," ",{"t":7,"e":"div","a":{"class":"list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item dropWrapper availableExtraServiceItem ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-code":[{"t":2,"r":"code"}]},"f":[{"t":7,"e":"div","a":{"class":"item__i mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":7,"e":"div","a":{"class":"iconBox"},"v":{"click":"switch-service-aeroexpress"},"f":[{"t":7,"e":"i","a":{"class":"icon_aeroexpress"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.desc\")"}}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}],"n":50,"x":{"r":["active"],"s":"!_0"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-aeroexpress"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.select\")"}}],"r":"active"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"aeroexpress mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"aeroexpress__i"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i__name"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}," (",{"t":2,"r":"dateOfBirth"},")"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"passengersInfo"},"f":[{"t":7,"e":"br"}," ",{"t":7,"e":"form","a":{"class":"passengerForm__js","name":["passengerDocForms[",{"t":2,"r":"passengerNum"},"]"],"novalidate":0},"f":[{"t":7,"e":"table","a":{"class":"passengerInfo"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"select","a":{"name":"documentType","value":[{"t":2,"rx":{"r":"sirenaOrder.passengers","m":[{"t":30,"n":"passengerNum"},"aeroexpressDocumentType"]}}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"rx":{"r":"documents","m":[{"t":30,"n":"docNum"},"code"]}}]},"f":[{"t":2,"rx":{"r":"documents","m":[{"t":30,"n":"docNum"},"name"]}}]}],"n":52,"i":"docNum","r":"documents"}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","name":"documentNumber","value":[{"t":2,"rx":{"r":"sirenaOrder.passengers","m":[{"t":30,"n":"passengerNum"},"aeroexpressDocumentNumber"]}}],"required":0,"class":"textInp","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.documentNumber\")"}}]}}]}]}," ",{"t":7,"e":"td","f":[]}]}]}]}]}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"aeroexpressList"}],"x":{"r":["itemsByPassengers","sirenaOrder.passengers","passengerNum","passengersFreeForAllDates"],"s":"{aeroexpressItems:_0[_2],passenger:_1[_2],passengerNum:_2,isOrderPassenger:true,isFreeForAllDates:_3[_2]}"}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i__name"},"f":[{"t":7,"e":"strong","f":[{"t":4,"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}," ",{"t":4,"f":["(",{"t":2,"r":"dateOfBirth"},")"],"n":50,"r":"dateOfBirth"}],"n":50,"x":{"r":["lastName","firstName"],"s":"_0&&_1"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.newPassenger\")"}}],"x":{"r":["lastName","firstName"],"s":"_0&&_1"}}]}," ",{"t":7,"e":"a","a":{"href":0,"data-passenger":[{"t":2,"r":"passengerNum"}],"class":"remove-ae-passenger"},"v":{"click":"remove-extra-passenger"},"f":[{"t":7,"e":"i","a":{"class":"icon_remove","data-passenger":[{"t":2,"r":"passengerNum"}]}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"passengersInfo"},"f":[{"t":7,"e":"br"}," ",{"t":7,"e":"form","a":{"class":"passengerForm__js","name":["extraPassengerDocForms[",{"t":2,"r":"passengerNum"},"]"],"novalidate":0},"f":[{"t":7,"e":"table","a":{"class":"passengerInfo"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","name":"lastName","value":[{"t":2,"rx":{"r":"extraPassengers","m":[{"t":30,"n":"passengerNum"},"lastName"]}}],"required":0,"class":"textInp","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.lastName\")"}}]}}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","name":"firstName","value":[{"t":2,"rx":{"r":"extraPassengers","m":[{"t":30,"n":"passengerNum"},"firstName"]}}],"required":0,"class":"textInp","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.firstName\")"}}]}}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","name":"dateOfBirth","value":[{"t":2,"rx":{"r":"extraPassengers","m":[{"t":30,"n":"passengerNum"},"dateOfBirth"]}}],"required":0,"class":"textInp","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.dateOfBirth\")"}}]}}]}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"select","a":{"name":"documentType","value":[{"t":2,"rx":{"r":"extraPassengers","m":[{"t":30,"n":"passengerNum"},"aeroexpressDocumentType"]}}]},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"value":[{"t":2,"rx":{"r":"documents","m":[{"t":30,"n":"docNum"},"code"]}}]},"f":[{"t":2,"rx":{"r":"documents","m":[{"t":30,"n":"docNum"},"name"]}}]}],"n":52,"i":"docNum","r":"documents"}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","name":"documentNumber","value":[{"t":2,"rx":{"r":"extraPassengers","m":[{"t":30,"n":"passengerNum"},"aeroexpressDocumentNumber"]}}],"required":0,"class":"textInp","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.documentNumber\")"}}]}}]}]}," ",{"t":7,"e":"td","f":[]}]}]}]}]}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"aeroexpressList"}],"x":{"r":["aeItemsByExtraPassengers","extraPassengers","isExtraPassengerFreeForAllDates","passengerNum"],"s":"{aeroexpressItems:_0[_3],passenger:_1[_3],passengerNum:_3,isFreeForAllDates:_2(_3)}"}}],"n":52,"i":"passengerNum","r":"extraPassengers"}," ",{"t":7,"e":"a","a":{"href":0,"class":"link"},"v":{"click":"add-extra-passenger"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.addPassenger\")"}}]}]}]}]}]}],"n":50,"r":"active"}]}," ",{"t":7,"e":"div","a":{"class":"item__i mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"switch-service-aeroexpress"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"i","a":{"class":"icon_aeroexpress"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"a","a":{"href":0},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-aeroexpress"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.aeroexpress.select\")"}}],"r":"active"}]}]}]}]}]}]}],"n":50,"x":{"r":["code"],"s":"_0==\"aeroexpress\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item dropWrapper availableExtraServiceItem ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-code":[{"t":2,"r":"code"}]},"f":[{"t":7,"e":"div","a":{"class":"item__i mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":7,"e":"div","a":{"class":"iconBox"},"v":{"click":"switch-service-insurance"},"f":[{"t":7,"e":"i","a":{"class":"icon_umbrella"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.desc\")"}}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","fullPrice.price","fullPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".fullPriceUnit\")"}}]}]}]}],"n":50,"x":{"r":["active"],"s":"!_0"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-insurance"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.select\")"}}],"r":"active"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"insurance mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"insurance__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i__name"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}," (",{"t":2,"r":"dateOfBirth"},")"]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"passengersInfo"},"f":[{"t":7,"e":"table","a":{"class":"insurance-fares"},"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"insurance-type-cell"},"f":[{"t":7,"e":"span","a":{"class":"customCheckbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","id":["insChb_",{"t":2,"r":"passengerNum"},"_",{"t":2,"r":"insuranceItemNum"}],"checked":[{"t":2,"rx":{"r":"itemsByPassengers","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"insuranceItemNum"},"selected"]}}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-item":[{"t":2,"r":"insuranceItemNum"}]},"v":{"change":"switch-insurance-item"}}," ",{"t":7,"e":"span"}]}]}," ",{"t":7,"e":"label","a":{"for":["insChb_",{"t":2,"r":"passengerNum"},"_",{"t":2,"r":"insuranceItemNum"}]},"f":[{"t":3,"x":{"r":["alias","ins","tins","productCode"],"s":"_0(\"oxygen-check-in.insuranceOnline.\"+_1+\".\"+_2+\".\"+_3)"}}]}]}," ",{"t":7,"e":"td","a":{"class":"insurance-rules-cell"},"f":[{"t":3,"x":{"r":["alias","ins","tins","productCode"],"s":"_0(\"oxygen-check-in.insuranceOnline.currentRules.\"+_1+\".\"+_2+\".\"+_3)"}}]}," ",{"t":7,"e":"td","a":{"class":"price-cell"},"f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":52,"i":"insuranceItemNum","rx":{"r":"itemsByPassengers","m":[{"t":30,"n":"passengerNum"}]}}]}]}],"n":50,"rx":{"r":"itemsByPassengers","m":[{"t":30,"n":"passengerNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}],"n":50,"r":"itemsByPassengers"},{"t":4,"n":51,"f":[{"t":7,"e":"table","a":{"class":"insurance-fares"},"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"insurance-type-cell"},"f":[{"t":7,"e":"span","a":{"class":"customCheckbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","id":["insChb_",{"t":2,"r":"insuranceItemNum"}],"checked":[{"t":2,"rx":{"r":"items","m":[{"t":30,"n":"insuranceItemNum"},"selected"]}}],"data-item":[{"t":2,"r":"insuranceItemNum"}]},"v":{"change":"switch-insurance-item"}}," ",{"t":7,"e":"span"}]}]}," ",{"t":7,"e":"label","a":{"for":["insChb_",{"t":2,"r":"insuranceItemNum"}]},"f":[{"t":3,"x":{"r":["alias","ins","tins"],"s":"_0(\"oxygen-check-in.insurance.\"+_1+\".\"+_2)"}}]}]}," ",{"t":7,"e":"td","a":{"class":"insurance-rules-cell"},"f":[{"t":3,"x":{"r":["alias","ins","tins"],"s":"_0(\"oxygen-check-in.insurance.currentRules.\"+_1+\".\"+_2)"}}]}," ",{"t":7,"e":"td","a":{"class":"price-cell"},"f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":52,"i":"insuranceItemNum","r":"items"}]}],"r":"itemsByPassengers"}]}]}]}]}],"n":50,"x":{"r":["active","items.length"],"s":"_0&&_1>1"}}]}," ",{"t":7,"e":"div","a":{"class":"item__i mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"switch-service-insurance"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"i","a":{"class":"icon_umbrella"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"a","a":{"href":0},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","fullPrice.price","fullPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".fullPriceUnit\")"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-insurance"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.insurance.select\")"}}],"r":"active"}]}]}]}]}]}]}],"n":50,"x":{"r":["code"],"s":"_0==\"insurance\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item dropWrapper availableExtraServiceItem ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-code":[{"t":2,"r":"code"}]},"f":[{"t":7,"e":"div","a":{"class":"item__i mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":7,"e":"div","a":{"class":"iconBox"},"v":{"click":"switch-service-meal"},"f":[{"t":7,"e":"i","a":{"class":"icon_meal"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.desc\")"}}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}],"n":50,"x":{"r":["active"],"s":"!_0"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-meal"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.select\")"}}],"r":"active"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect__i clearfix"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"routeOpen_js"},"f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"}]}]}," ",{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["passenger ",{"t":4,"f":["active"],"n":50,"x":{"r":["activeMealSegment","segmentNum","activeMealPassenger","passengerNum"],"s":"_0==_1&&_2==_3"}}],"data-segment":[{"t":2,"r":"segmentNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger_lnk"},"v":{"click":"select-meal-segment-passenger"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":4,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":2,"x":{"r":["alias","segmentNum","passengerNum","selectedMealByPassengerSegments"],"s":"_0(_3[_2][_1].title)"}}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":0,"class":"remove remove-meal"},"v":{"click":"remove-service-by-flight-passenger"}}]}],"n":50,"rx":{"r":"selectedMealByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}},{"t":4,"n":51,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.selectItem\")"}}]}]}],"rx":{"r":"selectedMealByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}]}]}]}],"n":50,"rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}]}],"n":50,"rx":{"r":"availableBySegments","m":[{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}," ",{"t":7,"e":"div","a":{"class":"col mobileHide"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"food "},"f":[{"t":7,"e":"div","a":{"class":"food__i"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"foodSorting"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":[{"t":4,"f":["active"],"n":50,"x":{"r":["activeMealSubgroup"],"s":"_0==-1"}}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","data-subgroup":"-1"},"v":{"click":"set-meal-subgroup"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.subgroup.all\")"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":[{"t":4,"f":["active"],"n":50,"x":{"r":["activeMealSubgroup","subgroupNum"],"s":"_0==_1"}}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","data-subgroup":[{"t":2,"r":"subgroupNum"}]},"v":{"click":"set-meal-subgroup"},"f":[{"t":2,"x":{"r":["alias","subgroupNum","subgroups"],"s":"_0(\"oxygen-check-in.extraServices.meal.subgroup.\"+_2[_1])"}}]}]}],"n":52,"i":"subgroupNum","r":"subgroups"}]}]}],"n":50,"x":{"r":["subgroups","subgroups.length"],"s":"_0&&_1>1"}}," ",{"t":7,"e":"div","a":{"class":"list"},"f":[{"t":7,"e":"div","a":{"class":"list__i isotopeGrid"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item ",{"t":4,"f":["active"],"n":50,"rx":{"r":"mealMenu","m":[{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"},"active"]}}],"data-subgroup":[{"t":2,"r":"subgroupNum"}],"data-item":[{"t":2,"r":"itemNum"}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"set-passenger-segment-meal"},"f":[{"t":7,"e":"div","a":{"class":"img"},"f":[{"t":7,"e":"img","a":{"src":[{"t":2,"r":"externalStorageBaseUrl"},"/",{"t":2,"r":"serviceType"},"-",{"t":2,"r":"rfisc"},".jpg"],"alt":""}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["alias","title"],"s":"_0(_1)"}}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":50,"x":{"r":["itemNum","subgroupNum","mealMenu"],"s":"!_2[_1][_0].active"}}]}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["alias","description"],"s":"_0(_1)"}}]}]}]}]}],"n":52,"i":"itemNum","rx":{"r":"mealMenu","m":[{"t":30,"n":"subgroupNum"}]}}],"n":50,"x":{"r":["subgroupNum","activeMealSubgroup"],"s":"_0==_1||_1==-1"}}],"n":52,"i":"subgroupNum","r":"mealMenu"}]}]}]}]}],"n":50,"r":"mealMenu"}]}]}]}]}]}],"n":50,"r":"active"}]}," ",{"t":7,"e":"div","a":{"class":"item__i mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"switch-service-meal"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"i","a":{"class":"icon_meal"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"a","a":{"href":0},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-meal"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.select\")"}}],"r":"active"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect__i clearfix"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"routeOpen_js"},"f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"}]}]}," ",{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["passenger ",{"t":4,"f":["active"],"n":50,"x":{"r":["activeMealSegment","segmentNum","activeMealPassenger","passengerNum"],"s":"_0==_1&&_2==_3"}}],"data-segment":[{"t":2,"r":"segmentNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger_lnk popup_js"},"v":{"click":"select-meal-segment-passenger-mobile"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":4,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":2,"x":{"r":["alias","segmentNum","passengerNum","selectedMealByPassengerSegments"],"s":"_0(_3[_2][_1].title)"}}]}]}],"n":50,"rx":{"r":"selectedMealByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}},{"t":4,"n":51,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.meal.selectItem\")"}}]}]}],"rx":{"r":"selectedMealByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}]}]}]}],"n":50,"rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}]}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}]}]}]}],"n":50,"r":"active"}]}]}],"n":50,"x":{"r":["code"],"s":"_0==\"meal\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item dropWrapper availableExtraServiceItem ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-code":[{"t":2,"r":"code"}]},"f":[{"t":7,"e":"div","a":{"class":"item__i mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":7,"e":"div","a":{"class":"iconBox"},"v":{"click":"switch-service-baggage"},"f":[{"t":7,"e":"i","a":{"class":"icon_luggage"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.desc\")"}}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.minPriceUnit\")"}}]}]}]}],"n":50,"x":{"r":["active"],"s":"!_0"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-baggage"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.select\")"}}],"r":"active"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"baggage mobileHide"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"baggage__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger active"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger__link"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i__name"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}," (",{"t":2,"r":"dateOfBirth"},")"]}]}]}]}]}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td"}," ",{"t":7,"e":"td"}," ",{"t":7,"e":"td","f":[{"t":7,"e":"span","a":{"class":"baggageInfo"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.paidLuggageLabel\")"}}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"}]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"},","]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}]}],"n":50,"x":{"r":["id","segmentNum","sirenaOrder.segments"],"s":"_0!=_2[_1].id"}}],"n":52,"x":{"r":["getAffectedFlights","itemNum","subgroupNum","segmentNum","passengerNum","itemsByPassengerSegments"],"s":"_0(_5[_4][_3][_2][_1].affectedSegmentIds)"}}],"n":50,"rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"},"affectedSegmentIds","length"]}}],"n":52,"i":"itemNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"}]}}],"n":52,"i":"subgroupNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}," ",{"t":7,"e":"td"}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"baggage-picker-cont"},"f":[{"t":7,"e":"span","a":{"class":"baggage-picker-label"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias","title"],"s":"_0(_1)"}}," ",{"t":7,"e":"span","f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"baggageControl","data-limit":[{"t":2,"r":"limit"}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-segment":[{"t":2,"r":"segmentNum"}],"data-subgroup":[{"t":2,"r":"subgroupNum"}],"data-subgroup-code":[{"t":2,"rx":{"r":"subgroups","m":[{"t":30,"n":"subgroupNum"},"code"]}}],"data-item":[{"t":2,"r":"itemNum"}],"data-count":[{"t":2,"rx":{"r":"baggageCountByPassengerSegmentsBySubgoupItems","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"}]}}]},"f":[{"t":7,"e":"div","a":{"class":"baggageControl__i"},"f":[{"t":7,"e":"a","v":{"click":"decrease-baggage-count"},"a":{"href":"#checkin","class":["minus ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["itemNum","subgroupNum","segmentNum","passengerNum","baggageCountByPassengerSegmentsBySubgoupItems"],"s":"!_4[_3][_2][_1][_0]"}}]},"f":["-"]}," ",{"t":7,"e":"div","a":{"class":"val val_noBagagge"},"f":[{"t":7,"e":"p","f":[{"t":2,"rx":{"r":"baggageCountByPassengerSegmentsBySubgoupItems","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"}]}}]}]}," ",{"t":7,"e":"a","v":{"click":"increase-baggage-count"},"a":{"href":"#checkin","class":["plus ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["limit","itemNum","subgroupNum","segmentNum","passengerNum","baggageCountByPassengerSegmentsBySubgoupItems"],"s":"_0<=_5[_4][_3][_2][_1]"}}]},"f":["+"]}]}]}]}],"n":52,"i":"itemNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"}]}}],"n":52,"i":"subgroupNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}]}],"n":50,"r":"active"}]}," ",{"t":7,"e":"div","a":{"class":"item__i mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"switch-service-baggage"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"i","a":{"class":"icon_luggage"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"a","a":{"href":0},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.minPrice\")"}}]}," ",{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","minPrice.price","minPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.minPriceUnit\")"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service-baggage"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.select\")"}}],"r":"active"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"baggage"},"f":[{"t":7,"e":"div","a":{"class":"baggage__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger active"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger__link"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i"},"f":[{"t":7,"e":"div","a":{"class":"passenger__link__i__name"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}," (",{"t":2,"r":"dateOfBirth"},")"]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"list__items"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"},","]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"},","]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}]}],"n":50,"x":{"r":["id","segmentNum","sirenaOrder.segments"],"s":"_0!=_2[_1].id"}}],"n":52,"x":{"r":["getAffectedFlights","itemNum","subgroupNum","segmentNum","passengerNum","itemsByPassengerSegments"],"s":"_0(_5[_4][_3][_2][_1].affectedSegmentIds)"}}],"n":50,"rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"},"affectedSegmentIds","length"]}}],"n":52,"i":"itemNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"}]}}],"n":52,"i":"subgroupNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}," ",{"t":7,"e":"div","a":{"class":"baggageInfo"},"f":[{"t":7,"e":"div","a":{"class":"baggageInfo__luggage"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.extraServices.baggage.paidLuggageLabel\")"}},":"]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"baggage-picker-cont"},"f":[{"t":7,"e":"span","a":{"class":"baggage-picker-label"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias","title"],"s":"_0(_1)"}}," ",{"t":7,"e":"span","f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"baggageControl","data-limit":[{"t":2,"r":"limit"}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-segment":[{"t":2,"r":"segmentNum"}],"data-subgroup":[{"t":2,"r":"subgroupNum"}],"data-subgroup-code":[{"t":2,"rx":{"r":"subgroups","m":[{"t":30,"n":"subgroupNum"},"code"]}}],"data-item":[{"t":2,"r":"itemNum"}],"data-count":[{"t":2,"rx":{"r":"baggageCountByPassengerSegmentsBySubgoupItems","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"}]}}]},"f":[{"t":7,"e":"div","a":{"class":"baggageControl__i"},"f":[{"t":7,"e":"a","v":{"click":"decrease-baggage-count"},"a":{"href":"#checkin","class":["minus ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["itemNum","subgroupNum","segmentNum","passengerNum","baggageCountByPassengerSegmentsBySubgoupItems"],"s":"!_4[_3][_2][_1][_0]"}}]},"f":["-"]}," ",{"t":7,"e":"div","a":{"class":"val val_noBagagge"},"f":[{"t":7,"e":"p","f":[{"t":2,"rx":{"r":"baggageCountByPassengerSegmentsBySubgoupItems","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"}]}}]}]}," ",{"t":7,"e":"a","v":{"click":"increase-baggage-count"},"a":{"href":"#checkin","class":["plus ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["limit","itemNum","subgroupNum","segmentNum","passengerNum","baggageCountByPassengerSegmentsBySubgoupItems"],"s":"_0<=_5[_4][_3][_2][_1]"}}]},"f":["+"]}]}]}]}],"n":52,"i":"itemNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"},{"t":30,"n":"subgroupNum"}]}}],"n":52,"i":"subgroupNum","rx":{"r":"itemsByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}]}]}],"n":50,"r":"active"}]}]}],"n":50,"x":{"r":["code"],"s":"_0==\"baggage\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item dropWrapper availableExtraServiceItem ",{"t":4,"f":["active"],"n":50,"r":"active"}],"data-code":[{"t":2,"r":"code"}]},"f":[{"t":7,"e":"div","a":{"class":"item__i mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"text"},"f":[{"t":7,"e":"div","a":{"class":"iconBox"},"v":{"click":"switch-service"},"f":[{"t":7,"e":"i","a":{"class":["icon_",{"t":2,"r":"iconCode"}]}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".desc\")"}}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","fullPrice.price","fullPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".fullPriceUnit\")"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".select\")"}}],"r":"active"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect__i clearfix"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"routeOpen_js"},"f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":["passenger ",{"t":4,"f":["active"],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}," passengerSegmentItem"],"data-flight":[{"t":2,"r":"segmentNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger_lnk"},"v":{"click":"switch-service-by-flight-passenger"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","segmentNum","passengerNum","pricesByPassengerSegments","fullPrice.currency"],"s":"_0.formatPrice(_3[_2][_1],_4)"}}]}],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".deselectItem\")"}}],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".selectItem\")"}}],"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}]}]}]}]}]}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}],"n":50,"rx":{"r":"availableBySegments","m":[{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}]}]}]}]}],"n":50,"r":"active"}]}," ",{"t":7,"e":"div","a":{"class":"item__i mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"top"},"f":[{"t":7,"e":"div","a":{"class":"top__i"},"f":[{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"switch-service"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"i","a":{"class":["icon_",{"t":2,"r":"iconCode"}]}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".header\")"}}," ",{"t":7,"e":"a","a":{"href":"#checkin"},"v":{"click":"open-conditions-modal"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"a","a":{"href":0},"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":7,"e":"div","a":{"class":"price__i"},"f":[{"t":4,"f":[{"t":7,"e":"h3","f":[{"t":3,"x":{"r":["utils","fullPrice.price","fullPrice.currency"],"s":"_0.formatPrice(_1,_2)"}}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".fullPriceUnit\")"}}]}],"n":50,"x":{"r":["active"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"h3","f":[" "]},{"t":7,"e":"p","f":[" "]}],"x":{"r":["active"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"a","a":{"href":"#checkin","class":["btn showDrop_js ",{"t":4,"f":["active"],"n":50,"r":"active"}]},"v":{"click":"switch-service"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".deselect\")"}}],"n":50,"r":"active"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".select\")"}}],"r":"active"}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":"drop__i"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect"},"f":[{"t":7,"e":"div","a":{"class":"serviceSelect__i clearfix"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"div","a":{"class":"title"},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"routeOpen_js"},"f":[{"t":2,"r":"originCityName"}," – ",{"t":2,"r":"destinationCityName"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"drop active show_js"},"f":[{"t":7,"e":"div","a":{"class":["passenger ",{"t":4,"f":["active"],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}," passengerSegmentItem"],"data-flight":[{"t":2,"r":"segmentNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"a","a":{"href":"#checkin","class":"passenger_lnk"},"v":{"click":"switch-service-by-flight-passenger"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","segmentNum","passengerNum","pricesByPassengerSegments","fullPrice.currency"],"s":"_0.formatPrice(_3[_2][_1],_4)"}}]}],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"choose"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".deselectItem\")"}}],"n":50,"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.extraServices.\"+_1+\".selectItem\")"}}],"rx":{"r":"pricesByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}]}]}]}]}]}]}]}]}],"n":50,"rx":{"r":"availableByPassengerSegments","m":[{"t":30,"n":"passengerNum"},{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"}]}]}],"n":50,"rx":{"r":"availableBySegments","m":[{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}]}]}]}],"n":50,"r":"active"}]}]}],"n":50,"x":{"r":["utils","code"],"s":"_0.isCommonServiceCode(_1)"}}],"n":52,"r":"availableExtraServices"}]}],"n":50,"r":"availableExtraServices"},{"t":4,"f":[{"t":7,"e":"div","a":{"class":"invoice"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"invoiceServicesSelected"},"f":[{"t":7,"e":"div","a":{"class":"invoiceServicesSelected__i"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"groupedServicesList"}],"x":{"r":["sirenaOrder"],"s":"{sirenaOrder:_0,mode:\"editable\"}"}}],"n":50,"x":{"r":["sirenaOrder.hasSelectedExtraServices","sirenaOrder.editableExtraServicesByPassengers.length"],"s":"_0&&_1"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal__i"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"orderPrices"}],"x":{"r":["sirenaOrder.pricesIssued"],"s":"{prices:_0,mode:\"pricesIssued\"}"}}],"n":50,"r":"sirenaOrder.pricesIssued"}," ",{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"orderPrices"}],"x":{"r":["sirenaOrder.pricesNotIssued"],"s":"{prices:_0,mode:\"pricesNotIssued\"}"}}],"n":50,"r":"sirenaOrder.pricesNotIssued"}]}]}]}]}]}],"n":50,"x":{"r":["sirenaOrder.hasSelectedExtraServices","sirenaOrder.pricesIssued"],"s":"_0||!!_1"}}]}
},{}],51:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"h2","a":{"class":"title"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.selected\")"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger-segment-services"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":4,"f":[{"t":4,"f":[{"t":3,"x":{"r":["alias","serviceItem.ins","serviceItem.tins","serviceItem.productCode"],"s":"_0(\"oxygen-check-in.insuranceOnline.\"+_1+\".\"+_2+\".\"+_3)"}}],"n":50,"r":"serviceItem.productCode"},{"t":4,"n":51,"f":[{"t":3,"x":{"r":["alias","serviceItem.ins","serviceItem.tins"],"s":"_0(\"oxygen-check-in.insurance.\"+_1+\".\"+_2)"}}],"r":"serviceItem.productCode"}],"n":50,"x":{"r":["code"],"s":"_0==\"insurance\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.serviceName.\"+_1)"}}],"x":{"r":["code"],"s":"_0==\"insurance\""}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":["service-status service-status-",{"t":2,"r":"serviceItem.status"}]},"f":[{"t":2,"x":{"r":["alias","serviceItem.status"],"s":"_0(\"oxygen-check-in.serviceStatus.\"+_1)"}}]}],"n":50,"r":"serviceItem.status"}]}],"n":52,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByPassengers\""},{"t":30,"n":"passengerNum"},"passengerSegmentServices",{"t":30,"n":"segmentNum"}]}}]}]}],"n":50,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByPassengers\""},{"t":30,"n":"passengerNum"},"passengerSegmentServices",{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}],"n":50,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByPassengers\""},{"t":30,"n":"passengerNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.passengers"},{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"strong","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"firstName"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger-segment-services"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.addServices.flight\")"}}," ",{"t":2,"r":"companyCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":7,"e":"ul","f":[{"t":4,"f":[{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.serviceName.\"+_1)"}}]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":["service-status service-status-",{"t":2,"r":"serviceItem.status"}]},"f":[{"t":2,"x":{"r":["alias","serviceItem.status"],"s":"_0(\"oxygen-check-in.serviceStatus.\"+_1)"}}]}],"n":50,"r":"serviceItem.status"}]}],"n":52,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByExtraPassengers\""},{"t":30,"n":"passengerNum"},"passengerSegmentServices",{"t":30,"n":"segmentNum"}]}}]}]}],"n":50,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByExtraPassengers\""},{"t":30,"n":"passengerNum"},"passengerSegmentServices",{"t":30,"n":"segmentNum"}]}}],"n":52,"i":"segmentNum","r":"sirenaOrder.segments"}]}]}],"n":50,"rx":{"r":"sirenaOrder","m":[{"r":["mode"],"s":"_0+\"ExtraServicesByExtraPassengers\""},{"t":30,"n":"passengerNum"}]}}],"n":52,"i":"passengerNum","r":"sirenaOrder.extraPassengers"}]}
},{}],52:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"h2","a":{"class":"title"},"f":[{"t":2,"x":{"r":["alias","mode"],"s":"_0(\"oxygen-check-in.\"+_1+\".header\")"}}]}," ",{"t":7,"e":"div","a":{"class":"totalTable"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.meal\")"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServiceByGroup.meal","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"prices.totalExtraServiceByGroup.meal"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.seat\")"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServiceByGroup.seat","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"prices.totalExtraServiceByGroup.seat"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.baggage\")"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServiceByGroup.baggage","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"prices.totalExtraServiceByGroup.baggage"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.aeroexpress\")"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServiceByGroup.aeroexpress","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"prices.totalExtraServiceByGroup.aeroexpress"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.insurance\")"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServiceByGroup.insurance","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"prices.totalExtraServiceByGroup.insurance"}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.servicePrices.\"+_1)"}}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","value","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":52,"r":"prices.totalCommonServicesList"}]}]}," ",{"t":7,"e":"div","a":{"class":"bottom"},"f":[{"t":7,"e":"div","a":{"class":"total"},"f":[{"t":7,"e":"table","f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"x":{"r":["alias","mode"],"s":"_0(\"oxygen-check-in.\"+_1+\".total\")"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"span","f":[{"t":3,"x":{"r":["utils","prices.totalExtraServices","prices.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}]}]}]}]}]}]}
},{}],53:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger__inner"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_name"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.name\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_nationality"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.nationality\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["countriesDict","value"],"s":"_0.getCountryNameByCode(_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"nationality\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentType"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentType\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["alias","value"],"s":"_0(\"oxygen-check-in.documentType.\"+_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"type\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentNumber"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentNumber\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"number\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentGender"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentGender\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["alias","value"],"s":"_0(\"oxygen-check-in.gender.\"+_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"gender\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentBirthDate"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentBirthDate\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"birthDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentIssueCountry"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentIssueCountry\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["countriesDict","value"],"s":"_0.getCountryNameByCode(_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_documentExpirationDate"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentExpirationDate\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"expirationDate\""}}],"n":50,"r":"value"}],"n":52,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"document","fields"]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_ticketNumber"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.ticketNumber\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"ticketNumbers"}]}]}],"n":50,"r":"ticketNumbers"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_ffpCardNumber"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.ffpCardNumber\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"ffpCardNumber"]}}]}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"ffpCardNumber"]}}," ",{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_visaNumber"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaNumber\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"number\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["dropPassenger__item dropPassenger__item_visaIssueCountry ",{"t":4,"f":["dropPassenger__item_visaIssueCountry__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueCountry\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["countriesDict","value"],"s":"_0.getCountryNameByCode(_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["dropPassenger__item dropPassenger__item_visaIssueCity ",{"t":4,"f":["dropPassenger__item_visaIssueCity__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueCity\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCity\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_visaIssueDate"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueDate\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_visaExpirationDate"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaExpirationDate\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"expirationDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_visaHostCountry"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaHostCountry\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"x":{"r":["countriesDict","value"],"s":"_0.getCountryNameByCode(_1)"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"hostCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item dropPassenger__item_visaBirthPlace"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__item__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaBirthPlace\")"}},":"]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger__item__content"},"f":[{"t":2,"r":"value"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"birthPlace\""}}],"n":50,"r":"value"}],"n":52,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"visa","fields"]}}],"n":50,"x":{"r":["segNum","segments"],"s":"_1[_0].visa&&_1[_0].visa.required&&!_1[_0].visa.checkboxNotRequired"}}]}]}
},{}],54:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"form","a":{"class":["pass-edit-form pax-cont ",{"t":4,"f":["pax-cont-active"],"n":50,"x":{"r":["passengerNum","activePassengerNum","isChild","activeIsChild"],"s":"_0==_1&&!!_2==_3"}}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-child":[{"t":2,"r":"isChild"}]},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerFormItemInner"}],"rx":{"r":"segments","m":[{"t":30,"n":"activeSegNum"}]}}]}]}
},{}],55:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__fields"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["visaNotRequired_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":"popup__i__inputBox__caption"},"f":[]}," ",{"t":7,"e":"div","a":{"class":"customCheckbox webRegistration__accept__checkbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"visaNotRequired","id":["visaNotRequired_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"checked":[{"t":2,"r":"visa.checkboxNotRequired"}]},"v":{"change":"toggle-visa-required"}}," ",{"t":7,"e":"span"}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaNotRequired\")"}}]}]}]}],"n":50,"r":"visa.allFieldsEmpty"}," ",{"t":7,"e":"div","a":{"class":["visa-fields ",{"t":4,"f":["visa-fields-disabled"],"n":50,"r":"visa.checkboxNotRequired"}]},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaNumber ",{"t":4,"f":["form-group__visaNumber__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaNumber\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-visa ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"visaNumber","id":["visaNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false","value":[{"t":2,"r":"value"}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"number\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaIssueCountry ",{"t":4,"f":["form-group__visaIssueCountry__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaIssueCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueCountry\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select form-control-visa","name":"visaIssueCountry","id":["visaIssueCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false"},"f":[{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["fieldNum","visa.fields","code"],"s":"_1[_0].value===_2"}}],"a":{"value":[{"t":2,"r":"code"}]},"f":[{"t":2,"r":"value"}]}],"n":52,"x":{"r":["countriesDict"],"s":"_0.getCountriesList()"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaIssueCity ",{"t":4,"f":["form-group__visaIssueCity__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaIssueCity_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueCity\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-visa ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"visaIssueCity","id":["visaIssueCity_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false","value":[{"t":2,"r":"value"}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCity\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaIssueDate ",{"t":4,"f":["form-group__visaIssueDate__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaIssueDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaIssueDate\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-visa ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"visaIssueDate","id":["visaIssueDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false","value":[{"t":2,"r":"value"}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaExpirationDate ",{"t":4,"f":["form-group__visaExpirationDate__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaExpirationDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaExpirationDate\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-visa ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"visaExpirationDate","id":["visaExpirationDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false","value":[{"t":2,"r":"value"}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"expirationDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaHostCountry ",{"t":4,"f":["form-group__visaHostCountry__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaHostCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaHostCountry\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select form-control-visa","name":"visaHostCountry","id":["visaHostCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false"},"f":[{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["fieldNum","visa.fields","code"],"s":"_1[_0].value===_2"}}],"a":{"value":[{"t":2,"r":"code"}]},"f":[{"t":2,"r":"value"}]}],"n":52,"x":{"r":["countriesDict"],"s":"_0.getCountriesList()"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"hostCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["popup__i__inputBox__wrapper form-group form-group__visaBirthPlace ",{"t":4,"f":["form-group__visaBirthPlace__required"],"n":50,"r":"required"}]},"f":[{"t":7,"e":"label","a":{"for":["visaBirthPlace_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visaBirthPlace\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-visa ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"visaBirthPlace","id":["visaBirthPlace_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"disabled":[{"t":2,"x":{"r":["visa.checkboxNotRequired","disabled"],"s":"_0||_1"}}],"twoway":"false","value":[{"t":2,"r":"value"}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"birthPlace\""}}],"n":52,"i":"fieldNum","r":"visa.fields"}]}," ",{"t":7,"e":"hr"}],"n":50,"r":"visa.required"},{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentType_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentType\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select","name":"documentType","id":["documentType_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}]},"f":[{"t":7,"e":"option","a":{"value":""},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.documentType.placeholder\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["value","."],"s":"_0==_1"}}],"a":{"value":[{"t":2,"r":"."}]},"f":[{"t":2,"x":{"r":["alias","."],"s":"_0(\"oxygen-check-in.documentType.\"+_1)"}}]}],"n":52,"r":"documentTypes"}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"type\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentNationality_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.nationality\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select","name":"documentNationality","id":["documentNationality_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}]},"f":[{"t":7,"e":"option","a":{"value":""},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.nationality.placeholder\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["fieldNum","document.fields","code"],"s":"_1[_0].value===_2"}}],"a":{"value":[{"t":2,"r":"code"}]},"f":[{"t":2,"r":"value"}]}],"n":52,"x":{"r":["countriesDict"],"s":"_0.getCountriesList()"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"nationality\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentNumber\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input form-control-document ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"documentNumber","id":["documentNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentNumber\")"}}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"number\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentGender_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentGender\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select","name":"documentGender","id":["documentGender_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}]},"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["value"],"s":"_0===\"M\""}}],"a":{"value":"M"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.gender.M\")"}}]}," ",{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["value"],"s":"_0===\"F\""}}],"a":{"value":"F"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.gender.F\")"}}]}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"gender\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentBirthDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentBirthDate\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"documentBirthDate","id":["documentBirthDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentBirthDate\")"}}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"birthDate\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentIssueCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentIssueCountry\")"}}]}," ",{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select","name":"documentIssueCountry","id":["documentIssueCountry_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}]},"f":[{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["fieldNum","document.fields","code"],"s":"_1[_0].value===_2"}}],"a":{"value":[{"t":2,"r":"code"}]},"f":[{"t":2,"r":"value"}]}],"n":52,"x":{"r":["countriesDict"],"s":"_0.getCountriesList()"}}]}]}],"n":50,"x":{"r":["name"],"s":"_0===\"issueCountry\""}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":["documentExpirationDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":["popup__i__inputBox__caption ",{"t":4,"f":["required"],"n":50,"r":"required"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentExpirationDate\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":["popup__i__inputBox__input ",{"t":4,"f":["required"],"n":50,"r":"required"}],"name":"documentExpirationDate","id":["documentExpirationDate_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","disabled":[{"t":2,"r":"disabled"}],"value":[{"t":2,"r":"value"}],"placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.documentExpirationDate\")"}}]}}]}],"n":50,"x":{"r":["name"],"s":"_0===\"expirationDate\""}}],"n":52,"i":"fieldNum","r":"document.fields"}," ",{"t":7,"e":"hr"}],"n":50,"x":{"r":["document.isAllFieldsDisabled","param"],"s":"!_0||!_1(\"oxygen-check-in.hideDisabledDocument\")"}},{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group popup__i__webReg__wrapper_loyality"},"f":[{"t":7,"e":"label","a":{"for":["ffpCardNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"class":"popup__i__inputBox__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.ffpCardNumber\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":"popup__i__inputBox__input","name":"ffpCardNumber","id":["ffpCardNumber_",{"t":2,"r":"passengerNum"},{"t":4,"f":["_child"],"n":50,"r":"isChild"}],"twoway":"false","value":[{"t":2,"r":"ffpCardNumber"}],"placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.ffpCardNumber\")"}}]}}]}],"n":50,"x":{"r":["isChild","param"],"s":"!_0&&_1(\"oxygen-check-in.workWithFFP\")"}}]}]}
},{}],56:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"li","a":{"class":["popup__i__webReg__dataPassenger passenger-item ",{"t":4,"f":["passenger-item-active"],"n":50,"x":{"r":["passengerNum","activePassengerNum","isChild","activeIsChild"],"s":"_0==_1&&!!_2==_3"}}],"data-passenger":[{"t":2,"r":"passengerNum"}],"data-child":[{"t":2,"r":"isChild"}]},"v":{"click":"passenger-data-click"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__dataPassenger__name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":["(",{"t":2,"r":"birthDate"},")"],"n":50,"r":"birthDate"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"pass-ffp"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.ffpCard\")"}}]}],"n":50,"x":{"r":["isChild","param"],"s":"!_0&&_1(\"oxygen-check-in.workWithFFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"pass-document"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.document\")"}}]}],"n":50,"x":{"r":["activeSegNum","segments","param"],"s":"!_1[_0].document.isAllFieldsDisabled||!_2(\"oxygen-check-in.hideDisabledDocument\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"pass-visa"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerData.label.visa\")"}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"activeSegNum"},"visa","required"]}}]}]}
},{}],57:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"view-craft-box-inner"},"f":[{"t":7,"e":"div","a":{"class":"seatMap"},"f":[{"t":7,"e":"div","a":{"class":"seatMap__i"},"f":[{"t":7,"e":"div","a":{"class":"planeBody"},"f":[{"t":7,"e":"div","a":{"class":"planeBody__i"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"view-craft-disabled-message"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.disabledChangeSeat\")"}}]}]}],"n":50,"r":"disabledMode"}," ",{"t":4,"f":[{"t":3,"x":{"r":["utils","properties"],"s":"_0.getCustomCabinLabel(_1)"}}," ",{"t":7,"e":"table","a":{"class":[{"t":4,"f":["seats-table-disabled"],"n":50,"r":"disabledMode"}]},"f":[{"t":7,"e":"tr","a":{"class":"colNameRow"},"f":[{"t":4,"f":[{"t":7,"e":"td","f":[{"t":2,"rx":{"r":"tableCols","m":[{"t":30,"n":"y"}]}}]}],"n":52,"i":"y","r":"tableCols"}]}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":4,"f":[{"t":7,"e":"td","m":[{"t":4,"f":["class=\"label-cell\""],"n":50,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"label"]}}],"f":[{"t":4,"f":[{"t":2,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"label"]}}],"n":50,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"label"]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"seats-splitter"}}],"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].type==\"PARTITION\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].type==\"CANTEEN\""},"f":[{"t":7,"e":"div","a":{"class":"icon-canteen"}}]},{"t":4,"n":50,"x":{"r":["x","y","tableRows"],"s":"(!(_2[_1][_0].type==\"CANTEEN\"))&&(_2[_1][_0].type==\"WC\")"},"f":[" ",{"t":7,"e":"div","a":{"class":"wc"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.wc\")"}}]}]},{"t":4,"n":50,"x":{"r":["x","y","tableRows"],"s":"(!(_2[_1][_0].type==\"CANTEEN\"))&&((!(_2[_1][_0].type==\"WC\"))&&((_2[_1][_0].type==\"RIGHT_EXIT\"||_2[_1][_0].type==\"LEFT_EXIT\")))"},"f":[" ",{"t":7,"e":"div","a":{"class":"door"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.exit\")"}}]}]},{"t":4,"n":50,"x":{"r":["x","y","tableRows"],"s":"(!(_2[_1][_0].type==\"CANTEEN\"))&&((!(_2[_1][_0].type==\"WC\"))&&(!((_2[_1][_0].type==\"RIGHT_EXIT\"||_2[_1][_0].type==\"LEFT_EXIT\"))))"},"f":[" ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["seat tooltip-cont ",{"t":4,"f":["seat--autoAssigned"],"n":50,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"autoAssigned"]}}," ",{"t":4,"f":["emergency_exit"],"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].type==\"SEAT_NEAR_EMERGENCY_EXIT\""}}," ",{"t":4,"f":["paid-seat"],"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].rate&&_2[_1][_0].rate.value"}}," seat-",{"t":2,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].available?\"vacant\":\"engaged\""}}],"data-show-warning":[{"t":2,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].showWarningPassengerCanLoseFreeSeat||false"}}],"data-seat":[{"t":2,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"seatNumber"]}}]},"v":{"click":"seat-click"},"f":[{"t":7,"e":"div","a":{"class":"tooltip tooltip-top"},"f":[{"t":7,"e":"div","a":{"class":"tooltip-inner"},"f":[{"t":4,"f":[{"t":2,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"seatNumber"]}}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"rate"},"f":[{"t":2,"x":{"r":[],"s":"\" - \""}}," ",{"t":3,"x":{"r":["utils","x","y","tableRows"],"s":"_0.formatPrice(_3[_2][_1].rate.value,_3[_2][_1].rate.currencyCode)"}}]}],"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].rate&&_2[_1][_0].rate.value"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"seat-type"},"f":[{"t":3,"x":{"r":["alias","x","y","tableRows"],"s":"_0(\"oxygen-check-in.viewCraft.propertyLabel.\"+_3[_2][_1].type)"}}]}],"n":50,"x":{"r":["utils","x","y","tableRows"],"s":"_3[_2][_1].type&&_0.hasAlias(\"oxygen-check-in.viewCraft.propertyLabel.\"+_3[_2][_1].type)"}}],"n":50,"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"available"]}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].unavailabilityReason"},"f":[{"t":2,"x":{"r":["alias","x","y","tableRows"],"s":"_0(\"oxygen-check-in.viewCraft.unavailabilityReason.\"+_3[_2][_1].unavailabilityReason)"}}]}],"rx":{"r":"tableRows","m":[{"t":30,"n":"y"},{"t":30,"n":"x"},"available"]}}]}]}]}],"n":50,"x":{"r":["x","y","tableRows"],"s":"!_2[_1][_0].isEmptyCell"}}]}],"x":{"r":["x","y","tableRows"],"s":"_2[_1][_0].type==\"PARTITION\""}}]}],"n":52,"i":"x","rx":{"r":"tableRows","m":[{"t":30,"n":"y"}]}}]}],"n":52,"i":"y","r":"tableRows"}]}],"n":52,"r":"cabins"}]}]}]}]}]}]}
},{}],58:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-cont"},"v":{"click":"outside-click"},"f":[{"t":7,"e":"div","a":{"class":["modal ",{"t":2,"x":{"r":["cssClass"],"s":"_0||\"\""}}]},"f":[{"t":7,"e":"div","a":{"class":"modal-header"},"f":[{"t":7,"e":"div","a":{"class":"modal-header-inner"},"f":[{"t":8,"r":"modalHeader"}]},{"t":7,"e":"a","a":{"class":"btn-close"},"v":{"click":"close"},"f":["×"]}]}," ",{"t":8,"r":"modalContent"}]}]}]}
},{}],59:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content popup_aeroexpressSchedule"},"f":[{"t":4,"f":[{"t":7,"e":"table","a":{"class":"aeroexpress-schedule-table"},"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"th","f":[{"t":2,"r":"departure"}]}," ",{"t":7,"e":"th","f":[{"t":2,"r":"arrival"}]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"rx":{"r":"schedule","m":[{"t":30,"n":"itemNum"},"departure"]}}]}," ",{"t":7,"e":"td","f":[{"t":2,"rx":{"r":"schedule","m":[{"t":30,"n":"itemNum"},"arrival"]}}]}]}],"n":52,"i":"itemNum","r":"schedule"}]}],"n":50,"r":"schedule"}]}]}
},{}],60:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"popup_webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__inputBox__text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.cancelCheckinModal.label.selectedPassenger\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__passenger"},"f":[{"t":2,"r":"passenger.lastName"}," ",{"t":2,"r":"passenger.name"}," ",{"t":4,"f":["(",{"t":2,"r":"passenger.birthDate"}],"n":50,"r":"passenger.birthDate"},")"]}," ",{"t":4,"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__passenger"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":2,"r":"passenger.child.lastName"}," ",{"t":2,"r":"passenger.child.name"}," ",{"t":4,"f":["(",{"t":2,"r":"passenger.child.birthDate"},")"],"n":50,"r":"passenger.child.birthDate"}]}],"n":50,"r":"passenger.child"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"confirm-cancel"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.confirmCancel\")"}}]}]}]}]}]}
},{}],61:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration webRegistration__condition_popup"},"f":[{"t":8,"r":"conditionsText"}]}]}]}
},{}],62:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content popup_webRegistration"},"f":[{"t":7,"e":"form","a":{"id":"paidServicesConfirmForm"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.meal\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.meal","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.meal"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.aeroexpress\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.aeroexpress","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.aeroexpress"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.insurance\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.insurance","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.insurance"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.seat\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.seat","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.seat"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.servicePrices.baggage\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.baggage","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":50,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalExtraServiceByGroup.baggage"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias","code"],"s":"_0(\"oxygen-check-in.servicePrices.\"+_1)"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":3,"x":{"r":["utils","value","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":52,"r":"orderInfo.sirenaOrder.pricesNotIssued.totalCommonServicesList"}," ",{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace"},"f":[{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.pricesNotIssued.total\")"}}]}," ",{"t":7,"e":"span","a":{"class":"popup__i__webReg__paidPlace__value"},"f":[{"t":7,"e":"b","f":[{"t":3,"x":{"r":["utils","orderInfo.sirenaOrder.pricesNotIssued.totalExtraServices","orderInfo.sirenaOrder.pricesNotIssued.currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}]}," ",{"t":7,"e":"br"},{"t":7,"e":"br"}],"n":50,"r":"orderInfo.sirenaOrder"}," ",{"t":7,"e":"div","a":{"class":"infoMessage"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.haveToPay\")"}}]}]}]}],"n":50,"r":"hasPaidServices"}," ",{"t":7,"e":"div","a":{"class":"popup__i__webReg__fields popup__i__webReg__paidPlace__fields"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__paidPlace__fields__caption"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.haveToFillinContacts\")"}}],"n":50,"r":"hasPaidServices"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.haveToFillinContactsWithoutPayment\")"}}],"r":"hasPaidServices"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"contacts-owner-select"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["inp contacts-owner-select__radio-option ",{"t":4,"f":["contacts-owner-select__radio-option_not-order-pax"],"n":50,"x":{"r":["num","contactsOwnerVariants"],"s":"_1[_0].id==-1"}}]},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"contactsOwnerNum"}],"value":[{"t":2,"r":"num"}]},"v":{"change":"contacts-owner-select"}}," ",{"t":7,"e":"span"}," ",{"t":2,"rx":{"r":"contactsOwnerVariants","m":[{"t":30,"n":"num"},"label"]}}]}]}]}],"n":52,"i":"num","r":"contactsOwnerVariants"}],"n":50,"x":{"r":["contactsOwnerVariants.length"],"s":"_0<=4"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"select","a":{"class":"popup__i__inputBox__select","value":[{"t":2,"r":"contactsOwnerNum"}]},"v":{"change":"contacts-owner-select","focus":"contacts-owner-focus"},"f":[{"t":4,"f":[{"t":7,"e":"option","a":{"selected":"selected"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.confirmPaidServicesModal.contactsOwnerSelectPlaceholder\")"}}]}],"n":50,"x":{"r":["contactsOwnerSelected"],"s":"!_0"}}," ",{"t":4,"f":[{"t":7,"e":"option","m":[{"t":4,"f":["selected=\"selected\""],"n":50,"x":{"r":["contactsOwnerNum","num"],"s":"_0===_1"}}],"a":{"value":[{"t":2,"r":"num"}]},"f":[{"t":2,"rx":{"r":"contactsOwnerVariants","m":[{"t":30,"n":"num"},"label"]}}]}],"n":52,"i":"num","r":"contactsOwnerVariants"}]}]}],"n":50,"x":{"r":["contactsOwnerVariants.length"],"s":"_0>4"}}]}],"n":50,"r":"contactsOwnerVariants"}," ",{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":"payerPhone","class":"popup__i__inputBox__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.confirmPaidServicesModal.label.phone\")"}}]}," ",{"t":7,"e":"input","a":{"type":"text","class":"popup__i__inputBox__input","name":"payerPhone","id":"payerPhone","disabled":[{"t":2,"x":{"r":["contactsOwnerVariants","contactsOwnerSelected"],"s":"_0&&!_1"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__inputBox__wrapper form-group"},"f":[{"t":7,"e":"label","a":{"for":"payerEmail","class":"popup__i__inputBox__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.confirmPaidServicesModal.label.email\")"}}]}," ",{"t":7,"e":"autocomplete","a":{"code":"payerEmail","type":"email","disabled":[{"t":2,"x":{"r":["contactsOwnerVariants","contactsOwnerSelected"],"s":"_0&&!_1"}}],"cssClass":"popup__i__inputBox__input","suggest":[{"t":2,"r":"utils.completeEmail"}]}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"submit"},"a":{"disabled":[{"t":2,"x":{"r":["contactsOwnerVariants","contactsOwnerSelected"],"s":"_0&&!_1"}}],"class":"btn popup__i__footer__buttons__button"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoPayment\")"}}],"n":50,"r":"hasPaidServices"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.confirmCheckin\")"}}],"r":"hasPaidServices"}]}]}]}]}]}
},{}],63:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"passengerCanLoseFreeSeatWarning"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerCanLoseFreeSeatWarning.text\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"button","v":{"click":"submit"},"a":{"class":"btn popup__i__footer__buttons__button popup__i__footer__buttons__button__ok"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerCanLoseFreeSeatWarning.continue\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"close"},"a":{"class":"btn popup__i__footer__buttons__button popup__i__footer__buttons__button__ok btn-close"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passengerCanLoseFreeSeatWarning.close\")"}}]}]}]}]}]}
},{}],64:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"id":"editPaxCont","class":"popup_webRegistration"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__info"},"f":[{"t":7,"e":"div","a":{"class":"route_item"},"f":[{"t":7,"e":"div","a":{"class":"route__i route_container"},"f":[{"t":7,"e":"div","a":{"class":"route_table"},"f":[{"t":7,"e":"div","a":{"class":"dep"},"f":[{"t":7,"e":"div","a":{"class":"dep__date"},"f":[{"t":2,"r":"departureDate"}]}," ",{"t":7,"e":"div","a":{"class":"dep__time"},"f":[{"t":2,"r":"departureTime"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point"},"f":[{"t":7,"e":"div","a":{"class":"dep__point_city"},"f":[{"t":2,"r":"departureCity"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point_airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info"},"f":[{"t":7,"e":"i","a":{"class":"icon_plane"}}," ",{"t":7,"e":"div","a":{"class":"info__number"},"f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__timeEnRoute"},"f":[{"t":2,"r":"airline"}," ",{"t":2,"r":"aircraft"}]}]}," ",{"t":7,"e":"div","a":{"class":"arr"},"f":[{"t":7,"e":"div","a":{"class":"arr__date"},"f":[{"t":2,"r":"arrivalDate"}]}," ",{"t":7,"e":"div","a":{"class":"arr__time"},"f":[{"t":2,"r":"arrivalTime"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point"},"f":[{"t":7,"e":"div","a":{"class":"arr__point_city"},"f":[{"t":2,"r":"arrivalCity"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point_airport"},"f":[{"t":2,"r":"arrivalAirport"}]}]}]}]}]}]}]}],"rx":{"r":"orderInfo.segments","m":[{"t":30,"n":"activeSegNum"}]}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passengerDataSeat"},"f":[{"t":7,"e":"div","a":{"class":"passengerDataSeat__tabsContainer"},"f":[{"t":7,"e":"ul","a":{"class":"passengerDataSeat__tabs"},"f":[{"t":4,"f":[{"t":7,"e":"li","v":{"click":"switch-to-data"},"a":{"class":["passengerDataSeat__tabs__item passenger-item ",{"t":4,"f":["passenger-item-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"data\""}}]},"f":[{"t":7,"e":"label","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.editPassengerData\")"}}]}]}],"n":50,"x":{"r":["utils","possibleActions"],"s":"_0.hasInList(_1,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"li","v":{"click":"switch-to-child"},"a":{"class":["passengerDataSeat__tabs__item passenger-item ",{"t":4,"f":["passenger-item-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"child\""}}]},"f":[{"t":7,"e":"label","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.editPassengerChildData\")"}}]}]}],"n":50,"x":{"r":["hasChild","utils","activeSegNum","activePassengerNum","orderInfo.passengers"],"s":"_0&&_1.hasInList(_4[_3].child.segments[_2].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"li","v":{"click":"switch-to-seat"},"a":{"class":["passengerDataSeat__tabs__item passenger-item ",{"t":4,"f":["passenger-item-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"seat\""}}]},"f":[{"t":7,"e":"label","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.editPassengerSeat\")"}}]}," ",{"t":7,"e":"span","a":{"class":["passengerDataSeat__tabs__seat ",{"t":4,"f":["passengerDataSeat__tabs__seat_empty"],"n":50,"x":{"r":["seat.number"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":2,"r":"seat.number"}],"n":50,"r":"seat.number"},{"t":4,"n":51,"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}],"r":"seat.number"}]}]}],"n":50,"x":{"r":["utils","possibleActions","activeSegNum","orderInfo.segments"],"s":"_0.hasInList(_1,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}]}," ",{"t":7,"e":"div","a":{"class":"passengerDataSeat__contentContainer"},"f":[{"t":4,"f":[{"t":7,"e":"form","a":{"class":["pass-edit-form pax-cont ",{"t":4,"f":["pax-cont-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"data\""}}]},"f":[{"t":8,"r":"passengerFormInner"}]}],"n":50,"x":{"r":["utils","possibleActions"],"s":"_0.hasInList(_1,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"form","a":{"class":["child-edit-form pax-cont ",{"t":4,"f":["pax-cont-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"child\""}}]},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerFormInner"}],"rx":{"r":"segments","m":[{"t":30,"n":"activeSegNum"}]}}]}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"activePassengerNum"},"child"]}}],"n":50,"x":{"r":["hasChild","utils","activeSegNum","activePassengerNum","orderInfo.passengers"],"s":"_0&&_1.hasInList(_4[_3].child.segments[_2].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":["pax-cont seatSelect ",{"t":4,"f":["pax-cont-active"],"n":50,"x":{"r":["mode"],"s":"_0===\"seat\""}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage infoMessage_error"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.unableSelectPaidSeat\")"}}]}]}]}],"n":50,"r":"showUnableSelectPaidSeatMessage"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number"},"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number-label"},"f":[{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.label.selectedSeatNumber\")"}}," ",{"t":2,"r":"selectedSeatNumber"}]}]}],"n":50,"r":"selectedSeatNumber"}," ",{"t":7,"e":"div","a":{"class":"info info-top"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"view-craft-box"}}," ",{"t":7,"e":"div","a":{"class":"info info-bottom"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}]}]}]}]}]}],"n":50,"x":{"r":["utils","possibleActions","activeSegNum","orderInfo.segments"],"s":"_0.hasInList(_1,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}]}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"activePassengerNum"},"segments",{"t":30,"n":"activeSegNum"}]}}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"passenger-data-submit"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.savePassengersData\")"}}]}]}]}]}]}
},{}],65:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"id":"savePaxCont","class":"popup_webRegistration"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__webReg__info"},"f":[{"t":7,"e":"div","a":{"class":"route_item"},"f":[{"t":7,"e":"div","a":{"class":"route__i route_container"},"f":[{"t":7,"e":"div","a":{"class":"route_table"},"f":[{"t":7,"e":"div","a":{"class":"dep"},"f":[{"t":7,"e":"div","a":{"class":"dep__date"},"f":[{"t":2,"r":"departureDate"}]}," ",{"t":7,"e":"div","a":{"class":"dep__time"},"f":[{"t":2,"r":"departureTime"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point"},"f":[{"t":7,"e":"div","a":{"class":"dep__point_city"},"f":[{"t":2,"r":"departureCity"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point_airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info"},"f":[{"t":7,"e":"i","a":{"class":"icon_plane"}}," ",{"t":7,"e":"div","a":{"class":"info__number"},"f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__timeEnRoute"},"f":[{"t":2,"r":"airline"}," ",{"t":2,"r":"aircraft"}]}]}," ",{"t":7,"e":"div","a":{"class":"arr"},"f":[{"t":7,"e":"div","a":{"class":"arr__date"},"f":[{"t":2,"r":"arrivalDate"}]}," ",{"t":7,"e":"div","a":{"class":"arr__time"},"f":[{"t":2,"r":"arrivalTime"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point"},"f":[{"t":7,"e":"div","a":{"class":"arr__point_city"},"f":[{"t":2,"r":"arrivalCity"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point_airport"},"f":[{"t":2,"r":"arrivalAirport"}]}]}]}]}]}]}]}],"rx":{"r":"orderInfo.segments","m":[{"t":30,"n":"activeSegNum"}]}}," ",{"t":7,"e":"div","a":{"class":"passengerDataPopup__container"},"f":[{"t":7,"e":"div","a":{"class":"passengerDataPopup__list"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"passengerDataPopup__list__item"},"f":[{"t":8,"r":"passengerMenuItem"}]}," ",{"t":7,"e":"div","a":{"class":"passengerDataPopup__list__fields"},"f":[{"t":8,"r":"passengerFormItem"}]}," ",{"t":4,"f":[{"t":7,"e":"ul","a":{"class":"passengerDataPopup__list__item"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerMenuItem"}],"r":"child"}]}," ",{"t":7,"e":"div","a":{"class":"passengerDataPopup__list__fields"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerFormItem"}],"r":"child"}]}],"n":50,"r":"child"}],"n":50,"r":"selected"}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"passenger-data-submit"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.savePassengersData\")"}}]}]}]}]}]}
},{}],66:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content-qr-image-all"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"qr-image-all-cont"},"f":[{"t":7,"e":"label","a":{"class":"qr-image-all-label"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]},"   ",{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"},"  ",{"t":2,"r":"departureDate"},{"t":7,"e":"br"}," ",{"t":7,"e":"b","f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}]},"  ",{"t":2,"r":"birthDate"}]}," ",{"t":7,"e":"img","a":{"src":["./qr/qr.png?segmentIndex=",{"t":2,"r":"segmentIndex"},"&passengerIndex=",{"t":2,"r":"passengerIndex"},"&tabId=",{"t":2,"r":"tabId"}],"class":"qr-image","alt":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.QRcode\")"}}]}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"qr-image-all-cont"},"f":[{"t":7,"e":"label","a":{"class":"qr-image-all-label"},"f":[{"t":7,"e":"b","f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]},"   ",{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"},"  ",{"t":2,"r":"departureDate"},{"t":7,"e":"br"}," ",{"t":7,"e":"b","f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}]},"  ",{"t":2,"r":"child.birthDate"}]}," ",{"t":7,"e":"img","a":{"src":["./qr/qr.png?segmentIndex=",{"t":2,"r":"segmentIndex"},"&passengerIndex=",{"t":2,"r":"passengerIndex"},"&forChild=true&tabId=",{"t":2,"r":"tabId"}],"class":"qr-image","alt":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.QRcode\")"}}]}}]}],"n":50,"r":"child"}],"n":50,"x":{"r":["utils","segmentIndex","passengerIndex","passengers"],"s":"_0.hasInList(_3[_2].segments[_1].possibleActions,\"GET_BOARDING_PASS\")"}}],"n":52,"i":"passengerIndex","r":"passengers"}],"n":52,"i":"segmentIndex","r":"segments"}]}]}
},{}],67:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"qr-image-cont"},"f":[{"t":7,"e":"img","a":{"src":["./qr/qr.png?segmentIndex=",{"t":2,"r":"segmentIndex"},"&passengerIndex=",{"t":2,"r":"passengerIndex"},"&tabId=",{"t":2,"r":"tabId"}],"class":"qr-image","alt":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.QRcode\")"}}]}}]}]}]}
},{}],68:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"removedServicesWarning"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.popupRemovedServicesWarning.text\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"r":"title"}]}," ",{"t":2,"x":{"r":[],"s":"\" / \""}}," ",{"t":7,"e":"strong","f":[{"t":2,"r":"passenger.lastName"}," ",{"t":2,"r":"passenger.firstName"}]}]}]}]}],"n":52,"i":"removedSvcNum","r":"removedSvcs"}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.popupRemovedServicesWarning.apologize\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"removed-services-warning-current-order"},"f":[{"t":7,"e":"div","a":{"class":"removed-services-warning-current-order__title"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.popupRemovedServicesWarning.currentOrder\")"}}]}," ",{"t":7,"e":"div","a":{"class":"removed-services-warning-current-order__content"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"p","a":{"class":"segment-label"},"f":[{"t":2,"r":"originCityName"}," ",{"t":2,"x":{"r":[],"s":"\" – \""}}," ",{"t":2,"r":"destinationCityName"}," (",{"t":2,"r":"companyCode"}," ",{"t":2,"r":"flightNumber"},")"]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"group-label"},"f":[{"t":2,"x":{"r":["alias","groupCode"],"s":"_0(\"oxygen-check-in.serviceName.\"+_1)"}}]}," ",{"t":7,"e":"table","a":{"class":"removed-services-warning-svcs-table"},"f":[{"t":4,"f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":2,"r":"passenger.firstName"}," ",{"t":2,"r":"passenger.lastName"}]}," ",{"t":7,"e":"td","f":[{"t":2,"r":"title"}]}," ",{"t":7,"e":"td","f":[{"t":3,"x":{"r":["utils","totalPrice","currency"],"s":"_0.formatPrice(_1,_2)"}}]}]}],"n":52,"i":"svcNumber","r":"servicesList"}]}],"n":52,"i":"svcsGroupeNumber","rx":{"r":"svcsToIssueBySegments","m":[{"t":30,"n":"segmentNumber"}]}}],"n":50,"rx":{"r":"svcsToIssueBySegments","m":[{"t":30,"n":"segmentNumber"}]}}],"n":52,"i":"segmentNumber","r":"orderInfo.sirenaOrder.segments"}]}]}],"n":50,"r":"svcsToIssueBySegments"}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"button","v":{"click":"submit"},"a":{"class":"btn popup__i__footer__buttons__button popup__i__footer__buttons__button__ok"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.popupRemovedServicesWarning.continue\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"close"},"a":{"class":"btn popup__i__footer__buttons__button popup__i__footer__buttons__button__ok btn-close"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.popupRemovedServicesWarning.close\")"}}]}]}]}]}]}
},{}],69:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content__segments popup_selectFood"},"f":[{"t":7,"e":"div","a":{"class":"foodSlider"},"f":[{"t":7,"e":"div","a":{"class":"foodSlider__i slick-initialized slick-slider"},"f":[{"t":7,"e":"div","a":{"aria-live":"polite","class":"slick-list draggable"},"f":[{"t":7,"e":"div","a":{"class":"slick-track","role":"listbox"},"f":[{"t":7,"e":"div","a":{"class":"item slick-slide slick-current slick-active"},"f":[{"t":7,"e":"div","a":{"class":"itemTitle"},"f":[{"t":7,"e":"div","a":{"class":"itemTitle__i"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"segment.departureCityName"}," – ",{"t":2,"r":"segment.arrivalCityName"}]}," ",{"t":7,"e":"p","f":[{"t":2,"r":"passenger.lastName"}," ",{"t":2,"r":"passenger.firstName"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"list"},"f":[{"t":7,"e":"div","a":{"class":"list__i isotopeGrid"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["item ",{"t":4,"f":["active"],"n":50,"rx":{"r":"mealMenu","m":[{"t":30,"n":"subgroupNum"},{"t":30,"n":"itemNum"},"active"]}}],"data-subgroup":[{"t":2,"r":"subgroupNum"}],"data-item":[{"t":2,"r":"itemNum"}]},"f":[{"t":7,"e":"a","a":{"href":0},"v":{"click":"meal-click"},"f":[{"t":7,"e":"div","a":{"class":"img"},"f":[{"t":7,"e":"img","a":{"src":["./themes/websky/build/img/content/meal/",{"t":2,"r":"serviceType"},"-",{"t":2,"r":"rfisc"},".jpg"],"alt":""}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["alias","title"],"s":"_0(_1)"}}]}," ",{"t":4,"f":[{"t":7,"e":"p","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","price","currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":50,"x":{"r":["itemNum","subgroupNum","mealMenu"],"s":"!_2[_1][_0].active"}}]}," ",{"t":7,"e":"div","a":{"class":"description"},"f":[{"t":7,"e":"p","f":[{"t":3,"x":{"r":["alias","description"],"s":"_0(_1)"}}]}]}]}]}],"n":52,"i":"itemNum","rx":{"r":"mealMenu","m":[{"t":30,"n":"subgroupNum"}]}}],"n":52,"i":"subgroupNum","r":"mealMenu"}]}]}]}]}]}]}]}]}]}
},{}],70:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content__segments"},"f":[{"t":7,"e":"form","a":{"id":"selectSegmentsForm"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__radio"},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":4,"f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"selectedSegments"}],"id":["selected-segments-",{"t":2,"r":"segGroupNum"}],"checked":"checked","value":[{"t":2,"r":"segGroupNum"}]}}," ",{"t":7,"e":"span"}],"n":50,"x":{"r":["segNum"],"s":"!_0"}}]}]}]}," ",{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}]}]}]}]}]}],"n":52,"i":"segNum","rx":{"r":"selectSegmentsGroupCase.segmentGroups","m":[{"t":30,"n":"segGroupNum"}]}}," ",{"t":7,"e":"br"}],"n":52,"i":"segGroupNum","r":"selectSegmentsGroupCase.segmentGroups"}],"n":50,"r":"selectSegmentsGroupCase.segmentGroups"}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"confirm-segments"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoCheckin\")"}}]}]}]}]}]}
},{}],71:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content__segments"},"f":[{"t":7,"e":"form","a":{"class":"","id":"selectSegmentsForm"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchResults webRegistration__searchResults_popup"},"f":[{"t":7,"e":"div","a":{"class":"passengers"},"f":[{"t":7,"e":"table","a":{"class":"passengers__tableTickets"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"lastName"]}}," ",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"name"]}}," ",{"t":4,"f":["(",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"birthDate"]}},")"],"n":50,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"birthDate"]}}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"ticketNumbers"]}}],"n":50,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"ticketNumbers"]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr passengers__tableTickets__tr_child"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","lastName"]}}," ",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","name"]}}," ",{"t":4,"f":["(",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","birthDate"]}},")"],"n":50,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","birthDate"]}}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","ticketNumbers"]}}],"n":50,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child","ticketNumbers"]}}]}]}],"n":50,"rx":{"r":"selectSegmentsCase.passengers","m":[{"t":30,"n":"paxNum"},"child"]}}],"n":52,"i":"paxNum","r":"selectSegmentsCase.passengers"}]}]}]}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__radio"},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"selectedSegments"}],"id":"selected-segments-through","checked":"checked","value":"through"}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"selectSegmentsCase.throughSegmentCitiesText"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.throughStatus\")"}}]}," ",{"t":7,"e":"span","a":{"class":"info__registration__condition success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.flightStatus.OPENED\")"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.webCheckInClose"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"selectSegmentsCase.segmentsForThroughCheckIn.0.stages.boardingClose"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"through-checkin-cont"},"f":[{"t":7,"e":"a","a":{"class":"link show-popover"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.throughInfo\")"}}]}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"span","f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"r":"departureDateTime"}," ",{"t":2,"r":"departureAirport"}]}]}],"n":52,"i":"segNum","r":"selectSegmentsCase.segmentsForThroughCheckIn"}]}]}]}]}]}]}]}]}]}],"n":50,"r":"selectSegmentsCase.segmentsForThroughCheckIn"}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__radio"},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"selectedSegments"}],"id":["selected-segments-",{"t":2,"r":"segNum"}],"checked":"checked","value":[{"t":2,"r":"segNum"}]}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":"info__registration__condition success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.flightStatus.OPENED\")"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}]}]}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsCase.openedSegments"}],"n":50,"r":"selectSegmentsCase.openedSegments"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"selectSegments__label error-text"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.selectSegments.unavailableSegments.label\")"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":"info__registration__condition error-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.flightStatus.CLOSED\")"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["utils","stages.webCheckInOpen"],"s":"_0.checkSegmentWillBeOpened(_1)"}}]}]}]}]}]}]}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsCase.unavailableSegments"}],"n":50,"r":"selectSegmentsCase.unavailableSegments"}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"confirm-segments"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoCheckin\")"}}]}]}]}]}]}
},{}],72:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content__segments"},"f":[{"t":7,"e":"form","a":{"class":"","id":"selectSegmentsTruncatedForm"},"f":[{"t":7,"e":"div","a":{"class":"selectSegments__label selectSegments__label--segmentsLeft"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.selectSegmentsTruncatedCase.segmentsLeft.label\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsTruncated__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsTruncated__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"selectSegmentsTruncated__info__segment__status success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.checked\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsTruncatedCase.segmentsLeft"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"selectSegments__label selectSegments__label--segmentsRemoved"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.selectSegmentsTruncatedCase.segmentsRemoved.label\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsTruncated__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsTruncated__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"selectSegmentsTruncated__info__segment__status error-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.notChecked\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsTruncatedCase.segmentsRemoved"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"confirm"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoCheckin\")"}}]}]}]}]}]}
},{}],73:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content modal-content__segments"},"f":[{"t":7,"e":"form","a":{"class":"","id":"selectSegmentsTypeForm"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchResults webRegistration__searchResults_popup"},"f":[{"t":7,"e":"div","a":{"class":"passengers"},"f":[{"t":7,"e":"table","a":{"class":"passengers__tableTickets"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"lastName"]}}," ",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"name"]}}," ",{"t":4,"f":["(",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"birthDate"]}},")"],"n":50,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"birthDate"]}}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"ticketNumbers"]}}],"n":50,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"ticketNumbers"]}}]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr passengers__tableTickets__tr_child"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","lastName"]}}," ",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","name"]}}," ",{"t":4,"f":["(",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","birthDate"]}},")"],"n":50,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","birthDate"]}}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","ticketNumbers"]}}],"n":50,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child","ticketNumbers"]}}]}]}],"n":50,"rx":{"r":"selectSegmentsTypeCase.passengers","m":[{"t":30,"n":"paxNum"},"child"]}}],"n":52,"i":"paxNum","r":"selectSegmentsTypeCase.passengers"}]}]}]}]}," ",{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"rowspan":[{"t":2,"r":"selectSegmentsTypeCase.segmentsWherePassengerChecked.length"}],"class":"selectableTable__td selectableTable__td__radio"},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"selectedSegmentsType"}],"id":"selected-segments-checked","checked":"checked","value":"checked"}}," ",{"t":7,"e":"span"}]}]}]}],"n":50,"x":{"r":["segNum"],"s":"_0==0"}}," ",{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment__status success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.checked\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsTypeCase.segmentsWherePassengerChecked"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":7,"e":"div","a":{"class":"info selectSegmentsType__info"},"f":[{"t":7,"e":"table","a":{"class":"selectableTable"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"selectableTable__tr"},"f":[{"t":4,"f":[{"t":7,"e":"td","a":{"rowspan":[{"t":2,"r":"selectSegmentsTypeCase.segmentsWherePassengerNotChecked.length"}],"class":"selectableTable__td selectableTable__td__radio"},"f":[{"t":7,"e":"div","a":{"class":"radioBtn"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"radio","name":[{"t":2,"r":"selectedSegmentsType"}],"id":"selected-segments-not-checked","value":"not_checked"}}," ",{"t":7,"e":"span"}]}]}]}],"n":50,"x":{"r":["segNum"],"s":"_0==0"}}," ",{"t":7,"e":"td","a":{"class":"selectableTable__td selectableTable__td__content"},"f":[{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"selectSegmentsType__info__segment__status error-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.notChecked\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":7,"e":"div","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}],"n":52,"i":"segNum","r":"selectSegmentsTypeCase.segmentsWherePassengerNotChecked"}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"confirm-segments-type"},"a":{"class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoCheckin\")"}}]}]}]}]}]}
},{}],74:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":4,"f":[{"t":7,"e":"form","a":{"id":"sendBoardingPassForm","class":"sendBoardingPass"},"v":{"submit":"send-boarding-pass"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__text sendBoardingPass__text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.sendBoardingPassModal.label.leadPassenger\")"}}]}],"n":50,"x":{"r":["withoutPaxSelect"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults webRegistration__searchResults_popup sendBoardingPass__section"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passengers"},"f":[{"t":7,"e":"table","a":{"class":"passengers__tableTickets"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__check"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox passengers__tableTickets__checkbox"},"f":[{"t":7,"e":"label","a":{"class":"passengers__tableTickets__label"},"f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"selected-passenger","id":["selected-passenger-",{"t":2,"r":"mainPassengerIndex"}],"checked":"checked"},"v":{"change":"passengers-change"}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"label","a":{"for":["selected-passenger-",{"t":2,"r":"mainPassengerIndex"}]},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"r":"mainPassenger.lastName"}," ",{"t":2,"r":"mainPassenger.name"}," (",{"t":2,"r":"mainPassenger.birthDate"},")"]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__passengers_child"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","f":[{"t":2,"r":"mainPassenger.child.lastName"}," ",{"t":2,"r":"mainPassenger.child.name"}," ",{"t":4,"f":["(",{"t":2,"r":"mainPassenger.child.birthDate"},")"],"n":50,"r":"mainPassenger.child.birthDate"}]}]}],"n":50,"r":"mainPassenger.child"}]}]}]}]}]}]}],"n":50,"x":{"r":["withoutPaxSelect"],"s":"!_0"}}," ",{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__emails"},"f":[{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__emails__wrapper"},"f":[{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__emails__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.sendBoardingPassModal.label.email\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"form-group sendBoardingPass__section__emails__fields","id":"mailListCell"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__emails__field"},"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"delete-mail"},"a":{"data-num":[{"t":2,"r":"num"}],"class":"sendBoardingPass__section__emails__field_remove error-text"},"f":[{"t":7,"e":"i","a":{"class":"icon_remove"}}]}],"n":50,"x":{"r":["num"],"s":"_0>0"}}," ",{"t":7,"e":"autocomplete","a":{"code":["email_",{"t":2,"r":"num"}],"value":[{"t":2,"rx":{"r":"mailList","m":[{"t":30,"n":"num"}]}}],"type":"email","cssClass":"popup__i__inputBox__input","suggest":[{"t":2,"r":"utils.completeEmail"}]}}]}],"n":52,"i":"num","r":"mailList"}," ",{"t":7,"e":"a","v":{"click":"add-mail"},"a":{"class":"link add-mail"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.sendBoardingPassModal.label.addEmail\")"}}]}]}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__text sendBoardingPass__text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.sendBoardingPassModal.label.otherPassengers\")"}}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__searchResults webRegistration__searchResults_popup sendBoardingPass__section"},"f":[{"t":7,"e":"div","a":{"class":"passengers"},"f":[{"t":7,"e":"table","a":{"class":"passengers__tableTickets"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr form-group"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__check"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox passengers__tableTickets__checkbox"},"f":[{"t":7,"e":"label","a":{"class":"passengers__tableTickets__label"},"f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"selected-passenger","id":["selected-passenger-",{"t":2,"r":"passengerIndex"}]},"v":{"change":"passengers-change"}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"label","a":{"for":["selected-passenger-",{"t":2,"r":"passengerIndex"}]},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":["(",{"t":2,"r":"birthDate"},")"],"n":50,"r":"birthDate"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"sendBoardingPass__section__passengers_child"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}," ",{"t":4,"f":["(",{"t":2,"r":"child.birthDate"},")"],"n":50,"r":"child.birthDate"}]}]}],"n":50,"r":"child"}]}]}]}],"n":52,"r":"otherPassengers"}]}]}]}]}],"n":50,"r":"otherPassengers.length"}],"n":50,"x":{"r":["withoutPaxSelect"],"s":"!_0"}}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer"},"f":[{"t":7,"e":"div","a":{"class":"popup__i__footer__links"},"f":[{"t":7,"e":"a","v":{"click":"close"},"a":{"class":"btn-close popup__i__footer__links__link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancel\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"popup__i__footer__buttons"},"f":[{"t":7,"e":"button","v":{"click":"submit"},"a":{"id":"submitBoardingPassButton","class":"btn popup__i__footer__buttons__button"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.send\")"}}]}]}]}],"n":50,"x":{"r":["showSuccessMessage"],"s":"!_0"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"popup__i__inputBox__text sendBoardingPass__text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.sendBoardingPassModal.successMessage\")"}}]}],"x":{"r":["showSuccessMessage"],"s":"!_0"}}]}]}
},{}],75:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"modal-content"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration webRegistration__serviceСondition_popup"},"f":[{"t":8,"r":"conditionsText"}]}]}]}
},{}],76:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"prev"},"f":[{"t":7,"e":"a","a":{"href":"#search"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"a","a":{"href":"#boardingPass"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i"},"f":[{"t":4,"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration"},"f":[{"t":7,"e":"div","a":{"class":"registration__info"},"f":[{"t":7,"e":"table","a":{"class":"registration__info__table"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__number"},"f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":2,"r":"airline"}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__baggage"},"f":[" ",{"t":7,"e":"span","a":{"class":"registration__info__table__baggage_plane"},"f":[{"t":2,"r":"aircraft"}]}]}]}," ",{"t":7,"e":"td","a":{"colspan":"2"},"f":[{"t":7,"e":"div","a":{"class":"route_item"},"f":[{"t":7,"e":"div","a":{"class":"route__i route_container"},"f":[{"t":7,"e":"div","a":{"class":"route_table"},"f":[{"t":7,"e":"div","a":{"class":"dep"},"f":[{"t":7,"e":"div","a":{"class":"dep__date"},"f":[{"t":2,"r":"departureDate"}]}," ",{"t":7,"e":"div","a":{"class":"dep__time"},"f":[{"t":2,"r":"departureTime"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point"},"f":[{"t":7,"e":"div","a":{"class":"dep__point_city"},"f":[{"t":2,"r":"departureCity"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point_airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info"},"f":[{"t":7,"e":"i","a":{"class":"icon_plane"}}," "]}," ",{"t":7,"e":"div","a":{"class":"arr"},"f":[{"t":7,"e":"div","a":{"class":"arr__date"},"f":[{"t":2,"r":"arrivalDate"}]}," ",{"t":7,"e":"div","a":{"class":"arr__time"},"f":[{"t":2,"r":"arrivalTime"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point"},"f":[{"t":7,"e":"div","a":{"class":"arr__point_city"},"f":[{"t":2,"r":"arrivalCity"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point_airport"},"f":[{"t":2,"r":"arrivalAirport"}]}]}]}]}]}]}]}," ",{"t":7,"e":"td","a":{"rowspan":"2","class":"conditionTd"},"f":[{"t":7,"e":"div","a":{"class":"registration__info__table__reg_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatus\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__reg_condition success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusChecked\")"}}]}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__beginTime_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInOpen\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__beginTime_time"},"f":[{"t":2,"r":"stages.webCheckInOpen"}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__endTime_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInClose\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__endTime_time"},"f":[{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__reg_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.status\")"}}]}," ",{"t":7,"e":"div","a":{"class":["registration__info__table__reg_condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}," ",{"t":7,"e":"div","a":{"class":"status-cont"},"f":[{"t":7,"e":"a","a":{"class":"info__tip show-popover"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"registration__passengers registration__passengers_ready"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger passenger-item","data-segment":[{"t":2,"r":"segNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"div","a":{"class":"accordion-head passenger_lnk accordion-head-closed"},"v":{"click":"passenger-click"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__inner"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__name"},"f":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":["(",{"t":2,"r":"birthDate"},")"],"n":50,"r":"birthDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"passenger_lnk__other"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"mail passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"show-send-modal"},"a":{"class":"mail__link btn-mail"}}]}," ",{"t":7,"e":"div","a":{"class":"print passenger_lnk__other__item"},"f":[{"t":7,"e":"a","a":{"href":["./boarding-pass.pdf?passengerIndex=",{"t":2,"r":"passengerNum"},"&tabId=",{"t":2,"r":"tabId"}],"target":"_blank","class":"print__link btn-print"}}]}," ",{"t":7,"e":"div","a":{"class":"qr passenger_lnk__other__item tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.QRcode\")"}}],"data-placement":"left"},"f":[{"t":7,"e":"a","v":{"click":"show-qr-modal"},"a":{"class":"qr__link btn-qr"}}]}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"GET_BOARDING_PASS\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"qr passenger_lnk__other__item tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.QRcode\")"}}],"data-placement":"left","style":"visibility: hidden;"},"f":[{"t":7,"e":"a","v":{"click":"show-qr-modal"},"a":{"class":"qr__link btn-qr"}}]}],"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"GET_BOARDING_PASS\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"data passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-data-click"},"a":{"class":"data_link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"data passenger_lnk__other__item"},"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive boardingPass__data_link tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifyData\")"}}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"seat passenger_lnk__other__item"},"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"edit-pass-seat-click"},"a":{"class":"data_link"},"f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}],"n":50,"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive boardingPass__seat_link tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifySeat\")"}}]},"f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}],"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"seat passenger_lnk__other__item"},"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"edit-pass-seat-click"},"a":{"class":"data_link"},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}],"n":50,"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifySeat\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}],"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}],"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price passenger_lnk__other__item"},"f":[{"t":3,"x":{"r":["utils","segNum","segments"],"s":"_0.formatPrice(_2[_1].seat.cost,_2[_1].seat.currency)"}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","cost"]}}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}}," ",{"t":7,"e":"div","a":{"class":"baggage_icon tooltip-cont passenger_lnk__other__item","data-title":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"bagNorm","message"]}}],"data-placement":"left"},"f":[{"t":7,"e":"i","a":{"class":"icon_carryon"}}]}," ",{"t":7,"e":"div","a":{"class":"condition passenger_lnk__other__item"},"f":[{"t":7,"e":"i","a":{"class":"icon_check"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.CHECKED\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cancel passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"cancel-checkin-click"},"a":{"class":"cancel__link cancel-btn"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancelCheckin\")"}}]}]}],"n":50,"x":{"r":["utils","possibleActions"],"s":"_0.hasInList(_1,\"WEB_CANCEL\")"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__walletCell"},"f":[{"t":7,"e":"a","a":{"href":["generate-wallet?passengerIndex=",{"t":2,"r":"passengerNum"},"&segmentIndex=",{"t":2,"r":"segNum"},"&tabId=",{"t":2,"r":"tabId"}],"class":"passenger_lnk__walletLink","target":"_blank"},"f":[{"t":7,"e":"img","a":{"src":["files/wallet/",{"t":2,"r":"systemLanguage"},".svg"],"alt":"Apple wallet"}}]}]}],"n":50,"r":"isIOS"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__walletCell"},"f":[{"t":7,"e":"a","a":{"href":["generate-wallet?passengerIndex=",{"t":2,"r":"passengerNum"},"&segmentIndex=",{"t":2,"r":"segNum"},"&tabId=",{"t":2,"r":"tabId"}],"class":"passenger_lnk__walletLink passenger_lnk__walletLink_text","target":"_blank"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-phone"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-phone"}}]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.walletLink\")"}}]}]}],"n":50,"r":"isAndroid"}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"GET_WALLET\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger accordion-body accordion-body-closed"},"f":[{"t":7,"e":"div","a":{"class":"accordion-body-inner"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger"},"f":[{"t":8,"r":"passengerItem"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger dropPassenger__passenger_child"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger__header"},"f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}," (",{"t":2,"r":"child.birthDate"},")"]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"passengerItem"}],"r":"child"}]}],"n":50,"r":"child"}]}]}]}],"n":50,"r":"selected"}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}]}]}],"n":52,"i":"segNum","r":"orderInfo.segments"}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"br"},{"t":7,"e":"br"},{"t":7,"e":"br"}," ",{"t":7,"e":"div","a":{"class":"invoice"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"invoiceServicesSelected"},"f":[{"t":7,"e":"div","a":{"class":"invoiceServicesSelected__i"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"groupedServicesList"}],"x":{"r":["orderInfo.sirenaOrder"],"s":"{sirenaOrder:_0,mode:\"all\"}"}}],"n":50,"x":{"r":["orderInfo.sirenaOrder.allExtraServicesByPassengers","orderInfo.sirenaOrder.allExtraServicesByPassengers.length"],"s":"_0&&_1"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal__i"},"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"orderPrices"}],"x":{"r":["orderInfo.sirenaOrder.pricesIssued"],"s":"{prices:_0,mode:\"pricesIssued\"}"}}],"n":50,"r":"orderInfo.sirenaOrder.pricesIssued"}]}]}]}]}]}," ",{"t":7,"e":"br"},{"t":7,"e":"br"},{"t":7,"e":"br"}],"n":50,"x":{"r":["orderInfo.sirenaOrder","orderInfo.sirenaOrder.pricesIssued"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":7,"e":"span","f":[{"t":4,"n":53,"f":[{"t":8,"r":"assignedAnotherSeatMessage"}],"rx":{"r":"notificationMessages","m":[{"t":30,"n":"num"}]}}]}],"n":50,"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"assignedAnotherSeat\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"checkinComplete\""},"f":[{"t":4,"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinComplete\")"}}]}],"n":50,"r":"orderInfo.hasPassengerSegmentsWithBoardingPass"},{"t":4,"n":51,"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinCompleteWithoutBoardingPass\")"}}]}],"r":"orderInfo.hasPassengerSegmentsWithBoardingPass"}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&(_1[_0].type===\"checkinCancel\")"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinCancel\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&(_1[_0].type===\"checkinCancelForLastPassenger\"))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinCancelForLastPassenger\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&((!(_1[_0].type===\"checkinCancelForLastPassenger\"))&&(_1[_0].type===\"needFullOrderUpdate\")))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.cancellationNeedFullOrderUpdate\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&((!(_1[_0].type===\"checkinCancelForLastPassenger\"))&&((!(_1[_0].type===\"needFullOrderUpdate\"))&&(_1[_0].type===\"dataModified\"))))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.dataModified\")"}}]}]}],"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"assignedAnotherSeat\""}}]}]}]}],"n":52,"i":"num","r":"notificationMessages"}],"n":50,"r":"notificationMessages"}," ",{"t":7,"e":"div","a":{"class":"registration__footer registration__footer_regReady"},"f":[{"t":7,"e":"a","v":{"click":"clear-session"},"a":{"class":"btn btn_back"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSearch\")"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"show-send-modal-all"},"a":{"class":"btn btn_next registration__footer__btn_send"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.sendBoardingPass\")"}}]}," ",{"t":7,"e":"a","v":{"click":"show-all-qrs-modal"},"a":{"class":"btn btn_next registration__footer__btn_show"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showAllQRs\")"}}]}," ",{"t":7,"e":"a","a":{"href":["./boarding-pass.pdf?tabId=",{"t":2,"r":"tabId"}],"target":"_blank","class":"btn btn_next registration__footer__btn_show"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showBoardingPass\")"}}]}],"n":50,"r":"orderInfo.hasPassengerSegmentsWithBoardingPass"},{"t":4,"n":51,"f":[{"t":7,"e":"a","v":{"click":"show-send-modal-all-without-pax-select"},"a":{"class":"btn btn_next registration__footer__btn_send"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.sendCheckinInfo\")"}}]}],"r":"orderInfo.hasPassengerSegmentsWithBoardingPass"}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"a","a":{"href":["./receipt.pdf?tabId=",{"t":2,"r":"tabId"}],"target":"_blank","class":"btn btn_next registration__footer__btn_show"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showReceipt\")"}}]}],"n":50,"x":{"r":["orderInfo.sirenaOrder","orderInfo.sirenaOrder.hasEmds"],"s":"_0&&_1"}}," ",{"t":7,"e":"a","v":{"click":"clear-session"},"a":{"class":"btn btn_next  registration__footer__btn_clear"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.clearSession\")"}}]}]}," "],"p":{"assignedAnotherSeatMessage":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeatPassenger\")"}}," ",{"t":2,"r":"passengerLastName"}," ",{"t":2,"r":"passengerName"}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeat\")"}}," ",{"t":7,"e":"b","f":[{"t":2,"r":"seatNumber"}]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeatFlight\")"}}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}}]}]}]}]}]}
},{}],77:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"prev"},"f":[{"t":7,"e":"a","a":{"href":"#search"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"a","a":{"href":"#boardingPass"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"a","a":{"href":"#boardingPass"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i"},"f":[{"t":4,"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinComplete.label\")"}}]}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["infoMessage infoMessage_type_",{"t":2,"rx":{"r":"notificationMessages","m":[{"t":30,"n":"num"},"type"]}}]},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":4,"f":[{"t":7,"e":"span","f":[{"t":4,"n":53,"f":[{"t":8,"r":"assignedAnotherSeatMessage"}],"rx":{"r":"notificationMessages","m":[{"t":30,"n":"num"}]}}]}],"n":50,"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"assignedAnotherSeat\""}},{"t":4,"n":51,"f":[{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"checkinComplete\""},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinComplete\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&(_1[_0].type===\"checkinCancel\")"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinCancel\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&(_1[_0].type===\"checkinCancelForLastPassenger\"))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.checkinCancelForLastPassenger\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&((!(_1[_0].type===\"checkinCancelForLastPassenger\"))&&(_1[_0].type===\"needFullOrderUpdate\")))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.cancellationNeedFullOrderUpdate\")"}}]}]},{"t":4,"n":50,"x":{"r":["num","notificationMessages"],"s":"(!(_1[_0].type===\"checkinComplete\"))&&((!(_1[_0].type===\"checkinCancel\"))&&((!(_1[_0].type===\"checkinCancelForLastPassenger\"))&&((!(_1[_0].type===\"needFullOrderUpdate\"))&&(_1[_0].type===\"dataModified\"))))"},"f":[" ",{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.dataModified\")"}}]}]}],"x":{"r":["num","notificationMessages"],"s":"_1[_0].type===\"assignedAnotherSeat\""}}]}]}]}],"n":52,"i":"num","r":"notificationMessages"}],"n":50,"r":"notificationMessages"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"quick-buttons mobileShow"},"f":[{"t":7,"e":"div","a":{"class":"round-buttons"},"f":[{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showBoardingPass\")"}}]}," ",{"t":7,"e":"a","a":{"href":"./boarding-pass.pdf","target":"_blank","class":"round-button round-button-boarding-pass"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showReceipt\")"}}]}," ",{"t":7,"e":"a","a":{"href":"./receipt.pdf","target":"_blank","class":"round-button round-button-receipt"}}]}],"n":50,"x":{"r":["orderInfo.sirenaOrder","orderInfo.sirenaOrder.hasEmds"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showAllQRs\")"}}]}," ",{"t":7,"e":"a","v":{"click":"show-all-qrs-modal"},"a":{"target":"_blank","class":"round-button round-button-qr"}}]}]}," ",{"t":7,"e":"a","v":{"click":"show-send-modal-all"},"a":{"class":"send-docs-button"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.sendBoardingPass\")"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration"},"f":[{"t":7,"e":"div","a":{"class":"registration__info"},"f":[{"t":7,"e":"table","a":{"class":"registration__info__table"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__number"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.flight\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":7,"e":"div","a":{"class":"status-cont status-cont-flight-rossiya"},"f":[{"t":7,"e":"a","a":{"class":"info__tip show-popover"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration__info__table__business_lounge"},"f":[{"t":7,"e":"a","a":{"href":"http://www.rossiya-airlines.com/onlineboard/onlineboard/business-lounge/","target":"_blank"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.businessLounge\")"}}]}]}],"n":50,"x":{"r":["departureAirport"],"s":"_0==\"Внуково\"||_0==\"Vnukovo\""}}]}," ",{"t":7,"e":"td","a":{"colspan":"2"},"f":[{"t":7,"e":"div","a":{"class":"route_item"},"f":[{"t":7,"e":"div","a":{"class":"route__i route_container"},"f":[{"t":7,"e":"div","a":{"class":"route_table"},"f":[{"t":7,"e":"div","a":{"class":"dep"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.dep\")"}}]}," ",{"t":7,"e":"div","a":{"class":"dep__date"},"f":[{"t":2,"r":"departureDate"}]}," ",{"t":7,"e":"div","a":{"class":"dep__time"},"f":[{"t":2,"r":"departureTime"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point"},"f":[{"t":7,"e":"div","a":{"class":"dep__point_city"},"f":[{"t":2,"r":"departureCity"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point_airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"arr"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.arr\")"}}]}," ",{"t":7,"e":"div","a":{"class":"arr__date"},"f":[{"t":2,"r":"arrivalDate"}]}," ",{"t":7,"e":"div","a":{"class":"arr__time"},"f":[{"t":2,"r":"arrivalTime"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point"},"f":[{"t":7,"e":"div","a":{"class":"arr__point_city"},"f":[{"t":2,"r":"arrivalCity"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point_airport"},"f":[{"t":2,"r":"arrivalAirport"}]}]}]}]}]}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"registration__passengers registration__passengers_ready"},"f":[{"t":7,"e":"div","a":{"class":"route"},"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger passenger-item","data-segment":[{"t":2,"r":"segNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__inner"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__name"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.pax\")"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"birthDate"},"f":[{"t":2,"r":"birthDate"}]}],"n":50,"r":"birthDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"passenger_lnk__other"},"f":[{"t":7,"e":"div","a":{"class":"mail passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"show-send-modal"},"a":{"class":"mail__link btn-mail"}}]}," ",{"t":7,"e":"div","a":{"class":"print passenger_lnk__other__item"},"f":[{"t":7,"e":"a","a":{"href":["./boarding-pass.pdf?passengerIndex=",{"t":2,"r":"passengerNum"}],"target":"_blank","class":"print__link btn-print"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"data passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-data-click"},"a":{"class":"data_link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"data passenger_lnk__other__item"},"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive boardingPass__data_link tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifyData\")"}}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"x":{"r":["utils","segNum","segments"],"s":"_0.hasInList(_2[_1].possibleActions,\"MODIFY_DOCUMENTS_AND_FFP\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"seat passenger_lnk__other__item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.seat\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"a","v":{"click":"edit-pass-seat-click"},"a":{"class":"data_link"},"f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}],"n":50,"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive boardingPass__seat_link tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifySeat\")"}}]},"f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}],"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"seat passenger_lnk__other__item"},"f":[{"t":4,"f":[{"t":7,"e":"a","v":{"click":"edit-pass-seat-click"},"a":{"class":"data_link"},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}],"n":50,"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}},{"t":4,"n":51,"f":[{"t":7,"e":"a","a":{"class":"data_link data_link_noActive tooltip-cont","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.tooltips.cantModifySeat\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}],"x":{"r":["utils","segments","segNum","orderInfo.segments"],"s":"_0.hasInList(_1[_2].possibleActions,\"CHANGE_SEAT\")&&_3[_2].selectSeatsMode!==\"CANT_SELECT\""}}]}],"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}}," ",{"t":7,"e":"div","a":{"class":"baggage passenger_lnk__other__item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.carryon\")"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.separator\")"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.baggage\")"}}]}," ",{"t":2,"x":{"r":["alias","segNum","segments"],"s":"_0(\"oxygen-check-in.rossiya.label.carryonValueForClass.\"+_2[_1].class)"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.separator\")"}},{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"bagNorm","message"]}}]}," ",{"t":7,"e":"div","a":{"class":"condition passenger_lnk__other__item"},"f":[{"t":7,"e":"i","a":{"class":"icon_check"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.CHECKED\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"cancel passenger_lnk__other__item"},"f":[{"t":7,"e":"a","v":{"click":"cancel-checkin-click"},"a":{"class":"cancel__link cancel-btn"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.cancelCheckin\")"}}]}]}],"n":50,"x":{"r":["utils","possibleActions"],"s":"_0.hasInList(_1,\"WEB_CANCEL\")"}}]}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger passenger-item passenger-item-child"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__inner"},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk__name"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.pax\")"}}]}," ",{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"birthDate"},"f":[{"t":2,"r":"child.birthDate"}]}],"n":50,"r":"child.birthDate"}]}]}," ",{"t":7,"e":"div","a":{"class":"passenger_lnk__other"},"f":[{"t":7,"e":"div","a":{"class":"baggage passenger_lnk__other__item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.childCarryon\")"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.separator\")"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.childBaggage\")"}}]}," ",{"t":2,"x":{"r":["alias","segNum","child.segments"],"s":"_0(\"oxygen-check-in.rossiya.label.childCarryonValueForClass.\"+_2[_1].class)"}},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.separator\")"}},{"t":2,"rx":{"r":"child.segments","m":[{"t":30,"n":"segNum"},"bagNorm","message"]}}]}]}]}]}]}],"n":50,"r":"child"}],"n":50,"r":"selected"}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}]}]}],"n":52,"i":"segNum","r":"orderInfo.segments"}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"invoice"},"f":[{"t":7,"e":"div","a":{"class":"row"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"col left-col"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal"},"f":[{"t":7,"e":"div","a":{"class":"invoiceTotal__i"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"orderPrices"}],"x":{"r":["orderInfo.sirenaOrder.pricesIssued"],"s":"{prices:_0,mode:\"pricesIssued\"}"}}]}]}]}],"n":50,"x":{"r":["orderInfo.sirenaOrder","orderInfo.sirenaOrder.pricesIssued"],"s":"_0&&_1"}}," ",{"t":7,"e":"div","a":{"class":"col right-col mobileHide"},"f":[{"t":7,"e":"div","a":{"class":"round-buttons"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showBoardingPass\")"}}]}," ",{"t":7,"e":"a","a":{"href":"./boarding-pass.pdf","target":"_blank","class":"round-button round-button-boarding-pass"}}]}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showReceipt\")"}}]}," ",{"t":7,"e":"a","a":{"href":"./receipt.pdf","target":"_blank","class":"round-button round-button-receipt"}}]}],"n":50,"x":{"r":["orderInfo.sirenaOrder","orderInfo.sirenaOrder.hasEmds"],"s":"_0&&_1"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"round-button-cont"},"f":[{"t":7,"e":"div","a":{"class":"round-button-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.showAllQRs\")"}}]}," ",{"t":7,"e":"a","v":{"click":"show-all-qrs-modal"},"a":{"target":"_blank","class":"round-button round-button-qr"}}]}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}]}," ",{"t":4,"f":[{"t":7,"e":"a","v":{"click":"show-send-modal-all"},"a":{"class":"send-docs-button"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.sendBoardingPass\")"}}]}]}],"n":50,"x":{"r":["orderInfo.passengers.length","orderInfo.segments.length"],"s":"_0&&_1"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"registration__footer registration__footer_regReady"},"f":[{"t":7,"e":"a","v":{"click":"clear-session"},"a":{"class":"btn btn_back"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSearch\")"}}]}," ",{"t":7,"e":"a","v":{"click":"clear-session"},"a":{"class":"btn btn_next  registration__footer__btn_clear"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.clearSession\")"}}]}]}," "],"p":{"assignedAnotherSeatMessage":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeatPassenger\")"}}," ",{"t":2,"r":"passengerLastName"}," ",{"t":2,"r":"passengerName"}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeat\")"}}," ",{"t":7,"e":"b","f":[{"t":2,"r":"seatNumber"}]}," ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.messages.assignedAnotherSeatFlight\")"}}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}}]}]}]}]}]}
},{}],78:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"prev"},"f":[{"t":7,"e":"a","a":{"href":"#search"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i","id":"checkinForm"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label\")"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["registration__container order-cont order-cont-segment-",{"t":2,"r":"segNum"}," ",{"t":4,"f":["twisted-order-cont"],"n":50,"x":{"r":["segNum","visibleSegments"],"s":"!_1[_0]"}}]},"f":[{"t":7,"e":"div","a":{"class":"registration"},"f":[{"t":7,"e":"div","a":{"class":"registration__info"},"f":[{"t":7,"e":"table","a":{"class":"registration__info__table"},"f":[{"t":7,"e":"tbody","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__number"},"f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}," ",{"t":2,"r":"airline"}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__baggage"},"f":[" ",{"t":7,"e":"span","a":{"class":"registration__info__table__baggage_plane"},"f":[{"t":2,"r":"aircraft"}]}]}]}," ",{"t":7,"e":"td","a":{"colspan":"2"},"f":[{"t":7,"e":"div","a":{"class":"route_item"},"f":[{"t":7,"e":"div","a":{"class":"route__i route_container"},"f":[{"t":7,"e":"div","a":{"class":"route_table"},"f":[{"t":7,"e":"div","a":{"class":"dep"},"f":[{"t":7,"e":"div","a":{"class":"dep__date"},"f":[{"t":2,"r":"departureDate"}]}," ",{"t":7,"e":"div","a":{"class":"dep__time"},"f":[{"t":2,"r":"departureTime"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point"},"f":[{"t":7,"e":"div","a":{"class":"dep__point_city"},"f":[{"t":2,"r":"departureCity"}]}," ",{"t":7,"e":"div","a":{"class":"dep__point_airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info"},"f":[{"t":7,"e":"i","a":{"class":"icon_plane"}}," "]}," ",{"t":7,"e":"div","a":{"class":"arr"},"f":[{"t":7,"e":"div","a":{"class":"arr__date"},"f":[{"t":2,"r":"arrivalDate"}]}," ",{"t":7,"e":"div","a":{"class":"arr__time"},"f":[{"t":2,"r":"arrivalTime"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point"},"f":[{"t":7,"e":"div","a":{"class":"arr__point_city"},"f":[{"t":2,"r":"arrivalCity"}]}," ",{"t":7,"e":"div","a":{"class":"arr__point_airport"},"f":[{"t":2,"r":"arrivalAirport"}]}]}]}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"a","v":{"click":"goto-segment"},"a":{"data-segment":[{"t":2,"r":"segNum"}],"class":["btn btn_search btn-goto-segment ",{"t":4,"f":["disabled"],"n":50,"r":"showPaymentFrame"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSegment\")"}}]}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__beginTime_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInOpen\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__beginTime_time"},"f":[{"t":2,"r":"stages.webCheckInOpen"}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__endTime_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInClose\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__endTime_time"},"f":[{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__reg_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.status\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__reg_condition open"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.flightStatus.OPENED\")"}}," ",{"t":7,"e":"div","a":{"class":"status-cont"},"f":[{"t":7,"e":"a","a":{"class":"info__tip show-popover"},"f":[{"t":7,"e":"i","a":{"class":"icon_info"}}]}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"registration__info__table__reg_caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatus\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration__info__table__reg_condition not_ready"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"warning-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusWaitingPayment\")"}}]}],"n":50,"r":"waitingPayment"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"success-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusReady\")"}}]}],"n":50,"x":{"r":["utils","orderInfo","segNum"],"s":"_0.checkPassengersSegmentReady(_1,_2)"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"error-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusNotReady\")"}}]}],"x":{"r":["utils","orderInfo","segNum"],"s":"_0.checkPassengersSegmentReady(_1,_2)"}}],"r":"waitingPayment"}]}]}]}]}]}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration__passengers passenger-section"},"f":[{"t":7,"e":"div","a":{"class":"box"},"f":[{"t":7,"e":"div","a":{"class":"box__i"},"f":[{"t":7,"e":"div","a":{"class":"seatSelect"},"f":[{"t":7,"e":"div","a":{"class":"seatSelect__i"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"route accordion-cont"},"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger passenger-item ready","data-segment":[{"t":2,"r":"segNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk accordion-head accordion-head-closed"},"v":{"click":"passenger-click"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger__icon_ready tooltip-cont","data-placement":"right","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.NOT_CHECKED\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_check"}}]}],"n":50,"x":{"r":["utils","orderInfo.segments","segNum","passengerNum","orderInfo.passengers"],"s":"_0.checkPassengerSeatSelected(_1,_2,_4[_3])"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"passenger__icon_ready error-text tooltip-cont tooltip-err-cont","data-placement":"right","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.SEAT_NOT_SELECTED\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_info2"}}]}],"x":{"r":["utils","orderInfo.segments","segNum","passengerNum","orderInfo.passengers"],"s":"_0.checkPassengerSeatSelected(_1,_2,_4[_3])"}}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"mobilePaxName","colspan":"5"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"paxName"}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"passengerNum"}]}}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"desktopPaxName"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"paxName"}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"passengerNum"}]}}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"data"},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-click"},"a":{"class":"data_link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.checkPassengerSegmentData(_2[_1])"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"data tooltip-cont tooltip-err-cont tooltip-cont-permanent-hover","data-placement":"top","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.INVALID_DATA\")"}}]},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-click"},"a":{"class":"data_link data_link_error"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"x":{"r":["utils","segNum","segments"],"s":"_0.checkPassengerSegmentData(_2[_1])"}}],"n":50,"x":{"r":["segNum","segments","param"],"s":"_1[_0].visa.required||!_1[_0].document.isAllFieldsDisabled||!_2(\"oxygen-check-in.hideDisabledDocument\")"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"baggage_icon tooltip-cont","data-title":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"bagNorm","message"]}}],"data-placement":"left"},"f":[{"t":7,"e":"i","a":{"class":"icon_carryon"}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","segNum","segments"],"s":"_0.formatPrice(_2[_1].seat.cost,_2[_1].seat.currency)"}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","cost"]}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}},{"t":4,"n":51,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"price"}}]}],"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}}],"n":50,"r":"availableViewCraft"}," "]}]}]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger accordion-body accordion-body-closed"},"f":[{"t":7,"e":"div","a":{"class":"accordion-body-inner"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger"},"f":[{"t":8,"r":"passengerItem"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger dropPassenger__passenger_child"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger__header"},"f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}," (",{"t":2,"r":"child.birthDate"},")"]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"passengerItem"}],"r":"child"}]}],"n":50,"r":"child"}]}]}]}],"n":50,"r":"selected"}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"paidCheckinInfo"}],"r":"orderInfo.paidSeats"}]}," ",{"t":7,"e":"div","a":{"class":["col registration__passengers__seatMap ",{"t":4,"f":["registration__passengers__seatMap_hidden"],"n":50,"x":{"r":["showViewCraft"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number"},"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number-label"},"f":[{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.label.selectedSeatNumber\")"}}," ",{"t":2,"r":"selectedSeatNumber"}]}]}],"n":50,"x":{"r":["selectedSeatNumber","showViewCraft"],"s":"_0&&_1"}}," ",{"t":7,"e":"a","a":{"href":0,"class":"viewCraftSwitcher link"},"v":{"click":"switch-view-craft"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.hide\")"}}],"n":50,"r":"showViewCraft"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.show\")"}}],"r":"showViewCraft"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info info-top"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"seat--autoAssigned"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.autoAssigned\")"}}]}],"n":50,"r":"hasAutoAssignedSeats"}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"emergency_exit"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.emergencyExit\")"}}]}],"n":50,"r":"hasSeatsNearEmergencyExit"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"view-craft-box customScroll_height","data-segment":[{"t":2,"r":"segNum"}]}}," ",{"t":7,"e":"div","a":{"class":"info info-bottom"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"seat--autoAssigned"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.autoAssigned\")"}}]}],"n":50,"r":"hasAutoAssignedSeats"}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"emergency_exit"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.emergencyExit\")"}}]}],"n":50,"r":"hasSeatsNearEmergencyExit"}]}]}]}]}],"n":50,"r":"availableViewCraft"}]}]}]}]}]}]}],"x":{"r":["segNum","orderInfo.segments"],"s":"{availableViewCraft:(_1[_0].selectSeatsMode!==\"CANT_SELECT\")}"}}],"n":50,"x":{"r":["showPaymentFrame"],"s":"!_0"}}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}],"n":52,"i":"segNum","r":"orderInfo.segments"}," ",{"t":7,"e":"div","a":{"id":"extraServicesCont"}}," ",{"t":4,"f":[{"t":7,"e":"iframe","a":{"src":[{"t":2,"r":"paymentFrameUrl"}],"id":"paymentFrame","width":"100%","height":"900","frameBorder":"0"},"v":{"load":"payment-frame-load"}}],"n":50,"r":"showPaymentFrame"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.waitingPayment\")"}}]}," ",{"t":7,"e":"span","a":{"id":"waitingPaymentDots"}}]}]}]}],"n":50,"r":"waitingPayment"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage infoMessage_error"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias","failedPayment"],"s":"_0(\"oxygen-check-in.errorMessage.paymentStatus.\"+_1)"}}]}]}]}]}],"n":50,"r":"failedPayment"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"webRegistration__footer","id":"conditionsAgreeCont"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__accept"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox webRegistration__accept__checkbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"conditions-agree","id":"conditions-agree","checked":[{"t":2,"r":"agree"}]},"v":{"change":"conditions-agree-change"}},{"t":7,"e":"span"}," ",{"t":4,"f":[{"t":8,"r":"agreeLabelHtml"}],"n":50,"r":"hasAgreeLabelHtml"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.termsAndConditions.agreeLabelText\")"}}," ",{"t":7,"e":"a","v":{"click":"open-conditions-modal"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.termsAndConditions.agreeLabelLink\")"}}]}],"r":"hasAgreeLabelHtml"}]}]}]}]}],"n":50,"x":{"r":["param"],"s":"!_0(\"oxygen-check-in.displayConditionsFirst\")&&!_0(\"oxygen-check-in.showSearchAgreeCheckbox\")"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration__footer"},"f":[{"t":7,"e":"a","a":{"id":"checkinConfirmButton","class":"btn btn_next disabled"},"v":{"click":"checkin-confirm"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.checkinConfirm\")"}}]}," ",{"t":7,"e":"a","a":{"href":"#search","class":"btn btn_back"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSearch\")"}}]}]}],"n":50,"x":{"r":["showPaymentFrame"],"s":"!_0"}}]}]}]}]}]}," "],"p":{"paxName":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":["(",{"t":2,"r":"birthDate"},")"],"n":50,"r":"birthDate"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"name--plusInfant"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.plusInfant\")"}}]}],"n":50,"r":"child"}]}}
},{}],79:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"prev"},"f":[{"t":7,"e":"a","a":{"href":"#search"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i","id":"checkinForm"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label\")"}}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["registration__container order-cont order-cont-segment-",{"t":2,"r":"segNum"}," ",{"t":4,"f":["twisted-order-cont"],"n":50,"x":{"r":["segNum","visibleSegments"],"s":"!_1[_0]"}}]},"f":[{"t":7,"e":"div","a":{"class":"registration"},"f":[{"t":7,"e":"div","a":{"class":"registration__info"},"f":[{"t":7,"e":"div","a":{"class":"registration__info__table_redesign"},"f":[{"t":7,"e":"div","a":{"class":"registration-info-cont"},"f":[{"t":7,"e":"div","a":{"class":"registration-info-row"},"f":[{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.flight\")"}}]}," ",{"t":7,"e":"span","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.dep\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"departureCity"}," ",{"t":4,"f":[{"t":2,"x":{"r":[],"s":"\" / \""}},{"t":2,"r":"departureAirport"}],"n":50,"r":"departureAirport"}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"departureDate"}," ",{"t":2,"r":"departureTime"}]}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.rossiya.label.arr\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"arrivalCity"}," ",{"t":4,"f":[{"t":2,"x":{"r":[],"s":"\" / \""}},{"t":2,"r":"arrivalAirport"}],"n":50,"r":"arrivalAirport"}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"arrivalDate"}," ",{"t":2,"r":"arrivalTime"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-row"},"f":[{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInOpen\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"stages.webCheckInOpen"}]}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.webCheckInClose\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item"},"f":[{"t":7,"e":"div","a":{"class":"alt-label"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.status\")"}}]}," ",{"t":7,"e":"div","a":{"class":"registration-info-item-text"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusWaitingPayment\")"}}],"n":50,"r":"waitingPayment"},{"t":4,"n":51,"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusReady\")"}}],"n":50,"x":{"r":["utils","orderInfo","segNum"],"s":"_0.checkPassengersSegmentReady(_1,_2)"}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.passengersStatusNotReady\")"}}],"x":{"r":["utils","orderInfo","segNum"],"s":"_0.checkPassengersSegmentReady(_1,_2)"}}],"r":"waitingPayment"}]}]}]}," ",{"t":7,"e":"a","v":{"click":"goto-segment"},"a":{"data-segment":[{"t":2,"r":"segNum"}],"class":"btn-open-segment"},"f":[{"t":7,"e":"span","v":{"click":"goto-segment"},"a":{"data-segment":[{"t":2,"r":"segNum"}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSegment\")"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"clearfix"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"registration__passengers passenger-section"},"f":[{"t":7,"e":"div","a":{"class":"box"},"f":[{"t":7,"e":"div","a":{"class":"box__i"},"f":[{"t":7,"e":"div","a":{"class":"seatSelect"},"f":[{"t":7,"e":"div","a":{"class":"seatSelect__i"},"f":[{"t":7,"e":"div","a":{"class":"col"},"f":[{"t":7,"e":"div","a":{"class":"route accordion-cont"},"f":[{"t":7,"e":"div","a":{"class":"item"},"f":[{"t":7,"e":"div","a":{"class":"item__i"},"f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger passenger-item ready","data-segment":[{"t":2,"r":"segNum"}],"data-passenger":[{"t":2,"r":"passengerNum"}]},"f":[{"t":7,"e":"div","a":{"class":"passenger_lnk accordion-head accordion-head-closed"},"v":{"click":"passenger-click"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"passenger__icon_ready tooltip-cont","data-placement":"right","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.NOT_CHECKED\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_check"}}]}],"n":50,"x":{"r":["utils","orderInfo.segments","segNum","passengerNum","orderInfo.passengers"],"s":"_0.checkPassengerSeatSelected(_1,_2,_4[_3])"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"passenger__icon_ready error-text tooltip-cont tooltip-err-cont","data-placement":"right","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.SEAT_NOT_SELECTED\")"}}]},"f":[{"t":7,"e":"i","a":{"class":"icon_info2"}}]}],"x":{"r":["utils","orderInfo.segments","segNum","passengerNum","orderInfo.passengers"],"s":"_0.checkPassengerSeatSelected(_1,_2,_4[_3])"}}," ",{"t":7,"e":"table","f":[{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"mobilePaxName","colspan":"5"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"paxName"}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"passengerNum"}]}}]}]}," ",{"t":7,"e":"tr","f":[{"t":7,"e":"td","a":{"class":"desktopPaxName"},"f":[{"t":4,"n":53,"f":[{"t":8,"r":"paxName"}],"rx":{"r":"orderInfo.passengers","m":[{"t":30,"n":"passengerNum"}]}}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"data"},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-click"},"a":{"class":"data_link"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"n":50,"x":{"r":["utils","segNum","segments"],"s":"_0.checkPassengerSegmentData(_2[_1])"}},{"t":4,"n":51,"f":[{"t":7,"e":"div","a":{"class":"data tooltip-cont tooltip-err-cont tooltip-cont-permanent-hover","data-placement":"top","data-title":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.passStatus.INVALID_DATA\")"}}]},"f":[{"t":7,"e":"a","v":{"click":"edit-pass-click"},"a":{"class":"data_link data_link_error"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.changePassengerData\")"}}]}]}],"x":{"r":["utils","segNum","segments"],"s":"_0.checkPassengerSegmentData(_2[_1])"}}],"n":50,"x":{"r":["segNum","segments","param"],"s":"_1[_0].visa.required||!_1[_0].document.isAllFieldsDisabled||!_2(\"oxygen-check-in.hideDisabledDocument\")"}}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"baggage_icon tooltip-cont","data-title":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"bagNorm","message"]}}],"data-placement":"left"},"f":[{"t":7,"e":"i","a":{"class":"icon_carryon"}}]}]}," ",{"t":4,"f":[{"t":4,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":2,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","number"]}}]}]}," ",{"t":7,"e":"td","f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"price"},"f":[{"t":3,"x":{"r":["utils","segNum","segments"],"s":"_0.formatPrice(_2[_1].seat.cost,_2[_1].seat.currency)"}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat","cost"]}}]}],"n":50,"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}},{"t":4,"n":51,"f":[{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"seatNum"},"f":[{"t":7,"e":"i","a":{"class":"icon_seat-reservation"}}]}]}," ",{"t":7,"e":"td","f":[{"t":7,"e":"div","a":{"class":"price"}}]}],"rx":{"r":"segments","m":[{"t":30,"n":"segNum"},"seat"]}}],"n":50,"r":"availableViewCraft"}," "]}]}]}," ",{"t":7,"e":"div","a":{"class":"dropPassenger accordion-body accordion-body-closed"},"f":[{"t":7,"e":"div","a":{"class":"accordion-body-inner"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger"},"f":[{"t":8,"r":"passengerItem"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger dropPassenger__passenger_child"},"f":[{"t":7,"e":"div","a":{"class":"dropPassenger__passenger__header"},"f":[{"t":2,"r":"child.lastName"}," ",{"t":2,"r":"child.name"}," (",{"t":2,"r":"child.birthDate"},")"]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"passengerItem"}],"r":"child"}]}],"n":50,"r":"child"}]}]}]}],"n":50,"r":"selected"}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}," ",{"t":4,"n":53,"f":[{"t":8,"r":"paidCheckinInfo"}],"r":"orderInfo.paidSeats"}]}," ",{"t":7,"e":"div","a":{"class":["col registration__passengers__seatMap ",{"t":4,"f":["registration__passengers__seatMap_hidden"],"n":50,"x":{"r":["showViewCraft"],"s":"!_0"}}]},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number"},"f":[{"t":7,"e":"div","a":{"class":"selected-seat-number-label"},"f":[{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.label.selectedSeatNumber\")"}}," ",{"t":2,"r":"selectedSeatNumber"}]}]}],"n":50,"x":{"r":["selectedSeatNumber","showViewCraft"],"s":"_0&&_1"}}," ",{"t":7,"e":"a","a":{"href":0,"class":"viewCraftSwitcher link"},"v":{"click":"switch-view-craft"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.hide\")"}}],"n":50,"r":"showViewCraft"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.show\")"}}],"r":"showViewCraft"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"info info-top"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"emergency_exit"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.emergencyExit\")"}}]}],"n":50,"r":"hasSeatsNearEmergencyExit"}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"view-craft-box customScroll_height","data-segment":[{"t":2,"r":"segNum"}]}}," ",{"t":7,"e":"div","a":{"class":"info info-bottom"},"f":[{"t":7,"e":"div","a":{"class":"info__i"},"f":[{"t":7,"e":"div","a":{"class":"seatInfo"},"f":[{"t":7,"e":"ul","f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.vacant\")"}}]}," ",{"t":7,"e":"li","a":{"class":"paid"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.paid\")"}}]}," ",{"t":7,"e":"li","a":{"class":"selected"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.selected\")"}}]}," ",{"t":7,"e":"li","a":{"class":"disabled"},"f":[{"t":7,"e":"span"},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.engaged\")"}}]}," ",{"t":4,"f":[{"t":7,"e":"li","a":{"class":"free"},"f":[{"t":7,"e":"span","f":[{"t":7,"e":"div","a":{"class":"emergency_exit"}}]},{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.viewCraft.label.emergencyExit\")"}}]}],"n":50,"r":"hasSeatsNearEmergencyExit"}]}]}]}]}],"n":50,"r":"availableViewCraft"}]}]}]}]}]}]}],"x":{"r":["segNum","orderInfo.segments"],"s":"{availableViewCraft:(_1[_0].selectSeatsMode!==\"CANT_SELECT\")}"}}]}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}],"n":52,"i":"segNum","r":"orderInfo.segments"}," ",{"t":7,"e":"div","a":{"id":"extraServicesCont"}}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.infoMessage.waitingPayment\")"}}]}," ",{"t":7,"e":"span","a":{"id":"waitingPaymentDots"}}]}]}]}],"n":50,"r":"waitingPayment"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage infoMessage_error"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias","failedPayment"],"s":"_0(\"oxygen-check-in.errorMessage.paymentStatus.\"+_1)"}}]}]}]}]}],"n":50,"r":"failedPayment"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"webRegistration__footer","id":"conditionsAgreeCont"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__accept"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox webRegistration__accept__checkbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"conditions-agree","id":"conditions-agree","checked":[{"t":2,"r":"agree"}]},"v":{"change":"conditions-agree-change"}},{"t":7,"e":"span"}," ",{"t":4,"f":[{"t":8,"r":"agreeLabelHtml"}],"n":50,"r":"hasAgreeLabelHtml"},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.termsAndConditions.agreeLabelText\")"}}," ",{"t":7,"e":"a","v":{"click":"open-conditions-modal"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.termsAndConditions.agreeLabelLink\")"}}]}],"r":"hasAgreeLabelHtml"}]}]}]}]}],"n":50,"x":{"r":["param"],"s":"!_0(\"oxygen-check-in.displayConditionsFirst\")&&!_0(\"oxygen-check-in.showSearchAgreeCheckbox\")"}}," ",{"t":7,"e":"div","a":{"class":"registration__footer"},"f":[{"t":7,"e":"a","a":{"id":"checkinConfirmButton","class":"btn btn_next disabled"},"v":{"click":"checkin-confirm"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.checkinConfirm\")"}}]}," ",{"t":7,"e":"a","a":{"href":"#search","class":"btn btn_back"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoSearch\")"}}]}]}]}]}]}]}]}," "],"p":{"paxName":[{"t":7,"e":"div","a":{"class":"name"},"f":[{"t":2,"r":"lastName"}," ",{"t":2,"r":"name"}," ",{"t":4,"f":["(",{"t":2,"r":"birthDate"},")"],"n":50,"r":"birthDate"}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"name--plusInfant"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.plusInfant\")"}}]}],"n":50,"r":"child"}]}}
},{}],80:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"id":"paidCheckinInfo","class":"placeInfo"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"placeInfo__count"},"f":[{"t":7,"e":"span","a":{"class":"placeInfo__count__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.paidCheckinInfo.paid.count\")"}}]}," ",{"t":7,"e":"span","a":{"class":"placeInfo__count__value"},"f":[{"t":2,"r":"paid.count"}]}]}," ",{"t":7,"e":"div","a":{"class":"placeInfo__total"},"f":[{"t":7,"e":"span","a":{"class":"placeInfo__total__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.paidCheckinInfo.paid.totalCost\")"}}]}," ",{"t":4,"f":[{"t":2,"x":{"r":["costNum"],"s":"_0?\" + \":\"\""}}," ",{"t":7,"e":"span","a":{"class":"placeInfo__total__value"},"f":[{"t":3,"x":{"r":["utils","totalCost","currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":52,"i":"costNum","r":"paid.costs"}]}," ",{"t":7,"e":"br"},{"t":7,"e":"br"}],"n":50,"r":"paid.count"}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"placeInfo__count"},"f":[{"t":7,"e":"span","a":{"class":"placeInfo__count__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.paidCheckinInfo.notPaid.count\")"}}]}," ",{"t":7,"e":"span","a":{"class":"placeInfo__count__value"},"f":[{"t":2,"r":"notPaid.count"}]}]}," ",{"t":7,"e":"div","a":{"class":"placeInfo__total"},"f":[{"t":7,"e":"span","a":{"class":"placeInfo__total__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.paidCheckinInfo.notPaid.totalCost\")"}}]}," ",{"t":4,"f":[{"t":2,"x":{"r":["costNum"],"s":"_0?\" + \":\"\""}}," ",{"t":7,"e":"span","a":{"class":"placeInfo__total__value"},"f":[{"t":3,"x":{"r":["utils","totalCost","currency"],"s":"_0.formatPrice(_1,_2)"}}]}],"n":52,"i":"costNum","r":"notPaid.costs"}]}," ",{"t":7,"e":"br"},{"t":7,"e":"br"}],"n":50,"r":"notPaid.count"}]}],"n":50,"x":{"r":["paid.count","notPaid.count"],"s":"_0||_1"}}]}
},{}],81:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"a","a":{"href":"#conditions"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.conditions\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__conditions"},"f":[{"t":8,"r":"conditionsText"}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__footer"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__accept"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox webRegistration__accept__checkbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"conditions-agree","id":"conditions-agree","checked":[{"t":2,"r":"agree"}]}},{"t":7,"e":"span"},{"t":3,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.termsAndConditions.agreeLabel\")"}}]}]}," ",{"t":7,"e":"a","a":{"href":"#search","class":[{"t":4,"f":["disabled"],"n":50,"x":{"r":["agree"],"s":"!_0"}}," btn btn_search webRegistration__accept__button"]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.startSearch\")"}}]}]}]}]}]}]}]}]}]}
},{}],82:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__conditions"},"f":[{"t":8,"r":"privacyPolicyText"}]}]}]}]}]}]}]}
},{}],83:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__check"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox passengers__tableTickets__checkbox"},"f":[{"t":7,"e":"label","a":{"class":"passengers__tableTickets__label"},"v":{"click":"passengers-click"},"f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"selected-passenger","data-passenger-index":[{"t":2,"r":"passenger.index"}],"checked":[{"t":2,"r":"passenger.selected"}],"disabled":[{"t":2,"x":{"r":["passenger.isAvailable","completelyInitialized"],"s":"!_0||_1"}}],"id":["selected-passenger-",{"t":2,"r":"passenger.index"}]},"v":{"change":"passengers-change"}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"label","a":{"for":["selected-passenger-",{"t":2,"r":"passenger.index"}]},"v":{"click":"passengers-click"},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"r":"passenger.lastName"}," ",{"t":2,"r":"passenger.name"}," ",{"t":4,"f":["(",{"t":2,"r":"passenger.birthDate"},")"],"n":50,"r":"passenger.birthDate"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"label","a":{"for":["selected-passenger-",{"t":2,"r":"passenger.index"}]},"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"r":"passenger.ticketNumbers"}]}],"n":50,"r":"passenger.ticketNumbers"}]}]}," ",{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr passengers__tableTickets__tr_child"},"f":[{"t":7,"e":"td","a":{"class":"passengers__tableTickets__check"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox passengers__tableTickets__checkbox","style":"display: none"},"f":[{"t":7,"e":"label","a":{"class":"passengers__tableTickets__label"},"f":[{"t":7,"e":"input","a":{"type":"checkbox"}}," ",{"t":7,"e":"span"}]}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__name"},"f":[{"t":7,"e":"i","a":{"class":"icon_child-discount"}}," ",{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"r":"passenger.child.lastName"}," ",{"t":2,"r":"passenger.child.name"}," ",{"t":4,"f":["(",{"t":2,"r":"passenger.child.birthDate"},")"],"n":50,"r":"passenger.child.birthDate"}]}]}," ",{"t":7,"e":"td","a":{"class":"passengers__tableTickets__tickets"},"f":[{"t":4,"f":[{"t":7,"e":"span","a":{"class":"passengers__tableTickets__strong"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.ticketNumber\")"}}]}," ",{"t":2,"r":"passenger.child.ticketNumbers"}],"n":50,"r":"passenger.child.ticketNumbers"}]}]}],"n":50,"r":"passenger.child"},{"t":4,"f":[{"t":7,"e":"tr","a":{"class":"passengers__tableTickets__tr"},"f":[{"t":7,"e":"td","a":{"class":"status-cell","colspan":"3"},"f":[{"t":7,"e":"div","a":{"class":"status-cont passengerItem__status"},"f":[{"t":7,"e":"span","a":{"class":"error-text"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.passengerUnavailable\")"}}]}," ",{"t":7,"e":"span","f":[" ",{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.checkInOnlyAtAirport\")"}}]}," ",{"t":7,"e":"i","a":{"class":"icon_info symbol-info show-popover passengerItem__info"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias","passenger.unavailabilityReason"],"s":"_0(\"oxygen-check-in.searchResult.label.unavailabilityReason.\"+_1)"}}]}]}]}]}]}]}]}],"n":50,"x":{"r":["passenger.isAvailable"],"s":"!_0"}}]}
},{}],84:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":7,"e":"div","a":{"class":"regSteps"},"f":[{"t":7,"e":"div","a":{"class":"wrap"},"f":[{"t":7,"e":"div","a":{"class":"regSteps__i"},"f":[{"t":7,"e":"ol","f":[{"t":7,"e":"li","a":{"class":"active"},"f":[{"t":7,"e":"a","a":{"href":"#search"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.search\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.checkIn\")"}}]}]}," ",{"t":7,"e":"li","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.steps.boardingPass\")"}}]}]}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"div","a":{"class":"wrap wrap_pt32"},"f":[{"t":7,"e":"div","a":{"class":"content__i"},"f":[{"t":7,"e":"div","a":{"class":["webRegistration ",{"t":4,"f":["webRegistration-hasPassengers"],"n":50,"r":"orderInfo.passengers"}]},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__i"},"f":[{"t":7,"e":"h2","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.checkinForm.label.mainTitle\")"}}]}," ",{"t":7,"e":"div","a":{"id":"searchFormHeader"},"f":[{"t":8,"r":"searchHeaderHtml"}]}," ",{"t":7,"e":"form","a":{"id":"searchForm","class":["search-form ",{"t":4,"f":["locked"],"n":50,"x":{"r":["orderInfo.passengers","orderInfo.passengers.0"],"s":"_0&&_1"}}]},"v":{"submit":"search-order"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchForm"},"f":[{"t":7,"e":"div","a":{"class":"fields"},"f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"textInp lastName-control","name":"lastName","id":"searchForm_0_lastName","value":[{"t":2,"x":{"r":["orderInfo.lastNameFromInput"],"s":"_0||\"\""}}],"twoway":"false","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.search.label.lastName\")"}}]},"v":{"input":"search-form-field-change"},"m":[{"t":4,"f":["disabled=\"disabled\""],"n":50,"x":{"r":["orderInfo.passengers","orderInfo.passengers.0"],"s":"_0&&_1"}}]}]}," ",{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"textInp number-control","name":"ticketNumber","id":"searchForm_0_ticketNumber","value":[{"t":2,"x":{"r":["orderInfo.ticketNumberFromInput"],"s":"_0||\"\""}}],"twoway":"false","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.search.label.ticketNumber\")"}}]},"v":{"input":"search-form-field-change"},"m":[{"t":4,"f":["disabled=\"disabled\""],"n":50,"x":{"r":["orderInfo.passengers","orderInfo.passengers.0"],"s":"_0&&_1"}}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"inp form-group search-captcha-cont"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"textInp captcha-control","name":"captcha","id":"searchForm_0_captcha","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.search.label.captcha\")"}}]}}]}," ",{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"div","a":{"class":"capcha captcha-reload"},"f":[{"t":7,"e":"img","a":{"class":"captcha","src":["./captcha?timestamp=",{"t":2,"x":{"r":["utils"],"s":"_0.getTimestamp()"}}]}}," ",{"t":7,"e":"a","a":{"class":"capcha_reload"},"f":[{"t":7,"e":"i","a":{"class":"icon_captcha-reload"}}]}]}]}],"n":50,"r":"captchaRequired"}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"infoMessage infoMessage_error"},"f":[{"t":7,"e":"div","a":{"class":"infoMessage__i"},"f":[{"t":7,"e":"p","f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.captchaRequired\")"}}]}]}]}]}],"n":50,"r":"captchaRequired"}," ",{"t":7,"e":"div","a":{"class":"webRegistration__footer"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"webRegistration__accept","id":"searchAgreeCont"},"f":[{"t":7,"e":"div","a":{"class":"customCheckbox webRegistration__accept__checkbox"},"f":[{"t":7,"e":"label","f":[{"t":7,"e":"input","a":{"type":"checkbox","name":"search-agree","id":"search-agree","disabled":[{"t":2,"x":{"r":["formReady"],"s":"!_0"}}],"checked":[{"t":2,"r":"agree"}]},"v":{"change":"search-agree-change"}},{"t":7,"e":"span"}," ",{"t":8,"r":"agreeLabelHtml"}]}]}]}],"n":50,"x":{"r":["param"],"s":"_0(\"oxygen-check-in.showSearchAgreeCheckbox\")"}}," ",{"t":7,"e":"div","a":{"class":"webRegistration__search__next"},"f":[{"t":7,"e":"button","a":{"type":"submit","class":["btn search-btn btn_next ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["formReady","agree","param"],"s":"!_0||(!_1&&_2(\"oxygen-check-in.showSearchAgreeCheckbox\"))"}}]},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.search\")"}}]}," ",{"t":7,"e":"a","v":{"click":"unlock-search-order"},"a":{"class":"webRegistration__search__change_link change-btn"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.change\")"}}]}]}]}]}," ",{"t":7,"e":"div","a":{"class":"checkinScreen"},"f":[{"t":7,"e":"div","a":{"id":"searchResult"},"f":[{"t":8,"r":"searchResult"}]}]}," ",{"t":7,"e":"div","a":{"id":"searchFormFooter"},"f":[{"t":8,"r":"searchFooterHtml"}]}]}]}]}]}]}]}
},{}],85:[function(require,module,exports){
module.exports={"v":3,"t":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchResults"},"f":[{"t":4,"f":[{"t":7,"e":"div","a":{"class":["info ",{"t":4,"f":["disabled"],"n":50,"x":{"r":["status"],"s":"_0!==\"OPENED\""}}]},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate"},"f":[{"t":7,"e":"div","a":{"class":"info__arrDate__route"},"f":[{"t":7,"e":"strong","f":[{"t":2,"r":"departureCity"}," — ",{"t":2,"r":"arrivalCity"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__arrDate__date"},"f":[{"t":2,"r":"departureDateTime"}," ",{"t":7,"e":"span","a":{"class":"info__arrDate__airport"},"f":[{"t":2,"r":"departureAirport"}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__flight"},"f":[{"t":7,"e":"div","a":{"class":"info__flight__caption"},"f":[{"t":7,"e":"span","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.flightNumber\")"}}]}," ",{"t":2,"r":"airlineCode"},"-",{"t":2,"r":"flightNumber"}]}," ",{"t":7,"e":"div","a":{"class":"info__flight__company"},"f":[{"t":2,"r":"airline"}]}]}," ",{"t":7,"e":"div","a":{"class":"info__registration"},"f":[{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__caption"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.status\")"}}]}," ",{"t":7,"e":"span","a":{"class":["info__registration__condition ",{"t":4,"f":["error-text"],"n":50,"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}},{"t":4,"n":51,"f":["success-text"],"x":{"r":["status"],"s":"_0===\"CLOSED\"||_0===\"TAKE_OFF\""}}]},"f":[{"t":2,"x":{"r":["alias","status"],"s":"_0(\"oxygen-check-in.flightStatus.\"+_1)"}}]}]}," ",{"t":7,"e":"div","f":[{"t":7,"e":"span","a":{"class":"info__registration__date"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInCloseDate\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}],"n":50,"x":{"r":["status"],"s":"_0===\"OPENED\""}}," ",{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpenDate\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}],"n":50,"x":{"r":["status","utils","stages.webCheckInOpen"],"s":"_0===\"CLOSED\"&&_1.checkSegmentWillBeOpened(_2)"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"info__tip status-cont"},"f":[{"t":7,"e":"i","a":{"class":"icon_info show-popover"}}," ",{"t":7,"e":"div","a":{"class":"popover"},"f":[{"t":7,"e":"svg","a":{"class":"svg-symbol-popover-arrow"},"f":[{"t":7,"e":"use","a":{"xlink:href":"#svg-symbol-popover-arrow"}}]}," ",{"t":7,"e":"div","a":{"class":"popover-inner"},"f":[{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.webCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInOpen\")"}}," ",{"t":2,"r":"stages.webCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.webCheckInClose\")"}}," ",{"t":2,"r":"stages.webCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.airportCheckIn\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInOpen\")"}}," ",{"t":2,"r":"stages.airportCheckInOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.airportCheckInClose\")"}}," ",{"t":2,"r":"stages.airportCheckInClose"}]}]}," ",{"t":7,"e":"div","a":{"class":"popover_header"},"f":[{"t":7,"e":"strong","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.header.boarding\")"}}]}]}," ",{"t":7,"e":"div","a":{"class":"content"},"f":[{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingOpen\")"}}," ",{"t":2,"r":"stages.boardingOpen"}]}," ",{"t":7,"e":"p","f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.stages.label.boardingClose\")"}}," ",{"t":2,"r":"stages.boardingClose"}]}]}]}]}]}]}],"n":52,"r":"orderInfo.segments"}," ",{"t":7,"e":"div","a":{"class":"passengers order-item"},"f":[{"t":7,"e":"div","a":{"class":"main-passenger"},"f":[{"t":7,"e":"div","a":{"class":"passengers__header"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.leadPassenger\")"}}]}," ",{"t":7,"e":"table","a":{"class":"passengers__tableTickets"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerItem"}],"x":{"r":["utils","orderInfo.passengers","orderInfo.completelyInitialized"],"s":"{passenger:_0.getLeadPassenger(_1),completelyInitialized:_2}"}}]}]}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"class":"other-passengers"},"f":[{"t":7,"e":"div","a":{"class":"passengers__header_second"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.searchResult.label.otherPassengers\")"}}]}," ",{"t":7,"e":"table","a":{"class":"passengers__tableTickets passengers__tableTickets_group"},"f":[{"t":7,"e":"tbody","f":[{"t":4,"f":[{"t":4,"f":[{"t":4,"n":53,"f":[{"t":8,"r":"passengerItem"}],"x":{"r":["passengerNum","orderInfo.passengers","orderInfo.completelyInitialized"],"s":"{passenger:_1[_0],completelyInitialized:_2}"}}],"n":50,"x":{"r":["lead"],"s":"!_0"}}],"n":52,"i":"passengerNum","r":"orderInfo.passengers"}]}]}]}],"n":50,"x":{"r":["orderInfo.passengers.length"],"s":"_0>1"}}]}," ",{"t":4,"f":[{"t":7,"e":"div","a":{"id":"addNewOrderPassengerCont","class":"buttons-cont webRegistration__newSearch"},"f":[{"t":7,"e":"button","a":{"class":"btn btn_search add-passenger-btn"},"v":{"click":"add-new-search-order"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.addNewPassenger\")"}}]}]}," ",{"t":7,"e":"form","a":{"id":"newSearchForm","class":"search-form"},"v":{"submit":"search-order"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__searchForm"},"f":[{"t":7,"e":"div","a":{"class":"fields"},"f":[{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"textInp lastName-control","name":"lastName","id":"searchForm_new_lastName","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.search.label.lastName\")"}}]},"v":{"input":"new-search-form-field-change"}}]}," ",{"t":7,"e":"div","a":{"class":"inp form-group"},"f":[{"t":7,"e":"input","a":{"type":"text","class":"textInp number-control","name":"ticketNumber","id":"searchForm_new_ticketNumber","placeholder":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.search.label.ticketNumber\")"}}]},"v":{"input":"new-search-form-field-change"}}]}]}]}," ",{"t":7,"e":"div","a":{"class":"webRegistration__footer"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__search__next"},"f":[{"t":7,"e":"button","a":{"type":"submit","class":"btn search-btn btn_next"},"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.search\")"}}]}]}]}]}],"n":50,"r":"orderInfo.canAddMorePassengers"}," ",{"t":7,"e":"div","a":{"class":"webRegistration__footer"},"f":[{"t":7,"e":"div","a":{"class":"webRegistration__toReg"},"f":[{"t":7,"e":"a","v":{"click":"goto-checkin"},"a":{"id":"gotoCheckinButton","class":"btn btn_search disabled"},"f":[{"t":4,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoBoardingPass\")"}}],"n":50,"x":{"r":["orderInfo.passengersType"],"s":"_0==\"CHECKED\""}},{"t":4,"n":51,"f":[{"t":2,"x":{"r":["alias"],"s":"_0(\"oxygen-check-in.buttons.gotoCheckin\")"}}],"x":{"r":["orderInfo.passengersType"],"s":"_0==\"CHECKED\""}}]}]}]}]}],"n":50,"x":{"r":["orderInfo","orderInfo.passengers","orderInfo.passengers.length"],"s":"_0&&_1&&_2"}}]}
},{}]},{},[9]);
